export const lvLV = {
    searchNotFound: "Valsts nav atrasta",
    searchPlaceholder: "Meklēt valsti",
    countries: {
        "Gibraltar": "Gibraltārs",
        "Gambia": "Gambija",
        "Equatorial Guinea": "Ekvatoriālā Gvineja",
        "Senegal": "Senegāla",
        "Jamaica": "Jamaika",
        "Seychelles": "Seišelu salas",
        "Comoros": "Komoru salas",
        "U.S. Virgin Islands": "ASV Virdžīnu salas",
        "Guinea": "Gvineja",
        "Niger": "Nigēra",
        "Libya": "Lībija",
        "Romania": "Rumānija",
        "Anguilla": "Angilja",
        "Togo": "Togo",
        "Paraguay": "Paragvaja",
        "India": "Indija",
        "Ireland": "Īrija",
        "Turkey": "Turcija",
        "Oman": "Omāna",
        "Ukraine": "Ukraina",
        "Spain": "Spānija",
        "Cameroon": "Kamerūna",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Sentvinsenta un Grenadīnas",
        "Cyprus": "Kipra",
        "Belarus": "Baltkrievija",
        "Gabon": "Gabona",
        "Samoa": "Samoa",
        "Chile": "Čīle",
        "United Arab Emirates": "Apvienotie Arābu Emirāti",
        "São Tomé and Príncipe": "Santome un Prinsipi",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puertoriko",
        "Portugal": "Portugāle",
        "Costa Rica": "Kostarika",
        "Swaziland": "Svazilenda",
        "Cape Verde": "Kaboverde",
        "Curaçao": "Kirasao",
        "Andorra": "Andora",
        "Armenia": "Armēnija",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Kotdivuāra",
        "Guinea-Bissau": "Gvineja-Bisava",
        "Mozambique": "Mozambika",
        "Poland": "Polija",
        "French Polynesia": "Franču Polinēzija",
        "Jersey": "Džērsija",
        "Kuwait": "Kuveita",
        "Dominican Republic": "Dominikānas Republika",
        "Kosovo": "Kosova",
        "Kyrgyzstan": "Kirgizstāna",
        "Syria": "Sīrija",
        "Zambia": "Zambija",
        "Croatia": "Horvātija",
        "Lithuania": "Lietuva",
        "Albania": "Albānija",
        "Netherlands": "Nīderlande",
        "France": "Francija",
        "Tunisia": "Tunisija",
        "Bosnia and Herzegovina": "Bosnija un Hercegovina",
        "Bahamas": "Bahamu salas",
        "Somalia": "Somālija",
        "Burundi": "Burundi",
        "Barbados": "Barbadosa",
        "Malawi": "Malāvija",
        "Honduras": "Hondurasa",
        "French Guiana": "Franču Gviāna",
        "Jordan": "Jordānija",
        "Serbia": "Serbija",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Gajāna",
        "Lesotho": "Lesoto",
        "Taiwan": "Taivāna",
        "Central African Republic": "Centrālāfrikas Republika",
        "Luxembourg": "Luksemburga",
        "Trinidad and Tobago": "Trinidāda un Tobāgo",
        "Estonia": "Igaunija",
        "Montserrat": "Monserata",
        "Norway": "Norvēģija",
        "North Korea": "Ziemeļkoreja",
        "Myanmar": "Mjanma",
        "Sri Lanka": "Šrilanka",
        "Faroe Islands": "Fēru salas",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Folklenda salas",
        "Namibia": "Namībija",
        "Saint Lucia": "Sentlūsija",
        "Indonesia": "Indonēzija",
        "Timor-Leste": "Austrumtimora",
        "Norfolk Island": "Norfolkas sala",
        "Bhutan": "Butāna",
        "Iran": "Irāna",
        "Turkmenistan": "Turkmenistāna",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazahstāna",
        "Cook Islands": "Kuka salas",
        "Micronesia": "Mikronēzija",
        "Sint Maarten": "Sintmārtena",
        "Liberia": "Libērija",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipīnas",
        "Rwanda": "Ruanda",
        "United Kingdom": "Apvienotā Karaliste",
        "Martinique": "Martinika",
        "Nepal": "Nepāla",
        "Guatemala": "Gvatemala",
        "Bermuda": "Bermudu salas",
        "Australia": "Austrālija",
        "Vatican City": "Vatikāns",
        "Slovenia": "Slovēnija",
        "Cayman Islands": "Kaimanu salas",
        "Hungary": "Ungārija",
        "American Samoa": "ASV Samoa",
        "Mauritania": "Mauritānija",
        "Japan": "Japāna",
        "Uzbekistan": "Uzbekistāna",
        "Cambodia": "Kambodža",
        "Wallis & Futuna": "Volisa un Futuna",
        "South Sudan": "Dienvidsudāna",
        "Morocco": "Maroka",
        "Argentina": "Argentīna",
        "Guadeloupe": "Gvadelupa",
        "Hong Kong": "Honkonga",
        "Qatar": "Katara",
        "Tanzania": "Tanzānija",
        "Mexico": "Meksika",
        "Russia": "Krievija",
        "Iceland": "Islande",
        "Monaco": "Monako",
        "Afghanistan": "Afganistāna",
        "Slovakia": "Slovākija",
        "Sweden": "Zviedrija",
        "Azerbaijan": "Azerbaidžāna",
        "Bangladesh": "Bangladeša",
        "Brazil": "Brazīlija",
        "Cuba": "Kuba",
        "Ghana": "Gana",
        "Mongolia": "Mongolija",
        "Saint Kitts and Nevis": "Sentkitsa un Nevisa",
        "Burkina Faso": "Burkinafaso",
        "Nicaragua": "Nikaragva",
        "Malaysia": "Malaizija",
        "Uruguay": "Urugvaja",
        "Brunei": "Bruneja",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Ziemeļu Marianas salas",
        "Pakistan": "Pakistāna",
        "Greenland": "Grenlande",
        "Mauritius": "Maurīcija",
        "Caribbean Netherlands": "Karību Nīderlande",
        "Belize": "Beliza",
        "Liechtenstein": "Lihtenšteina",
        "Sierra Leone": "Sjerraleone",
        "Czech Republic": "Čehija",
        "Moldova": "Moldova",
        "Singapore": "Singapūra",
        "Belgium": "Beļģija",
        "Maldives": "Maldīvija",
        "New Zealand": "Jaunzēlande",
        "South Korea": "Dienvidkoreja",
        "Italy": "Itālija",
        "Israel": "Izraēla",
        "Grenada": "Grenāda",
        "Kenya": "Kenija",
        "St. Helena": "Svētā Helēna",
        "Guam": "Guama",
        "Denmark": "Dānija",
        "New Caledonia": "Jaunkaledonija",
        "Ecuador": "Ekvadora",
        "Canada": "Kanāda",
        "Egypt": "Ēģipte",
        "Saudi Arabia": "Saūda Arābija",
        "Botswana": "Botsvana",
        "Turks & Caicos Islands": "Tērksas un Kaikosas salas",
        "Latvia": "Latvija",
        "St. Pierre & Miquelon": "Senpjēra un Mikelona",
        "Georgia": "Gruzija",
        "Laos": "Laosa",
        "Réunion": "Reinjona",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabve",
        "Thailand": "Taizeme",
        "Algeria": "Alžīrija",
        "Finland": "Somija",
        "Macedonia": "Maķedonija",
        "Antigua and Barbuda": "Antigva un Barbuda",
        "Nigeria": "Nigērija",
        "Switzerland": "Šveice",
        "Bulgaria": "Bulgārija",
        "Montenegro": "Melnkalne",
        "Tajikistan": "Tadžikistāna",
        "Austria": "Austrija",
        "Bolivia": "Bolīvija",
        "Sudan": "Sudāna",
        "Suriname": "Surinama",
        "Iraq": "Irāka",
        "Bahrain": "Bahreina",
        "Colombia": "Kolumbija",
        "Papua New Guinea": "Papua-Jaungvineja",
        "Yemen": "Jemena",
        "Venezuela": "Venecuēla",
        "Djibouti": "Džibutija",
        "British Indian Ocean Territory": "Britu Indijas okeāna teritorija",
        "Chad": "Čada",
        "Germany": "Vācija",
        "Fiji": "Fidži",
        "British Virgin Islands": "Britu Virdžīnu salas",
        "San Marino": "Sanmarīno",
        "Vietnam": "Vjetnama",
        "Macau": "Makao",
        "South Africa": "Dienvidāfrika",
        "Eritrea": "Eritreja",
        "Greece": "Grieķija",
        "Ethiopia": "Etiopija",
        "Madagascar": "Madagaskara",
        "Marshall Islands": "Māršala salas",
        "United States": "ASV",
        "Benin": "Benina",
        "El Salvador": "Salvadora",
        "Lebanon": "Libāna",
        "Palestine": "Palestīna",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Zālamana salas",
        "China": "Ķīna",
        "Tonga": "Tonga"
    },
};
export const msMY = {
    searchNotFound: "Negara tidak dijumpai",
    searchPlaceholder: "Cari negara",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Guinea Khatulistiwa",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychelles",
        "Comoros": "Komoro",
        "U.S. Virgin Islands": "Kepulauan Virgin AS",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libya",
        "Romania": "Romania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Ireland",
        "Turkey": "Turki",
        "Oman": "Oman",
        "Ukraine": "Ukraine",
        "Spain": "Sepanyol",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent dan Grenadine",
        "Cyprus": "Cyprus",
        "Belarus": "Belarus",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Emiriah Arab Bersatu",
        "São Tomé and Príncipe": "Sao Tome dan Principe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Tanjung Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Pantai Gading",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mozambik",
        "Poland": "Poland",
        "French Polynesia": "Polynesia Perancis",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Republik Dominika",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgizstan",
        "Syria": "Syria",
        "Zambia": "Zambia",
        "Croatia": "Croatia",
        "Lithuania": "Lithuania",
        "Albania": "Albania",
        "Netherlands": "Belanda",
        "France": "Perancis",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia dan Herzegovina",
        "Bahamas": "Bahama",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Guiana Perancis",
        "Jordan": "Jordan",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Republik Afrika Tengah",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinidad dan Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Norway",
        "North Korea": "Korea Utara",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Kepulauan Faroe",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Kepulauan Falkland",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Timor-Leste",
        "Norfolk Island": "Pulau Norfolk",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Kepulauan Cook",
        "Micronesia": "Mikronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipina",
        "Rwanda": "Rwanda",
        "United Kingdom": "United Kingdom",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australia",
        "Vatican City": "Vatican",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Kepulauan Cayman",
        "Hungary": "Hungary",
        "American Samoa": "Samoa Amerika",
        "Mauritania": "Mauritania",
        "Japan": "Jepun",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kemboja",
        "Wallis & Futuna": "Wallis dan Futuna",
        "South Sudan": "Sudan Selatan",
        "Morocco": "Maghribi",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexico",
        "Russia": "Rusia",
        "Iceland": "Iceland",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovakia",
        "Sweden": "Sweden",
        "Azerbaijan": "Azerbaijan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brazil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts dan Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Kepulauan Mariana Utara",
        "Pakistan": "Pakistan",
        "Greenland": "Greenland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Caribbean Netherlands",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Republik Czech",
        "Moldova": "Moldova",
        "Singapore": "Singapura",
        "Belgium": "Belgium",
        "Maldives": "Maldives",
        "New Zealand": "New Zealand",
        "South Korea": "Korea Selatan",
        "Italy": "Itali",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Saint Helena",
        "Guam": "Guam",
        "Denmark": "Denmark",
        "New Caledonia": "New Caledonia",
        "Ecuador": "Ecuador",
        "Canada": "Kanada",
        "Egypt": "Mesir",
        "Saudi Arabia": "Arab Saudi",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Kepulauan Turks & Caicos",
        "Latvia": "Latvia",
        "St. Pierre & Miquelon": "Saint Pierre dan Miquelon",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Reunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algeria",
        "Finland": "Finland",
        "Macedonia": "Macedonia",
        "Antigua and Barbuda": "Antigua dan Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Switzerland",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tajikistan",
        "Austria": "Austria",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Iraq",
        "Bahrain": "Bahrain",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papua New Guinea",
        "Yemen": "Yaman",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Wilayah Lautan Hindi British",
        "Chad": "Chad",
        "Germany": "Jerman",
        "Fiji": "Fiji",
        "British Virgin Islands": "Kepulauan Virgin British",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macau",
        "South Africa": "Afrika Selatan",
        "Eritrea": "Eritrea",
        "Greece": "Greece",
        "Ethiopia": "Ethiopia",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Kepulauan Marshall",
        "United States": "Amerika Syarikat",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Lubnan",
        "Palestine": "Palestin",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Kepulauan Solomon",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const kaGE = {
    searchNotFound: "ქვეყანა ვერ მოიძებნა",
    searchPlaceholder: "ძებნა ქვეყნის",
    countries: {
        "Gibraltar": "გიბრალტარი",
        "Gambia": "გამბია",
        "Equatorial Guinea": "ეკვატორული გვინეა",
        "Senegal": "სენეგალი",
        "Jamaica": "იამაიკა",
        "Seychelles": "სეიშელის კუნძულები",
        "Comoros": "კომორის კუნძულები",
        "U.S. Virgin Islands": "აშშ-ის ვირჯინის კუნძულები",
        "Guinea": "გვინეა",
        "Niger": "ნიგერი",
        "Libya": "ლიბია",
        "Romania": "რუმინეთი",
        "Anguilla": "ანგუილა",
        "Togo": "ტოგო",
        "Paraguay": "პარაგვაი",
        "India": "ინდოეთი",
        "Ireland": "ირლანდია",
        "Turkey": "თურქეთი",
        "Oman": "ომანი",
        "Ukraine": "უკრაინა",
        "Spain": "ესპანეთი",
        "Cameroon": "კამერუნი",
        "Angola": "ანგოლა",
        "Mali": "მალი",
        "Saint Vincent and the Grenadines": "სენტ-ვინსენტი და გრენადინები",
        "Cyprus": "კვიპროსი",
        "Belarus": "ბელარუსი",
        "Gabon": "გაბონი",
        "Samoa": "სამოა",
        "Chile": "ჩილე",
        "United Arab Emirates": "არაბთა გაერთიანებული საამიროები",
        "São Tomé and Príncipe": "სან-ტომე და პრინსიპი",
        "Palau": "პალაუ",
        "Tokelau": "ტოკელაუ",
        "Puerto Rico": "პუერტო-რიკო",
        "Portugal": "პორტუგალია",
        "Costa Rica": "კოსტა-რიკა",
        "Swaziland": "სვაზილენდი",
        "Cape Verde": "კაბო-ვერდე",
        "Curaçao": "კიურასაო",
        "Andorra": "ანდორა",
        "Armenia": "სომხეთი",
        "Haiti": "ჰაიტი",
        "Côte d’Ivoire": "კოტ-დ’ივუარი",
        "Guinea-Bissau": "გვინეა-ბისაუ",
        "Mozambique": "მოზამბიკი",
        "Poland": "პოლონეთი",
        "French Polynesia": "საფრანგეთის პოლინეზია",
        "Jersey": "ჯერსი",
        "Kuwait": "ქუვეითი",
        "Dominican Republic": "დომინიკის რესპუბლიკა",
        "Kosovo": "კოსოვო",
        "Kyrgyzstan": "ყირგიზეთი",
        "Syria": "სირია",
        "Zambia": "ზამბია",
        "Croatia": "ხორვატია",
        "Lithuania": "ლიტვა",
        "Albania": "ალბანეთი",
        "Netherlands": "ნიდერლანდები",
        "France": "საფრანგეთი",
        "Tunisia": "ტუნისი",
        "Bosnia and Herzegovina": "ბოსნია და ჰერცეგოვინა",
        "Bahamas": "ბაჰამის კუნძულები",
        "Somalia": "სომალი",
        "Burundi": "ბურუნდი",
        "Barbados": "ბარბადოსი",
        "Malawi": "მალავი",
        "Honduras": "ჰონდურასი",
        "French Guiana": "საფრანგეთის გვიანა",
        "Jordan": "იორდანია",
        "Serbia": "სერბეთი",
        "Vanuatu": "ვანუატუ",
        "Aruba": "არუბა",
        "Guyana": "გაიანა",
        "Lesotho": "ლესოთო",
        "Taiwan": "ტაივანი",
        "Central African Republic": "ცენტრალური აფრიკის რესპუბლიკა",
        "Luxembourg": "ლუქსემბურგი",
        "Trinidad and Tobago": "ტრინიდადი და ტობაგო",
        "Estonia": "ესტონეთი",
        "Montserrat": "მონსერატი",
        "Norway": "ნორვეგია",
        "North Korea": "ჩრდილოეთ კორეა",
        "Myanmar": "მიანმარი",
        "Sri Lanka": "შრი-ლანკა",
        "Faroe Islands": "ფარერის კუნძულები",
        "Dominica": "დომინიკა",
        "Kiribati": "კირიბატი",
        "Falkland Islands": "ფოლკლენდის კუნძულები",
        "Namibia": "ნამიბია",
        "Saint Lucia": "სენტ-ლუსია",
        "Indonesia": "ინდონეზია",
        "Timor-Leste": "აღმოსავლეთი ტიმორი",
        "Norfolk Island": "ნორფოლკის კუნძული",
        "Bhutan": "ბუტანი",
        "Iran": "ირანი",
        "Turkmenistan": "თურქმენეთი",
        "Uganda": "უგანდა",
        "Kazakhstan": "ყაზახეთი",
        "Cook Islands": "კუკის კუნძულები",
        "Micronesia": "მიკრონეზია",
        "Sint Maarten": "სინტ-მარტენი",
        "Liberia": "ლიბერია",
        "Panama": "პანამა",
        "Malta": "მალტა",
        "Peru": "პერუ",
        "Philippines": "ფილიპინები",
        "Rwanda": "რუანდა",
        "United Kingdom": "გაერთიანებული სამეფო",
        "Martinique": "მარტინიკა",
        "Nepal": "ნეპალი",
        "Guatemala": "გვატემალა",
        "Bermuda": "ბერმუდა",
        "Australia": "ავსტრალია",
        "Vatican City": "ვატიკანი",
        "Slovenia": "სლოვენია",
        "Cayman Islands": "კაიმანის კუნძულები",
        "Hungary": "უნგრეთი",
        "American Samoa": "ამერიკული სამოა",
        "Mauritania": "მავრიტანია",
        "Japan": "იაპონია",
        "Uzbekistan": "უზბეკეთი",
        "Cambodia": "კამბოჯა",
        "Wallis & Futuna": "უოლისი და ფუტუნა",
        "South Sudan": "სამხრეთ სუდანი",
        "Morocco": "მაროკო",
        "Argentina": "არგენტინა",
        "Guadeloupe": "გვადელუპა",
        "Hong Kong": "ჰონგ კონგი",
        "Qatar": "ყატარი",
        "Tanzania": "ტანზანია",
        "Mexico": "მექსიკა",
        "Russia": "რუსეთი",
        "Iceland": "ისლანდია",
        "Monaco": "მონაკო",
        "Afghanistan": "ავღანეთი",
        "Slovakia": "სლოვაკეთი",
        "Sweden": "შვედეთი",
        "Azerbaijan": "აზერბაიჯანი",
        "Bangladesh": "ბანგლადეში",
        "Brazil": "ბრაზილია",
        "Cuba": "კუბა",
        "Ghana": "განა",
        "Mongolia": "მონღოლეთი",
        "Saint Kitts and Nevis": "სენტ-კიტსი და ნევისი",
        "Burkina Faso": "ბურკინა ფასო",
        "Nicaragua": "ნიკარაგუა",
        "Malaysia": "მალაიზია",
        "Uruguay": "ურუგვაი",
        "Brunei": "ბრუნეი",
        "Congo": "კონგო",
        "Nauru": "ნაურუ",
        "Northern Mariana Islands": "ჩრდილოეთ მარიანას კუნძულები",
        "Pakistan": "პაკისტანი",
        "Greenland": "გრენლანდია",
        "Mauritius": "მავრიკია",
        "Caribbean Netherlands": "კარიბული ნიდერლანდები",
        "Belize": "ბელიზი",
        "Liechtenstein": "ლიხტენშტაინი",
        "Sierra Leone": "სიერა ლეონე",
        "Czech Republic": "ჩეხეთი",
        "Moldova": "მოლდოვა",
        "Singapore": "სინგაპური",
        "Belgium": "ბელგია",
        "Maldives": "მალდივები",
        "New Zealand": "ახალი ზელანდია",
        "South Korea": "სამხრეთ კორეა",
        "Italy": "იტალია",
        "Israel": "ისრაელი",
        "Grenada": "გრენადა",
        "Kenya": "კენია",
        "St. Helena": "სენტ-ჰელენა",
        "Guam": "გუამი",
        "Denmark": "დანია",
        "New Caledonia": "ახალი კალედონია",
        "Ecuador": "ეკვადორი",
        "Canada": "კანადა",
        "Egypt": "ეგვიპტე",
        "Saudi Arabia": "საუდის არაბეთი",
        "Botswana": "ბოტსვანა",
        "Turks & Caicos Islands": "თერქსის და კაიკოსის კუნძულები",
        "Latvia": "ლატვია",
        "St. Pierre & Miquelon": "სენ-პიერი და მიკელონი",
        "Georgia": "საქართველო",
        "Laos": "ლაოსი",
        "Réunion": "რეიუნიონი",
        "Niue": "ნიუე",
        "Zimbabwe": "ზიმბაბვე",
        "Thailand": "ტაილანდი",
        "Algeria": "ალჟირი",
        "Finland": "ფინეთი",
        "Macedonia": "მაკედონია",
        "Antigua and Barbuda": "ანტიგუა და ბარბუდა",
        "Nigeria": "ნიგერია",
        "Switzerland": "შვეიცარია",
        "Bulgaria": "ბულგარეთი",
        "Montenegro": "მონტენეგრო",
        "Tajikistan": "ტაჯიკეთი",
        "Austria": "ავსტრია",
        "Bolivia": "ბოლივია",
        "Sudan": "სუდანი",
        "Suriname": "სურინამი",
        "Iraq": "ერაყი",
        "Bahrain": "ბაჰრეინი",
        "Colombia": "კოლუმბია",
        "Papua New Guinea": "პაპუა ახალი გვინეა",
        "Yemen": "იემენი",
        "Venezuela": "ვენესუელა",
        "Djibouti": "ჯიბუტი",
        "British Indian Ocean Territory": "ბრიტანეთის ინდოეთის ოკეანის ტერიტორია",
        "Chad": "ჩადი",
        "Germany": "გერმანია",
        "Fiji": "ფიჯი",
        "British Virgin Islands": "ბრიტანეთის ვირჯინის კუნძულები",
        "San Marino": "სან-მარინო",
        "Vietnam": "ვიეტნამი",
        "Macau": "მაკაო",
        "South Africa": "სამხრეთ აფრიკა",
        "Eritrea": "ერიტრეა",
        "Greece": "საბერძნეთი",
        "Ethiopia": "ეთიოპია",
        "Madagascar": "მადაგასკარი",
        "Marshall Islands": "მარშალის კუნძულები",
        "United States": "აშშ",
        "Benin": "ბენინი",
        "El Salvador": "სალვადორი",
        "Lebanon": "ლიბანი",
        "Palestine": "პალესტინა",
        "Tuvalu": "ტუვალუ",
        "Solomon Islands": "სოლომონის კუნძულები",
        "China": "ჩინეთი",
        "Tonga": "ტონგა"
    },
};
export const kkKZ = {
    searchNotFound: "Ел табылмады",
    searchPlaceholder: "Елді іздеу",
    countries: {
        "Gibraltar": "Гибралтар",
        "Gambia": "Гамбия",
        "Equatorial Guinea": "Экваторлық Гвинея",
        "Senegal": "Сенегал",
        "Jamaica": "Ямайка",
        "Seychelles": "Сейшель аралдары",
        "Comoros": "Комор аралдары",
        "U.S. Virgin Islands": "АҚШ Виргин аралдары",
        "Guinea": "Гвинея",
        "Niger": "Нигер",
        "Libya": "Ливия",
        "Romania": "Румыния",
        "Anguilla": "Ангилья",
        "Togo": "Того",
        "Paraguay": "Парагвай",
        "India": "Үндістан",
        "Ireland": "Ирландия",
        "Turkey": "Түркия",
        "Oman": "Оман",
        "Ukraine": "Украина",
        "Spain": "Испания",
        "Cameroon": "Камерун",
        "Angola": "Ангола",
        "Mali": "Мали",
        "Saint Vincent and the Grenadines": "Сент-Винсент және Гренадиндер",
        "Cyprus": "Кипр",
        "Belarus": "Беларусь",
        "Gabon": "Габон",
        "Samoa": "Самоа",
        "Chile": "Чили",
        "United Arab Emirates": "Біріккен Араб Әмірліктері",
        "São Tomé and Príncipe": "Сан-Томе және Принсипи",
        "Palau": "Палау",
        "Tokelau": "Токелау",
        "Puerto Rico": "Пуэрто-Рико",
        "Portugal": "Португалия",
        "Costa Rica": "Коста-Рика",
        "Swaziland": "Эсватини",
        "Cape Verde": "Кабо-Верде",
        "Curaçao": "Кюрасао",
        "Andorra": "Андорра",
        "Armenia": "Армения",
        "Haiti": "Гаити",
        "Côte d’Ivoire": "Кот-д'Ивуар",
        "Guinea-Bissau": "Гвинея-Бисау",
        "Mozambique": "Мозамбик",
        "Poland": "Польша",
        "French Polynesia": "Француз Полинезиясы",
        "Jersey": "Джерси",
        "Kuwait": "Кувейт",
        "Dominican Republic": "Доминикан Республикасы",
        "Kosovo": "Косово",
        "Kyrgyzstan": "Қырғызстан",
        "Syria": "Сирия",
        "Zambia": "Замбия",
        "Croatia": "Хорватия",
        "Lithuania": "Литва",
        "Albania": "Албания",
        "Netherlands": "Нидерланды",
        "France": "Франция",
        "Tunisia": "Тунис",
        "Bosnia and Herzegovina": "Босния және Герцеговина",
        "Bahamas": "Багам аралдары",
        "Somalia": "Сомали",
        "Burundi": "Бурунди",
        "Barbados": "Барбадос",
        "Malawi": "Малави",
        "Honduras": "Гондурас",
        "French Guiana": "Француз Гвианасы",
        "Jordan": "Иордания",
        "Serbia": "Сербия",
        "Vanuatu": "Вануату",
        "Aruba": "Аруба",
        "Guyana": "Гайана",
        "Lesotho": "Лесото",
        "Taiwan": "Тайвань",
        "Central African Republic": "Орталық Африка Республикасы",
        "Luxembourg": "Люксембург",
        "Trinidad and Tobago": "Тринидад және Тобаго",
        "Estonia": "Эстония",
        "Montserrat": "Монтсеррат",
        "Norway": "Норвегия",
        "North Korea": "Солтүстік Корея",
        "Myanmar": "Мьянма",
        "Sri Lanka": "Шри-Ланка",
        "Faroe Islands": "Фарер аралдары",
        "Dominica": "Доминика",
        "Kiribati": "Кирибати",
        "Falkland Islands": "Фолкленд аралдары",
        "Namibia": "Намибия",
        "Saint Lucia": "Сент-Люсия",
        "Indonesia": "Индонезия",
        "Timor-Leste": "Шығыс Тимор",
        "Norfolk Island": "Норфолк аралы",
        "Bhutan": "Бутан",
        "Iran": "Иран",
        "Turkmenistan": "Түрікменстан",
        "Uganda": "Уганда",
        "Kazakhstan": "Қазақстан",
        "Cook Islands": "Кук аралдары",
        "Micronesia": "Микронезия",
        "Sint Maarten": "Синт-Мартен",
        "Liberia": "Либерия",
        "Panama": "Панама",
        "Malta": "Мальта",
        "Peru": "Перу",
        "Philippines": "Филиппиндер",
        "Rwanda": "Руанда",
        "United Kingdom": "Ұлыбритания",
        "Martinique": "Мартиника",
        "Nepal": "Непал",
        "Guatemala": "Гватемала",
        "Bermuda": "Бермуд аралдары",
        "Australia": "Австралия",
        "Vatican City": "Ватикан",
        "Slovenia": "Словения",
        "Cayman Islands": "Кайман аралдары",
        "Hungary": "Венгрия",
        "American Samoa": "Американдық Самоа",
        "Mauritania": "Мавритания",
        "Japan": "Жапония",
        "Uzbekistan": "Өзбекстан",
        "Cambodia": "Камбоджа",
        "Wallis & Futuna": "Уоллис және Футуна",
        "South Sudan": "Оңтүстік Судан",
        "Morocco": "Марокко",
        "Argentina": "Аргентина",
        "Guadeloupe": "Гваделупа",
        "Hong Kong": "Гонконг",
        "Qatar": "Катар",
        "Tanzania": "Танзания",
        "Mexico": "Мексика",
        "Russia": "Ресей",
        "Iceland": "Исландия",
        "Monaco": "Монако",
        "Afghanistan": "Ауғанстан",
        "Slovakia": "Словакия",
        "Sweden": "Швеция",
        "Azerbaijan": "Әзірбайжан",
        "Bangladesh": "Бангладеш",
        "Brazil": "Бразилия",
        "Cuba": "Куба",
        "Ghana": "Гана",
        "Mongolia": "Моңғолия",
        "Saint Kitts and Nevis": "Сент-Китс және Невис",
        "Burkina Faso": "Буркина-Фасо",
        "Nicaragua": "Никарагуа",
        "Malaysia": "Малайзия",
        "Uruguay": "Уругвай",
        "Brunei": "Бруней",
        "Congo": "Конго",
        "Nauru": "Науру",
        "Northern Mariana Islands": "Солтүстік Мариан аралдары",
        "Pakistan": "Пәкістан",
        "Greenland": "Гренландия",
        "Mauritius": "Маврикий",
        "Caribbean Netherlands": "Кариб Нидерландтары",
        "Belize": "Белиз",
        "Liechtenstein": "Лихтенштейн",
        "Sierra Leone": "Сьерра-Леоне",
        "Czech Republic": "Чех Республикасы",
        "Moldova": "Молдова",
        "Singapore": "Сингапур",
        "Belgium": "Бельгия",
        "Maldives": "Мальдив аралдары",
        "New Zealand": "Жаңа Зеландия",
        "South Korea": "Оңтүстік Корея",
        "Italy": "Италия",
        "Israel": "Израиль",
        "Grenada": "Гренада",
        "Kenya": "Кения",
        "St. Helena": "Әулие Елена",
        "Guam": "Гуам",
        "Denmark": "Дания",
        "New Caledonia": "Жаңа Каледония",
        "Ecuador": "Эквадор",
        "Canada": "Канада",
        "Egypt": "Мысыр",
        "Saudi Arabia": "Сауд Арабиясы",
        "Botswana": "Ботсвана",
        "Turks & Caicos Islands": "Теркс және Кайкос аралдары",
        "Latvia": "Латвия",
        "St. Pierre & Miquelon": "Сен-Пьер және Микелон",
        "Georgia": "Грузия",
        "Laos": "Лаос",
        "Réunion": "Реюньон",
        "Niue": "Ниуэ",
        "Zimbabwe": "Зимбабве",
        "Thailand": "Тайланд",
        "Algeria": "Алжир",
        "Finland": "Финляндия",
        "Macedonia": "Македония",
        "Antigua and Barbuda": "Антигуа және Барбуда",
        "Nigeria": "Нигерия",
        "Switzerland": "Швейцария",
        "Bulgaria": "Болгария",
        "Montenegro": "Черногория",
        "Tajikistan": "Тәжікстан",
        "Austria": "Австрия",
        "Bolivia": "Боливия",
        "Sudan": "Судан",
        "Suriname": "Суринам",
        "Iraq": "Ирак",
        "Bahrain": "Бахрейн",
        "Colombia": "Колумбия",
        "Papua New Guinea": "Папуа-Жаңа Гвинея",
        "Yemen": "Йемен",
        "Venezuela": "Венесуэла",
        "Djibouti": "Джибути",
        "British Indian Ocean Territory": "Британ Үнді мұхиты аумағы",
        "Chad": "Чад",
        "Germany": "Германия",
        "Fiji": "Фиджи",
        "British Virgin Islands": "Британ Виргин аралдары",
        "San Marino": "Сан-Марино",
        "Vietnam": "Вьетнам",
        "Macau": "Макао",
        "South Africa": "Оңтүстік Африка",
        "Eritrea": "Эритрея",
        "Greece": "Грекия",
        "Ethiopia": "Эфиопия",
        "Madagascar": "Мадагаскар",
        "Marshall Islands": "Маршалл аралдары",
        "United States": "Америка Құрама Штаттары",
        "Benin": "Бенин",
        "El Salvador": "Эль-Сальвадор",
        "Lebanon": "Ливан",
        "Palestine": "Палестина",
        "Tuvalu": "Тувалу",
        "Solomon Islands": "Соломон аралдары",
        "China": "Қытай",
        "Tonga": "Тонга"
    },
};
export const kmrIQ = {
    searchNotFound: "Welatek nehat dîtin",
    searchPlaceholder: "Lêgerîn welatek",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambiya",
        "Equatorial Guinea": "Gîneya Rojbendî",
        "Senegal": "Senegal",
        "Jamaica": "Jamaîka",
        "Seychelles": "Seyşel",
        "Comoros": "Komor",
        "U.S. Virgin Islands": "Giravên Verjînên Dewletên Yekbûyî",
        "Guinea": "Gîneya",
        "Niger": "Nîjer",
        "Libya": "Lîbya",
        "Romania": "Romanya",
        "Anguilla": "Anguîla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Hindistan",
        "Ireland": "Îrlanda",
        "Turkey": "Tirkiye",
        "Oman": "Oman",
        "Ukraine": "Ûkrayna",
        "Spain": "Spanî",
        "Cameroon": "Kamerûn",
        "Angola": "Angola",
        "Mali": "Malî",
        "Saint Vincent and the Grenadines": "Saint Vincent û Grenadîn",
        "Cyprus": "Kîpros",
        "Belarus": "Belarus",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Şîle",
        "United Arab Emirates": "Emîrtiyên Erebî yên Yekbûyî",
        "São Tomé and Príncipe": "São Tomé û Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portûgal",
        "Costa Rica": "Kosta Rîka",
        "Swaziland": "Eswatînî",
        "Cape Verde": "Verdeya Cabo",
        "Curaçao": "Kurasao",
        "Andorra": "Andorra",
        "Armenia": "Ermenistan",
        "Haiti": "Haîtî",
        "Côte d’Ivoire": "Kote d'Ivoire",
        "Guinea-Bissau": "Gîneya-Bîsau",
        "Mozambique": "Mozambîk",
        "Poland": "Polonya",
        "French Polynesia": "Polînezya Fransî",
        "Jersey": "Jersey",
        "Kuwait": "Kuweyt",
        "Dominican Republic": "Komara Domînîk",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Qirgizistan",
        "Syria": "Sûrî",
        "Zambia": "Zambiya",
        "Croatia": "Kroatî",
        "Lithuania": "Lîtvanya",
        "Albania": "Elbanî",
        "Netherlands": "Holenda",
        "France": "Fransa",
        "Tunisia": "Tûnîs",
        "Bosnia and Herzegovina": "Bosna û Herzegovîna",
        "Bahamas": "Bahama",
        "Somalia": "Somalya",
        "Burundi": "Burundî",
        "Barbados": "Barbados",
        "Malawi": "Malawî",
        "Honduras": "Hondûras",
        "French Guiana": "Guiyana Fransî",
        "Jordan": "Urdun",
        "Serbia": "Serbî",
        "Vanuatu": "Vanuatû",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taywan",
        "Central African Republic": "Komara Afrîkaya Navendî",
        "Luxembourg": "Lûxembûrg",
        "Trinidad and Tobago": "Trinidad û Tobago",
        "Estonia": "Estonya",
        "Montserrat": "Montserrat",
        "Norway": "Norwêc",
        "North Korea": "Bakurê Koreyê",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Srî Lanka",
        "Faroe Islands": "Giravên Faro",
        "Dominica": "Dominika",
        "Kiribati": "Kirîbatî",
        "Falkland Islands": "Giravên Falkland",
        "Namibia": "Namîbya",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Endonezya",
        "Timor-Leste": "Tîmora-Leste",
        "Norfolk Island": "Girava Norfolk",
        "Bhutan": "Bûtan",
        "Iran": "Îran",
        "Turkmenistan": "Tirkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Qazaxistan",
        "Cook Islands": "Giravên Cook",
        "Micronesia": "Mîkronezya",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Lîberya",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Perû",
        "Philippines": "Filîpîn",
        "Rwanda": "Rwanda",
        "United Kingdom": "Keyaniya Yekbûyî",
        "Martinique": "Martînik",
        "Nepal": "Nepal",
        "Guatemala": "Guwatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australya",
        "Vatican City": "Vatîkan",
        "Slovenia": "Slovenya",
        "Cayman Islands": "Giravên Cayman",
        "Hungary": "Macaristan",
        "American Samoa": "Samoa Amerîkî",
        "Mauritania": "Morîtanya",
        "Japan": "Japon",
        "Uzbekistan": "Ûzbêkistan",
        "Cambodia": "Kamboca",
        "Wallis & Futuna": "Wallis & Futuna",
        "South Sudan": "Rojava Sûdan",
        "Morocco": "Moroqo",
        "Argentina": "Arjantîn",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qeter",
        "Tanzania": "Tanzanya",
        "Mexico": "Meksîk",
        "Russia": "Rûsya",
        "Iceland": "Îsland",
        "Monaco": "Monako",
        "Afghanistan": "Efxanistan",
        "Slovakia": "Slovakya",
        "Sweden": "Swêd",
        "Azerbaijan": "Azerbaycan",
        "Bangladesh": "Bangladeş",
        "Brazil": "Brazîl",
        "Cuba": "Kûba",
        "Ghana": "Gana",
        "Mongolia": "Mongolya",
        "Saint Kitts and Nevis": "Saint Kitts û Nevis",
        "Burkina Faso": "Burkîna Faso",
        "Nicaragua": "Nîkaragua",
        "Malaysia": "Malezya",
        "Uruguay": "Urûguay",
        "Brunei": "Bruney",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Giravên Marîana Bakur",
        "Pakistan": "Pakistan",
        "Greenland": "Grênland",
        "Mauritius": "Maurîtîus",
        "Caribbean Netherlands": "Holenda Karîbî",
        "Belize": "Belîze",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Komara Çekî",
        "Moldova": "Moldova",
        "Singapore": "Singapûr",
        "Belgium": "Belçîka",
        "Maldives": "Maldîvler",
        "New Zealand": "Zelanda Nû",
        "South Korea": "Koreya Başûr",
        "Italy": "Îtalya",
        "Israel": "Îsraêl",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "St. Helena",
        "Guam": "Guam",
        "Denmark": "Danîmarka",
        "New Caledonia": "New Caledonia",
        "Ecuador": "Ecuador",
        "Canada": "Kanada",
        "Egypt": "Misir",
        "Saudi Arabia": "Erebistana Sûdî",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Giravên Turks & Caicos",
        "Latvia": "Latvîya",
        "St. Pierre & Miquelon": "Saint Pierre & Miquelon",
        "Georgia": "Gurcistan",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zîmbabwe",
        "Thailand": "Tayland",
        "Algeria": "Cezayir",
        "Finland": "Fînlenda",
        "Macedonia": "Makedonya",
        "Antigua and Barbuda": "Antîgua û Barbuda",
        "Nigeria": "Nîjerya",
        "Switzerland": "Swîsre",
        "Bulgaria": "Bulgaristan",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tacîkistan",
        "Austria": "Awistirya",
        "Bolivia": "Bolîvya",
        "Sudan": "Sûdan",
        "Suriname": "Sûrînam",
        "Iraq": "Îraq",
        "Bahrain": "Bahrêyn",
        "Colombia": "Kolombiya",
        "Papua New Guinea": "Papua Nîw Guinea",
        "Yemen": "Yemen",
        "Venezuela": "Venezûela",
        "Djibouti": "Cîbûtî",
        "British Indian Ocean Territory": "Herema Hindî ya Britanya",
        "Chad": "Çad",
        "Germany": "Almanya",
        "Fiji": "Fîjî",
        "British Virgin Islands": "Giravên Verjînên Brîtanya",
        "San Marino": "San Marîno",
        "Vietnam": "Viyetnam",
        "Macau": "Macau",
        "South Africa": "Afrîkaya Başûr",
        "Eritrea": "Erîtrea",
        "Greece": "Yewnanistan",
        "Ethiopia": "Etiyopya",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Giravên Marşal",
        "United States": "Dewletên Yekbûyî",
        "Benin": "Benîn",
        "El Salvador": "El Salvador",
        "Lebanon": "Libnan",
        "Palestine": "Filistîn",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Giravên Solomoni",
        "China": "Çîn",
        "Tonga": "Tonga"
    },
};
export const myMM = {
    searchNotFound: "နိုင်ငံရှာမတွေ့ပါ",
    searchPlaceholder: "နိုင်ငံကို ရှာဖွေပါ",
    countries: {
        "Gibraltar": "ဂျီဘရော်လ်တာ",
        "Gambia": "ဂမ်ဘီယာ",
        "Equatorial Guinea": "အီကွေတာ ဂီနီ",
        "Senegal": "ဆီနီဂေါ",
        "Jamaica": "ဂျမေကာ",
        "Seychelles": "ဆေးရှဲလ်",
        "Comoros": "ကိုမိုရို",
        "U.S. Virgin Islands": "ယူအက်စ် ဗာဂျင်းကျွန်းစု",
        "Guinea": "ဂီနီ",
        "Niger": "နိုင်ဂျာ",
        "Libya": "လစ်ဗျား",
        "Romania": "ရိုမေးနီးယား",
        "Anguilla": "အန်ဂီလာ",
        "Togo": "တိုဂို",
        "Paraguay": "ပါရာဂွေး",
        "India": "အိန္ဒိယ",
        "Ireland": "အိုင်ယာလန်",
        "Turkey": "တူရကီ",
        "Oman": "အိုမန်",
        "Ukraine": "ယူကရိန်း",
        "Spain": "စပိန်",
        "Cameroon": "ကင်မရွန်း",
        "Angola": "အင်ဂိုလာ",
        "Mali": "မာလီ",
        "Saint Vincent and the Grenadines": "စိန့်ဗင်ဆင့် နှင့် ဂရီနာဒင်း",
        "Cyprus": "ဆိုက်ပရပ်စ်",
        "Belarus": "ဘီလာရုစ်",
        "Gabon": "ဂါဘွန်",
        "Samoa": "ဆာမိုအာ",
        "Chile": "ချီလီ",
        "United Arab Emirates": "ယူအေအီး",
        "São Tomé and Príncipe": "ဆောင်တူမေး နှင့် ပရင်စီပီ",
        "Palau": "ပလာအို",
        "Tokelau": "တိုကေလာ",
        "Puerto Rico": "ပေါ်တိုရီကို",
        "Portugal": "ပေါ်တူဂီ",
        "Costa Rica": "ကို့စတာရီကာ",
        "Swaziland": "အီစဝာတီနီ",
        "Cape Verde": "Cape Verde",
        "Curaçao": "ကျူရာဆာ",
        "Andorra": "အန်ဒိုရာ",
        "Armenia": "အာမေနီးယား",
        "Haiti": "ဟေတီ",
        "Côte d’Ivoire": "ကို့တ်ဒီဗွာ",
        "Guinea-Bissau": "ဂီနီ-ဘီဆော်",
        "Mozambique": "မိုဇမ်ဘစ်",
        "Poland": "ပိုလန်",
        "French Polynesia": "ပြင်သစ် ပေါ်လီနေးရှား",
        "Jersey": "ဂျာစီ",
        "Kuwait": "ကူဝိတ်",
        "Dominican Republic": "ဒိုမီနီကန်သမ္မတနိုင်ငံ",
        "Kosovo": "ကိုဆိုဗို",
        "Kyrgyzstan": "ကာဂျစ္စတန်",
        "Syria": "ဆီးရီးယား",
        "Zambia": "ဇမ်ဘီယာ",
        "Croatia": "ခရိုအေးရှား",
        "Lithuania": "လစ်သူအေးနီးယား",
        "Albania": "အယ်လ်ဘေးနီးယား",
        "Netherlands": "နယ်သာလန်",
        "France": "ပြင်သစ်",
        "Tunisia": "တူနီးရှား",
        "Bosnia and Herzegovina": "ဘော့စနီးယား နှင့် ဟာဇီကိုဗီးနီးယား",
        "Bahamas": "ဘာဟားမား",
        "Somalia": "ဆိုမာလီယာ",
        "Burundi": "ဘူရွန်ဒီ",
        "Barbados": "ဘာဘဒိုးစ်",
        "Malawi": "မာလာဝီ",
        "Honduras": "ဟွန်ဒူးရပ်စ်",
        "French Guiana": "ပြင်သစ် ဂူရာနာ",
        "Jordan": "ဂျော်ဒန်",
        "Serbia": "ဆားဘီးယား",
        "Vanuatu": "ဗာနွာတူ",
        "Aruba": "အရူဘာ",
        "Guyana": "ဂိုင်ယာနာ",
        "Lesotho": "လီဆိုသို",
        "Taiwan": "ထိုင်ဝမ်",
        "Central African Republic": "ဗဟို အာဖရိက ပြည်ထောင်စု",
        "Luxembourg": "လူဇင်ဘတ်",
        "Trinidad and Tobago": "ထရီနီဒက်နှင့် တိုဘာဂို",
        "Estonia": "အက်စ်တွိုနီးယား",
        "Montserrat": "Montserrat",
        "Norway": "နော်ဝေ",
        "North Korea": "မြောက်ကိုရီးယား",
        "Myanmar": "မြန်မာ",
        "Sri Lanka": "သရိလင်္ကာ",
        "Faroe Islands": "ဖာရို ကျွန်းစု",
        "Dominica": "ဒိုမီနီကာ",
        "Kiribati": "ကီရီဘတီ",
        "Falkland Islands": "ဖော့ခ်လန် ကျွန်းစု",
        "Namibia": "နမ်ဘီယာ",
        "Saint Lucia": "စိန့်လူစီယာ",
        "Indonesia": "အင်ဒိုနီးရှား",
        "Timor-Leste": "တီမော-လက်စ်တီ",
        "Norfolk Island": "နော်ဖိုက် ကျွန်း",
        "Bhutan": "ဘူတန်",
        "Iran": "အီရန်",
        "Turkmenistan": "တူရကမင်နစ္စတန်",
        "Uganda": "ယူဂန်ဒါ",
        "Kazakhstan": "ကာဇက်စတန်",
        "Cook Islands": "Cook Islands",
        "Micronesia": "မိုက်ခရိုနီးရှား",
        "Sint Maarten": "စင့်မာတင်",
        "Liberia": "လိုက်ဘေးရီးယား",
        "Panama": "ပနားမား",
        "Malta": "မော်လ်တာ",
        "Peru": "ပီရူး",
        "Philippines": "ဖိလစ်ပိုင်",
        "Rwanda": "ရဝမ်ဒါ",
        "United Kingdom": "ယူနိုက်တက် ကင်းဒမ်း",
        "Martinique": "မာတီနီ",
        "Nepal": "နီပေါ",
        "Guatemala": "ဂူအာတီမာလာ",
        "Bermuda": "ဘာမူဒါ",
        "Australia": "ဩစတြေးလျ",
        "Vatican City": "ဗာတီကန်",
        "Slovenia": "ဆလိုဗေးနီးယား",
        "Cayman Islands": "ကေမန် ကျွန်းစု",
        "Hungary": "ဟန်ဂေရီ",
        "American Samoa": "အမေရိကန် ဆာမိုအာ",
        "Mauritania": "မော်ရီတေးနီးယား",
        "Japan": "ဂျပန်",
        "Uzbekistan": "ဥဇဘက်စတန်",
        "Cambodia": "ကမ္ဘောဒီးယား",
        "Wallis & Futuna": "ဝေါလစ်နှင့် ဖူတူနာ",
        "South Sudan": "တောင် စူဒန်",
        "Morocco": "မော်ရိုကို",
        "Argentina": "အာဂျင်တီးနား",
        "Guadeloupe": "ဂွာဒလုပ်",
        "Hong Kong": "ဟောင်ကောင်",
        "Qatar": "ကာတာ",
        "Tanzania": "တန်ဇန်းနီးယား",
        "Mexico": "မက္ကဆီကို",
        "Russia": "ရုရှ",
        "Iceland": "အိုက်စလန်",
        "Monaco": "မိုနာကို",
        "Afghanistan": "အာဖဂန်နစ္စတန်",
        "Slovakia": "ဆလိုဗက်ကီးယား",
        "Sweden": "ဆွီဒင်",
        "Azerbaijan": "အဇာဘိုင်ဂျန်",
        "Bangladesh": "ဘင်္ဂလားဒေ့ရှ်",
        "Brazil": "ဘရာဇီး",
        "Cuba": "ကျူးဘား",
        "Ghana": "ဂါနာ",
        "Mongolia": "မွန်ဂိုးလီးယား",
        "Saint Kitts and Nevis": "စိန့်ကစ်နှင့် နီဗစ်",
        "Burkina Faso": "ဘူခင်နာဖာဆို",
        "Nicaragua": "နီကာရာဂွာ",
        "Malaysia": "မလေးရှား",
        "Uruguay": "ဥရုဂွေး",
        "Brunei": "ဘရူနိုင်း",
        "Congo": "ကွန်ဂို",
        "Nauru": "နာဥရူ",
        "Northern Mariana Islands": "မြောက်မာရီအာနာ ကျွန်းစု",
        "Pakistan": "ပါကစ္စတန်",
        "Greenland": "ဂရင်းလန်း",
        "Mauritius": "မော်ရေရှား",
        "Caribbean Netherlands": "ကာရစ်ဘီယံ နယ်သာလန်",
        "Belize": "ဘီလီဇီ",
        "Liechtenstein": "လစ်ခ်တန်စတိန်း",
        "Sierra Leone": "ဆီအဲရာလီယုံ",
        "Czech Republic": "ချက် ပြည်ထောင်စု",
        "Moldova": "မောလ်ဒိုဗာ",
        "Singapore": "စင်္ကာပူ",
        "Belgium": "ဘယ်လ်ဂျီယမ်",
        "Maldives": "မော်လ်ဒိုက်",
        "New Zealand": "နယူးဇီလန်",
        "South Korea": "တောင်ကိုရီးယား",
        "Italy": "အီတလီ",
        "Israel": "အစ္စရေး",
        "Grenada": "ဂရီနေဒါ",
        "Kenya": "ကင်ညာ",
        "St. Helena": "စိန့်ဟယ်လီနာ",
        "Guam": "ဂူအမ်",
        "Denmark": "ဒိန်းမတ်",
        "New Caledonia": "နယူးကယ်လီဒိုးနီးယား",
        "Ecuador": "အီကွေဒေါ",
        "Canada": "ကနေဒါ",
        "Egypt": "အီဂျစ်",
        "Saudi Arabia": "ဆော်ဒီအာရေးဗီးယား",
        "Botswana": "ဘော့စ်ဝါနာ",
        "Turks & Caicos Islands": "တတ်ခ်နှင့် ကေကော့စ်ကျွန်းစု",
        "Latvia": "လတ်ဗီးယား",
        "St. Pierre & Miquelon": "စိန့်ပြီအဲနှင့် မီကွဲလွန်",
        "Georgia": "ဂျော်ဂျီယာ",
        "Laos": "လာအို",
        "Réunion": "ရဲယူနီယံ",
        "Niue": "နီယူအေ",
        "Zimbabwe": "ဇင်ဘာဘွေ",
        "Thailand": "ထိုင်း",
        "Algeria": "အဲလ်ဂျီးရီးယား",
        "Finland": "ဖင်လန်",
        "Macedonia": "မာဆီဒိုးနီးယား",
        "Antigua and Barbuda": "အန်တီဂွါနှင့် ဘာဘူဒါ",
        "Nigeria": "နိုင်ဂျီးရီးယား",
        "Switzerland": "ဆွစ်ဇလန်",
        "Bulgaria": "ဘူဂေးရီးယား",
        "Montenegro": "မွန်တီနီဂရိုး",
        "Tajikistan": "တာဂျီကစ္စတန်",
        "Austria": "ဩစတြီးယား",
        "Bolivia": "ဘိုလီးဗီးယား",
        "Sudan": "ဆူဒန်",
        "Suriname": "ဆူရီနာမ်",
        "Iraq": "အီရတ်",
        "Bahrain": "ဘာရိန်း",
        "Colombia": "ကိုလံဘီယာ",
        "Papua New Guinea": "ပါပူအာ နယူးဂီနီ",
        "Yemen": "ယီမင်",
        "Venezuela": "ဗင်နီဇွဲလား",
        "Djibouti": "ဂျီဘူတီ",
        "British Indian Ocean Territory": "ဗြိတိသျှ အိန္ဒိယသမုဒ္ဒရာ နယ်မြေ",
        "Chad": "ချဒ်",
        "Germany": "ဂျာမနီ",
        "Fiji": "ဖီဂျီ",
        "British Virgin Islands": "ဗြိတိသျှ ဗာဂျင်းကျွန်းစု",
        "San Marino": "ဆန်မာရီနို",
        "Vietnam": "ဗီယက်နမ်",
        "Macau": "မာကာအို",
        "South Africa": "တောင်အာဖရိက",
        "Eritrea": "အီရီထရီးယား",
        "Greece": "ဂရိ",
        "Ethiopia": "အီသီယိုးပီးယား",
        "Madagascar": "မဒါဂတ်စကာ",
        "Marshall Islands": "မာရှယ်ကျွန်းစု",
        "United States": "ယူနိုက်တက်စတိတ်",
        "Benin": "ဘီနင်",
        "El Salvador": "အယ်လ်ဆားဗေးဒိုး",
        "Lebanon": "လက်ဘနွန်",
        "Palestine": "ပါလက်စတိုင်း",
        "Tuvalu": "တူဗာလူ",
        "Solomon Islands": "ဆာလမန် ကျွန်းစု",
        "China": "တရုတ်",
        "Tonga": "တောင်ဂါ"
    },
};
export const ruRU = {
    searchNotFound: "Страна не найдена",
    searchPlaceholder: "Поиск страны",
    countries: {
        "Gibraltar": "Гибралтар",
        "Gambia": "Гамбия",
        "Equatorial Guinea": "Экваториальная Гвинея",
        "Senegal": "Сенегал",
        "Jamaica": "Ямайка",
        "Seychelles": "Сейшельские Острова",
        "Comoros": "Коморы",
        "U.S. Virgin Islands": "Американские Виргинские острова",
        "Guinea": "Гвинея",
        "Niger": "Нигер",
        "Libya": "Ливия",
        "Romania": "Румыния",
        "Anguilla": "Ангилья",
        "Togo": "Того",
        "Paraguay": "Парагвай",
        "India": "Индия",
        "Ireland": "Ирландия",
        "Turkey": "Турция",
        "Oman": "Оман",
        "Ukraine": "Украина",
        "Spain": "Испания",
        "Cameroon": "Камерун",
        "Angola": "Ангола",
        "Mali": "Мали",
        "Saint Vincent and the Grenadines": "Сент-Винсент и Гренадины",
        "Cyprus": "Кипр",
        "Belarus": "Беларусь",
        "Gabon": "Габон",
        "Samoa": "Самоа",
        "Chile": "Чили",
        "United Arab Emirates": "Объединенные Арабские Эмираты",
        "São Tomé and Príncipe": "Сан-Томе и Принсипи",
        "Palau": "Палау",
        "Tokelau": "Токелау",
        "Puerto Rico": "Пуэрто-Рико",
        "Portugal": "Португалия",
        "Costa Rica": "Коста-Рика",
        "Swaziland": "Эсватини",
        "Cape Verde": "Кабо-Верде",
        "Curaçao": "Кюрасао",
        "Andorra": "Андорра",
        "Armenia": "Армения",
        "Haiti": "Гаити",
        "Côte d’Ivoire": "Кот-д’Ивуар",
        "Guinea-Bissau": "Гвинея-Бисау",
        "Mozambique": "Мозамбик",
        "Poland": "Польша",
        "French Polynesia": "Французская Полинезия",
        "Jersey": "Джерси",
        "Kuwait": "Кувейт",
        "Dominican Republic": "Доминиканская Республика",
        "Kosovo": "Косово",
        "Kyrgyzstan": "Киргизия",
        "Syria": "Сирия",
        "Zambia": "Замбия",
        "Croatia": "Хорватия",
        "Lithuania": "Литва",
        "Albania": "Албания",
        "Netherlands": "Нидерланды",
        "France": "Франция",
        "Tunisia": "Тунис",
        "Bosnia and Herzegovina": "Босния и Герцеговина",
        "Bahamas": "Багамы",
        "Somalia": "Сомали",
        "Burundi": "Бурунди",
        "Barbados": "Барбадос",
        "Malawi": "Малави",
        "Honduras": "Гондурас",
        "French Guiana": "Французская Гвиана",
        "Jordan": "Иордания",
        "Serbia": "Сербия",
        "Vanuatu": "Вануату",
        "Aruba": "Аруба",
        "Guyana": "Гайана",
        "Lesotho": "Лесото",
        "Taiwan": "Тайвань",
        "Central African Republic": "Центральноафриканская Республика",
        "Luxembourg": "Люксембург",
        "Trinidad and Tobago": "Тринидад и Тобаго",
        "Estonia": "Эстония",
        "Montserrat": "Монтсеррат",
        "Norway": "Норвегия",
        "North Korea": "Северная Корея",
        "Myanmar": "Мьянма",
        "Sri Lanka": "Шри-Ланка",
        "Faroe Islands": "Фарерские острова",
        "Dominica": "Доминика",
        "Kiribati": "Кирибати",
        "Falkland Islands": "Фолклендские острова",
        "Namibia": "Намибия",
        "Saint Lucia": "Сент-Люсия",
        "Indonesia": "Индонезия",
        "Timor-Leste": "Восточный Тимор",
        "Norfolk Island": "Норфолк",
        "Bhutan": "Бутан",
        "Iran": "Иран",
        "Turkmenistan": "Туркменистан",
        "Uganda": "Уганда",
        "Kazakhstan": "Казахстан",
        "Cook Islands": "Острова Кука",
        "Micronesia": "Микронезия",
        "Sint Maarten": "Синт-Мартен",
        "Liberia": "Либерия",
        "Panama": "Панама",
        "Malta": "Мальта",
        "Peru": "Перу",
        "Philippines": "Филиппины",
        "Rwanda": "Руанда",
        "United Kingdom": "Великобритания",
        "Martinique": "Мартиника",
        "Nepal": "Непал",
        "Guatemala": "Гватемала",
        "Bermuda": "Бермуды",
        "Australia": "Австралия",
        "Vatican City": "Ватикан",
        "Slovenia": "Словения",
        "Cayman Islands": "Каймановы острова",
        "Hungary": "Венгрия",
        "American Samoa": "Американское Самоа",
        "Mauritania": "Мавритания",
        "Japan": "Япония",
        "Uzbekistan": "Узбекистан",
        "Cambodia": "Камбоджа",
        "Wallis & Futuna": "Уоллис и Футуна",
        "South Sudan": "Южный Судан",
        "Morocco": "Марокко",
        "Argentina": "Аргентина",
        "Guadeloupe": "Гваделупа",
        "Hong Kong": "Гонконг",
        "Qatar": "Катар",
        "Tanzania": "Танзания",
        "Mexico": "Мексика",
        "Russia": "Россия",
        "Iceland": "Исландия",
        "Monaco": "Монако",
        "Afghanistan": "Афганистан",
        "Slovakia": "Словакия",
        "Sweden": "Швеция",
        "Azerbaijan": "Азербайджан",
        "Bangladesh": "Бангладеш",
        "Brazil": "Бразилия",
        "Cuba": "Куба",
        "Ghana": "Гана",
        "Mongolia": "Монголия",
        "Saint Kitts and Nevis": "Сент-Китс и Невис",
        "Burkina Faso": "Буркина-Фасо",
        "Nicaragua": "Никарагуа",
        "Malaysia": "Малайзия",
        "Uruguay": "Уругвай",
        "Brunei": "Бруней",
        "Congo": "Конго",
        "Nauru": "Науру",
        "Northern Mariana Islands": "Северные Марианские острова",
        "Pakistan": "Пакистан",
        "Greenland": "Гренландия",
        "Mauritius": "Маврикий",
        "Caribbean Netherlands": "Карибские Нидерланды",
        "Belize": "Белиз",
        "Liechtenstein": "Лихтенштейн",
        "Sierra Leone": "Сьерра-Леоне",
        "Czech Republic": "Чехия",
        "Moldova": "Молдова",
        "Singapore": "Сингапур",
        "Belgium": "Бельгия",
        "Maldives": "Мальдивы",
        "New Zealand": "Новая Зеландия",
        "South Korea": "Южная Корея",
        "Italy": "Италия",
        "Israel": "Израиль",
        "Grenada": "Гренада",
        "Kenya": "Кения",
        "St. Helena": "Остров Святой Елены",
        "Guam": "Гуам",
        "Denmark": "Дания",
        "New Caledonia": "Новая Каледония",
        "Ecuador": "Эквадор",
        "Canada": "Канада",
        "Egypt": "Египет",
        "Saudi Arabia": "Саудовская Аравия",
        "Botswana": "Ботсвана",
        "Turks & Caicos Islands": "Теркс и Кайкос",
        "Latvia": "Латвия",
        "St. Pierre & Miquelon": "Сен-Пьер и Микелон",
        "Georgia": "Грузия",
        "Laos": "Лаос",
        "Réunion": "Реюньон",
        "Niue": "Ниуэ",
        "Zimbabwe": "Зимбабве",
        "Thailand": "Таиланд",
        "Algeria": "Алжир",
        "Finland": "Финляндия",
        "Macedonia": "Македония",
        "Antigua and Barbuda": "Антигуа и Барбуда",
        "Nigeria": "Нигерия",
        "Switzerland": "Швейцария",
        "Bulgaria": "Болгария",
        "Montenegro": "Черногория",
        "Tajikistan": "Таджикистан",
        "Austria": "Австрия",
        "Bolivia": "Боливия",
        "Sudan": "Судан",
        "Suriname": "Суринам",
        "Iraq": "Ирак",
        "Bahrain": "Бахрейн",
        "Colombia": "Колумбия",
        "Papua New Guinea": "Папуа-Новая Гвинея",
        "Yemen": "Йемен",
        "Venezuela": "Венесуэла",
        "Djibouti": "Джибути",
        "British Indian Ocean Territory": "Британская территория в Индийском океане",
        "Chad": "Чад",
        "Germany": "Германия",
        "Fiji": "Фиджи",
        "British Virgin Islands": "Британские Виргинские острова",
        "San Marino": "Сан-Марино",
        "Vietnam": "Вьетнам",
        "Macau": "Макао",
        "South Africa": "Южная Африка",
        "Eritrea": "Эритрея",
        "Greece": "Греция",
        "Ethiopia": "Эфиопия",
        "Madagascar": "Мадагаскар",
        "Marshall Islands": "Маршалловы Острова",
        "United States": "Соединенные Штаты",
        "Benin": "Бенин",
        "El Salvador": "Сальвадор",
        "Lebanon": "Ливан",
        "Palestine": "Палестина",
        "Tuvalu": "Тувалу",
        "Solomon Islands": "Соломоновы Острова",
        "China": "Китай",
        "Tonga": "Тонга"
    },
};
export const idID = {
    searchNotFound: "Negara tidak ditemukan",
    searchPlaceholder: "Cari negara",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Guinea Khatulistiwa",
        "Senegal": "Senegal",
        "Jamaica": "Jamaika",
        "Seychelles": "Seychelles",
        "Comoros": "Komoro",
        "U.S. Virgin Islands": "Kepulauan Virgin Amerika Serikat",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libya",
        "Romania": "Rumania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Irlandia",
        "Turkey": "Turki",
        "Oman": "Oman",
        "Ukraine": "Ukraina",
        "Spain": "Spanyol",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent dan Grenadines",
        "Cyprus": "Siprus",
        "Belarus": "Belarus",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chili",
        "United Arab Emirates": "Uni Emirat Arab",
        "São Tomé and Príncipe": "Sao Tome dan Principe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Kosta Rika",
        "Swaziland": "Eswatini",
        "Cape Verde": "Tanjung Verde",
        "Curaçao": "Curacao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Pantai Gading",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mozambik",
        "Poland": "Polandia",
        "French Polynesia": "Polinesia Prancis",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Republik Dominika",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgizstan",
        "Syria": "Suriah",
        "Zambia": "Zambia",
        "Croatia": "Kroasia",
        "Lithuania": "Lithuania",
        "Albania": "Albania",
        "Netherlands": "Belanda",
        "France": "Prancis",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia dan Herzegovina",
        "Bahamas": "Bahama",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Guyana Prancis",
        "Jordan": "Yordania",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Republik Afrika Tengah",
        "Luxembourg": "Luksemburg",
        "Trinidad and Tobago": "Trinidad dan Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Norwegia",
        "North Korea": "Korea Utara",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Kepulauan Faroe",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Kepulauan Falkland",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Timor-Leste",
        "Norfolk Island": "Pulau Norfolk",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Kepulauan Cook",
        "Micronesia": "Mikronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipina",
        "Rwanda": "Rwanda",
        "United Kingdom": "Inggris Raya",
        "Martinique": "Martinik",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australia",
        "Vatican City": "Vatikan",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Kepulauan Cayman",
        "Hungary": "Hongaria",
        "American Samoa": "Samoa Amerika",
        "Mauritania": "Mauritania",
        "Japan": "Jepang",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kamboja",
        "Wallis & Futuna": "Wallis dan Futuna",
        "South Sudan": "Sudan Selatan",
        "Morocco": "Maroko",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Meksiko",
        "Russia": "Rusia",
        "Iceland": "Islandia",
        "Monaco": "Monako",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovakia",
        "Sweden": "Swedia",
        "Azerbaijan": "Azerbaijan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasil",
        "Cuba": "Kuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts dan Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nikaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Kepulauan Mariana Utara",
        "Pakistan": "Pakistan",
        "Greenland": "Greenland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Belanda Karibia",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Republik Ceko",
        "Moldova": "Moldova",
        "Singapore": "Singapura",
        "Belgium": "Belgia",
        "Maldives": "Maladewa",
        "New Zealand": "Selandia Baru",
        "South Korea": "Korea Selatan",
        "Italy": "Italia",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Saint Helena",
        "Guam": "Guam",
        "Denmark": "Denmark",
        "New Caledonia": "Kaledonia Baru",
        "Ecuador": "Ekuador",
        "Canada": "Kanada",
        "Egypt": "Mesir",
        "Saudi Arabia": "Arab Saudi",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Kepulauan Turks dan Caicos",
        "Latvia": "Latvia",
        "St. Pierre & Miquelon": "Saint Pierre dan Miquelon",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Reunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Aljazair",
        "Finland": "Finlandia",
        "Macedonia": "Makedonia",
        "Antigua and Barbuda": "Antigua dan Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Swiss",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tajikistan",
        "Austria": "Austria",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Suriname",
        "Iraq": "Irak",
        "Bahrain": "Bahrain",
        "Colombia": "Kolombia",
        "Papua New Guinea": "Papua Nugini",
        "Yemen": "Yaman",
        "Venezuela": "Venezuela",
        "Djibouti": "Jibuti",
        "British Indian Ocean Territory": "Wilayah Samudra Hindia Britania",
        "Chad": "Chad",
        "Germany": "Jerman",
        "Fiji": "Fiji",
        "British Virgin Islands": "Kepulauan Virgin Britania Raya",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Makau",
        "South Africa": "Afrika Selatan",
        "Eritrea": "Eritrea",
        "Greece": "Yunani",
        "Ethiopia": "Etiopia",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Kepulauan Marshall",
        "United States": "Amerika Serikat",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Lebanon",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Kepulauan Solomon",
        "China": "Cina",
        "Tonga": "Tonga"
    },
};
export const faIR = {
    searchNotFound: "کشوری پیدا نشد",
    searchPlaceholder: "جستجوی کشور",
    countries: {
        "Gibraltar": "جبل‌الطارق",
        "Gambia": "گامبیا",
        "Equatorial Guinea": "گینه استوایی",
        "Senegal": "سنگال",
        "Jamaica": "جامائیکا",
        "Seychelles": "سیشل",
        "Comoros": "کومور",
        "U.S. Virgin Islands": "جزایر ویرجین ایالات متحده",
        "Guinea": "گینه",
        "Niger": "نیجر",
        "Libya": "لیبی",
        "Romania": "رومانی",
        "Anguilla": "آنگویلا",
        "Togo": "توگو",
        "Paraguay": "پاراگوئه",
        "India": "هند",
        "Ireland": "ایرلند",
        "Turkey": "ترکیه",
        "Oman": "عمان",
        "Ukraine": "اوکراین",
        "Spain": "اسپانیا",
        "Cameroon": "کامرون",
        "Angola": "آنگولا",
        "Mali": "مالی",
        "Saint Vincent and the Grenadines": "سنت وینسنت و گرنادین‌ها",
        "Cyprus": "قبرس",
        "Belarus": "بلاروس",
        "Gabon": "گابن",
        "Samoa": "ساموآ",
        "Chile": "شیلی",
        "United Arab Emirates": "امارات متحده عربی",
        "São Tomé and Príncipe": "سائوتومه و پرنسیپ",
        "Palau": "پالائو",
        "Tokelau": "توکلائو",
        "Puerto Rico": "پورتوریکو",
        "Portugal": "پرتغال",
        "Costa Rica": "کاستاریکا",
        "Swaziland": "اسواتینی",
        "Cape Verde": "کیپ ورد",
        "Curaçao": "کوراسائو",
        "Andorra": "آندورا",
        "Armenia": "ارمنستان",
        "Haiti": "هائیتی",
        "Côte d’Ivoire": "ساحل عاج",
        "Guinea-Bissau": "گینه بیسائو",
        "Mozambique": "موزامبیک",
        "Poland": "لهستان",
        "French Polynesia": "پلی‌نزی فرانسه",
        "Jersey": "جرزی",
        "Kuwait": "کویت",
        "Dominican Republic": "جمهوری دومینیکن",
        "Kosovo": "کوزوو",
        "Kyrgyzstan": "قرقیزستان",
        "Syria": "سوریه",
        "Zambia": "زامبیا",
        "Croatia": "کرواسی",
        "Lithuania": "لیتوانی",
        "Albania": "آلبانی",
        "Netherlands": "هلند",
        "France": "فرانسه",
        "Tunisia": "تونس",
        "Bosnia and Herzegovina": "بوسنی و هرزگوین",
        "Bahamas": "باهاما",
        "Somalia": "سومالی",
        "Burundi": "بوروندی",
        "Barbados": "باربادوس",
        "Malawi": "مالاوی",
        "Honduras": "هندوراس",
        "French Guiana": "گویان فرانسه",
        "Jordan": "اردن",
        "Serbia": "صربستان",
        "Vanuatu": "وانواتو",
        "Aruba": "آروبا",
        "Guyana": "گویان",
        "Lesotho": "لسوتو",
        "Taiwan": "تایوان",
        "Central African Republic": "جمهوری آفریقای مرکزی",
        "Luxembourg": "لوکزامبورگ",
        "Trinidad and Tobago": "ترینیداد و توباگو",
        "Estonia": "استونی",
        "Montserrat": "مونتسرات",
        "Norway": "نروژ",
        "North Korea": "کره شمالی",
        "Myanmar": "میانمار",
        "Sri Lanka": "سری‌لانکا",
        "Faroe Islands": "جزایر فارو",
        "Dominica": "دومینیکا",
        "Kiribati": "کیریباتی",
        "Falkland Islands": "جزایر فالکلند",
        "Namibia": "نامیبیا",
        "Saint Lucia": "سنت لوسیا",
        "Indonesia": "اندونزی",
        "Timor-Leste": "تیمور شرقی",
        "Norfolk Island": "جزیره نورفولک",
        "Bhutan": "بوتان",
        "Iran": "ایران",
        "Turkmenistan": "ترکمنستان",
        "Uganda": "اوگاندا",
        "Kazakhstan": "قزاقستان",
        "Cook Islands": "جزایر کوک",
        "Micronesia": "میکرونزی",
        "Sint Maarten": "سینت مارتن",
        "Liberia": "لیبریا",
        "Panama": "پاناما",
        "Malta": "مالت",
        "Peru": "پرو",
        "Philippines": "فیلیپین",
        "Rwanda": "رواندا",
        "United Kingdom": "بریتانیا",
        "Martinique": "مارتینیک",
        "Nepal": "نپال",
        "Guatemala": "گواتمالا",
        "Bermuda": "برمودا",
        "Australia": "استرالیا",
        "Vatican City": "واتیکان",
        "Slovenia": "اسلوونی",
        "Cayman Islands": "جزایر کیمن",
        "Hungary": "مجارستان",
        "American Samoa": "ساموآی آمریکا",
        "Mauritania": "موریتانی",
        "Japan": "ژاپن",
        "Uzbekistan": "ازبکستان",
        "Cambodia": "کامبوج",
        "Wallis & Futuna": "والیس و فوتونا",
        "South Sudan": "سودان جنوبی",
        "Morocco": "مراکش",
        "Argentina": "آرژانتین",
        "Guadeloupe": "گوادلوپ",
        "Hong Kong": "هنگ کنگ",
        "Qatar": "قطر",
        "Tanzania": "تانزانیا",
        "Mexico": "مکزیک",
        "Russia": "روسیه",
        "Iceland": "ایسلند",
        "Monaco": "موناکو",
        "Afghanistan": "افغانستان",
        "Slovakia": "اسلواکی",
        "Sweden": "سوئد",
        "Azerbaijan": "جمهوری آذربایجان",
        "Bangladesh": "بنگلادش",
        "Brazil": "برزیل",
        "Cuba": "کوبا",
        "Ghana": "غنا",
        "Mongolia": "مغولستان",
        "Saint Kitts and Nevis": "سنت کیتس و نویس",
        "Burkina Faso": "بورکینافاسو",
        "Nicaragua": "نیکاراگوئه",
        "Malaysia": "مالزی",
        "Uruguay": "اروگوئه",
        "Brunei": "برونئی",
        "Congo": "کنگو",
        "Nauru": "نائورو",
        "Northern Mariana Islands": "جزایر ماریانای شمالی",
        "Pakistan": "پاکستان",
        "Greenland": "گرینلند",
        "Mauritius": "موریس",
        "Caribbean Netherlands": "هلند کارائیب",
        "Belize": "بلیز",
        "Liechtenstein": "لیختن‌اشتاین",
        "Sierra Leone": "سیرالئون",
        "Czech Republic": "جمهوری چک",
        "Moldova": "مولداوی",
        "Singapore": "سنگاپور",
        "Belgium": "بلژیک",
        "Maldives": "مالدیو",
        "New Zealand": "نیوزیلند",
        "South Korea": "کره جنوبی",
        "Italy": "ایتالیا",
        "Israel": "اسرائیل",
        "Grenada": "گرنادا",
        "Kenya": "کنیا",
        "St. Helena": "سنت هلنا",
        "Guam": "گوام",
        "Denmark": "دانمارک",
        "New Caledonia": "کالدونیای جدید",
        "Ecuador": "اکوادور",
        "Canada": "کانادا",
        "Egypt": "مصر",
        "Saudi Arabia": "عربستان سعودی",
        "Botswana": "بوتسوانا",
        "Turks & Caicos Islands": "جزایر تورکس و کایکوس",
        "Latvia": "لتونی",
        "St. Pierre & Miquelon": "سن-پیر و میکلن",
        "Georgia": "گرجستان",
        "Laos": "لائوس",
        "Réunion": "ریونیون",
        "Niue": "نیووه",
        "Zimbabwe": "زیمبابوه",
        "Thailand": "تایلند",
        "Algeria": "الجزایر",
        "Finland": "فنلاند",
        "Macedonia": "مقدونیه",
        "Antigua and Barbuda": "آنتیگوا و باربودا",
        "Nigeria": "نیجریه",
        "Switzerland": "سوئیس",
        "Bulgaria": "بلغارستان",
        "Montenegro": "مونته‌نگرو",
        "Tajikistan": "تاجیکستان",
        "Austria": "اتریش",
        "Bolivia": "بولیوی",
        "Sudan": "سودان",
        "Suriname": "سورینام",
        "Iraq": "عراق",
        "Bahrain": "بحرین",
        "Colombia": "کلمبیا",
        "Papua New Guinea": "پاپوآ گینه نو",
        "Yemen": "یمن",
        "Venezuela": "ونزوئلا",
        "Djibouti": "جیبوتی",
        "British Indian Ocean Territory": "قلمرو اقیانوس هند بریتانیا",
        "Chad": "چاد",
        "Germany": "آلمان",
        "Fiji": "فیجی",
        "British Virgin Islands": "جزایر ویرجین بریتانیا",
        "San Marino": "سان مارینو",
        "Vietnam": "ویتنام",
        "Macau": "ماکائو",
        "South Africa": "آفریقای جنوبی",
        "Eritrea": "اریتره",
        "Greece": "یونان",
        "Ethiopia": "اتیوپی",
        "Madagascar": "ماداگاسکار",
        "Marshall Islands": "جزایر مارشال",
        "United States": "ایالات متحده",
        "Benin": "بنین",
        "El Salvador": "السالوادور",
        "Lebanon": "لبنان",
        "Palestine": "فلسطین",
        "Tuvalu": "تووالو",
        "Solomon Islands": "جزایر سلیمان",
        "China": "چین",
        "Tonga": "تونگا"
    },
};
export const frCA = {
    searchNotFound: "Aucun pays trouvé",
    searchPlaceholder: "Rechercher un pays",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambie",
        "Equatorial Guinea": "Guinée équatoriale",
        "Senegal": "Sénégal",
        "Jamaica": "Jamaïque",
        "Seychelles": "Seychelles",
        "Comoros": "Comores",
        "U.S. Virgin Islands": "Îles Vierges des États-Unis",
        "Guinea": "Guinée",
        "Niger": "Niger",
        "Libya": "Libye",
        "Romania": "Roumanie",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Inde",
        "Ireland": "Irlande",
        "Turkey": "Turquie",
        "Oman": "Oman",
        "Ukraine": "Ukraine",
        "Spain": "Espagne",
        "Cameroon": "Cameroun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint-Vincent-et-les-Grenadines",
        "Cyprus": "Chypre",
        "Belarus": "Biélorussie",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chili",
        "United Arab Emirates": "Émirats arabes unis",
        "São Tomé and Príncipe": "Sao Tomé-et-Principe",
        "Palau": "Palaos",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Porto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cap-Vert",
        "Curaçao": "Curaçao",
        "Andorra": "Andorre",
        "Armenia": "Arménie",
        "Haiti": "Haïti",
        "Côte d’Ivoire": "Côte d’Ivoire",
        "Guinea-Bissau": "Guinée-Bissau",
        "Mozambique": "Mozambique",
        "Poland": "Pologne",
        "French Polynesia": "Polynésie française",
        "Jersey": "Jersey",
        "Kuwait": "Koweït",
        "Dominican Republic": "République dominicaine",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirghizistan",
        "Syria": "Syrie",
        "Zambia": "Zambie",
        "Croatia": "Croatie",
        "Lithuania": "Lituanie",
        "Albania": "Albanie",
        "Netherlands": "Pays-Bas",
        "France": "France",
        "Tunisia": "Tunisie",
        "Bosnia and Herzegovina": "Bosnie-Herzégovine",
        "Bahamas": "Bahamas",
        "Somalia": "Somalie",
        "Burundi": "Burundi",
        "Barbados": "Barbade",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Guyane française",
        "Jordan": "Jordanie",
        "Serbia": "Serbie",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taïwan",
        "Central African Republic": "République centrafricaine",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinité-et-Tobago",
        "Estonia": "Estonie",
        "Montserrat": "Montserrat",
        "Norway": "Norvège",
        "North Korea": "Corée du Nord",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Îles Féroé",
        "Dominica": "Dominique",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Îles Malouines",
        "Namibia": "Namibie",
        "Saint Lucia": "Sainte-Lucie",
        "Indonesia": "Indonésie",
        "Timor-Leste": "Timor-Leste",
        "Norfolk Island": "Île Norfolk",
        "Bhutan": "Bhoutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkménistan",
        "Uganda": "Ouganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Îles Cook",
        "Micronesia": "Micronésie",
        "Sint Maarten": "Saint-Martin",
        "Liberia": "Libéria",
        "Panama": "Panama",
        "Malta": "Malte",
        "Peru": "Pérou",
        "Philippines": "Philippines",
        "Rwanda": "Rwanda",
        "United Kingdom": "Royaume-Uni",
        "Martinique": "Martinique",
        "Nepal": "Népal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermudes",
        "Australia": "Australie",
        "Vatican City": "Vatican",
        "Slovenia": "Slovénie",
        "Cayman Islands": "Îles Caïmans",
        "Hungary": "Hongrie",
        "American Samoa": "Samoa américaines",
        "Mauritania": "Mauritanie",
        "Japan": "Japon",
        "Uzbekistan": "Ouzbékistan",
        "Cambodia": "Cambodge",
        "Wallis & Futuna": "Wallis-et-Futuna",
        "South Sudan": "Soudan du Sud",
        "Morocco": "Maroc",
        "Argentina": "Argentine",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzanie",
        "Mexico": "Mexique",
        "Russia": "Russie",
        "Iceland": "Islande",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovaquie",
        "Sweden": "Suède",
        "Azerbaijan": "Azerbaïdjan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brésil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolie",
        "Saint Kitts and Nevis": "Saint-Christophe-et-Niévès",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaisie",
        "Uruguay": "Uruguay",
        "Brunei": "Brunéi",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Îles Mariannes du Nord",
        "Pakistan": "Pakistan",
        "Greenland": "Groenland",
        "Mauritius": "Maurice",
        "Caribbean Netherlands": "Pays-Bas caribéens",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "République tchèque",
        "Moldova": "Moldavie",
        "Singapore": "Singapour",
        "Belgium": "Belgique",
        "Maldives": "Maldives",
        "New Zealand": "Nouvelle-Zélande",
        "South Korea": "Corée du Sud",
        "Italy": "Italie",
        "Israel": "Israël",
        "Grenada": "Grenade",
        "Kenya": "Kenya",
        "St. Helena": "Sainte-Hélène",
        "Guam": "Guam",
        "Denmark": "Danemark",
        "New Caledonia": "Nouvelle-Calédonie",
        "Ecuador": "Équateur",
        "Canada": "Canada",
        "Egypt": "Égypte",
        "Saudi Arabia": "Arabie saoudite",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Îles Turques-et-Caïques",
        "Latvia": "Lettonie",
        "St. Pierre & Miquelon": "Saint-Pierre-et-Miquelon",
        "Georgia": "Géorgie",
        "Laos": "Laos",
        "Réunion": "La Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thaïlande",
        "Algeria": "Algérie",
        "Finland": "Finlande",
        "Macedonia": "Macédoine",
        "Antigua and Barbuda": "Antigua-et-Barbuda",
        "Nigeria": "Nigéria",
        "Switzerland": "Suisse",
        "Bulgaria": "Bulgarie",
        "Montenegro": "Monténégro",
        "Tajikistan": "Tadjikistan",
        "Austria": "Autriche",
        "Bolivia": "Bolivie",
        "Sudan": "Soudan",
        "Suriname": "Suriname",
        "Iraq": "Irak",
        "Bahrain": "Bahreïn",
        "Colombia": "Colombie",
        "Papua New Guinea": "Papouasie-Nouvelle-Guinée",
        "Yemen": "Yémen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Territoire britannique de l'océan Indien",
        "Chad": "Tchad",
        "Germany": "Allemagne",
        "Fiji": "Fidji",
        "British Virgin Islands": "Îles Vierges britanniques",
        "San Marino": "Saint-Marin",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Afrique du Sud",
        "Eritrea": "Érythrée",
        "Greece": "Grèce",
        "Ethiopia": "Éthiopie",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Îles Marshall",
        "United States": "États-Unis",
        "Benin": "Bénin",
        "El Salvador": "Salvador",
        "Lebanon": "Liban",
        "Palestine": "Palestine",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Îles Salomon",
        "China": "Chine",
        "Tonga": "Tonga"
    },
};
export const mlIN = {
    searchNotFound: "രാജ്യം കണ്ടെത്തിയില്ല",
    searchPlaceholder: "രാജ്യം തിരയുക",
    countries: {
        "Gibraltar": "ജിബ്രാൾട്ടർ",
        "Gambia": "ഗാംബിയ",
        "Equatorial Guinea": "ഇക്വറ്റോറിയൽ ഗിനിയ",
        "Senegal": "സെനഗൽ",
        "Jamaica": "ജമൈക്ക",
        "Seychelles": "സെയ്ഷെൽസ്",
        "Comoros": "കോമറോസ്",
        "U.S. Virgin Islands": "യു.എസ്. വെർജിൻ ദ്വീപുകൾ",
        "Guinea": "ഗിനിയ",
        "Niger": "നൈജർ",
        "Libya": "ലിബിയ",
        "Romania": "റൊമാനിയ",
        "Anguilla": "ആൻഗ്വില്ല",
        "Togo": "ടോഗോ",
        "Paraguay": "പരാഗ്വേ",
        "India": "ഇന്ത്യ",
        "Ireland": "അയർലൻഡ്",
        "Turkey": "ടർക്കി",
        "Oman": "ഒമാൻ",
        "Ukraine": "ഉക്രൈൻ",
        "Spain": "സ്പെയിൻ",
        "Cameroon": "കാമറൂൺ",
        "Angola": "അംഗോള",
        "Mali": "മാലി",
        "Saint Vincent and the Grenadines": "സെയിന്റ് വിന്സെന്റ് & ഗ്രനഡൈൻസ്",
        "Cyprus": "സൈപ്രസ്",
        "Belarus": "ബെലറൂസ്",
        "Gabon": "ഗാബോൺ",
        "Samoa": "സാമോവ",
        "Chile": "ചിലി",
        "United Arab Emirates": "യുനൈറ്റഡ് അറബ് എമിറേറ്റ്സ്",
        "São Tomé and Príncipe": "സാവോ ടോമെ & പ്രിൻസിപി",
        "Palau": "പാലാവു",
        "Tokelau": "ടോക്കെലോ",
        "Puerto Rico": "പ്യുറ്ടോ റിക്കോ",
        "Portugal": "പോർച്ചുഗൽ",
        "Costa Rica": "കോസ്റ്റാ റിക്ക",
        "Swaziland": "സ്വാസിലാൻഡ്",
        "Cape Verde": "കേപ്പ് വെർഡെ",
        "Curaçao": "കുറാകാവോ",
        "Andorra": "അൻഡോറ",
        "Armenia": "ആർമേനിയ",
        "Haiti": "ഹൈത്തി",
        "Côte d’Ivoire": "ഐവറി കോസ്റ്റ്",
        "Guinea-Bissau": "ഗിനിയ-ബിസ്സാവു",
        "Mozambique": "മോസാംബിക്ക്",
        "Poland": "പോളണ്ട്",
        "French Polynesia": "ഫ്രഞ്ച് പോളിനേഷ്യ",
        "Jersey": "ജേഴ്‌സി",
        "Kuwait": "കുവൈത്ത്",
        "Dominican Republic": "ഡൊമിനിക്കൻ റിപ്പബ്ലിക്",
        "Kosovo": "കൊസോവോ",
        "Kyrgyzstan": "കിർഗിസ്ഥാൻ",
        "Syria": "സിറിയ",
        "Zambia": "സാംബിയ",
        "Croatia": "ക്രൊയേഷ്യ",
        "Lithuania": "ലിത്വാനിയ",
        "Albania": "അൽബാനിയ",
        "Netherlands": "നെതർലൻഡ്സ്",
        "France": "ഫ്രാൻസ്",
        "Tunisia": "ടുണീഷ്യ",
        "Bosnia and Herzegovina": "ബോസ്നിയ & ഹെർസഗോവിന",
        "Bahamas": "ബഹാമാസ്",
        "Somalia": "സോമാലിയ",
        "Burundi": "ബുരുണ്ടി",
        "Barbados": "ബാർബഡോസ്",
        "Malawi": "മലാവി",
        "Honduras": "ഹോണ്ടുറാസ്",
        "French Guiana": "ഫ്രഞ്ച് ഗയാന",
        "Jordan": "ജോർദ്ദാൻ",
        "Serbia": "സെർബിയ",
        "Vanuatu": "വന്വാതു",
        "Aruba": "അറുബ",
        "Guyana": "ഗയാന",
        "Lesotho": "ലെസോതോ",
        "Taiwan": "ടൈവാൻ",
        "Central African Republic": "സെൻട്രൽ ആഫ്രിക്കൻ റിപ്പബ്ലിക്",
        "Luxembourg": "ലക്സംബർഗ്",
        "Trinidad and Tobago": "ട്രിനിഡാഡ് & ടുബാഗോ",
        "Estonia": "എസ്റ്റോണിയ",
        "Montserrat": "മോണ്ട്സെറാറ്റ്",
        "Norway": "നോർവേ",
        "North Korea": "നോർത്ത് കൊറിയ",
        "Myanmar": "മ്യാൻമാർ",
        "Sri Lanka": "ശ്രീലങ്ക",
        "Faroe Islands": "ഫാറോ ദ്വീപുകൾ",
        "Dominica": "ഡൊമിനിക്ക",
        "Kiribati": "കിരിബാറ്റി",
        "Falkland Islands": "ഫാക്ക്ലൻഡ് ദ്വീപുകൾ",
        "Namibia": "നമീബിയ",
        "Saint Lucia": "സെയിന്റ് ലൂസിയ",
        "Indonesia": "ഇൻഡോനേഷ്യ",
        "Timor-Leste": "ടിമോർ-ലെസ്റ്റെ",
        "Norfolk Island": "നോർഫോക് ദ്വീപ്",
        "Bhutan": "ഭൂട്ടാൻ",
        "Iran": "ഇറാൻ",
        "Turkmenistan": "തുര്‍kmenistan",
        "Uganda": "ഉഗാണ്ട",
        "Kazakhstan": "കസാഖിസ്ഥാൻ",
        "Cook Islands": "കുക്ക് ദ്വീപുകൾ",
        "Micronesia": "മൈക്രോണേഷ്യ",
        "Sint Maarten": "സിന്റ് മാർട്ടൻ",
        "Liberia": "ലൈബീരിയ",
        "Panama": "പനാമ",
        "Malta": "മാൾട്ട",
        "Peru": "പെറു",
        "Philippines": "ഫിലിപ്പീൻസ്",
        "Rwanda": "റുവാണ്ട",
        "United Kingdom": "യുണൈറ്റഡ് കിംഗ്‌ഡം",
        "Martinique": "മാർട്ടിനിക്ക്",
        "Nepal": "നേപ്പാൾ",
        "Guatemala": "ഗ്വാട്ടിമാല",
        "Bermuda": "ബർമുഡ",
        "Australia": "ഓസ്ട്രേലിയ",
        "Vatican City": "വത്തിക്കാൻ സിറ്റി",
        "Slovenia": "സ്ലോവേനിയ",
        "Cayman Islands": "കെയ്‌മാൻ ദ്വീപുകൾ",
        "Hungary": "ഹംഗറി",
        "American Samoa": "അമേരിക്കൻ സാമോവ",
        "Mauritania": "മൗറിറ്റാനിയ",
        "Japan": "ജപ്പാൻ",
        "Uzbekistan": "ഉസ്ബെക്കിസ്ഥാൻ",
        "Cambodia": "കംബോഡിയ",
        "Wallis & Futuna": "വാലിസ് & ഫ്യൂച്ചൂന",
        "South Sudan": "ദക്ഷിണ സൂഡാൻ",
        "Morocco": "മൊറോക്കോ",
        "Argentina": "അർജന്റീന",
        "Guadeloupe": "ഗ്വാഡലൂപ്",
        "Hong Kong": "ഹോങ്കോംഗ്",
        "Qatar": "ഖത്തർ",
        "Tanzania": "ടാൻസാനിയ",
        "Mexico": "മെക്സിക്കോ",
        "Russia": "റഷ്യ",
        "Iceland": "ഐസ്‌ലാന്റ്",
        "Monaco": "മൊണാകോ",
        "Afghanistan": "അഫ്ഗാനിസ്ഥാൻ",
        "Slovakia": "സ്ലോവാക്യ",
        "Sweden": "സ്വീഡൻ",
        "Azerbaijan": "അസർബൈജാൻ",
        "Bangladesh": "ബംഗ്ലാദേശ്",
        "Brazil": "ബ്രസീൽ",
        "Cuba": "ക്യൂബ",
        "Ghana": "ഘാന",
        "Mongolia": "മംഗോളിയ",
        "Saint Kitts and Nevis": "സെയിന്റ് കിറ്റ്‌സ് & നെവിസ്",
        "Burkina Faso": "ബുര്‍കിന ഫാസോ",
        "Nicaragua": "നിക്കാരാഗ്വ",
        "Malaysia": "മലേഷ്യ",
        "Uruguay": "ഉറുഗ്വേ",
        "Brunei": "ബ്രൂണൈ",
        "Congo": "കോംഗോ",
        "Nauru": "നൗറൂ",
        "Northern Mariana Islands": "നോർത്ത് മരിയാന ദ്വീപുകൾ",
        "Pakistan": "പാക്കിസ്ഥാൻ",
        "Greenland": "ഗ്രീൻലാൻഡ്",
        "Mauritius": "മൗറീഷ്യസ്",
        "Caribbean Netherlands": "കരീബിയൻ നെതർലാൻഡ്സ്",
        "Belize": "ബെലീസ്",
        "Liechtenstein": "ലിക്ടൻസ്റ്റെയിൻ",
        "Sierra Leone": "സിയറ ലിയോൺ",
        "Czech Republic": "ചെക്ക് റിപ്പബ്ലിക്",
        "Moldova": "മോൾഡോവ",
        "Singapore": "സിംഗപ്പൂർ",
        "Belgium": "ബെൽജിയം",
        "Maldives": "മാലിദ്വീപ്",
        "New Zealand": "ന്യൂസിലാൻഡ്",
        "South Korea": "ദക്ഷിണ കൊറിയ",
        "Italy": "ഇറ്റലി",
        "Israel": "ഇസ്രായേൽ",
        "Grenada": "ഗ്രെനേഡ",
        "Kenya": "കീന്യ",
        "St. Helena": "സെന്റ് ഹെലേന",
        "Guam": "ഗുവാം",
        "Denmark": "ഡെൻമാർക്ക്",
        "New Caledonia": "ന്യൂ കാലിഡോണിയ",
        "Ecuador": "ഇക്വഡോർ",
        "Canada": "കനഡ",
        "Egypt": "ഈജിപ്ത്",
        "Saudi Arabia": "സൗദി അറേബ്യ",
        "Botswana": "ബോട്ട്സ്വാന",
        "Turks & Caicos Islands": "ടർക്ക്സ് & കൈകോസ് ദ്വീപുകൾ",
        "Latvia": "ലാത്വിയ",
        "St. Pierre & Miquelon": "സെന്റ് പിയറേ & മിക്കലോൺ",
        "Georgia": "ജോർജിയ",
        "Laos": "ലാവോസ്",
        "Réunion": "റീയൂണിയൻ",
        "Niue": "നിയൂവ",
        "Zimbabwe": "സിംബാബ്‌വേ",
        "Thailand": "തായ്ലാന്റ്",
        "Algeria": "അൾജീരിയ",
        "Finland": "ഫിൻലാന്റ്",
        "Macedonia": "മാസിഡോണിയ",
        "Antigua and Barbuda": "ആന്റിഗ്വ & ബാർബുഡ",
        "Nigeria": "നൈജീരിയ",
        "Switzerland": "സ്വിറ്റ്സർലാൻഡ്",
        "Bulgaria": "ബൾഗേറിയ",
        "Montenegro": "മോണ്ടെനേഗ്രോ",
        "Tajikistan": "താജിക്കിസ്ഥാൻ",
        "Austria": "ഓസ്ട്രിയ",
        "Bolivia": "ബൊളീവിയ",
        "Sudan": "സൂഡാൻ",
        "Suriname": "സുറിനാം",
        "Iraq": "ഇറാക്ക്",
        "Bahrain": "ബഹ്റൈൻ",
        "Colombia": "കൊളംബിയ",
        "Papua New Guinea": "പാപുവ ന്യൂ ഗിനിയ",
        "Yemen": "യെമൻ",
        "Venezuela": "വെനസ്വേല",
        "Djibouti": "ജിബൗട്ടി",
        "British Indian Ocean Territory": "ബ്രിട്ടീഷ് ഇന്ത്യൻ മഹാസമുദ്ര പ്രദേശം",
        "Chad": "ചാദ്",
        "Germany": "ജർമനി",
        "Fiji": "ഫിജി",
        "British Virgin Islands": "ബ്രിട്ടീഷ് വെർജിൻ ദ്വീപുകൾ",
        "San Marino": "സാൻ മറിനോ",
        "Vietnam": "വിയറ്റ്നാം",
        "Macau": "മകാവോ",
        "South Africa": "ദക്ഷിണാഫ്രിക്ക",
        "Eritrea": "എറിത്രിയ",
        "Greece": "ഗ്രീസ്",
        "Ethiopia": "എത്യോപ്യ",
        "Madagascar": "മഡഗാസ്കർ",
        "Marshall Islands": "മാർഷൽ ദ്വീപുകൾ",
        "United States": "യുണൈറ്റഡ് സ്റ്റേറ്റ്സ്",
        "Benin": "ബെനിൻ",
        "El Salvador": "എൽ സാൽവഡോർ",
        "Lebanon": "ലെബനൻ",
        "Palestine": "പാലസ്തീൻ",
        "Tuvalu": "ടുവാലൂ",
        "Solomon Islands": "സോളമൻ ദ്വീപുകൾ",
        "China": "ചൈന",
        "Tonga": "ടോംഗ"
    },
};
export const thTH = {
    searchNotFound: "ไม่พบประเทศ",
    searchPlaceholder: "ค้นหาประเทศ",
    countries: {
        "Gibraltar": "ยิบรอลตาร์",
        "Gambia": "แกมเบีย",
        "Equatorial Guinea": "อิเควทอเรียลกินี",
        "Senegal": "เซเนกัล",
        "Jamaica": "จาเมกา",
        "Seychelles": "เซเชลส์",
        "Comoros": "คอโมโรส",
        "U.S. Virgin Islands": "หมู่เกาะเวอร์จินของสหรัฐ",
        "Guinea": "กินี",
        "Niger": "ไนเจอร์",
        "Libya": "ลิเบีย",
        "Romania": "โรมาเนีย",
        "Anguilla": "แองกวิลลา",
        "Togo": "โตโก",
        "Paraguay": "ปารากวัย",
        "India": "อินเดีย",
        "Ireland": "ไอร์แลนด์",
        "Turkey": "ตุรกี",
        "Oman": "โอมาน",
        "Ukraine": "ยูเครน",
        "Spain": "สเปน",
        "Cameroon": "แคเมอรูน",
        "Angola": "แองโกลา",
        "Mali": "มาลี",
        "Saint Vincent and the Grenadines": "เซนต์วินเซนต์และเกรนาดีนส์",
        "Cyprus": "ไซปรัส",
        "Belarus": "เบลารุส",
        "Gabon": "กาบอง",
        "Samoa": "ซามัว",
        "Chile": "ชิลี",
        "United Arab Emirates": "สหรัฐอาหรับเอมิเรตส์",
        "São Tomé and Príncipe": "เซาตูเมและปรินซิปี",
        "Palau": "ปาเลา",
        "Tokelau": "โตเกเลา",
        "Puerto Rico": "เปอร์โตริโก",
        "Portugal": "โปรตุเกส",
        "Costa Rica": "คอสตาริกา",
        "Swaziland": "เอสวาตินี",
        "Cape Verde": "เคปเวิร์ด",
        "Curaçao": "คูราเซา",
        "Andorra": "อันดอร์รา",
        "Armenia": "อาร์เมเนีย",
        "Haiti": "เฮติ",
        "Côte d’Ivoire": "โกตดิวัวร์",
        "Guinea-Bissau": "กินี-บิสเซา",
        "Mozambique": "โมซัมบิก",
        "Poland": "โปแลนด์",
        "French Polynesia": "เฟรนช์โปลินีเซีย",
        "Jersey": "เจอร์ซีย์",
        "Kuwait": "คูเวต",
        "Dominican Republic": "สาธารณรัฐโดมินิกัน",
        "Kosovo": "โคโซโว",
        "Kyrgyzstan": "คีร์กีซสถาน",
        "Syria": "ซีเรีย",
        "Zambia": "แซมเบีย",
        "Croatia": "โครเอเชีย",
        "Lithuania": "ลิทัวเนีย",
        "Albania": "แอลเบเนีย",
        "Netherlands": "เนเธอร์แลนด์",
        "France": "ฝรั่งเศส",
        "Tunisia": "ตูนิเซีย",
        "Bosnia and Herzegovina": "บอสเนียและเฮอร์เซโกวีนา",
        "Bahamas": "บาฮามาส",
        "Somalia": "โซมาเลีย",
        "Burundi": "บุรุนดี",
        "Barbados": "บาร์เบโดส",
        "Malawi": "มาลาวี",
        "Honduras": "ฮอนดูรัส",
        "French Guiana": "เฟรนช์เกียนา",
        "Jordan": "จอร์แดน",
        "Serbia": "เซอร์เบีย",
        "Vanuatu": "วานูอาตู",
        "Aruba": "อารูบา",
        "Guyana": "กายอานา",
        "Lesotho": "เลโซโท",
        "Taiwan": "ไต้หวัน",
        "Central African Republic": "สาธารณรัฐแอฟริกากลาง",
        "Luxembourg": "ลักเซมเบิร์ก",
        "Trinidad and Tobago": "ตรินิแดดและโตเบโก",
        "Estonia": "เอสโตเนีย",
        "Montserrat": "มอนต์เซอร์รัต",
        "Norway": "นอร์เวย์",
        "North Korea": "เกาหลีเหนือ",
        "Myanmar": "เมียนมาร์",
        "Sri Lanka": "ศรีลังกา",
        "Faroe Islands": "หมู่เกาะแฟโร",
        "Dominica": "โดมินิกา",
        "Kiribati": "คิริบาส",
        "Falkland Islands": "หมู่เกาะฟอล์กแลนด์",
        "Namibia": "นามิเบีย",
        "Saint Lucia": "เซนต์ลูเซีย",
        "Indonesia": "อินโดนีเซีย",
        "Timor-Leste": "ติมอร์-เลสเต",
        "Norfolk Island": "เกาะนอร์ฟอล์ก",
        "Bhutan": "ภูฏาน",
        "Iran": "อิหร่าน",
        "Turkmenistan": "เติร์กเมนิสถาน",
        "Uganda": "ยูกันดา",
        "Kazakhstan": "คาซัคสถาน",
        "Cook Islands": "หมู่เกาะคุก",
        "Micronesia": "ไมโครนีเซีย",
        "Sint Maarten": "ซินท์มาร์เติน",
        "Liberia": "ไลบีเรีย",
        "Panama": "ปานามา",
        "Malta": "มอลตา",
        "Peru": "เปรู",
        "Philippines": "ฟิลิปปินส์",
        "Rwanda": "รวันดา",
        "United Kingdom": "สหราชอาณาจักร",
        "Martinique": "มาร์ตินีก",
        "Nepal": "เนปาล",
        "Guatemala": "กัวเตมาลา",
        "Bermuda": "เบอร์มิวดา",
        "Australia": "ออสเตรเลีย",
        "Vatican City": "นครรัฐวาติกัน",
        "Slovenia": "สโลวีเนีย",
        "Cayman Islands": "หมู่เกาะเคย์แมน",
        "Hungary": "ฮังการี",
        "American Samoa": "อเมริกันซามัว",
        "Mauritania": "มอริเตเนีย",
        "Japan": "ญี่ปุ่น",
        "Uzbekistan": "อุซเบกิสถาน",
        "Cambodia": "กัมพูชา",
        "Wallis & Futuna": "วาลลิสและฟุตูนา",
        "South Sudan": "เซาท์ซูดาน",
        "Morocco": "โมร็อกโก",
        "Argentina": "อาร์เจนตินา",
        "Guadeloupe": "กวาเดอลูป",
        "Hong Kong": "ฮ่องกง",
        "Qatar": "กาตาร์",
        "Tanzania": "แทนซาเนีย",
        "Mexico": "เม็กซิโก",
        "Russia": "รัสเซีย",
        "Iceland": "ไอซ์แลนด์",
        "Monaco": "โมนาโก",
        "Afghanistan": "อัฟกานิสถาน",
        "Slovakia": "สโลวาเกีย",
        "Sweden": "สวีเดน",
        "Azerbaijan": "อาเซอร์ไบจาน",
        "Bangladesh": "บังกลาเทศ",
        "Brazil": "บราซิล",
        "Cuba": "คิวบา",
        "Ghana": "กานา",
        "Mongolia": "มองโกเลีย",
        "Saint Kitts and Nevis": "เซนต์คิตส์และเนวิส",
        "Burkina Faso": "บูร์กินาฟาโซ",
        "Nicaragua": "นิการากัว",
        "Malaysia": "มาเลเซีย",
        "Uruguay": "อุรุกวัย",
        "Brunei": "บรูไน",
        "Congo": "คองโก",
        "Nauru": "นาอูรู",
        "Northern Mariana Islands": "หมู่เกาะนอร์เทิร์นมาเรียนา",
        "Pakistan": "ปากีสถาน",
        "Greenland": "กรีนแลนด์",
        "Mauritius": "มอริเชียส",
        "Caribbean Netherlands": "แคริบเบียนเนเธอร์แลนด์",
        "Belize": "เบลีซ",
        "Liechtenstein": "ลิกเตนสไตน์",
        "Sierra Leone": "เซียร์ราลีโอน",
        "Czech Republic": "สาธารณรัฐเช็ก",
        "Moldova": "มอลโดวา",
        "Singapore": "สิงคโปร์",
        "Belgium": "เบลเยียม",
        "Maldives": "มัลดีฟส์",
        "New Zealand": "นิวซีแลนด์",
        "South Korea": "เกาหลีใต้",
        "Italy": "อิตาลี",
        "Israel": "อิสราเอล",
        "Grenada": "เกรเนดา",
        "Kenya": "เคนยา",
        "St. Helena": "เซนต์เฮเลนา",
        "Guam": "กวม",
        "Denmark": "เดนมาร์ก",
        "New Caledonia": "นิวแคลิโดเนีย",
        "Ecuador": "เอกวาดอร์",
        "Canada": "แคนาดา",
        "Egypt": "อียิปต์",
        "Saudi Arabia": "ซาอุดีอาระเบีย",
        "Botswana": "บอตสวานา",
        "Turks & Caicos Islands": "หมู่เกาะเติกส์และเคคอส",
        "Latvia": "ลัตเวีย",
        "St. Pierre & Miquelon": "แซงปีแยร์และมีเกอลง",
        "Georgia": "จอร์เจีย",
        "Laos": "ลาว",
        "Réunion": "เรอูนียง",
        "Niue": "นีอูเอ",
        "Zimbabwe": "ซิมบับเว",
        "Thailand": "ไทย",
        "Algeria": "แอลจีเรีย",
        "Finland": "ฟินแลนด์",
        "Macedonia": "มาซิโดเนีย",
        "Antigua and Barbuda": "แอนติกาและบาร์บูดา",
        "Nigeria": "ไนจีเรีย",
        "Switzerland": "สวิตเซอร์แลนด์",
        "Bulgaria": "บัลแกเรีย",
        "Montenegro": "มอนเตเนโกร",
        "Tajikistan": "ทาจิกิสถาน",
        "Austria": "ออสเตรีย",
        "Bolivia": "โบลิเวีย",
        "Sudan": "ซูดาน",
        "Suriname": "ซูรินาเม",
        "Iraq": "อิรัก",
        "Bahrain": "บาห์เรน",
        "Colombia": "โคลอมเบีย",
        "Papua New Guinea": "ปาปัวนิวกินี",
        "Yemen": "เยเมน",
        "Venezuela": "เวเนซุเอลา",
        "Djibouti": "จิบูตี",
        "British Indian Ocean Territory": "บริติชอินเดียนโอเชียนเทร์ริทอรี",
        "Chad": "ชาด",
        "Germany": "เยอรมนี",
        "Fiji": "ฟิจิ",
        "British Virgin Islands": "หมู่เกาะบริติชเวอร์จิน",
        "San Marino": "ซานมารีโน",
        "Vietnam": "เวียดนาม",
        "Macau": "มาเก๊า",
        "South Africa": "แอฟริกาใต้",
        "Eritrea": "เอริเทรีย",
        "Greece": "กรีซ",
        "Ethiopia": "เอธิโอเปีย",
        "Madagascar": "มาดากัสการ์",
        "Marshall Islands": "หมู่เกาะมาร์แชลล์",
        "United States": "สหรัฐอเมริกา",
        "Benin": "เบนิน",
        "El Salvador": "เอลซัลวาดอร์",
        "Lebanon": "เลบานอน",
        "Palestine": "ปาเลสไตน์",
        "Tuvalu": "ตูวาลู",
        "Solomon Islands": "หมู่เกาะโซโลมอน",
        "China": "จีน",
        "Tonga": "ตองกา"
    },
};
export const enGB = {
    searchNotFound: "No country found",
    searchPlaceholder: "Search for a country",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Equatorial Guinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychelles",
        "Comoros": "Comoros",
        "U.S. Virgin Islands": "U.S. Virgin Islands",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libya",
        "Romania": "Romania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Ireland",
        "Turkey": "Turkey",
        "Oman": "Oman",
        "Ukraine": "Ukraine",
        "Spain": "Spain",
        "Cameroon": "Cameroon",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent and the Grenadines",
        "Cyprus": "Cyprus",
        "Belarus": "Belarus",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "United Arab Emirates",
        "São Tomé and Príncipe": "São Tomé and Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cape Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Côte d’Ivoire",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mozambique",
        "Poland": "Poland",
        "French Polynesia": "French Polynesia",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Dominican Republic",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kyrgyzstan",
        "Syria": "Syria",
        "Zambia": "Zambia",
        "Croatia": "Croatia",
        "Lithuania": "Lithuania",
        "Albania": "Albania",
        "Netherlands": "Netherlands",
        "France": "France",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia and Herzegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "French Guiana",
        "Jordan": "Jordan",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Central African Republic",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinidad and Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Norway",
        "North Korea": "North Korea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Faroe Islands",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falkland Islands",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Timor-Leste",
        "Norfolk Island": "Norfolk Island",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Cook Islands",
        "Micronesia": "Micronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Philippines",
        "Rwanda": "Rwanda",
        "United Kingdom": "United Kingdom",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australia",
        "Vatican City": "Vatican City",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Cayman Islands",
        "Hungary": "Hungary",
        "American Samoa": "American Samoa",
        "Mauritania": "Mauritania",
        "Japan": "Japan",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Cambodia",
        "Wallis & Futuna": "Wallis & Futuna",
        "South Sudan": "South Sudan",
        "Morocco": "Morocco",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexico",
        "Russia": "Russia",
        "Iceland": "Iceland",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovakia",
        "Sweden": "Sweden",
        "Azerbaijan": "Azerbaijan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brazil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts and Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Northern Mariana Islands",
        "Pakistan": "Pakistan",
        "Greenland": "Greenland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Caribbean Netherlands",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Czech Republic",
        "Moldova": "Moldova",
        "Singapore": "Singapore",
        "Belgium": "Belgium",
        "Maldives": "Maldives",
        "New Zealand": "New Zealand",
        "South Korea": "South Korea",
        "Italy": "Italy",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "St. Helena",
        "Guam": "Guam",
        "Denmark": "Denmark",
        "New Caledonia": "New Caledonia",
        "Ecuador": "Ecuador",
        "Canada": "Canada",
        "Egypt": "Egypt",
        "Saudi Arabia": "Saudi Arabia",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks & Caicos Islands",
        "Latvia": "Latvia",
        "St. Pierre & Miquelon": "St. Pierre & Miquelon",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algeria",
        "Finland": "Finland",
        "Macedonia": "Macedonia",
        "Antigua and Barbuda": "Antigua and Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Switzerland",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tajikistan",
        "Austria": "Austria",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Suriname",
        "Iraq": "Iraq",
        "Bahrain": "Bahrain",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papua New Guinea",
        "Yemen": "Yemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "British Indian Ocean Territory",
        "Chad": "Chad",
        "Germany": "Germany",
        "Fiji": "Fiji",
        "British Virgin Islands": "British Virgin Islands",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macau",
        "South Africa": "South Africa",
        "Eritrea": "Eritrea",
        "Greece": "Greece",
        "Ethiopia": "Ethiopia",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Marshall Islands",
        "United States": "United States",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Lebanon",
        "Palestine": "Palestine",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Solomon Islands",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const tkTK = {
    searchNotFound: "Ýurt tapylmady",
    searchPlaceholder: "Ýurt gözlemek",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Ekwatorial Gwineýa",
        "Senegal": "Senegal",
        "Jamaica": "Ýamaýka",
        "Seychelles": "Seýşel adalary",
        "Comoros": "Komor adalary",
        "U.S. Virgin Islands": "ABŞ-nyň Wirgin adalary",
        "Guinea": "Gwineýa",
        "Niger": "Niger",
        "Libya": "Liwiýa",
        "Romania": "Rumyniýa",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paragwaý",
        "India": "Hindistan",
        "Ireland": "Irlandiýa",
        "Turkey": "Türkiýe",
        "Oman": "Oman",
        "Ukraine": "Ukraina",
        "Spain": "Ispaniýa",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Sent-Winsent we Grenadinler",
        "Cyprus": "Kipr",
        "Belarus": "Belarus",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Çili",
        "United Arab Emirates": "Birleşen Arap Emirlikleri",
        "São Tomé and Príncipe": "San-Tome we Prinsipi",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto-Riko",
        "Portugal": "Portugaliýa",
        "Costa Rica": "Kosta-Rika",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kabo-Werde",
        "Curaçao": "Kýurasao",
        "Andorra": "Andorra",
        "Armenia": "Ermenistan",
        "Haiti": "Gaiti",
        "Côte d’Ivoire": "Kot-d’Iwuar",
        "Guinea-Bissau": "Gwineýa-Bisau",
        "Mozambique": "Mozambik",
        "Poland": "Polşa",
        "French Polynesia": "Fransuz Polineziýasy",
        "Jersey": "Jersi",
        "Kuwait": "Kuweýt",
        "Dominican Republic": "Dominikan Respublikasy",
        "Kosovo": "Kosowo",
        "Kyrgyzstan": "Gyrgyzystan",
        "Syria": "Siriýa",
        "Zambia": "Zambiýa",
        "Croatia": "Horwatiýa",
        "Lithuania": "Litwa",
        "Albania": "Albaniýa",
        "Netherlands": "Niderlandlar",
        "France": "Fransiýa",
        "Tunisia": "Tunis",
        "Bosnia and Herzegovina": "Bosniýa we Gersegowina",
        "Bahamas": "Bagama adalary",
        "Somalia": "Somali",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Gonduras",
        "French Guiana": "Fransuz Gwianasy",
        "Jordan": "Iordaniýa",
        "Serbia": "Serbiýa",
        "Vanuatu": "Wanuatu",
        "Aruba": "Aruba",
        "Guyana": "Gaýana",
        "Lesotho": "Lesoto",
        "Taiwan": "Taýwan",
        "Central African Republic": "Merkezi Afrika Respublikasy",
        "Luxembourg": "Lýuksemburg",
        "Trinidad and Tobago": "Trinidad we Tobago",
        "Estonia": "Estoniýa",
        "Montserrat": "Montserrat",
        "Norway": "Norwegiýa",
        "North Korea": "Demirgazyk Koreýa",
        "Myanmar": "Mýanma",
        "Sri Lanka": "Şri-Lanka",
        "Faroe Islands": "Farer adalary",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Folkland adalary",
        "Namibia": "Namibiýa",
        "Saint Lucia": "Sent-Lýusiýa",
        "Indonesia": "Indoneziýa",
        "Timor-Leste": "Gündogar Timor",
        "Norfolk Island": "Norfolk adasy",
        "Bhutan": "Butan",
        "Iran": "Eýran",
        "Turkmenistan": "Türkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Gazagystan",
        "Cook Islands": "Kuk adalary",
        "Micronesia": "Mikroneziýa",
        "Sint Maarten": "Sint-Marten",
        "Liberia": "Liberiýa",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filippinler",
        "Rwanda": "Ruanda",
        "United Kingdom": "Birleşen Patyşalyk",
        "Martinique": "Martinika",
        "Nepal": "Nepal",
        "Guatemala": "Gwatemala",
        "Bermuda": "Bermuda",
        "Australia": "Awstraliýa",
        "Vatican City": "Watikan",
        "Slovenia": "Sloweniýa",
        "Cayman Islands": "Kaýman adalary",
        "Hungary": "Wengriýa",
        "American Samoa": "Amerikan Samoasy",
        "Mauritania": "Mawritaniýa",
        "Japan": "Ýaponiýa",
        "Uzbekistan": "Özbegistan",
        "Cambodia": "Kamboja",
        "Wallis & Futuna": "Wallis we Futuna",
        "South Sudan": "Günorta Sudan",
        "Morocco": "Marokko",
        "Argentina": "Argentina",
        "Guadeloupe": "Gwadelupe",
        "Hong Kong": "Gonkong",
        "Qatar": "Katar",
        "Tanzania": "Tanzaniýa",
        "Mexico": "Meksika",
        "Russia": "Russiýa",
        "Iceland": "Islandiýa",
        "Monaco": "Monako",
        "Afghanistan": "Owganystan",
        "Slovakia": "Slowakiýa",
        "Sweden": "Şwesiýa",
        "Azerbaijan": "Azerbaýjan",
        "Bangladesh": "Bangladeş",
        "Brazil": "Braziliýa",
        "Cuba": "Kuba",
        "Ghana": "Gana",
        "Mongolia": "Mongoliýa",
        "Saint Kitts and Nevis": "Sent-Kits we Newis",
        "Burkina Faso": "Burkina-Faso",
        "Nicaragua": "Nikaragua",
        "Malaysia": "Malaýziýa",
        "Uruguay": "Urugwaý",
        "Brunei": "Bruneý",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Demirgazyk Mariana adalary",
        "Pakistan": "Pakistan",
        "Greenland": "Grenlandiýa",
        "Mauritius": "Mawrikiý",
        "Caribbean Netherlands": "Karib Niderlandlary",
        "Belize": "Beliz",
        "Liechtenstein": "Lihtenşteýn",
        "Sierra Leone": "Sýerra-Leone",
        "Czech Republic": "Çeh Respublikasy",
        "Moldova": "Moldowa",
        "Singapore": "Singapur",
        "Belgium": "Belgiýa",
        "Maldives": "Maldiwler",
        "New Zealand": "Täze Zelandiýa",
        "South Korea": "Günorta Koreýa",
        "Italy": "Italiýa",
        "Israel": "Ysraýyl",
        "Grenada": "Grenada",
        "Kenya": "Keniýa",
        "St. Helena": "Sent-Helena",
        "Guam": "Guam",
        "Denmark": "Daniýa",
        "New Caledonia": "Täze Kaledoniýa",
        "Ecuador": "Ekwador",
        "Canada": "Kanada",
        "Egypt": "Müsür",
        "Saudi Arabia": "Saud Arabystany",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Terk we Kaýkos adalary",
        "Latvia": "Latwiýa",
        "St. Pierre & Miquelon": "Sent-Pýer we Mikelon",
        "Georgia": "Gruziýa",
        "Laos": "Laos",
        "Réunion": "Reýunýon",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Taýland",
        "Algeria": "Alžir",
        "Finland": "Finlandiýa",
        "Macedonia": "Makedoniýa",
        "Antigua and Barbuda": "Antigua we Barbuda",
        "Nigeria": "Nigeriýa",
        "Switzerland": "Şweýsariýa",
        "Bulgaria": "Bolgariýa",
        "Montenegro": "Çernogoriýa",
        "Tajikistan": "Täjigistan",
        "Austria": "Awstriýa",
        "Bolivia": "Boliwiýa",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Yrak",
        "Bahrain": "Bahreýn",
        "Colombia": "Kolumbiýa",
        "Papua New Guinea": "Papua Täze Gwineýa",
        "Yemen": "Ýemen",
        "Venezuela": "Wenesuela",
        "Djibouti": "Jibuti",
        "British Indian Ocean Territory": "Britan Hindi Okeany Territory",
        "Chad": "Çad",
        "Germany": "Germaniýa",
        "Fiji": "Fiji",
        "British Virgin Islands": "Britan Wirgin adalary",
        "San Marino": "San-Marino",
        "Vietnam": "Wýetnam",
        "Macau": "Makao",
        "South Africa": "Günorta Afrika",
        "Eritrea": "Eritreýa",
        "Greece": "Gresiýa",
        "Ethiopia": "Efiopiýa",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marşal adalary",
        "United States": "Amerikanyň Birleşen Ştatlary",
        "Benin": "Benin",
        "El Salvador": "Salwador",
        "Lebanon": "Liwan",
        "Palestine": "Palestina",
        "Tuvalu": "Tuwalu",
        "Solomon Islands": "Solomon adalary",
        "China": "Hytaý",
        "Tonga": "Tonga"
    },
};
export const ptBR = {
    searchNotFound: "Nenhum país encontrado",
    searchPlaceholder: "Pesquisar um país",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gâmbia",
        "Equatorial Guinea": "Guiné Equatorial",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seicheles",
        "Comoros": "Comores",
        "U.S. Virgin Islands": "Ilhas Virgens Americanas",
        "Guinea": "Guiné",
        "Niger": "Níger",
        "Libya": "Líbia",
        "Romania": "Romênia",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguai",
        "India": "Índia",
        "Ireland": "Irlanda",
        "Turkey": "Turquia",
        "Oman": "Omã",
        "Ukraine": "Ucrânia",
        "Spain": "Espanha",
        "Cameroon": "Camarões",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "São Vicente e Granadinas",
        "Cyprus": "Chipre",
        "Belarus": "Bielorrússia",
        "Gabon": "Gabão",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Emirados Árabes Unidos",
        "São Tomé and Príncipe": "São Tomé e Príncipe",
        "Palau": "Palau",
        "Tokelau": "Toquelau",
        "Puerto Rico": "Porto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Essuatíni",
        "Cape Verde": "Cabo Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armênia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Costa do Marfim",
        "Guinea-Bissau": "Guiné-Bissau",
        "Mozambique": "Moçambique",
        "Poland": "Polônia",
        "French Polynesia": "Polinésia Francesa",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "República Dominicana",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Quirguistão",
        "Syria": "Síria",
        "Zambia": "Zâmbia",
        "Croatia": "Croácia",
        "Lithuania": "Lituânia",
        "Albania": "Albânia",
        "Netherlands": "Países Baixos",
        "France": "França",
        "Tunisia": "Tunísia",
        "Bosnia and Herzegovina": "Bósnia e Herzegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somália",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Maláui",
        "Honduras": "Honduras",
        "French Guiana": "Guiana Francesa",
        "Jordan": "Jordânia",
        "Serbia": "Sérvia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guiana",
        "Lesotho": "Lesoto",
        "Taiwan": "Taiwan",
        "Central African Republic": "República Centro-Africana",
        "Luxembourg": "Luxemburgo",
        "Trinidad and Tobago": "Trindade e Tobago",
        "Estonia": "Estônia",
        "Montserrat": "Montserrat",
        "Norway": "Noruega",
        "North Korea": "Coreia do Norte",
        "Myanmar": "Mianmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Ilhas Faroé",
        "Dominica": "Dominica",
        "Kiribati": "Quiribati",
        "Falkland Islands": "Ilhas Malvinas",
        "Namibia": "Namíbia",
        "Saint Lucia": "Santa Lúcia",
        "Indonesia": "Indonésia",
        "Timor-Leste": "Timor-Leste",
        "Norfolk Island": "Ilha Norfolk",
        "Bhutan": "Butão",
        "Iran": "Irã",
        "Turkmenistan": "Turquemenistão",
        "Uganda": "Uganda",
        "Kazakhstan": "Cazaquistão",
        "Cook Islands": "Ilhas Cook",
        "Micronesia": "Micronésia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Libéria",
        "Panama": "Panamá",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipinas",
        "Rwanda": "Ruanda",
        "United Kingdom": "Reino Unido",
        "Martinique": "Martinica",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermudas",
        "Australia": "Austrália",
        "Vatican City": "Vaticano",
        "Slovenia": "Eslovênia",
        "Cayman Islands": "Ilhas Cayman",
        "Hungary": "Hungria",
        "American Samoa": "Samoa Americana",
        "Mauritania": "Mauritânia",
        "Japan": "Japão",
        "Uzbekistan": "Uzbequistão",
        "Cambodia": "Camboja",
        "Wallis & Futuna": "Wallis e Futuna",
        "South Sudan": "Sudão do Sul",
        "Morocco": "Marrocos",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadalupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Catar",
        "Tanzania": "Tanzânia",
        "Mexico": "México",
        "Russia": "Rússia",
        "Iceland": "Islândia",
        "Monaco": "Mônaco",
        "Afghanistan": "Afeganistão",
        "Slovakia": "Eslováquia",
        "Sweden": "Suécia",
        "Azerbaijan": "Azerbaijão",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasil",
        "Cuba": "Cuba",
        "Ghana": "Gana",
        "Mongolia": "Mongólia",
        "Saint Kitts and Nevis": "São Cristóvão e Nevis",
        "Burkina Faso": "Burquina Faso",
        "Nicaragua": "Nicarágua",
        "Malaysia": "Malásia",
        "Uruguay": "Uruguai",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Ilhas Marianas do Norte",
        "Pakistan": "Paquistão",
        "Greenland": "Gronelândia",
        "Mauritius": "Maurício",
        "Caribbean Netherlands": "Países Baixos Caribenhos",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Serra Leoa",
        "Czech Republic": "República Tcheca",
        "Moldova": "Moldávia",
        "Singapore": "Singapura",
        "Belgium": "Bélgica",
        "Maldives": "Maldivas",
        "New Zealand": "Nova Zelândia",
        "South Korea": "Coreia do Sul",
        "Italy": "Itália",
        "Israel": "Israel",
        "Grenada": "Granada",
        "Kenya": "Quênia",
        "St. Helena": "Santa Helena",
        "Guam": "Guam",
        "Denmark": "Dinamarca",
        "New Caledonia": "Nova Caledônia",
        "Ecuador": "Equador",
        "Canada": "Canadá",
        "Egypt": "Egito",
        "Saudi Arabia": "Arábia Saudita",
        "Botswana": "Botsuana",
        "Turks & Caicos Islands": "Ilhas Turks e Caicos",
        "Latvia": "Letônia",
        "St. Pierre & Miquelon": "São Pedro e Miquelon",
        "Georgia": "Geórgia",
        "Laos": "Laos",
        "Réunion": "Reunião",
        "Niue": "Niue",
        "Zimbabwe": "Zimbábue",
        "Thailand": "Tailândia",
        "Algeria": "Argélia",
        "Finland": "Finlândia",
        "Macedonia": "Macedônia",
        "Antigua and Barbuda": "Antígua e Barbuda",
        "Nigeria": "Nigéria",
        "Switzerland": "Suíça",
        "Bulgaria": "Bulgária",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tajiquistão",
        "Austria": "Áustria",
        "Bolivia": "Bolívia",
        "Sudan": "Sudão",
        "Suriname": "Suriname",
        "Iraq": "Iraque",
        "Bahrain": "Bahrein",
        "Colombia": "Colômbia",
        "Papua New Guinea": "Papua-Nova Guiné",
        "Yemen": "Iêmen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Território Britânico do Oceano Índico",
        "Chad": "Chade",
        "Germany": "Alemanha",
        "Fiji": "Fiji",
        "British Virgin Islands": "Ilhas Virgens Britânicas",
        "San Marino": "San Marino",
        "Vietnam": "Vietnã",
        "Macau": "Macau",
        "South Africa": "África do Sul",
        "Eritrea": "Eritreia",
        "Greece": "Grécia",
        "Ethiopia": "Etiópia",
        "Madagascar": "Madagáscar",
        "Marshall Islands": "Ilhas Marshall",
        "United States": "Estados Unidos",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Líbano",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Ilhas Salomão",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const mnMN = {
    searchNotFound: "Улс олдсонгүй",
    searchPlaceholder: "Улс хайх",
    countries: {
        "Gibraltar": "Гибралтар",
        "Gambia": "Гамби",
        "Equatorial Guinea": "Экваторын Гвиней",
        "Senegal": "Сенегал",
        "Jamaica": "Ямайка",
        "Seychelles": "Сейшелийн Арлууд",
        "Comoros": "Коморын Арлууд",
        "U.S. Virgin Islands": "АНУ-ын Виржиний Арлууд",
        "Guinea": "Гвиней",
        "Niger": "Нигер",
        "Libya": "Ливи",
        "Romania": "Румын",
        "Anguilla": "Ангуила",
        "Togo": "Того",
        "Paraguay": "Парагвай",
        "India": "Энэтхэг",
        "Ireland": "Ирланд",
        "Turkey": "Турк",
        "Oman": "Оман",
        "Ukraine": "Украин",
        "Spain": "Испани",
        "Cameroon": "Камерун",
        "Angola": "Ангол",
        "Mali": "Мали",
        "Saint Vincent and the Grenadines": "Сент-Винсент ба Гренадин",
        "Cyprus": "Кипр",
        "Belarus": "Беларусь",
        "Gabon": "Габон",
        "Samoa": "Самоа",
        "Chile": "Чили",
        "United Arab Emirates": "Арабын Нэгдсэн Эмират Улс",
        "São Tomé and Príncipe": "Сан-Томе ба Принсипи",
        "Palau": "Палау",
        "Tokelau": "Токелау",
        "Puerto Rico": "Пуэрто-Рико",
        "Portugal": "Португал",
        "Costa Rica": "Коста-Рика",
        "Swaziland": "Эсватини",
        "Cape Verde": "Кабо-Верде",
        "Curaçao": "Кюрасао",
        "Andorra": "Андорра",
        "Armenia": "Армени",
        "Haiti": "Гаити",
        "Côte d’Ivoire": "Кот-д’Ивуар",
        "Guinea-Bissau": "Гвиней-Бисау",
        "Mozambique": "Мозамбик",
        "Poland": "Польш",
        "French Polynesia": "Францын Полинези",
        "Jersey": "Жерси",
        "Kuwait": "Кувейт",
        "Dominican Republic": "Доминиканы Бүгд Найрамдах Улс",
        "Kosovo": "Косово",
        "Kyrgyzstan": "Кыргызстан",
        "Syria": "Сири",
        "Zambia": "Замби",
        "Croatia": "Хорват",
        "Lithuania": "Литва",
        "Albania": "Албани",
        "Netherlands": "Нидерланд",
        "France": "Франц",
        "Tunisia": "Тунис",
        "Bosnia and Herzegovina": "Босни ба Херцеговин",
        "Bahamas": "Багамын Арлууд",
        "Somalia": "Сомали",
        "Burundi": "Бурунди",
        "Barbados": "Барбадос",
        "Malawi": "Малави",
        "Honduras": "Гондурас",
        "French Guiana": "Францын Гвиан",
        "Jordan": "Йордан",
        "Serbia": "Серби",
        "Vanuatu": "Вануату",
        "Aruba": "Аруба",
        "Guyana": "Гайана",
        "Lesotho": "Лесото",
        "Taiwan": "Тайвань",
        "Central African Republic": "Төв Африкийн Бүгд Найрамдах Улс",
        "Luxembourg": "Люксембург",
        "Trinidad and Tobago": "Тринидад ба Тобаго",
        "Estonia": "Эстон",
        "Montserrat": "Монтсеррат",
        "Norway": "Норвег",
        "North Korea": "Хойд Солонгос",
        "Myanmar": "Мьянмар",
        "Sri Lanka": "Шри Ланка",
        "Faroe Islands": "Фарерын Арлууд",
        "Dominica": "Доминик",
        "Kiribati": "Кирибати",
        "Falkland Islands": "Фолклендийн Арлууд",
        "Namibia": "Намиби",
        "Saint Lucia": "Сент Люсиа",
        "Indonesia": "Индонез",
        "Timor-Leste": "Тимор-Лесте",
        "Norfolk Island": "Норфолкийн Арлууд",
        "Bhutan": "Бутан",
        "Iran": "Иран",
        "Turkmenistan": "Туркменистан",
        "Uganda": "Уганда",
        "Kazakhstan": "Казахстан",
        "Cook Islands": "Кукийн Арлууд",
        "Micronesia": "Микронези",
        "Sint Maarten": "Синт-Маартен",
        "Liberia": "Либери",
        "Panama": "Панам",
        "Malta": "Мальт",
        "Peru": "Перу",
        "Philippines": "Филиппин",
        "Rwanda": "Руанда",
        "United Kingdom": "Их Британи",
        "Martinique": "Мартиник",
        "Nepal": "Балба",
        "Guatemala": "Гватемал",
        "Bermuda": "Бермудын Арлууд",
        "Australia": "Австрали",
        "Vatican City": "Ватикан",
        "Slovenia": "Словени",
        "Cayman Islands": "Кайманы Арлууд",
        "Hungary": "Унгар",
        "American Samoa": "Америкийн Самоа",
        "Mauritania": "Мавритани",
        "Japan": "Япон",
        "Uzbekistan": "Узбекистан",
        "Cambodia": "Камбож",
        "Wallis & Futuna": "Уоллис ба Футуна",
        "South Sudan": "Өмнөд Судан",
        "Morocco": "Марокко",
        "Argentina": "Аргентин",
        "Guadeloupe": "Гваделуп",
        "Hong Kong": "Хонг Конг",
        "Qatar": "Катар",
        "Tanzania": "Танзани",
        "Mexico": "Мексик",
        "Russia": "Орос",
        "Iceland": "Исланд",
        "Monaco": "Монако",
        "Afghanistan": "Афганистан",
        "Slovakia": "Словак",
        "Sweden": "Швед",
        "Azerbaijan": "Азербайжан",
        "Bangladesh": "Бангладеш",
        "Brazil": "Бразил",
        "Cuba": "Куба",
        "Ghana": "Гана",
        "Mongolia": "Монгол",
        "Saint Kitts and Nevis": "Сент-Китс ба Невис",
        "Burkina Faso": "Буркина-Фасо",
        "Nicaragua": "Никарагуа",
        "Malaysia": "Малайз",
        "Uruguay": "Уругвай",
        "Brunei": "Бруней",
        "Congo": "Конго",
        "Nauru": "Науру",
        "Northern Mariana Islands": "Хойд Марианы Арлууд",
        "Pakistan": "Пакистан",
        "Greenland": "Гренланд",
        "Mauritius": "Мавритани",
        "Caribbean Netherlands": "Карибын Нидерланд",
        "Belize": "Белиз",
        "Liechtenstein": "Лихтенштейн",
        "Sierra Leone": "Сьерра-Леон",
        "Czech Republic": "Чех",
        "Moldova": "Молдав",
        "Singapore": "Сингапур",
        "Belgium": "Бельги",
        "Maldives": "Мальдив",
        "New Zealand": "Шинэ Зеланд",
        "South Korea": "Өмнөд Солонгос",
        "Italy": "Итали",
        "Israel": "Израил",
        "Grenada": "Гренада",
        "Kenya": "Кени",
        "St. Helena": "Сент-Хелена",
        "Guam": "Гуам",
        "Denmark": "Дани",
        "New Caledonia": "Шинэ Каледони",
        "Ecuador": "Эквадор",
        "Canada": "Канад",
        "Egypt": "Египет",
        "Saudi Arabia": "Саудын Араб",
        "Botswana": "Ботсвана",
        "Turks & Caicos Islands": "Туркс ба Кайкосын Арлууд",
        "Latvia": "Латви",
        "St. Pierre & Miquelon": "Сен-Пьер ба Микелон",
        "Georgia": "Гүрж",
        "Laos": "Лаос",
        "Réunion": "Реюнион",
        "Niue": "Ниуэ",
        "Zimbabwe": "Зимбабве",
        "Thailand": "Тайланд",
        "Algeria": "Алжир",
        "Finland": "Финланд",
        "Macedonia": "Македон",
        "Antigua and Barbuda": "Антигуа ба Барбуда",
        "Nigeria": "Нигери",
        "Switzerland": "Швейцари",
        "Bulgaria": "Болгар",
        "Montenegro": "Черногор",
        "Tajikistan": "Тажикистан",
        "Austria": "Австри",
        "Bolivia": "Боливи",
        "Sudan": "Судан",
        "Suriname": "Суринам",
        "Iraq": "Ирак",
        "Bahrain": "Бахрейн",
        "Colombia": "Колумб",
        "Papua New Guinea": "Папуа Шинэ Гвиней",
        "Yemen": "Йемен",
        "Venezuela": "Венесуэл",
        "Djibouti": "Жибути",
        "British Indian Ocean Territory": "Британийн Энэтхэгийн Далайн Газар нутаг",
        "Chad": "Чад",
        "Germany": "Герман",
        "Fiji": "Фижи",
        "British Virgin Islands": "Британийн Виржиний Арлууд",
        "San Marino": "Сан-Марино",
        "Vietnam": "Вьетнам",
        "Macau": "Макао",
        "South Africa": "Өмнөд Африк",
        "Eritrea": "Эритрей",
        "Greece": "Грек",
        "Ethiopia": "Этиоп",
        "Madagascar": "Мадагаскар",
        "Marshall Islands": "Маршаллын Арлууд",
        "United States": "Америкийн Нэгдсэн Улс",
        "Benin": "Бенин",
        "El Salvador": "Эль Сальвадор",
        "Lebanon": "Ливан",
        "Palestine": "Палестин",
        "Tuvalu": "Тувалу",
        "Solomon Islands": "Соломоны Арлууд",
        "China": "Хятад",
        "Tonga": "Тонга"
    },
};
export const frFR = {
    searchNotFound: "Aucun pays trouvé",
    searchPlaceholder: "Rechercher un pays",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambie",
        "Equatorial Guinea": "Guinée équatoriale",
        "Senegal": "Sénégal",
        "Jamaica": "Jamaïque",
        "Seychelles": "Seychelles",
        "Comoros": "Comores",
        "U.S. Virgin Islands": "Îles Vierges des États-Unis",
        "Guinea": "Guinée",
        "Niger": "Niger",
        "Libya": "Libye",
        "Romania": "Roumanie",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Inde",
        "Ireland": "Irlande",
        "Turkey": "Turquie",
        "Oman": "Oman",
        "Ukraine": "Ukraine",
        "Spain": "Espagne",
        "Cameroon": "Cameroun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint-Vincent-et-les-Grenadines",
        "Cyprus": "Chypre",
        "Belarus": "Biélorussie",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chili",
        "United Arab Emirates": "Émirats arabes unis",
        "São Tomé and Príncipe": "Sao Tomé-et-Principe",
        "Palau": "Palaos",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Porto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cap-Vert",
        "Curaçao": "Curaçao",
        "Andorra": "Andorre",
        "Armenia": "Arménie",
        "Haiti": "Haïti",
        "Côte d’Ivoire": "Côte d’Ivoire",
        "Guinea-Bissau": "Guinée-Bissau",
        "Mozambique": "Mozambique",
        "Poland": "Pologne",
        "French Polynesia": "Polynésie française",
        "Jersey": "Jersey",
        "Kuwait": "Koweït",
        "Dominican Republic": "République dominicaine",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirghizistan",
        "Syria": "Syrie",
        "Zambia": "Zambie",
        "Croatia": "Croatie",
        "Lithuania": "Lituanie",
        "Albania": "Albanie",
        "Netherlands": "Pays-Bas",
        "France": "France",
        "Tunisia": "Tunisie",
        "Bosnia and Herzegovina": "Bosnie-Herzégovine",
        "Bahamas": "Bahamas",
        "Somalia": "Somalie",
        "Burundi": "Burundi",
        "Barbados": "Barbade",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Guyane française",
        "Jordan": "Jordanie",
        "Serbia": "Serbie",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taïwan",
        "Central African Republic": "République centrafricaine",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinité-et-Tobago",
        "Estonia": "Estonie",
        "Montserrat": "Montserrat",
        "Norway": "Norvège",
        "North Korea": "Corée du Nord",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Îles Féroé",
        "Dominica": "Dominique",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Îles Malouines",
        "Namibia": "Namibie",
        "Saint Lucia": "Sainte-Lucie",
        "Indonesia": "Indonésie",
        "Timor-Leste": "Timor-Leste",
        "Norfolk Island": "Île Norfolk",
        "Bhutan": "Bhoutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkménistan",
        "Uganda": "Ouganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Îles Cook",
        "Micronesia": "Micronésie",
        "Sint Maarten": "Saint-Martin",
        "Liberia": "Libéria",
        "Panama": "Panama",
        "Malta": "Malte",
        "Peru": "Pérou",
        "Philippines": "Philippines",
        "Rwanda": "Rwanda",
        "United Kingdom": "Royaume-Uni",
        "Martinique": "Martinique",
        "Nepal": "Népal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermudes",
        "Australia": "Australie",
        "Vatican City": "Vatican",
        "Slovenia": "Slovénie",
        "Cayman Islands": "Îles Caïmans",
        "Hungary": "Hongrie",
        "American Samoa": "Samoa américaines",
        "Mauritania": "Mauritanie",
        "Japan": "Japon",
        "Uzbekistan": "Ouzbékistan",
        "Cambodia": "Cambodge",
        "Wallis & Futuna": "Wallis-et-Futuna",
        "South Sudan": "Soudan du Sud",
        "Morocco": "Maroc",
        "Argentina": "Argentine",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzanie",
        "Mexico": "Mexique",
        "Russia": "Russie",
        "Iceland": "Islande",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovaquie",
        "Sweden": "Suède",
        "Azerbaijan": "Azerbaïdjan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brésil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolie",
        "Saint Kitts and Nevis": "Saint-Christophe-et-Niévès",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaisie",
        "Uruguay": "Uruguay",
        "Brunei": "Brunéi",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Îles Mariannes du Nord",
        "Pakistan": "Pakistan",
        "Greenland": "Groenland",
        "Mauritius": "Maurice",
        "Caribbean Netherlands": "Pays-Bas caribéens",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "République tchèque",
        "Moldova": "Moldavie",
        "Singapore": "Singapour",
        "Belgium": "Belgique",
        "Maldives": "Maldives",
        "New Zealand": "Nouvelle-Zélande",
        "South Korea": "Corée du Sud",
        "Italy": "Italie",
        "Israel": "Israël",
        "Grenada": "Grenade",
        "Kenya": "Kenya",
        "St. Helena": "Sainte-Hélène",
        "Guam": "Guam",
        "Denmark": "Danemark",
        "New Caledonia": "Nouvelle-Calédonie",
        "Ecuador": "Équateur",
        "Canada": "Canada",
        "Egypt": "Égypte",
        "Saudi Arabia": "Arabie saoudite",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Îles Turques-et-Caïques",
        "Latvia": "Lettonie",
        "St. Pierre & Miquelon": "Saint-Pierre-et-Miquelon",
        "Georgia": "Géorgie",
        "Laos": "Laos",
        "Réunion": "La Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thaïlande",
        "Algeria": "Algérie",
        "Finland": "Finlande",
        "Macedonia": "Macédoine",
        "Antigua and Barbuda": "Antigua-et-Barbuda",
        "Nigeria": "Nigéria",
        "Switzerland": "Suisse",
        "Bulgaria": "Bulgarie",
        "Montenegro": "Monténégro",
        "Tajikistan": "Tadjikistan",
        "Austria": "Autriche",
        "Bolivia": "Bolivie",
        "Sudan": "Soudan",
        "Suriname": "Suriname",
        "Iraq": "Irak",
        "Bahrain": "Bahreïn",
        "Colombia": "Colombie",
        "Papua New Guinea": "Papouasie-Nouvelle-Guinée",
        "Yemen": "Yémen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Territoire britannique de l'océan Indien",
        "Chad": "Tchad",
        "Germany": "Allemagne",
        "Fiji": "Fidji",
        "British Virgin Islands": "Îles Vierges britanniques",
        "San Marino": "Saint-Marin",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Afrique du Sud",
        "Eritrea": "Érythrée",
        "Greece": "Grèce",
        "Ethiopia": "Éthiopie",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Îles Marshall",
        "United States": "États-Unis",
        "Benin": "Bénin",
        "El Salvador": "Salvador",
        "Lebanon": "Liban",
        "Palestine": "Palestine",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Îles Salomon",
        "China": "Chine",
        "Tonga": "Tonga"
    },
};
export const khKH = {
    searchNotFound: "រកមិនឃើញប្រទេស",
    searchPlaceholder: "ស្វែងរកប្រទេស",
    countries: {
        "Gibraltar": "ហ៊ីប្រាល់តា",
        "Gambia": "ហ្គាំប៊ី",
        "Equatorial Guinea": "ហ្គីណេអេក្វាទ័រ",
        "Senegal": "សេនេហ្គាល់",
        "Jamaica": "ហ្សាម៉ាអ៉ិច",
        "Seychelles": "សេសែល",
        "Comoros": "កូម័រ",
        "U.S. Virgin Islands": "កោះវឺជីនអាមេរិក",
        "Guinea": "ហ្គីណេ",
        "Niger": "នីហ្សេ",
        "Libya": "លីប៊ី",
        "Romania": "រូម៉ានី",
        "Anguilla": "អង់ហ្គីឡា",
        "Togo": "តូហ្គូ",
        "Paraguay": "បារ៉ាហ្គាយ",
        "India": "ឥណ្ឌា",
        "Ireland": "អៀរឡង់",
        "Turkey": "តួកគី",
        "Oman": "អូម៉ង់",
        "Ukraine": "អ៊ុយក្រែន",
        "Spain": "អេស្ប៉ាញ",
        "Cameroon": "កាមេរូន",
        "Angola": "អង់ហ្គោឡា",
        "Mali": "ម៉ាលី",
        "Saint Vincent and the Grenadines": "សាំង វាំងសង់ និងកោះហ្គ្រេណាឌីន",
        "Cyprus": "ស៊ីប",
        "Belarus": "បេឡារុស",
        "Gabon": "ហ្គាបុង",
        "Samoa": "សាមូអា",
        "Chile": "ឈីលី",
        "United Arab Emirates": "អេមីរ៉ាតអារ៉ាប់រួម",
        "São Tomé and Príncipe": "សៅតូម៉េ និងព្រីនស៊ីប",
        "Palau": "ប៉ាលៅ",
        "Tokelau": "តូខេឡាវ",
        "Puerto Rico": "ព័រតូរីកូ",
        "Portugal": "ព័រទុយហ្កាល់",
        "Costa Rica": "កូស្តារីកា",
        "Swaziland": "ស្វាស៊ីឡង់",
        "Cape Verde": "កាបវែរ",
        "Curaçao": "គូរ៉ាកាវ",
        "Andorra": "អង់ដូរ៉ា",
        "Armenia": "អាមេនី",
        "Haiti": "ហៃទី",
        "Côte d’Ivoire": "កូតឌីវ័រ",
        "Guinea-Bissau": "ហ្គីណេ-ប៊ីស្សូ",
        "Mozambique": "ម៉ូសំប៊ិក",
        "Poland": "ប៉ូឡូញ",
        "French Polynesia": "ប៉ូលីនេស៊ីបារាំង",
        "Jersey": "ជឺស៊ី",
        "Kuwait": "កូវ៉ែត",
        "Dominican Republic": "សាធារណរដ្ឋដូមីនីកែន",
        "Kosovo": "កូសូវ៉ូ",
        "Kyrgyzstan": "កៀហ្ស៊ីស៊ីស៊ីស្តង់",
        "Syria": "ស៊ីរី",
        "Zambia": "សាំប៊ី",
        "Croatia": "ក្រូអាស៊ី",
        "Lithuania": "លីទុយអានី",
        "Albania": "អាល់បានី",
        "Netherlands": "ហុល្លង់",
        "France": "បារាំង",
        "Tunisia": "ទុយនីស៊ី",
        "Bosnia and Herzegovina": "បូស្នី និងហឺហ្សេហ្គូវីណា",
        "Bahamas": "បាហាម៉ា",
        "Somalia": "សូម៉ាលី",
        "Burundi": "ប៊ូរុនឌី",
        "Barbados": "បារបាដុស",
        "Malawi": "ម៉ាឡាវី",
        "Honduras": "ហុងឌូរ៉ាស",
        "French Guiana": "ហ្គីណាបារាំង",
        "Jordan": "ហ្សូដានី",
        "Serbia": "ស៊ែប៊ី",
        "Vanuatu": "វ៉ានូទូ",
        "Aruba": "អារុបា",
        "Guyana": "ហ្គីយ៉ាណា",
        "Lesotho": "ឡេសូតូ",
        "Taiwan": "តៃវ៉ាន់",
        "Central African Republic": "សាធារណរដ្ឋអាហ្វ្រិកកណ្ដាល",
        "Luxembourg": "លុចសំបួរ",
        "Trinidad and Tobago": "ទ្រីនីដាដ និងតូបាហ្គោ",
        "Estonia": "អេស្តូនី",
        "Montserrat": "ម៉ុងស៊េរ៉ាត",
        "Norway": "ន័រវែស",
        "North Korea": "កូរ៉េខាងជើង",
        "Myanmar": "ភូមា",
        "Sri Lanka": "ស្រីលង្កា",
        "Faroe Islands": "កោះហ្វារ៉ូ",
        "Dominica": "ដូមីនីក",
        "Kiribati": "កិរិបាទី",
        "Falkland Islands": "កោះហ្វក់ឡែន",
        "Namibia": "ណាមីប៊ី",
        "Saint Lucia": "សាំង លូស៊ី",
        "Indonesia": "ឥណ្ឌូនេស៊ី",
        "Timor-Leste": "ទីម័រខាងកើត",
        "Norfolk Island": "កោះណរហ្វុលក",
        "Bhutan": "ភូតាន",
        "Iran": "អ៊ីរ៉ង់",
        "Turkmenistan": "ទួគ្មេនីស្តង់",
        "Uganda": "អ៊ូហ្គង់ដា",
        "Kazakhstan": "កាហ្សាក់ស្ថាន",
        "Cook Islands": "កោះខូក",
        "Micronesia": "មីក្រូណេស៊ី",
        "Sint Maarten": "សាំងម៉ាទីន",
        "Liberia": "លីបេរីយ៉ា",
        "Panama": "ប៉ាណាម៉ា",
        "Malta": "ម៉ាល់តា",
        "Peru": "ប៉េរូ",
        "Philippines": "ហ្វីលីពីន",
        "Rwanda": "រវ៉ាន់ដា",
        "United Kingdom": "ចក្រភពអង់គ្លេស",
        "Martinique": "ម៉ាទីនីក",
        "Nepal": "នេប៉ាល់",
        "Guatemala": "ក្វាតេម៉ាឡា",
        "Bermuda": "ប៊ឺមុយដា",
        "Australia": "អូស្ត្រាលី",
        "Vatican City": "ទីក្រុងវ៉ាទីកង់",
        "Slovenia": "ស្លូវេនី",
        "Cayman Islands": "កោះកៃម៉ង់",
        "Hungary": "ហុងគ្រី",
        "American Samoa": "សាម័រអាមេរិក",
        "Mauritania": "ម៉ូរីតានី",
        "Japan": "ជប៉ុន",
        "Uzbekistan": "អ៊ូហ្សបេគីស្ថាន",
        "Cambodia": "កម្ពុជា",
        "Wallis & Futuna": "វ៉ាលីស និង ហ្វុយទូណា",
        "South Sudan": "ស៊ូដង់ខាងត្បូង",
        "Morocco": "ម៉ារ៉ុក",
        "Argentina": "អាហ្សង់ទីន",
        "Guadeloupe": "ក្វាឌីលូប",
        "Hong Kong": "ហុងកុង",
        "Qatar": "កាតា",
        "Tanzania": "តង់សានី",
        "Mexico": "ម៉ិកស៊ិក",
        "Russia": "រុស្ស៊ី",
        "Iceland": "អ៊ីស្លង់",
        "Monaco": "ម៉ូណាកូ",
        "Afghanistan": "អាហ្វហ្គានីស្ថាន",
        "Slovakia": "ស្លូវ៉ាគី",
        "Sweden": "ស៊ុយអែត",
        "Azerbaijan": "អាស៊ែបៃហ្សង់",
        "Bangladesh": "បង់ក្លាដែស",
        "Brazil": "ប្រេស៊ីល",
        "Cuba": "គុយបា",
        "Ghana": "ហ្គាណា",
        "Mongolia": "ម៉ុងហ្គោលី",
        "Saint Kitts and Nevis": "សាំងគីត និង ណេវីស",
        "Burkina Faso": "ប៊ូរកីណាហ្វាសូ",
        "Nicaragua": "នីការ៉ាហ្គា",
        "Malaysia": "ម៉ាឡេស៊ី",
        "Uruguay": "អ៊ូរុយហ្គាយ",
        "Brunei": "ប្រ៊ុយណេ",
        "Congo": "កុងហ្គោ",
        "Nauru": "ណូរុ",
        "Northern Mariana Islands": "កោះម៉ារីណាខាងជើង",
        "Pakistan": "ប៉ាគីស្ថាន",
        "Greenland": "ក្រីនលែន",
        "Mauritius": "ម៉ូរីស",
        "Caribbean Netherlands": "កាដាស់ហេរីញេនណេដើឡង់",
        "Belize": "បេលី",
        "Liechtenstein": "លីចទិនស្តែន",
        "Sierra Leone": "សេរ៉ាឡេអូន",
        "Czech Republic": "សាធារណរដ្ឋឆែក",
        "Moldova": "ម៉ុលដាវី",
        "Singapore": "សិង្ហបុរី",
        "Belgium": "បែលហ្សិក",
        "Maldives": "ម៉ាល់ឌីវ",
        "New Zealand": "នូវែលសេឡង់",
        "South Korea": "កូរ៉េខាងត្បូង",
        "Italy": "អ៊ីតាលី",
        "Israel": "អ៊ីស្រាអែល",
        "Grenada": "ហ្គ្រេណាដា",
        "Kenya": "កេនយ៉ា",
        "St. Helena": "សង់តាហេលេណា",
        "Guam": "ក្វាម",
        "Denmark": "ដាណឺម៉ាក",
        "New Caledonia": "កាឡេដូនីថ្មី",
        "Ecuador": "អេក្វាទ័រ",
        "Canada": "កាណាដា",
        "Egypt": "អេហ្ស៊ីប",
        "Saudi Arabia": "សោធីអារ៉ាប៊ី",
        "Botswana": "បុតស្វាណា",
        "Turks & Caicos Islands": "កោះទួក និង កៃកូស",
        "Latvia": "ឡាតវី",
        "St. Pierre & Miquelon": "សាំងពីហែរ និងមីគែល",
        "Georgia": "ហ្សកហ្សី",
        "Laos": "ឡាវ",
        "Réunion": "រេអ៊ូនីយ៉ុង",
        "Niue": "នីយូ",
        "Zimbabwe": "ហ្ស៊ីមបាប៊េ",
        "Thailand": "ថៃ",
        "Algeria": "អាល់ហ្សេរី",
        "Finland": "ហ្វាំងឡង់",
        "Macedonia": "ម៉ាសេដូនី",
        "Antigua and Barbuda": "អង់ទីហ្គា និងបាប៊ូដា",
        "Nigeria": "នីហ្សេរីយ៉ា",
        "Switzerland": "ស្វីស",
        "Bulgaria": "ប៊ុលហ្គារី",
        "Montenegro": "ម៉ុងតេណេហ្គ្រោ",
        "Tajikistan": "តាហ្ស៊ីគីស្តង់",
        "Austria": "អូទ្រីស",
        "Bolivia": "បូលីវី",
        "Sudan": "ស៊ូដង់",
        "Suriname": "ស៊ូរីណាម",
        "Iraq": "អ៊ីរ៉ាក់",
        "Bahrain": "បារ៉ែន",
        "Colombia": "កូឡុំប៊ី",
        "Papua New Guinea": "ប៉ាពួញូវហ្គីណេ",
        "Yemen": "យេម៉ែន",
        "Venezuela": "វេនេហ្ស៊ុយឡា",
        "Djibouti": "ជីបូទី",
        "British Indian Ocean Territory": "ទឹកដីមហាសមុទ្រឥណ្ឌាប្រ៊ីត",
        "Chad": "ឆាដ",
        "Germany": "អាល្លឺម៉ង់",
        "Fiji": "ហ្វ៊ីជ៊ី",
        "British Virgin Islands": "កោះវឺជីនចក្រភព",
        "San Marino": "សាន់ម៉ារីណូ",
        "Vietnam": "វៀតណាម",
        "Macau": "ម៉ាកាវ",
        "South Africa": "អាហ្វ្រិកខាងត្បូង",
        "Eritrea": "អេរីទ្រា",
        "Greece": "ក្រិក",
        "Ethiopia": "អេត្យូពី",
        "Madagascar": "ម៉ាដាហ្គាស្ការ",
        "Marshall Islands": "កោះម៉ាសែល",
        "United States": "សហរដ្ឋអាមេរិក",
        "Benin": "បេណាំង",
        "El Salvador": "អែលសាល់វ៉ាឌ័រ",
        "Lebanon": "លីបង់",
        "Palestine": "ប៉ាលេស្ទីន",
        "Tuvalu": "ទូវ៉ាលូ",
        "Solomon Islands": "កោះសូឡូម៉ុង",
        "China": "ចិន",
        "Tonga": "តុងហ្គា"
    },
};
export const isIS = {
    searchNotFound: "Engin land fannst",
    searchPlaceholder: "Leita að landi",
    countries: {
        "Gibraltar": "Gíbraltar",
        "Gambia": "Gambía",
        "Equatorial Guinea": "Miðbaugs-Gínea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaíka",
        "Seychelles": "Seychelles",
        "Comoros": "Kómoreyjar",
        "U.S. Virgin Islands": "BNA Jómfrúaeyjar",
        "Guinea": "Gínea",
        "Niger": "Níger",
        "Libya": "Líbía",
        "Romania": "Rúmenía",
        "Anguilla": "Angvilla",
        "Togo": "Tógó",
        "Paraguay": "Paragvæ",
        "India": "Indland",
        "Ireland": "Írland",
        "Turkey": "Tyrkland",
        "Oman": "Óman",
        "Ukraine": "Úkraína",
        "Spain": "Spánn",
        "Cameroon": "Kamerún",
        "Angola": "Angóla",
        "Mali": "Malí",
        "Saint Vincent and the Grenadines": "Sankti Vinsent og Grenadíneyjar",
        "Cyprus": "Kýpur",
        "Belarus": "Hvíta-Rússland",
        "Gabon": "Gabon",
        "Samoa": "Samóa",
        "Chile": "Síle",
        "United Arab Emirates": "Sameinuðu arabísku furstadæmin",
        "São Tomé and Príncipe": "Saó Tóme og Prinsípe",
        "Palau": "Palá",
        "Tokelau": "Tókelá",
        "Puerto Rico": "Púertó Ríkó",
        "Portugal": "Portúgal",
        "Costa Rica": "Kosta Ríka",
        "Swaziland": "Esvatíní",
        "Cape Verde": "Grænhöfðaeyjar",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenía",
        "Haiti": "Haítí",
        "Côte d’Ivoire": "Fílabeinsströndin",
        "Guinea-Bissau": "Gínea-Bissá",
        "Mozambique": "Mósambík",
        "Poland": "Pólland",
        "French Polynesia": "Franska Pólýnesía",
        "Jersey": "Jersey",
        "Kuwait": "Kúveit",
        "Dominican Republic": "Dóminíska lýðveldið",
        "Kosovo": "Kosóvó",
        "Kyrgyzstan": "Kirgistan",
        "Syria": "Sýrland",
        "Zambia": "Sambía",
        "Croatia": "Króatía",
        "Lithuania": "Litháen",
        "Albania": "Albanía",
        "Netherlands": "Holland",
        "France": "Frakkland",
        "Tunisia": "Túnis",
        "Bosnia and Herzegovina": "Bosnía og Hersegóvína",
        "Bahamas": "Bahamaeyjar",
        "Somalia": "Sómalía",
        "Burundi": "Búrúndí",
        "Barbados": "Barbados",
        "Malawi": "Malaví",
        "Honduras": "Hondúras",
        "French Guiana": "Franska Gvæjana",
        "Jordan": "Jórdanía",
        "Serbia": "Serbía",
        "Vanuatu": "Vanúatú",
        "Aruba": "Arúba",
        "Guyana": "Gvæjana",
        "Lesotho": "Lesótó",
        "Taiwan": "Taívan",
        "Central African Republic": "Mið-Afríkulýðveldið",
        "Luxembourg": "Lúxemborg",
        "Trinidad and Tobago": "Trínidad og Tóbagó",
        "Estonia": "Eistland",
        "Montserrat": "Montserrat",
        "Norway": "Noregur",
        "North Korea": "Norður-Kórea",
        "Myanmar": "Mjanmar",
        "Sri Lanka": "Srí Lanka",
        "Faroe Islands": "Færeyjar",
        "Dominica": "Dóminíka",
        "Kiribati": "Kíribatí",
        "Falkland Islands": "Falklandseyjar",
        "Namibia": "Namibía",
        "Saint Lucia": "Sankti Lúsía",
        "Indonesia": "Indónesía",
        "Timor-Leste": "Austur-Tímor",
        "Norfolk Island": "Norfolkeyja",
        "Bhutan": "Bútan",
        "Iran": "Íran",
        "Turkmenistan": "Túrkmenistan",
        "Uganda": "Úganda",
        "Kazakhstan": "Kasakstan",
        "Cook Islands": "Cooks-eyjar",
        "Micronesia": "Míkrónesía",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Líbería",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Perú",
        "Philippines": "Filippseyjar",
        "Rwanda": "Rúanda",
        "United Kingdom": "Bretland",
        "Martinique": "Martiník",
        "Nepal": "Nepal",
        "Guatemala": "Gvatemala",
        "Bermuda": "Bermúda",
        "Australia": "Ástralía",
        "Vatican City": "Vatíkanið",
        "Slovenia": "Slóvenía",
        "Cayman Islands": "Cayman-eyjar",
        "Hungary": "Ungverjaland",
        "American Samoa": "Ameríska Samóa",
        "Mauritania": "Máritanía",
        "Japan": "Japan",
        "Uzbekistan": "Úsbekistan",
        "Cambodia": "Kambódía",
        "Wallis & Futuna": "Wallis og Futuna",
        "South Sudan": "Suður-Súdan",
        "Morocco": "Marokkó",
        "Argentina": "Argentína",
        "Guadeloupe": "Gvadelúpeyjar",
        "Hong Kong": "Hong Kong",
        "Qatar": "Katar",
        "Tanzania": "Tansanía",
        "Mexico": "Mexíkó",
        "Russia": "Rússland",
        "Iceland": "Ísland",
        "Monaco": "Mónakó",
        "Afghanistan": "Afganistan",
        "Slovakia": "Slóvakía",
        "Sweden": "Svíþjóð",
        "Azerbaijan": "Aserbaídsjan",
        "Bangladesh": "Bangladess",
        "Brazil": "Brasilía",
        "Cuba": "Kúba",
        "Ghana": "Gana",
        "Mongolia": "Mongólía",
        "Saint Kitts and Nevis": "Sankti Kitts og Nevis",
        "Burkina Faso": "Búrkína Fasó",
        "Nicaragua": "Níkaragva",
        "Malaysia": "Malasía",
        "Uruguay": "Úrúgvæ",
        "Brunei": "Brúnei",
        "Congo": "Kongó",
        "Nauru": "Nárú",
        "Northern Mariana Islands": "Norðmaríanaeyjar",
        "Pakistan": "Pakistan",
        "Greenland": "Grænland",
        "Mauritius": "Máritíus",
        "Caribbean Netherlands": "Karíbahafshluti Hollands",
        "Belize": "Belís",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Síerra Leóne",
        "Czech Republic": "Tékkland",
        "Moldova": "Moldóva",
        "Singapore": "Singapúr",
        "Belgium": "Belgía",
        "Maldives": "Maldíveyjar",
        "New Zealand": "Nýja-Sjáland",
        "South Korea": "Suður-Kórea",
        "Italy": "Ítalía",
        "Israel": "Ísrael",
        "Grenada": "Grenada",
        "Kenya": "Kenía",
        "St. Helena": "Sankti Helena",
        "Guam": "Gvam",
        "Denmark": "Danmörk",
        "New Caledonia": "Nýja-Kaledónía",
        "Ecuador": "Ekvador",
        "Canada": "Kanada",
        "Egypt": "Egyptaland",
        "Saudi Arabia": "Sádi-Arabía",
        "Botswana": "Botsvana",
        "Turks & Caicos Islands": "Turks og Caicos eyjar",
        "Latvia": "Lettland",
        "St. Pierre & Miquelon": "Sankti Pierre og Miquelon",
        "Georgia": "Georgía",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Simbabve",
        "Thailand": "Taíland",
        "Algeria": "Alsír",
        "Finland": "Finnland",
        "Macedonia": "Makedónía",
        "Antigua and Barbuda": "Antígva og Barbúda",
        "Nigeria": "Nígería",
        "Switzerland": "Sviss",
        "Bulgaria": "Búlgaría",
        "Montenegro": "Svartfjallaland",
        "Tajikistan": "Tadsjikistan",
        "Austria": "Austurríki",
        "Bolivia": "Bólivía",
        "Sudan": "Súdan",
        "Suriname": "Súrínam",
        "Iraq": "Írak",
        "Bahrain": "Barein",
        "Colombia": "Kólumbía",
        "Papua New Guinea": "Papúa Nýja-Gínea",
        "Yemen": "Jemen",
        "Venezuela": "Venesúela",
        "Djibouti": "Djíbútí",
        "British Indian Ocean Territory": "Bresku Indlandshafseyjar",
        "Chad": "Tsjad",
        "Germany": "Þýskaland",
        "Fiji": "Fídjíeyjar",
        "British Virgin Islands": "Bresku Jómfrúaeyjar",
        "San Marino": "San Marínó",
        "Vietnam": "Víetnam",
        "Macau": "Makaó",
        "South Africa": "Suður-Afríka",
        "Eritrea": "Erítrea",
        "Greece": "Grikkland",
        "Ethiopia": "Eþíópía",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshalleyjar",
        "United States": "Bandaríkin",
        "Benin": "Benín",
        "El Salvador": "El Salvador",
        "Lebanon": "Líbanon",
        "Palestine": "Palestína",
        "Tuvalu": "Túvalú",
        "Solomon Islands": "Salómonseyjar",
        "China": "Kína",
        "Tonga": "Tonga"
    },
};
export const hiIN = {
    searchNotFound: "कोई देश नहीं मिला",
    searchPlaceholder: "देश खोजें",
    countries: {
        "Gibraltar": "जिब्राल्टर",
        "Gambia": "गाम्बिया",
        "Equatorial Guinea": "भूमध्यरेखीय गिनी",
        "Senegal": "सेनेगल",
        "Jamaica": "जमैका",
        "Seychelles": "सेशेल्स",
        "Comoros": "कोमोरोस",
        "U.S. Virgin Islands": "अमेरिकी वर्जिन द्वीपसमूह",
        "Guinea": "गिनी",
        "Niger": "नाइजर",
        "Libya": "लीबिया",
        "Romania": "रोमानिया",
        "Anguilla": "एंगुइला",
        "Togo": "टोगो",
        "Paraguay": "पैराग्वे",
        "India": "भारत",
        "Ireland": "आयरलैंड",
        "Turkey": "तुर्की",
        "Oman": "ओमान",
        "Ukraine": "यूक्रेन",
        "Spain": "स्पेन",
        "Cameroon": "कैमरून",
        "Angola": "अंगोला",
        "Mali": "माली",
        "Saint Vincent and the Grenadines": "सेंट विंसेंट और ग्रेनाडीन्स",
        "Cyprus": "साइप्रस",
        "Belarus": "बेलारूस",
        "Gabon": "गैबॉन",
        "Samoa": "समोआ",
        "Chile": "चिली",
        "United Arab Emirates": "संयुक्त अरब अमीरात",
        "São Tomé and Príncipe": "साओ टोमे और प्रिंसिपे",
        "Palau": "पलाऊ",
        "Tokelau": "टोकलाउ",
        "Puerto Rico": "प्यूर्टो रिको",
        "Portugal": "पुर्तगाल",
        "Costa Rica": "कोस्टा रिका",
        "Swaziland": "स्वाज़ीलैंड",
        "Cape Verde": "केप वर्डे",
        "Curaçao": "कुरासाओ",
        "Andorra": "अंडोरा",
        "Armenia": "आर्मेनिया",
        "Haiti": "हैती",
        "Côte d’Ivoire": "कोट दीवोआरे",
        "Guinea-Bissau": "गिनी-बिसाऊ",
        "Mozambique": "मोज़ाम्बिक",
        "Poland": "पोलैंड",
        "French Polynesia": "फ्रेंच पोलिनेशिया",
        "Jersey": "जर्सी",
        "Kuwait": "कुवैत",
        "Dominican Republic": "डोमिनिकन गणराज्य",
        "Kosovo": "कोसोवो",
        "Kyrgyzstan": "किर्गिज़स्तान",
        "Syria": "सीरिया",
        "Zambia": "ज़ाम्बिया",
        "Croatia": "क्रोएशिया",
        "Lithuania": "लिथुआनिया",
        "Albania": "अल्बानिया",
        "Netherlands": "नीदरलैंड्स",
        "France": "फ्रांस",
        "Tunisia": "ट्यूनिसिया",
        "Bosnia and Herzegovina": "बोस्निया और हर्ज़ेगोविना",
        "Bahamas": "बहामास",
        "Somalia": "सोमालिया",
        "Burundi": "बुरुंडी",
        "Barbados": "बारबाडोस",
        "Malawi": "मलावी",
        "Honduras": "होंडुरस",
        "French Guiana": "फ्रेंच गयाना",
        "Jordan": "जॉर्डन",
        "Serbia": "सर्बिया",
        "Vanuatu": "वानुआतु",
        "Aruba": "अरूबा",
        "Guyana": "गुयाना",
        "Lesotho": "लेसोथो",
        "Taiwan": "ताइवान",
        "Central African Republic": "मध्य अफ्रीकी गणराज्य",
        "Luxembourg": "लक्ज़मबर्ग",
        "Trinidad and Tobago": "त्रिनिदाद और टोबैगो",
        "Estonia": "एस्टोनिया",
        "Montserrat": "मॉन्ट्सेराट",
        "Norway": "नॉर्वे",
        "North Korea": "उत्तर कोरिया",
        "Myanmar": "म्यांमार",
        "Sri Lanka": "श्रीलंका",
        "Faroe Islands": "फैरो द्वीपसमूह",
        "Dominica": "डोमिनिका",
        "Kiribati": "किरिबाती",
        "Falkland Islands": "फ़ॉकलैंड द्वीपसमूह",
        "Namibia": "नामीबिया",
        "Saint Lucia": "सेंट लूसिया",
        "Indonesia": "इंडोनेशिया",
        "Timor-Leste": "तिमोर-लेस्ते",
        "Norfolk Island": "नॉरफ़ॉक द्वीप",
        "Bhutan": "भूटान",
        "Iran": "ईरान",
        "Turkmenistan": "तुर्कमेनिस्तान",
        "Uganda": "युगांडा",
        "Kazakhstan": "कजाखस्तान",
        "Cook Islands": "कुक द्वीपसमूह",
        "Micronesia": "माइक्रोनेशिया",
        "Sint Maarten": "सिंट मार्टेन",
        "Liberia": "लाइबेरिया",
        "Panama": "पनामा",
        "Malta": "माल्टा",
        "Peru": "पेरू",
        "Philippines": "फिलीपींस",
        "Rwanda": "रवांडा",
        "United Kingdom": "यूनाइटेड किंगडम",
        "Martinique": "मार्टीनिक",
        "Nepal": "नेपाल",
        "Guatemala": "ग्वाटेमाला",
        "Bermuda": "बरमूडा",
        "Australia": "ऑस्ट्रेलिया",
        "Vatican City": "वेटिकन सिटी",
        "Slovenia": "स्लोवेनिया",
        "Cayman Islands": "केमैन द्वीपसमूह",
        "Hungary": "हंगरी",
        "American Samoa": "अमेरिकी समोआ",
        "Mauritania": "मॉरिटानिया",
        "Japan": "जापान",
        "Uzbekistan": "उज़्बेकिस्तान",
        "Cambodia": "कंबोडिया",
        "Wallis & Futuna": "वालिस और फ़्यूचूना",
        "South Sudan": "दक्षिण सूडान",
        "Morocco": "मोरक्को",
        "Argentina": "अर्जेंटीना",
        "Guadeloupe": "ग्वाडेलोप",
        "Hong Kong": "हांगकांग",
        "Qatar": "कतर",
        "Tanzania": "तंजानिया",
        "Mexico": "मेक्सिको",
        "Russia": "रूस",
        "Iceland": "आइसलैंड",
        "Monaco": "मोनाको",
        "Afghanistan": "अफगानिस्तान",
        "Slovakia": "स्लोवाकिया",
        "Sweden": "स्वीडन",
        "Azerbaijan": "अज़रबैजान",
        "Bangladesh": "बांग्लादेश",
        "Brazil": "ब्राजील",
        "Cuba": "क्यूबा",
        "Ghana": "घाना",
        "Mongolia": "मंगोलिया",
        "Saint Kitts and Nevis": "सेंट किट्स और नेविस",
        "Burkina Faso": "बुर्किना फासो",
        "Nicaragua": "निकारागुआ",
        "Malaysia": "मलेशिया",
        "Uruguay": "उरुग्वे",
        "Brunei": "ब्रुनेई",
        "Congo": "कांगो",
        "Nauru": "नाउरू",
        "Northern Mariana Islands": "उत्तरी मारियाना द्वीपसमूह",
        "Pakistan": "पाकिस्तान",
        "Greenland": "ग्रीनलैंड",
        "Mauritius": "मॉरिशस",
        "Caribbean Netherlands": "कैरेबियाई नीदरलैंड्स",
        "Belize": "बेलीज",
        "Liechtenstein": "लिकटेंस्टीन",
        "Sierra Leone": "सिएरा लियोन",
        "Czech Republic": "चेक गणराज्य",
        "Moldova": "मोल्डोवा",
        "Singapore": "सिंगापुर",
        "Belgium": "बेल्जियम",
        "Maldives": "मालदीव",
        "New Zealand": "न्यूजीलैंड",
        "South Korea": "दक्षिण कोरिया",
        "Italy": "इटली",
        "Israel": "इज़राइल",
        "Grenada": "ग्रेनाडा",
        "Kenya": "केन्या",
        "St. Helena": "सेंट हेलेना",
        "Guam": "गुआम",
        "Denmark": "डेनमार्क",
        "New Caledonia": "न्यू कैलेडोनिया",
        "Ecuador": "इक्वाडोर",
        "Canada": "कनाडा",
        "Egypt": "मिस्र",
        "Saudi Arabia": "सऊदी अरब",
        "Botswana": "बोत्सवाना",
        "Turks & Caicos Islands": "तुर्क और कैकोस द्वीपसमूह",
        "Latvia": "लातविया",
        "St. Pierre & Miquelon": "सेंट पियरे और मिक्वेलोन",
        "Georgia": "जॉर्जिया",
        "Laos": "लाओस",
        "Réunion": "रियूनियन",
        "Niue": "नीयू",
        "Zimbabwe": "जिम्बाब्वे",
        "Thailand": "थाईलैंड",
        "Algeria": "अल्जीरिया",
        "Finland": "फिनलैंड",
        "Macedonia": "मैसेडोनिया",
        "Antigua and Barbuda": "एंटिगुआ और बारबुडा",
        "Nigeria": "नाइजीरिया",
        "Switzerland": "स्विट्जरलैंड",
        "Bulgaria": "बुल्गारिया",
        "Montenegro": "मोंटेनेग्रो",
        "Tajikistan": "तजाकिस्तान",
        "Austria": "ऑस्ट्रिया",
        "Bolivia": "बोलीविया",
        "Sudan": "सूडान",
        "Suriname": "सूरीनाम",
        "Iraq": "इराक",
        "Bahrain": "बहरीन",
        "Colombia": "कोलम्बिया",
        "Papua New Guinea": "पापुआ न्यू गिनी",
        "Yemen": "यमन",
        "Venezuela": "वेनेजुएला",
        "Djibouti": "जिबूती",
        "British Indian Ocean Territory": "ब्रिटिश हिन्द महासागर क्षेत्र",
        "Chad": "चाड",
        "Germany": "जर्मनी",
        "Fiji": "फ़िजी",
        "British Virgin Islands": "ब्रिटिश वर्जिन द्वीपसमूह",
        "San Marino": "सैन मैरीनो",
        "Vietnam": "वियतनाम",
        "Macau": "मकाओ",
        "South Africa": "दक्षिण अफ्रीका",
        "Eritrea": "एरिट्रिया",
        "Greece": "यूनान",
        "Ethiopia": "इथियोपिया",
        "Madagascar": "मेडागास्कर",
        "Marshall Islands": "मार्शल द्वीपसमूह",
        "United States": "संयुक्त राज्य अमेरिका",
        "Benin": "बेनिन",
        "El Salvador": "अल सल्वाडोर",
        "Lebanon": "लेबनान",
        "Palestine": "फिलिस्तीन",
        "Tuvalu": "तुवालु",
        "Solomon Islands": "सोलोमन द्वीपसमूह",
        "China": "चीन",
        "Tonga": "टोंगा"
    },
};
export const msMS = {
    searchNotFound: "Tiada negara ditemui",
    searchPlaceholder: "Cari negara",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Guinea Khatulistiwa",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychelles",
        "Comoros": "Komoros",
        "U.S. Virgin Islands": "Kepulauan Virgin A.S.",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libya",
        "Romania": "Romania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Ireland",
        "Turkey": "Turki",
        "Oman": "Oman",
        "Ukraine": "Ukraine",
        "Spain": "Sepanyol",
        "Cameroon": "Cameroon",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent dan Grenadines",
        "Cyprus": "Cyprus",
        "Belarus": "Belarus",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Emiriah Arab Bersatu",
        "São Tomé and Príncipe": "São Tomé dan Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cape Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Côte d’Ivoire",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mozambique",
        "Poland": "Poland",
        "French Polynesia": "Polynesia Perancis",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Republik Dominica",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kyrgyzstan",
        "Syria": "Syria",
        "Zambia": "Zambia",
        "Croatia": "Croatia",
        "Lithuania": "Lithuania",
        "Albania": "Albania",
        "Netherlands": "Belanda",
        "France": "Perancis",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia dan Herzegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Guiana Perancis",
        "Jordan": "Jordan",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Republik Afrika Tengah",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinidad dan Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Norway",
        "North Korea": "Korea Utara",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Kepulauan Faroe",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Kepulauan Falkland",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Timor-Leste",
        "Norfolk Island": "Pulau Norfolk",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Kepulauan Cook",
        "Micronesia": "Mikronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipina",
        "Rwanda": "Rwanda",
        "United Kingdom": "United Kingdom",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australia",
        "Vatican City": "Bandar Vatican",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Kepulauan Cayman",
        "Hungary": "Hungary",
        "American Samoa": "Samoa Amerika",
        "Mauritania": "Mauritania",
        "Japan": "Jepun",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kambodia",
        "Wallis & Futuna": "Wallis dan Futuna",
        "South Sudan": "Sudan Selatan",
        "Morocco": "Maghribi",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexico",
        "Russia": "Rusia",
        "Iceland": "Iceland",
        "Monaco": "Monako",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovakia",
        "Sweden": "Sweden",
        "Azerbaijan": "Azerbaijan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brazil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts dan Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Kepulauan Mariana Utara",
        "Pakistan": "Pakistan",
        "Greenland": "Greenland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Karibia Belanda",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Republik Czech",
        "Moldova": "Moldova",
        "Singapore": "Singapura",
        "Belgium": "Belgium",
        "Maldives": "Maldives",
        "New Zealand": "New Zealand",
        "South Korea": "Korea Selatan",
        "Italy": "Itali",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Saint Helena",
        "Guam": "Guam",
        "Denmark": "Denmark",
        "New Caledonia": "Kaledonia Baru",
        "Ecuador": "Ecuador",
        "Canada": "Kanada",
        "Egypt": "Mesir",
        "Saudi Arabia": "Arab Saudi",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Kepulauan Turks dan Caicos",
        "Latvia": "Latvia",
        "St. Pierre & Miquelon": "Saint Pierre dan Miquelon",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algeria",
        "Finland": "Finland",
        "Macedonia": "Macedonia",
        "Antigua and Barbuda": "Antigua dan Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Switzerland",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tajikistan",
        "Austria": "Austria",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Iraq",
        "Bahrain": "Bahrain",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papua New Guinea",
        "Yemen": "Yaman",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Wilayah Lautan Hindi British",
        "Chad": "Chad",
        "Germany": "Jerman",
        "Fiji": "Fiji",
        "British Virgin Islands": "Kepulauan Virgin British",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macau",
        "South Africa": "Afrika Selatan",
        "Eritrea": "Eritrea",
        "Greece": "Greece",
        "Ethiopia": "Ethiopia",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Kepulauan Marshall",
        "United States": "Amerika Syarikat",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Lubnan",
        "Palestine": "Palestin",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Kepulauan Solomon",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const euES = {
    searchNotFound: "Ez da herrialderik aurkitu",
    searchPlaceholder: "Bilatu herrialdea",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Ekuatore Ginea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaika",
        "Seychelles": "Seychelles",
        "Comoros": "Komoreak",
        "U.S. Virgin Islands": "AEBetako Birjina uharteak",
        "Guinea": "Ginea",
        "Niger": "Niger",
        "Libya": "Libia",
        "Romania": "Errumania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguai",
        "India": "India",
        "Ireland": "Irlanda",
        "Turkey": "Turkia",
        "Oman": "Oman",
        "Ukraine": "Ukraina",
        "Spain": "Espainia",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent eta Grenadinak",
        "Cyprus": "Zipre",
        "Belarus": "Bielorrusia",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Txile",
        "United Arab Emirates": "Arabiar Emirerri Batuak",
        "São Tomé and Príncipe": "São Tomé eta Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cabo Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haití",
        "Côte d’Ivoire": "Boli Kosta",
        "Guinea-Bissau": "Ginea-Bissau",
        "Mozambique": "Mozambike",
        "Poland": "Polonia",
        "French Polynesia": "Polinesia Frantsesa",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Dominikar Errepublika",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgizistan",
        "Syria": "Siria",
        "Zambia": "Zambia",
        "Croatia": "Kroazia",
        "Lithuania": "Lituania",
        "Albania": "Albania",
        "Netherlands": "Herbehereak",
        "France": "Frantzia",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia-Herzegovina",
        "Bahamas": "Bahamak",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Guyana Frantsesa",
        "Jordan": "Jordania",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Afrika Erdiko Errepublika",
        "Luxembourg": "Luxenburgo",
        "Trinidad and Tobago": "Trinidad eta Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Norvegia",
        "North Korea": "Ipar Korea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Faroe Uharteak",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandak",
        "Namibia": "Namibia",
        "Saint Lucia": "Santa Luzia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Ekialdeko Timor",
        "Norfolk Island": "Norfolk uhartea",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Cook Uharteak",
        "Micronesia": "Mikronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipinak",
        "Rwanda": "Ruanda",
        "United Kingdom": "Erresuma Batua",
        "Martinique": "Martinika",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australia",
        "Vatican City": "Vatikano Hiria",
        "Slovenia": "Eslovenia",
        "Cayman Islands": "Kaiman uharteak",
        "Hungary": "Hungaria",
        "American Samoa": "Amerikar Samoa",
        "Mauritania": "Mauritania",
        "Japan": "Japonia",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kanbodia",
        "Wallis & Futuna": "Wallis eta Futuna",
        "South Sudan": "Hego Sudan",
        "Morocco": "Maroko",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadalupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexiko",
        "Russia": "Errusia",
        "Iceland": "Islandia",
        "Monaco": "Monako",
        "Afghanistan": "Afganistan",
        "Slovakia": "Eslovakia",
        "Sweden": "Suedia",
        "Azerbaijan": "Azerbaijan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasil",
        "Cuba": "Kuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts eta Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nikaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguai",
        "Brunei": "Brunei",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Ipar Mariana uharteak",
        "Pakistan": "Pakistan",
        "Greenland": "Groenlandia",
        "Mauritius": "Maurizio",
        "Caribbean Netherlands": "Karibeko Herbehereak",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leona",
        "Czech Republic": "Txekiar Errepublika",
        "Moldova": "Moldavia",
        "Singapore": "Singapur",
        "Belgium": "Belgika",
        "Maldives": "Maldivak",
        "New Zealand": "Zeelanda Berria",
        "South Korea": "Hego Korea",
        "Italy": "Italia",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Santa Helena",
        "Guam": "Guam",
        "Denmark": "Danimarka",
        "New Caledonia": "Kaledonia Berria",
        "Ecuador": "Ekuador",
        "Canada": "Kanada",
        "Egypt": "Egipto",
        "Saudi Arabia": "Saudi Arabia",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks eta Caicos uharteak",
        "Latvia": "Letonia",
        "St. Pierre & Miquelon": "San Pedro eta Mikelune",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Reunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Tailandia",
        "Algeria": "Aljeria",
        "Finland": "Finlandia",
        "Macedonia": "Mazedonia",
        "Antigua and Barbuda": "Antigua eta Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Suitza",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tajikistan",
        "Austria": "Austria",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrain",
        "Colombia": "Kolonbia",
        "Papua New Guinea": "Papua Ginea Berria",
        "Yemen": "Yemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Indiako Ozeanoko Lurralde Britaniarra",
        "Chad": "Txad",
        "Germany": "Alemania",
        "Fiji": "Fiji",
        "British Virgin Islands": "Birjina britainiar uharteak",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macau",
        "South Africa": "Hegoafrika",
        "Eritrea": "Eritrea",
        "Greece": "Grezia",
        "Ethiopia": "Etiopia",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshall uharteak",
        "United States": "Ameriketako Estatu Batuak",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libano",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomon uharteak",
        "China": "Txina",
        "Tonga": "Tonga"
    },
};
export const bgBG = {
    searchNotFound: "Не е намерена държава",
    searchPlaceholder: "Търсене на държава",
    countries: {
        "Gibraltar": "Гибралтар",
        "Gambia": "Гамбия",
        "Equatorial Guinea": "Екваториална Гвинея",
        "Senegal": "Сенегал",
        "Jamaica": "Ямайка",
        "Seychelles": "Сейшели",
        "Comoros": "Коморски острови",
        "U.S. Virgin Islands": "Американски Вирджински острови",
        "Guinea": "Гвинея",
        "Niger": "Нигер",
        "Libya": "Либия",
        "Romania": "Румъния",
        "Anguilla": "Ангуила",
        "Togo": "Того",
        "Paraguay": "Парагвай",
        "India": "Индия",
        "Ireland": "Ирландия",
        "Turkey": "Турция",
        "Oman": "Оман",
        "Ukraine": "Украйна",
        "Spain": "Испания",
        "Cameroon": "Камерун",
        "Angola": "Ангола",
        "Mali": "Мали",
        "Saint Vincent and the Grenadines": "Сейнт Винсент и Гренадини",
        "Cyprus": "Кипър",
        "Belarus": "Беларус",
        "Gabon": "Габон",
        "Samoa": "Самоа",
        "Chile": "Чили",
        "United Arab Emirates": "Обединени арабски емирства",
        "São Tomé and Príncipe": "Сао Томе и Принсипи",
        "Palau": "Палау",
        "Tokelau": "Токелау",
        "Puerto Rico": "Пуерто Рико",
        "Portugal": "Португалия",
        "Costa Rica": "Коста Рика",
        "Swaziland": "Есватини",
        "Cape Verde": "Кабо Верде",
        "Curaçao": "Кюрасао",
        "Andorra": "Андора",
        "Armenia": "Армения",
        "Haiti": "Хаити",
        "Côte d’Ivoire": "Кот д'Ивоар",
        "Guinea-Bissau": "Гвинея-Бисау",
        "Mozambique": "Мозамбик",
        "Poland": "Полша",
        "French Polynesia": "Френска Полинезия",
        "Jersey": "Джърси",
        "Kuwait": "Кувейт",
        "Dominican Republic": "Доминиканска република",
        "Kosovo": "Косово",
        "Kyrgyzstan": "Киргизстан",
        "Syria": "Сирия",
        "Zambia": "Замбия",
        "Croatia": "Хърватия",
        "Lithuania": "Литва",
        "Albania": "Албания",
        "Netherlands": "Нидерландия",
        "France": "Франция",
        "Tunisia": "Тунис",
        "Bosnia and Herzegovina": "Босна и Херцеговина",
        "Bahamas": "Бахамски острови",
        "Somalia": "Сомалия",
        "Burundi": "Бурунди",
        "Barbados": "Барбадос",
        "Malawi": "Малави",
        "Honduras": "Хондурас",
        "French Guiana": "Френска Гвиана",
        "Jordan": "Йордания",
        "Serbia": "Сърбия",
        "Vanuatu": "Вануату",
        "Aruba": "Аруба",
        "Guyana": "Гаяна",
        "Lesotho": "Лесото",
        "Taiwan": "Тайван",
        "Central African Republic": "Централноафриканска република",
        "Luxembourg": "Люксембург",
        "Trinidad and Tobago": "Тринидад и Тобаго",
        "Estonia": "Естония",
        "Montserrat": "Монсерат",
        "Norway": "Норвегия",
        "North Korea": "Северна Корея",
        "Myanmar": "Мианмар",
        "Sri Lanka": "Шри Ланка",
        "Faroe Islands": "Фарьорски острови",
        "Dominica": "Доминика",
        "Kiribati": "Кирибати",
        "Falkland Islands": "Фолкландски острови",
        "Namibia": "Намибия",
        "Saint Lucia": "Сейнт Лусия",
        "Indonesia": "Индонезия",
        "Timor-Leste": "Източен Тимор",
        "Norfolk Island": "остров Норфолк",
        "Bhutan": "Бутан",
        "Iran": "Иран",
        "Turkmenistan": "Туркменистан",
        "Uganda": "Уганда",
        "Kazakhstan": "Казахстан",
        "Cook Islands": "острови Кук",
        "Micronesia": "Микронезия",
        "Sint Maarten": "Синт Мартен",
        "Liberia": "Либерия",
        "Panama": "Панама",
        "Malta": "Малта",
        "Peru": "Перу",
        "Philippines": "Филипини",
        "Rwanda": "Руанда",
        "United Kingdom": "Обединено кралство",
        "Martinique": "Мартиника",
        "Nepal": "Непал",
        "Guatemala": "Гватемала",
        "Bermuda": "Бермуди",
        "Australia": "Австралия",
        "Vatican City": "Ватикан",
        "Slovenia": "Словения",
        "Cayman Islands": "Кайманови острови",
        "Hungary": "Унгария",
        "American Samoa": "Американска Самоа",
        "Mauritania": "Мавритания",
        "Japan": "Япония",
        "Uzbekistan": "Узбекистан",
        "Cambodia": "Камбоджа",
        "Wallis & Futuna": "Уолис и Футуна",
        "South Sudan": "Южен Судан",
        "Morocco": "Мароко",
        "Argentina": "Аржентина",
        "Guadeloupe": "Гваделупа",
        "Hong Kong": "Хонконг",
        "Qatar": "Катар",
        "Tanzania": "Танзания",
        "Mexico": "Мексико",
        "Russia": "Русия",
        "Iceland": "Исландия",
        "Monaco": "Монако",
        "Afghanistan": "Афганистан",
        "Slovakia": "Словакия",
        "Sweden": "Швеция",
        "Azerbaijan": "Азербайджан",
        "Bangladesh": "Бангладеш",
        "Brazil": "Бразилия",
        "Cuba": "Куба",
        "Ghana": "Гана",
        "Mongolia": "Монголия",
        "Saint Kitts and Nevis": "Сейнт Китс и Невис",
        "Burkina Faso": "Буркина Фасо",
        "Nicaragua": "Никарагуа",
        "Malaysia": "Малайзия",
        "Uruguay": "Уругвай",
        "Brunei": "Бруней",
        "Congo": "Конго",
        "Nauru": "Науру",
        "Northern Mariana Islands": "Северни Мариански острови",
        "Pakistan": "Пакистан",
        "Greenland": "Гренландия",
        "Mauritius": "Мавриций",
        "Caribbean Netherlands": "Карибски Нидерландии",
        "Belize": "Белиз",
        "Liechtenstein": "Лихтенщайн",
        "Sierra Leone": "Сиера Леоне",
        "Czech Republic": "Чешка република",
        "Moldova": "Молдова",
        "Singapore": "Сингапур",
        "Belgium": "Белгия",
        "Maldives": "Малдиви",
        "New Zealand": "Нова Зеландия",
        "South Korea": "Южна Корея",
        "Italy": "Италия",
        "Israel": "Израел",
        "Grenada": "Гренада",
        "Kenya": "Кения",
        "St. Helena": "Света Елена",
        "Guam": "Гуам",
        "Denmark": "Дания",
        "New Caledonia": "Нова Каледония",
        "Ecuador": "Еквадор",
        "Canada": "Канада",
        "Egypt": "Египет",
        "Saudi Arabia": "Саудитска Арабия",
        "Botswana": "Ботсвана",
        "Turks & Caicos Islands": "острови Търкс и Кайкос",
        "Latvia": "Латвия",
        "St. Pierre & Miquelon": "Сен Пиер и Микелон",
        "Georgia": "Грузия",
        "Laos": "Лаос",
        "Réunion": "Реюнион",
        "Niue": "Ниуе",
        "Zimbabwe": "Зимбабве",
        "Thailand": "Тайланд",
        "Algeria": "Алжир",
        "Finland": "Финландия",
        "Macedonia": "Македония",
        "Antigua and Barbuda": "Антигуа и Барбуда",
        "Nigeria": "Нигерия",
        "Switzerland": "Швейцария",
        "Bulgaria": "България",
        "Montenegro": "Черна гора",
        "Tajikistan": "Таджикистан",
        "Austria": "Австрия",
        "Bolivia": "Боливия",
        "Sudan": "Судан",
        "Suriname": "Суринам",
        "Iraq": "Ирак",
        "Bahrain": "Бахрейн",
        "Colombia": "Колумбия",
        "Papua New Guinea": "Папуа Нова Гвинея",
        "Yemen": "Йемен",
        "Venezuela": "Венецуела",
        "Djibouti": "Джибути",
        "British Indian Ocean Territory": "Британска територия в Индийския океан",
        "Chad": "Чад",
        "Germany": "Германия",
        "Fiji": "Фиджи",
        "British Virgin Islands": "Британски Вирджински острови",
        "San Marino": "Сан Марино",
        "Vietnam": "Виетнам",
        "Macau": "Макао",
        "South Africa": "Южна Африка",
        "Eritrea": "Еритрея",
        "Greece": "Гърция",
        "Ethiopia": "Етиопия",
        "Madagascar": "Мадагаскар",
        "Marshall Islands": "Маршалови острови",
        "United States": "Съединени американски щати",
        "Benin": "Бенин",
        "El Salvador": "Ел Салвадор",
        "Lebanon": "Ливан",
        "Palestine": "Палестина",
        "Tuvalu": "Тувалу",
        "Solomon Islands": "Соломонови острови",
        "China": "Китай",
        "Tonga": "Тонга"
    },
};
export const nbNO = {
    searchNotFound: "Ingen land funnet",
    searchPlaceholder: "Søk etter land",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Ekvatorial-Guinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychellene",
        "Comoros": "Komorene",
        "U.S. Virgin Islands": "De amerikanske jomfruøyene",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libya",
        "Romania": "Romania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Irland",
        "Turkey": "Tyrkia",
        "Oman": "Oman",
        "Ukraine": "Ukraina",
        "Spain": "Spania",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent og Grenadinene",
        "Cyprus": "Kypros",
        "Belarus": "Hviterussland",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "De forente arabiske emirater",
        "São Tomé and Príncipe": "São Tomé og Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kapp Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Elfenbenskysten",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mosambik",
        "Poland": "Polen",
        "French Polynesia": "Fransk Polynesia",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Den dominikanske republikk",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgisistan",
        "Syria": "Syria",
        "Zambia": "Zambia",
        "Croatia": "Kroatia",
        "Lithuania": "Litauen",
        "Albania": "Albania",
        "Netherlands": "Nederland",
        "France": "Frankrike",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia-Hercegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Fransk Guyana",
        "Jordan": "Jordan",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Den sentralafrikanske republikk",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinidad og Tobago",
        "Estonia": "Estland",
        "Montserrat": "Montserrat",
        "Norway": "Norge",
        "North Korea": "Nord-Korea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Færøyene",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandsøyene",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Øst-Timor",
        "Norfolk Island": "Norfolkøya",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kasakhstan",
        "Cook Islands": "Cookøyene",
        "Micronesia": "Mikronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filippinene",
        "Rwanda": "Rwanda",
        "United Kingdom": "Storbritannia",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australia",
        "Vatican City": "Vatikanstaten",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Caymanøyene",
        "Hungary": "Ungarn",
        "American Samoa": "Amerikansk Samoa",
        "Mauritania": "Mauritania",
        "Japan": "Japan",
        "Uzbekistan": "Usbekistan",
        "Cambodia": "Kambodsja",
        "Wallis & Futuna": "Wallis og Futuna",
        "South Sudan": "Sør-Sudan",
        "Morocco": "Marokko",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexico",
        "Russia": "Russland",
        "Iceland": "Island",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovakia",
        "Sweden": "Sverige",
        "Azerbaijan": "Aserbajdsjan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts og Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Nord-Marianene",
        "Pakistan": "Pakistan",
        "Greenland": "Grønland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Karibisk Nederland",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Tsjekkia",
        "Moldova": "Moldova",
        "Singapore": "Singapore",
        "Belgium": "Belgia",
        "Maldives": "Maldivene",
        "New Zealand": "New Zealand",
        "South Korea": "Sør-Korea",
        "Italy": "Italia",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "St. Helena",
        "Guam": "Guam",
        "Denmark": "Danmark",
        "New Caledonia": "Ny-Caledonia",
        "Ecuador": "Ecuador",
        "Canada": "Canada",
        "Egypt": "Egypt",
        "Saudi Arabia": "Saudi-Arabia",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks- og Caicosøyene",
        "Latvia": "Latvia",
        "St. Pierre & Miquelon": "Saint-Pierre og Miquelon",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algerie",
        "Finland": "Finland",
        "Macedonia": "Makedonia",
        "Antigua and Barbuda": "Antigua og Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Sveits",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tadsjikistan",
        "Austria": "Østerrike",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrain",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papua Ny-Guinea",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Det britiske territoriet i Indiahavet",
        "Chad": "Tsjad",
        "Germany": "Tyskland",
        "Fiji": "Fiji",
        "British Virgin Islands": "De britiske jomfruøyene",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Sør-Afrika",
        "Eritrea": "Eritrea",
        "Greece": "Hellas",
        "Ethiopia": "Etiopia",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshalløyene",
        "United States": "USA",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomonøyene",
        "China": "Kina",
        "Tonga": "Tonga"
    },
};
export const plPL = {
    searchNotFound: "Nie znaleziono kraju",
    searchPlaceholder: "Szukaj kraju",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Gwinea Równikowa",
        "Senegal": "Senegal",
        "Jamaica": "Jamajka",
        "Seychelles": "Seszele",
        "Comoros": "Komory",
        "U.S. Virgin Islands": "Wyspy Dziewicze Stanów Zjednoczonych",
        "Guinea": "Gwinea",
        "Niger": "Niger",
        "Libya": "Libia",
        "Romania": "Rumunia",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paragwaj",
        "India": "Indie",
        "Ireland": "Irlandia",
        "Turkey": "Turcja",
        "Oman": "Oman",
        "Ukraine": "Ukraina",
        "Spain": "Hiszpania",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent i Grenadyny",
        "Cyprus": "Cypr",
        "Belarus": "Białoruś",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Zjednoczone Emiraty Arabskie",
        "São Tomé and Príncipe": "Wyspy Świętego Tomasza i Książęca",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Portoryko",
        "Portugal": "Portugalia",
        "Costa Rica": "Kostaryka",
        "Swaziland": "Eswatini",
        "Cape Verde": "Wyspy Zielonego Przylądka",
        "Curaçao": "Curaçao",
        "Andorra": "Andora",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Wybrzeże Kości Słoniowej",
        "Guinea-Bissau": "Gwinea Bissau",
        "Mozambique": "Mozambik",
        "Poland": "Polska",
        "French Polynesia": "Polinezja Francuska",
        "Jersey": "Jersey",
        "Kuwait": "Kuwejt",
        "Dominican Republic": "Dominikana",
        "Kosovo": "Kosowo",
        "Kyrgyzstan": "Kirgistan",
        "Syria": "Syria",
        "Zambia": "Zambia",
        "Croatia": "Chorwacja",
        "Lithuania": "Litwa",
        "Albania": "Albania",
        "Netherlands": "Holandia",
        "France": "Francja",
        "Tunisia": "Tunezja",
        "Bosnia and Herzegovina": "Bośnia i Hercegowina",
        "Bahamas": "Bahamy",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Gujana Francuska",
        "Jordan": "Jordania",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Gujana",
        "Lesotho": "Lesotho",
        "Taiwan": "Tajwan",
        "Central African Republic": "Republika Środkowoafrykańska",
        "Luxembourg": "Luksemburg",
        "Trinidad and Tobago": "Trynidad i Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Norwegia",
        "North Korea": "Korea Północna",
        "Myanmar": "Mjanma",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Wyspy Owcze",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandy",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonezja",
        "Timor-Leste": "Timor Wschodni",
        "Norfolk Island": "Wyspa Norfolk",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazachstan",
        "Cook Islands": "Wyspy Cooka",
        "Micronesia": "Mikronezja",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipiny",
        "Rwanda": "Rwanda",
        "United Kingdom": "Wielka Brytania",
        "Martinique": "Martynika",
        "Nepal": "Nepal",
        "Guatemala": "Gwatemala",
        "Bermuda": "Bermudy",
        "Australia": "Australia",
        "Vatican City": "Watykan",
        "Slovenia": "Słowenia",
        "Cayman Islands": "Kajmany",
        "Hungary": "Węgry",
        "American Samoa": "Samoa Amerykańskie",
        "Mauritania": "Mauretania",
        "Japan": "Japonia",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kambodża",
        "Wallis & Futuna": "Wallis i Futuna",
        "South Sudan": "Sudan Południowy",
        "Morocco": "Maroko",
        "Argentina": "Argentyna",
        "Guadeloupe": "Gwadelupa",
        "Hong Kong": "Hongkong",
        "Qatar": "Katar",
        "Tanzania": "Tanzania",
        "Mexico": "Meksyk",
        "Russia": "Rosja",
        "Iceland": "Islandia",
        "Monaco": "Monako",
        "Afghanistan": "Afganistan",
        "Slovakia": "Słowacja",
        "Sweden": "Szwecja",
        "Azerbaijan": "Azerbejdżan",
        "Bangladesh": "Bangladesz",
        "Brazil": "Brazylia",
        "Cuba": "Kuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts i Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nikaragua",
        "Malaysia": "Malezja",
        "Uruguay": "Urugwaj",
        "Brunei": "Brunei",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Mariany Północne",
        "Pakistan": "Pakistan",
        "Greenland": "Grenlandia",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Niderlandy Karaibskie",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Czechy",
        "Moldova": "Mołdawia",
        "Singapore": "Singapur",
        "Belgium": "Belgia",
        "Maldives": "Malediwy",
        "New Zealand": "Nowa Zelandia",
        "South Korea": "Korea Południowa",
        "Italy": "Włochy",
        "Israel": "Izrael",
        "Grenada": "Grenada",
        "Kenya": "Kenia",
        "St. Helena": "Wyspa Świętej Heleny",
        "Guam": "Guam",
        "Denmark": "Dania",
        "New Caledonia": "Nowa Kaledonia",
        "Ecuador": "Ekwador",
        "Canada": "Kanada",
        "Egypt": "Egipt",
        "Saudi Arabia": "Arabia Saudyjska",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks i Caicos",
        "Latvia": "Łotwa",
        "St. Pierre & Miquelon": "Saint-Pierre i Miquelon",
        "Georgia": "Gruzja",
        "Laos": "Laos",
        "Réunion": "Reunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Tajlandia",
        "Algeria": "Algieria",
        "Finland": "Finlandia",
        "Macedonia": "Macedonia",
        "Antigua and Barbuda": "Antigua i Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Szwajcaria",
        "Bulgaria": "Bułgaria",
        "Montenegro": "Czarnogóra",
        "Tajikistan": "Tadżykistan",
        "Austria": "Austria",
        "Bolivia": "Boliwia",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrajn",
        "Colombia": "Kolumbia",
        "Papua New Guinea": "Papua-Nowa Gwinea",
        "Yemen": "Jemen",
        "Venezuela": "Wenezuela",
        "Djibouti": "Dżibuti",
        "British Indian Ocean Territory": "Brytyjskie Terytorium Oceanu Indyjskiego",
        "Chad": "Czad",
        "Germany": "Niemcy",
        "Fiji": "Fidżi",
        "British Virgin Islands": "Brytyjskie Wyspy Dziewicze",
        "San Marino": "San Marino",
        "Vietnam": "Wietnam",
        "Macau": "Makau",
        "South Africa": "Republika Południowej Afryki",
        "Eritrea": "Erytrea",
        "Greece": "Grecja",
        "Ethiopia": "Etiopia",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Wyspy Marshalla",
        "United States": "Stany Zjednoczone",
        "Benin": "Benin",
        "El Salvador": "Salwador",
        "Lebanon": "Liban",
        "Palestine": "Palestyna",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Wyspy Salomona",
        "China": "Chiny",
        "Tonga": "Tonga"
    },
};
export const nnNO = {
    searchNotFound: "Ingen land funnet",
    searchPlaceholder: "Søk etter land",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Ekvatorial-Guinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychellene",
        "Comoros": "Komorene",
        "U.S. Virgin Islands": "De amerikanske jomfruøyene",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libya",
        "Romania": "Romania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Irland",
        "Turkey": "Tyrkia",
        "Oman": "Oman",
        "Ukraine": "Ukraina",
        "Spain": "Spania",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent og Grenadinene",
        "Cyprus": "Kypros",
        "Belarus": "Hviterussland",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "De forente arabiske emirater",
        "São Tomé and Príncipe": "São Tomé og Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kapp Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Elfenbenskysten",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mosambik",
        "Poland": "Polen",
        "French Polynesia": "Fransk Polynesia",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Den dominikanske republikk",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgisistan",
        "Syria": "Syria",
        "Zambia": "Zambia",
        "Croatia": "Kroatia",
        "Lithuania": "Litauen",
        "Albania": "Albania",
        "Netherlands": "Nederland",
        "France": "Frankrike",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia-Hercegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Fransk Guyana",
        "Jordan": "Jordan",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Den sentralafrikanske republikk",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinidad og Tobago",
        "Estonia": "Estland",
        "Montserrat": "Montserrat",
        "Norway": "Norge",
        "North Korea": "Nord-Korea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Færøyene",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandsøyene",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Øst-Timor",
        "Norfolk Island": "Norfolkøya",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kasakhstan",
        "Cook Islands": "Cookøyene",
        "Micronesia": "Mikronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filippinene",
        "Rwanda": "Rwanda",
        "United Kingdom": "Storbritannia",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australia",
        "Vatican City": "Vatikanstaten",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Caymanøyene",
        "Hungary": "Ungarn",
        "American Samoa": "Amerikansk Samoa",
        "Mauritania": "Mauritania",
        "Japan": "Japan",
        "Uzbekistan": "Usbekistan",
        "Cambodia": "Kambodsja",
        "Wallis & Futuna": "Wallis og Futuna",
        "South Sudan": "Sør-Sudan",
        "Morocco": "Marokko",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexico",
        "Russia": "Russland",
        "Iceland": "Island",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovakia",
        "Sweden": "Sverige",
        "Azerbaijan": "Aserbajdsjan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts og Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Nord-Marianene",
        "Pakistan": "Pakistan",
        "Greenland": "Grønland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Karibisk Nederland",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Tsjekkia",
        "Moldova": "Moldova",
        "Singapore": "Singapore",
        "Belgium": "Belgia",
        "Maldives": "Maldivene",
        "New Zealand": "New Zealand",
        "South Korea": "Sør-Korea",
        "Italy": "Italia",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "St. Helena",
        "Guam": "Guam",
        "Denmark": "Danmark",
        "New Caledonia": "Ny-Caledonia",
        "Ecuador": "Ecuador",
        "Canada": "Canada",
        "Egypt": "Egypt",
        "Saudi Arabia": "Saudi-Arabia",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks- og Caicosøyene",
        "Latvia": "Latvia",
        "St. Pierre & Miquelon": "Saint-Pierre og Miquelon",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algerie",
        "Finland": "Finland",
        "Macedonia": "Makedonia",
        "Antigua and Barbuda": "Antigua og Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Sveits",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tadsjikistan",
        "Austria": "Østerrike",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrain",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papua Ny-Guinea",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Det britiske territoriet i Indiahavet",
        "Chad": "Tsjad",
        "Germany": "Tyskland",
        "Fiji": "Fiji",
        "British Virgin Islands": "De britiske jomfruøyene",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Sør-Afrika",
        "Eritrea": "Eritrea",
        "Greece": "Hellas",
        "Ethiopia": "Etiopia",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshalløyene",
        "United States": "USA",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomonøyene",
        "China": "Kina",
        "Tonga": "Tonga"
    },
};
export const mkMK = {
    searchNotFound: "Не е најдена држава",
    searchPlaceholder: "Пребарај држава",
    countries: {
        "Gibraltar": "Гибралтар",
        "Gambia": "Гамбија",
        "Equatorial Guinea": "Екваторијална Гвинеја",
        "Senegal": "Сенегал",
        "Jamaica": "Јамајка",
        "Seychelles": "Сејшели",
        "Comoros": "Комори",
        "U.S. Virgin Islands": "Американски Девствени Острови",
        "Guinea": "Гвинеја",
        "Niger": "Нигер",
        "Libya": "Либија",
        "Romania": "Романија",
        "Anguilla": "Ангуила",
        "Togo": "Того",
        "Paraguay": "Парагвај",
        "India": "Индија",
        "Ireland": "Ирска",
        "Turkey": "Турција",
        "Oman": "Оман",
        "Ukraine": "Украина",
        "Spain": "Шпанија",
        "Cameroon": "Камерун",
        "Angola": "Ангола",
        "Mali": "Мали",
        "Saint Vincent and the Grenadines": "Свети Винсент и Гренадини",
        "Cyprus": "Кипар",
        "Belarus": "Белорусија",
        "Gabon": "Габон",
        "Samoa": "Самоа",
        "Chile": "Чиле",
        "United Arab Emirates": "Обединети Арапски Емирати",
        "São Tomé and Príncipe": "Сао Томе и Принсипе",
        "Palau": "Палау",
        "Tokelau": "Токелау",
        "Puerto Rico": "Порторико",
        "Portugal": "Португалија",
        "Costa Rica": "Костарика",
        "Swaziland": "Есватини",
        "Cape Verde": "Зеленортски Острови",
        "Curaçao": "Курасао",
        "Andorra": "Андора",
        "Armenia": "Ерменија",
        "Haiti": "Хаити",
        "Côte d’Ivoire": "Брегот на Слоновата Коска",
        "Guinea-Bissau": "Гвинеја-Бисао",
        "Mozambique": "Мозамбик",
        "Poland": "Полска",
        "French Polynesia": "Француска Полинезија",
        "Jersey": "Џерси",
        "Kuwait": "Кувајт",
        "Dominican Republic": "Доминиканска Република",
        "Kosovo": "Косово",
        "Kyrgyzstan": "Киргистан",
        "Syria": "Сирија",
        "Zambia": "Замбија",
        "Croatia": "Хрватска",
        "Lithuania": "Литванија",
        "Albania": "Албанија",
        "Netherlands": "Холандија",
        "France": "Франција",
        "Tunisia": "Тунис",
        "Bosnia and Herzegovina": "Босна и Херцеговина",
        "Bahamas": "Бахами",
        "Somalia": "Сомалија",
        "Burundi": "Бурунди",
        "Barbados": "Барбадос",
        "Malawi": "Малави",
        "Honduras": "Хондурас",
        "French Guiana": "Француска Гвајана",
        "Jordan": "Јордан",
        "Serbia": "Србија",
        "Vanuatu": "Вануату",
        "Aruba": "Аруба",
        "Guyana": "Гвајана",
        "Lesotho": "Лесото",
        "Taiwan": "Тајван",
        "Central African Republic": "Централноафриканска Република",
        "Luxembourg": "Луксембург",
        "Trinidad and Tobago": "Тринидад и Тобаго",
        "Estonia": "Естонија",
        "Montserrat": "Монсерат",
        "Norway": "Норвешка",
        "North Korea": "Северна Кореја",
        "Myanmar": "Мјанмар",
        "Sri Lanka": "Шри Ланка",
        "Faroe Islands": "Фарски Острови",
        "Dominica": "Доминика",
        "Kiribati": "Кирибати",
        "Falkland Islands": "Фолкландски Острови",
        "Namibia": "Намибија",
        "Saint Lucia": "Света Луција",
        "Indonesia": "Индонезија",
        "Timor-Leste": "Источен Тимор",
        "Norfolk Island": "Норфолшки Острови",
        "Bhutan": "Бутан",
        "Iran": "Иран",
        "Turkmenistan": "Туркменистан",
        "Uganda": "Уганда",
        "Kazakhstan": "Казахстан",
        "Cook Islands": "Кукови Острови",
        "Micronesia": "Микронезија",
        "Sint Maarten": "Синт Мартен",
        "Liberia": "Либерија",
        "Panama": "Панама",
        "Malta": "Малта",
        "Peru": "Перу",
        "Philippines": "Филипини",
        "Rwanda": "Руанда",
        "United Kingdom": "Обединето Кралство",
        "Martinique": "Мартиник",
        "Nepal": "Непал",
        "Guatemala": "Гватемала",
        "Bermuda": "Бермуда",
        "Australia": "Австралија",
        "Vatican City": "Ватикан",
        "Slovenia": "Словенија",
        "Cayman Islands": "Кајмански Острови",
        "Hungary": "Унгарија",
        "American Samoa": "Американска Самоа",
        "Mauritania": "Мавританија",
        "Japan": "Јапонија",
        "Uzbekistan": "Узбекистан",
        "Cambodia": "Камбоџа",
        "Wallis & Futuna": "Валис и Футуна",
        "South Sudan": "Јужен Судан",
        "Morocco": "Мароко",
        "Argentina": "Аргентина",
        "Guadeloupe": "Гвадалупе",
        "Hong Kong": "Хонг Конг",
        "Qatar": "Катар",
        "Tanzania": "Танзанија",
        "Mexico": "Мексико",
        "Russia": "Русија",
        "Iceland": "Исланд",
        "Monaco": "Монако",
        "Afghanistan": "Авганистан",
        "Slovakia": "Словачка",
        "Sweden": "Шведска",
        "Azerbaijan": "Азербејџан",
        "Bangladesh": "Бангладеш",
        "Brazil": "Бразил",
        "Cuba": "Куба",
        "Ghana": "Гана",
        "Mongolia": "Монголија",
        "Saint Kitts and Nevis": "Сент Китс и Невис",
        "Burkina Faso": "Буркина Фасо",
        "Nicaragua": "Никарагва",
        "Malaysia": "Малезија",
        "Uruguay": "Уругвај",
        "Brunei": "Брунеј",
        "Congo": "Конго",
        "Nauru": "Науру",
        "Northern Mariana Islands": "Северни Маријански Острови",
        "Pakistan": "Пакистан",
        "Greenland": "Гренланд",
        "Mauritius": "Маврициус",
        "Caribbean Netherlands": "Карипска Холандија",
        "Belize": "Белизе",
        "Liechtenstein": "Лихтенштајн",
        "Sierra Leone": "Сиера Леоне",
        "Czech Republic": "Чешка Република",
        "Moldova": "Молдавија",
        "Singapore": "Сингапур",
        "Belgium": "Белгија",
        "Maldives": "Малдиви",
        "New Zealand": "Нов Зеланд",
        "South Korea": "Јужна Кореја",
        "Italy": "Италија",
        "Israel": "Израел",
        "Grenada": "Гренада",
        "Kenya": "Кенија",
        "St. Helena": "Света Елена",
        "Guam": "Гуам",
        "Denmark": "Данска",
        "New Caledonia": "Нова Каледонија",
        "Ecuador": "Еквадор",
        "Canada": "Канада",
        "Egypt": "Египет",
        "Saudi Arabia": "Саудиска Арабија",
        "Botswana": "Боцвана",
        "Turks & Caicos Islands": "Туркс и Кајкос",
        "Latvia": "Латвија",
        "St. Pierre & Miquelon": "Сен Пјер и Микелон",
        "Georgia": "Грузија",
        "Laos": "Лаос",
        "Réunion": "Реинион",
        "Niue": "Ниуе",
        "Zimbabwe": "Зимбабве",
        "Thailand": "Тајланд",
        "Algeria": "Алжир",
        "Finland": "Финска",
        "Macedonia": "Северна Македонија",
        "Antigua and Barbuda": "Антигва и Барбуда",
        "Nigeria": "Нигерија",
        "Switzerland": "Швајцарија",
        "Bulgaria": "Бугарија",
        "Montenegro": "Црна Гора",
        "Tajikistan": "Таџикистан",
        "Austria": "Австрија",
        "Bolivia": "Боливија",
        "Sudan": "Судан",
        "Suriname": "Суринам",
        "Iraq": "Ирак",
        "Bahrain": "Бахреин",
        "Colombia": "Колумбија",
        "Papua New Guinea": "Папуа Нова Гвинеја",
        "Yemen": "Јемен",
        "Venezuela": "Венецуела",
        "Djibouti": "Џибути",
        "British Indian Ocean Territory": "Британска територија на Индискиот Океан",
        "Chad": "Чад",
        "Germany": "Германија",
        "Fiji": "Фиџи",
        "British Virgin Islands": "Британски Девствени Острови",
        "San Marino": "Сан Марино",
        "Vietnam": "Виетнам",
        "Macau": "Макао",
        "South Africa": "Јужна Африка",
        "Eritrea": "Еритреја",
        "Greece": "Грција",
        "Ethiopia": "Етиопија",
        "Madagascar": "Мадагаскар",
        "Marshall Islands": "Маршалски Острови",
        "United States": "Соединети Американски Држави",
        "Benin": "Бенин",
        "El Salvador": "Салвадор",
        "Lebanon": "Либан",
        "Palestine": "Палестина",
        "Tuvalu": "Тувалу",
        "Solomon Islands": "Соломонови Острови",
        "China": "Кина",
        "Tonga": "Тонга"
    },
};
export const taIN = {
    searchNotFound: "நாடு கிடைக்கவில்லை",
    searchPlaceholder: "நாட்டைத் தேடு",
    countries: {
        "Gibraltar": "ஜிப்ரால்டர்",
        "Gambia": "காம்பியா",
        "Equatorial Guinea": "இக்வேட்டோரியல் கினியா",
        "Senegal": "செனகல்",
        "Jamaica": "ஜமைகா",
        "Seychelles": "சீஷெல்ஸ்",
        "Comoros": "கோமரோஸ்",
        "U.S. Virgin Islands": "அமெரிக்க மலைவெற்றியூர்",
        "Guinea": "கினியா",
        "Niger": "நைஜர்",
        "Libya": "லிபியா",
        "Romania": "ருமேனியா",
        "Anguilla": "அன்கிலா",
        "Togo": "டோகோ",
        "Paraguay": "பராகுவே",
        "India": "இந்தியா",
        "Ireland": "அயர்லாந்து",
        "Turkey": "துருக்கி",
        "Oman": "ஓமன்",
        "Ukraine": "உக்ரைன்",
        "Spain": "ஸ்பெயின்",
        "Cameroon": "கேமரூன்",
        "Angola": "அங்கோலா",
        "Mali": "மாலி",
        "Saint Vincent and the Grenadines": "செயின்ட் வின்சென்ட் மற்றும் கிரெனடைன்ஸ்",
        "Cyprus": "சைப்ரஸ்",
        "Belarus": "பெலாரஸ்",
        "Gabon": "கேபான்",
        "Samoa": "சமோவா",
        "Chile": "சிலி",
        "United Arab Emirates": "ஐக்கிய அரபு அமீரகம்",
        "São Tomé and Príncipe": "சாவ் தாமே மற்றும் பிரின்ஸிபி",
        "Palau": "பலாவ்",
        "Tokelau": "டோகெலாவ்",
        "Puerto Rico": "பியூர்ட்டோ ரிகோ",
        "Portugal": "போர்ச்சுகல்",
        "Costa Rica": "கோஸ்டா ரிக்கா",
        "Swaziland": "எஸ்வதினி",
        "Cape Verde": "கேப் வெர்டே",
        "Curaçao": "குராகாவ்",
        "Andorra": "அன்டோரா",
        "Armenia": "அர்மேனியா",
        "Haiti": "ஹைத்தி",
        "Côte d’Ivoire": "கோட் தி'இவோயர்",
        "Guinea-Bissau": "கினி-பிஸ்ஸோ",
        "Mozambique": "மொசாம்பிக்",
        "Poland": "போலந்து",
        "French Polynesia": "பிரஞ்சுப் பாலினேசியா",
        "Jersey": "ஜெர்சி",
        "Kuwait": "குவைத்",
        "Dominican Republic": "டொமினிகன் குடியரசு",
        "Kosovo": "கொசோவோ",
        "Kyrgyzstan": "கிர்கிஸ்தான்",
        "Syria": "சிரியா",
        "Zambia": "ஜாம்பியா",
        "Croatia": "குரோயேஷியா",
        "Lithuania": "லிதுவேனியா",
        "Albania": "அல்பேனியா",
        "Netherlands": "நெதர்லாந்து",
        "France": "பிரான்ஸ்",
        "Tunisia": "டுனிசியா",
        "Bosnia and Herzegovina": "போஸ்னியா மற்றும் ஹெர்செகோவினா",
        "Bahamas": "பஹாமாஸ்",
        "Somalia": "சோமாலியா",
        "Burundi": "புருண்டி",
        "Barbados": "பார்படோஸ்",
        "Malawi": "மலாவி",
        "Honduras": "ஹோண்டூரஸ்",
        "French Guiana": "பிரஞ்சுப் கயானா",
        "Jordan": "ஜோர்டான்",
        "Serbia": "செர்பியா",
        "Vanuatu": "வனுவாட்டு",
        "Aruba": "அரூபா",
        "Guyana": "கயானா",
        "Lesotho": "லெசோதோ",
        "Taiwan": "தைவான்",
        "Central African Republic": "மத்திய ஆப்பிரிக்கக் குடியரசு",
        "Luxembourg": "லக்ஸம்பர்க்",
        "Trinidad and Tobago": "டிரினிடாட் மற்றும் டொபாகோ",
        "Estonia": "எஸ்டோனியா",
        "Montserrat": "மொன்செரட்",
        "Norway": "நார்வே",
        "North Korea": "வட கொரியா",
        "Myanmar": "மியான்மார்",
        "Sri Lanka": "இலங்கை",
        "Faroe Islands": "பரோ தீவுகள்",
        "Dominica": "டொமினிகா",
        "Kiribati": "கிரிபட்டி",
        "Falkland Islands": "பால்க்லாந்து தீவுகள்",
        "Namibia": "நமீபியா",
        "Saint Lucia": "செயின்ட் லூசியா",
        "Indonesia": "இந்தோனேசியா",
        "Timor-Leste": "திமோர்-லெஸ்டே",
        "Norfolk Island": "நார்ஃபோக் தீவு",
        "Bhutan": "பூடான்",
        "Iran": "ஈரான்",
        "Turkmenistan": "துர்க்மெனிஸ்தான்",
        "Uganda": "உகாண்டா",
        "Kazakhstan": "கஜகஸ்தான்",
        "Cook Islands": "குக் தீவுகள்",
        "Micronesia": "மைக்ரோநேசியா",
        "Sint Maarten": "சின்ட் மார்டன்",
        "Liberia": "லைபீரியா",
        "Panama": "பனாமா",
        "Malta": "மால்டா",
        "Peru": "பெரு",
        "Philippines": "பிலிப்பைன்ஸ்",
        "Rwanda": "ருவாண்டா",
        "United Kingdom": "ஐக்கிய இராச்சியம்",
        "Martinique": "மார்டினிக்",
        "Nepal": "நேபாளம்",
        "Guatemala": "குவாத்தமாலா",
        "Bermuda": "பெர்முடா",
        "Australia": "ஆஸ்திரேலியா",
        "Vatican City": "வத்திக்கான் நகரம்",
        "Slovenia": "ஸ்லோவேனியா",
        "Cayman Islands": "கெய்மென் தீவுகள்",
        "Hungary": "ஹங்கேரி",
        "American Samoa": "அமெரிக்க சமோவா",
        "Mauritania": "மொரிட்டானியா",
        "Japan": "ஜப்பான்",
        "Uzbekistan": "உஸ்பெகிஸ்தான்",
        "Cambodia": "கம்போடியா",
        "Wallis & Futuna": "வாலிஸ் மற்றும் ஃபுடுனா",
        "South Sudan": "தெற்கு சூடான்",
        "Morocco": "மொராக்கோ",
        "Argentina": "அர்ஜென்டினா",
        "Guadeloupe": "குவாதெலோப்",
        "Hong Kong": "ஹாங் காங்",
        "Qatar": "கத்தார்",
        "Tanzania": "தான்சானியா",
        "Mexico": "மெக்சிகோ",
        "Russia": "ரஷ்யா",
        "Iceland": "ஐஸ்லாந்து",
        "Monaco": "மொனாகோ",
        "Afghanistan": "ஆப்கானிஸ்தான்",
        "Slovakia": "ஸ்லோவாகியா",
        "Sweden": "ஸ்வீடன்",
        "Azerbaijan": "அசர்பைஜான்",
        "Bangladesh": "பங்களாதேஷ்",
        "Brazil": "பிரேசில்",
        "Cuba": "கியூபா",
        "Ghana": "கானா",
        "Mongolia": "மங்கோலியா",
        "Saint Kitts and Nevis": "செயின்ட் கிட்ஸ் மற்றும் நெவிஸ்",
        "Burkina Faso": "புர்கினா ஃபாஸோ",
        "Nicaragua": "நிகாரகுவா",
        "Malaysia": "மலேசியா",
        "Uruguay": "உருகுவே",
        "Brunei": "புருனே",
        "Congo": "காங்கோ",
        "Nauru": "நௌரு",
        "Northern Mariana Islands": "வடக்கு மரியானா தீவுகள்",
        "Pakistan": "பாகிஸ்தான்",
        "Greenland": "கிரீன்லாந்து",
        "Mauritius": "மொரீஷியஸ்",
        "Caribbean Netherlands": "கரிபியன் நெதர்லாந்து",
        "Belize": "பெலிஸ்",
        "Liechtenstein": "லிச்செஸ்டெய்ன்",
        "Sierra Leone": "சியெரா லியோன்",
        "Czech Republic": "செக் குடியரசு",
        "Moldova": "மொல்டோவா",
        "Singapore": "சிங்கப்பூர்",
        "Belgium": "பெல்ஜியம்",
        "Maldives": "மாலத்தீவுகள்",
        "New Zealand": "நியூசிலாந்து",
        "South Korea": "தென் கொரியா",
        "Italy": "இத்தாலி",
        "Israel": "இஸ்ரேல்",
        "Grenada": "கிரெனடா",
        "Kenya": "கென்யா",
        "St. Helena": "செயின்ட் ஹெலினா",
        "Guam": "குவாம்",
        "Denmark": "டென்மார்க்",
        "New Caledonia": "நியூ கலிடோனியா",
        "Ecuador": "ஈக்வடார்",
        "Canada": "கனடா",
        "Egypt": "எகிப்து",
        "Saudi Arabia": "சவுதி அரேபியா",
        "Botswana": "போட்ஸ்வானா",
        "Turks & Caicos Islands": "டர்க்ஸ் மற்றும் கைகோஸ் தீவுகள்",
        "Latvia": "லாட்வியா",
        "St. Pierre & Miquelon": "செயின்ட் பியரே மற்றும் மிக்வெலான்",
        "Georgia": "ஜோர்ஜியா",
        "Laos": "லாவோஸ்",
        "Réunion": "ரியூனியன்",
        "Niue": "நியுவே",
        "Zimbabwe": "ஜிம்பாப்வே",
        "Thailand": "தாய்லாந்து",
        "Algeria": "அல்ஜீரியா",
        "Finland": "பின்லாந்து",
        "Macedonia": "மாசிடோனியா",
        "Antigua and Barbuda": "ஆண்டிகுவா மற்றும் பார்புடா",
        "Nigeria": "நைஜீரியா",
        "Switzerland": "சுவிட்சர்லாந்து",
        "Bulgaria": "பல்கேரியா",
        "Montenegro": "மோன்டெனிக்ரோ",
        "Tajikistan": "தஜிகிஸ்தான்",
        "Austria": "ஆஸ்திரியா",
        "Bolivia": "பொலிவியா",
        "Sudan": "சூடான்",
        "Suriname": "சூரினாம்",
        "Iraq": "ஈராக்",
        "Bahrain": "பஹ்ரைன்",
        "Colombia": "கொலம்பியா",
        "Papua New Guinea": "பாப்புவா நியூ கினியா",
        "Yemen": "யேமன்",
        "Venezuela": "வெனிசுவேலா",
        "Djibouti": "ஜிபௌட்டி",
        "British Indian Ocean Territory": "பிரிட்டிஷ் இந்தியப் பெருங்கடல் பிரதேசம்",
        "Chad": "சாட்",
        "Germany": "ஜெர்மனி",
        "Fiji": "ஃபிஜி",
        "British Virgin Islands": "பிரிட்டிஷ் கன்னி தீவுகள்",
        "San Marino": "சான் மரினோ",
        "Vietnam": "வியட்நாம்",
        "Macau": "மகாவோ",
        "South Africa": "தென் ஆப்பிரிக்கா",
        "Eritrea": "எரிட்ரியா",
        "Greece": "கிரீஸ்",
        "Ethiopia": "எத்தியோப்பியா",
        "Madagascar": "மடகாஸ்கர்",
        "Marshall Islands": "மார்ஷல் தீவுகள்",
        "United States": "அமெரிக்கா",
        "Benin": "பெனின்",
        "El Salvador": "எல் சால்வடோர்",
        "Lebanon": "லெபனான்",
        "Palestine": "பாலஸ்தீனம்",
        "Tuvalu": "துவாலு",
        "Solomon Islands": "சாலமன் தீவுகள்",
        "China": "சீனா",
        "Tonga": "டோங்கா"
    },
};
export const caES = {
    searchNotFound: "Cap país trobat",
    searchPlaceholder: "Cerca un país",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gàmbia",
        "Equatorial Guinea": "Guinea Equatorial",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychelles",
        "Comoros": "Comores",
        "U.S. Virgin Islands": "Illes Verges dels EUA",
        "Guinea": "Guinea",
        "Niger": "Níger",
        "Libya": "Líbia",
        "Romania": "Romania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguai",
        "India": "Índia",
        "Ireland": "Irlanda",
        "Turkey": "Turquia",
        "Oman": "Oman",
        "Ukraine": "Ucraïna",
        "Spain": "Espanya",
        "Cameroon": "Camerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent i les Grenadines",
        "Cyprus": "Xipre",
        "Belarus": "Bielorússia",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Xile",
        "United Arab Emirates": "Emirats Àrabs Units",
        "São Tomé and Príncipe": "São Tomé i Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cap Verd",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armènia",
        "Haiti": "Haití",
        "Côte d’Ivoire": "Costa d'Ivori",
        "Guinea-Bissau": "Guinea Bissau",
        "Mozambique": "Moçambic",
        "Poland": "Polònia",
        "French Polynesia": "Polinèsia Francesa",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "República Dominicana",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirguizistan",
        "Syria": "Síria",
        "Zambia": "Zàmbia",
        "Croatia": "Croàcia",
        "Lithuania": "Lituània",
        "Albania": "Albània",
        "Netherlands": "Països Baixos",
        "France": "França",
        "Tunisia": "Tunísia",
        "Bosnia and Herzegovina": "Bòsnia i Hercegovina",
        "Bahamas": "Bahames",
        "Somalia": "Somàlia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Hondures",
        "French Guiana": "Guaiana Francesa",
        "Jordan": "Jordània",
        "Serbia": "Sèrbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "República Centreafricana",
        "Luxembourg": "Luxemburg",
        "Trinidad and Tobago": "Trinitat i Tobago",
        "Estonia": "Estònia",
        "Montserrat": "Montserrat",
        "Norway": "Noruega",
        "North Korea": "Corea del Nord",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Illes Fèroe",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Illes Malvines",
        "Namibia": "Namíbia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonèsia",
        "Timor-Leste": "Timor Oriental",
        "Norfolk Island": "Illes Norfolk",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Illes Cook",
        "Micronesia": "Micronèsia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Libèria",
        "Panama": "Panamà",
        "Malta": "Malta",
        "Peru": "Perú",
        "Philippines": "Filipines",
        "Rwanda": "Rwanda",
        "United Kingdom": "Regne Unit",
        "Martinique": "Martinica",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermudes",
        "Australia": "Austràlia",
        "Vatican City": "Ciutat del Vaticà",
        "Slovenia": "Eslovènia",
        "Cayman Islands": "Illes Caiman",
        "Hungary": "Hongria",
        "American Samoa": "Samoa Nord-americana",
        "Mauritania": "Mauritània",
        "Japan": "Japó",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Cambodja",
        "Wallis & Futuna": "Wallis i Futuna",
        "South Sudan": "Sudan del Sud",
        "Morocco": "Marroc",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzània",
        "Mexico": "Mèxic",
        "Russia": "Rússia",
        "Iceland": "Islàndia",
        "Monaco": "Mònaco",
        "Afghanistan": "Afganistan",
        "Slovakia": "Eslovàquia",
        "Sweden": "Suècia",
        "Azerbaijan": "Azerbaidjan",
        "Bangladesh": "Bangla Desh",
        "Brazil": "Brasil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongòlia",
        "Saint Kitts and Nevis": "Saint Kitts i Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malàisia",
        "Uruguay": "Uruguai",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Illes Mariannes del Nord",
        "Pakistan": "Pakistan",
        "Greenland": "Grenlàndia",
        "Mauritius": "Maurici",
        "Caribbean Netherlands": "Països Baixos Caribencs",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "República Txeca",
        "Moldova": "Moldàvia",
        "Singapore": "Singapur",
        "Belgium": "Bèlgica",
        "Maldives": "Maldives",
        "New Zealand": "Nova Zelanda",
        "South Korea": "Corea del Sud",
        "Italy": "Itàlia",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Santa Helena",
        "Guam": "Guam",
        "Denmark": "Dinamarca",
        "New Caledonia": "Nova Caledònia",
        "Ecuador": "Equador",
        "Canada": "Canadà",
        "Egypt": "Egipte",
        "Saudi Arabia": "Aràbia Saudita",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Illes Turks i Caicos",
        "Latvia": "Letònia",
        "St. Pierre & Miquelon": "Saint-Pierre i Miquelon",
        "Georgia": "Geòrgia",
        "Laos": "Laos",
        "Réunion": "Reunió",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Tailàndia",
        "Algeria": "Algèria",
        "Finland": "Finlàndia",
        "Macedonia": "Macedònia del Nord",
        "Antigua and Barbuda": "Antigua i Barbuda",
        "Nigeria": "Nigèria",
        "Switzerland": "Suïssa",
        "Bulgaria": "Bulgària",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tadjikistan",
        "Austria": "Àustria",
        "Bolivia": "Bolívia",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Iraq",
        "Bahrain": "Bahrain",
        "Colombia": "Colòmbia",
        "Papua New Guinea": "Papua Nova Guinea",
        "Yemen": "Iemen",
        "Venezuela": "Veneçuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Territori Britànic de l'Oceà Índic",
        "Chad": "Txad",
        "Germany": "Alemanya",
        "Fiji": "Fiji",
        "British Virgin Islands": "Illes Verges Britàniques",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macau",
        "South Africa": "Sud-àfrica",
        "Eritrea": "Eritrea",
        "Greece": "Grècia",
        "Ethiopia": "Etiòpia",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Illes Marshall",
        "United States": "Estats Units",
        "Benin": "Benín",
        "El Salvador": "El Salvador",
        "Lebanon": "Líban",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Illes Salomó",
        "China": "Xina",
        "Tonga": "Tonga"
    },
};
export const azAZ = {
    searchNotFound: "Heç bir ölkə tapılmadı",
    searchPlaceholder: "Ölkə axtar",
    countries: {
        "Gibraltar": "Cəbəllütariq",
        "Gambia": "Qambiya",
        "Equatorial Guinea": "Ekvatorial Qvineya",
        "Senegal": "Seneqal",
        "Jamaica": "Yamayka",
        "Seychelles": "Seyşel adaları",
        "Comoros": "Komor adaları",
        "U.S. Virgin Islands": "ABŞ Virgin Adaları",
        "Guinea": "Qvineya",
        "Niger": "Niger",
        "Libya": "Liviya",
        "Romania": "Rumıniya",
        "Anguilla": "Anquilya",
        "Togo": "Toqo",
        "Paraguay": "Paraqvay",
        "India": "Hindistan",
        "Ireland": "İrlandiya",
        "Turkey": "Türkiyə",
        "Oman": "Oman",
        "Ukraine": "Ukrayna",
        "Spain": "İspaniya",
        "Cameroon": "Kamerun",
        "Angola": "Anqola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Sent-Vinsent və Qrenadinlər",
        "Cyprus": "Kipr",
        "Belarus": "Belarus",
        "Gabon": "Qabon",
        "Samoa": "Samoa",
        "Chile": "Çili",
        "United Arab Emirates": "Birləşmiş Ərəb Əmirlikləri",
        "São Tomé and Príncipe": "San-Tome və Prinsipi",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto-Riko",
        "Portugal": "Portuqaliya",
        "Costa Rica": "Kosta-Rika",
        "Swaziland": "Esvatini",
        "Cape Verde": "Kabo-Verde",
        "Curaçao": "Kurasao",
        "Andorra": "Andorra",
        "Armenia": "Ermənistan",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Fil Dişi Sahili",
        "Guinea-Bissau": "Qvineya-Bisau",
        "Mozambique": "Mozambik",
        "Poland": "Polşa",
        "French Polynesia": "Fransız Polineziyası",
        "Jersey": "Cersi",
        "Kuwait": "Küveyt",
        "Dominican Republic": "Dominikan Respublikası",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Qırğızıstan",
        "Syria": "Suriya",
        "Zambia": "Zambiya",
        "Croatia": "Xorvatiya",
        "Lithuania": "Litva",
        "Albania": "Albaniya",
        "Netherlands": "Niderland",
        "France": "Fransa",
        "Tunisia": "Tunis",
        "Bosnia and Herzegovina": "Bosniya və Herseqovina",
        "Bahamas": "Baham adaları",
        "Somalia": "Somali",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malavi",
        "Honduras": "Honduras",
        "French Guiana": "Fransız Qvianası",
        "Jordan": "İordaniya",
        "Serbia": "Serbiya",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Qayana",
        "Lesotho": "Lesoto",
        "Taiwan": "Tayvan",
        "Central African Republic": "Mərkəzi Afrika Respublikası",
        "Luxembourg": "Lüksemburq",
        "Trinidad and Tobago": "Trinidad və Tobaqo",
        "Estonia": "Estoniya",
        "Montserrat": "Monserrat",
        "Norway": "Norveç",
        "North Korea": "Şimali Koreya",
        "Myanmar": "Myanma",
        "Sri Lanka": "Şri Lanka",
        "Faroe Islands": "Farer adaları",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Folklend adaları",
        "Namibia": "Namibiya",
        "Saint Lucia": "Sent-Lusiya",
        "Indonesia": "İndoneziya",
        "Timor-Leste": "Şərqi Timor",
        "Norfolk Island": "Norfolk adası",
        "Bhutan": "Butan",
        "Iran": "İran",
        "Turkmenistan": "Türkmənistan",
        "Uganda": "Uqanda",
        "Kazakhstan": "Qazaxıstan",
        "Cook Islands": "Kuk adaları",
        "Micronesia": "Mikroneziya",
        "Sint Maarten": "Sint-Marten",
        "Liberia": "Liberiya",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filippinlər",
        "Rwanda": "Ruanda",
        "United Kingdom": "Birləşmiş Krallıq",
        "Martinique": "Martinik",
        "Nepal": "Nepal",
        "Guatemala": "Qvatemala",
        "Bermuda": "Bermud adaları",
        "Australia": "Avstraliya",
        "Vatican City": "Vatikan",
        "Slovenia": "Sloveniya",
        "Cayman Islands": "Kayman adaları",
        "Hungary": "Macarıstan",
        "American Samoa": "Amerika Samoası",
        "Mauritania": "Mavritaniya",
        "Japan": "Yaponiya",
        "Uzbekistan": "Özbəkistan",
        "Cambodia": "Kamboca",
        "Wallis & Futuna": "Uollis və Futuna",
        "South Sudan": "Cənubi Sudan",
        "Morocco": "Mərakeş",
        "Argentina": "Argentina",
        "Guadeloupe": "Qvadelupa",
        "Hong Kong": "Honq-Konq",
        "Qatar": "Qətər",
        "Tanzania": "Tanzaniya",
        "Mexico": "Meksika",
        "Russia": "Rusiya",
        "Iceland": "İslandiya",
        "Monaco": "Monako",
        "Afghanistan": "Əfqanıstan",
        "Slovakia": "Slovakiya",
        "Sweden": "İsveç",
        "Azerbaijan": "Azərbaycan",
        "Bangladesh": "Banqladeş",
        "Brazil": "Braziliya",
        "Cuba": "Kuba",
        "Ghana": "Qana",
        "Mongolia": "Monqolustan",
        "Saint Kitts and Nevis": "Sent-Kits və Nevis",
        "Burkina Faso": "Burkina-Faso",
        "Nicaragua": "Nikaraqua",
        "Malaysia": "Malayziya",
        "Uruguay": "Uruqvay",
        "Brunei": "Bruney",
        "Congo": "Konqo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Şimal Marian adaları",
        "Pakistan": "Pakistan",
        "Greenland": "Qrenlandiya",
        "Mauritius": "Mavriki",
        "Caribbean Netherlands": "Karib Niderlandları",
        "Belize": "Beliz",
        "Liechtenstein": "Lixtenşteyn",
        "Sierra Leone": "Syerra-Leone",
        "Czech Republic": "Çexiya",
        "Moldova": "Moldova",
        "Singapore": "Sinqapur",
        "Belgium": "Belçika",
        "Maldives": "Maldiv adaları",
        "New Zealand": "Yeni Zelandiya",
        "South Korea": "Cənubi Koreya",
        "Italy": "İtaliya",
        "Israel": "İsrail",
        "Grenada": "Qrenada",
        "Kenya": "Keniya",
        "St. Helena": "Müqəddəs Yelena adası",
        "Guam": "Quam",
        "Denmark": "Danimarka",
        "New Caledonia": "Yeni Kaledoniya",
        "Ecuador": "Ekvador",
        "Canada": "Kanada",
        "Egypt": "Misir",
        "Saudi Arabia": "Səudiyyə Ərəbistanı",
        "Botswana": "Botsvana",
        "Turks & Caicos Islands": "Törks və Kaykos Adaları",
        "Latvia": "Latviya",
        "St. Pierre & Miquelon": "Sent Pyer və Mikelon",
        "Georgia": "Gürcüstan",
        "Laos": "Laos",
        "Réunion": "Reyunyon",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabve",
        "Thailand": "Tayland",
        "Algeria": "Əlcəzair",
        "Finland": "Finlandiya",
        "Macedonia": "Makedoniya",
        "Antigua and Barbuda": "Antiqua və Barbuda",
        "Nigeria": "Nigeriya",
        "Switzerland": "İsveçrə",
        "Bulgaria": "Bolqarıstan",
        "Montenegro": "Monteneqro",
        "Tajikistan": "Tacikistan",
        "Austria": "Avstriya",
        "Bolivia": "Boliviya",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "İraq",
        "Bahrain": "Bəhreyn",
        "Colombia": "Kolumbiya",
        "Papua New Guinea": "Papua Yeni Qvineya",
        "Yemen": "Yəmən",
        "Venezuela": "Venesuela",
        "Djibouti": "Cibuti",
        "British Indian Ocean Territory": "Hind Okeanı Bölgəsi",
        "Chad": "Çad",
        "Germany": "Almaniya",
        "Fiji": "Fici",
        "British Virgin Islands": "Britaniya Virgin adaları",
        "San Marino": "San-Marino",
        "Vietnam": "Vyetnam",
        "Macau": "Makao",
        "South Africa": "Cənubi Afrika",
        "Eritrea": "Eritreya",
        "Greece": "Yunanıstan",
        "Ethiopia": "Efiopiya",
        "Madagascar": "Madaqaskar",
        "Marshall Islands": "Marşall adaları",
        "United States": "Amerika Birləşmiş Ştatları",
        "Benin": "Benin",
        "El Salvador": "El-Salvador",
        "Lebanon": "Livan",
        "Palestine": "Fələstin",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Solomon adaları",
        "China": "Çin",
        "Tonga": "Tonqa"
    },
};
export const byBY = {
    searchNotFound: "Краіна не знойдзена",
    searchPlaceholder: "Шукаць краіну",
    countries: {
        "Gibraltar": "Гібралтар",
        "Gambia": "Гамбія",
        "Equatorial Guinea": "Экватарыяльная Гвінея",
        "Senegal": "Сенегал",
        "Jamaica": "Ямайка",
        "Seychelles": "Сейшэльскія Астравы",
        "Comoros": "Каморскія Астравы",
        "U.S. Virgin Islands": "Амерыканскія Віргінскія астравы",
        "Guinea": "Гвінея",
        "Niger": "Нігер",
        "Libya": "Лівія",
        "Romania": "Румынія",
        "Anguilla": "Ангілья",
        "Togo": "Тога",
        "Paraguay": "Парагвай",
        "India": "Індыя",
        "Ireland": "Ірландыя",
        "Turkey": "Турцыя",
        "Oman": "Аман",
        "Ukraine": "Украіна",
        "Spain": "Іспанія",
        "Cameroon": "Камерун",
        "Angola": "Ангола",
        "Mali": "Малі",
        "Saint Vincent and the Grenadines": "Сэнт-Вінсэнт і Грэнадыны",
        "Cyprus": "Кіпр",
        "Belarus": "Беларусь",
        "Gabon": "Габон",
        "Samoa": "Самоа",
        "Chile": "Чылі",
        "United Arab Emirates": "Аб'яднаныя Арабскія Эміраты",
        "São Tomé and Príncipe": "Сан-Томе і Прынсіпі",
        "Palau": "Палау",
        "Tokelau": "Такелаў",
        "Puerto Rico": "Пуэрта-Рыка",
        "Portugal": "Партугалія",
        "Costa Rica": "Коста-Рыка",
        "Swaziland": "Эсваціні",
        "Cape Verde": "Каба-Вэрдэ",
        "Curaçao": "Кюрасао",
        "Andorra": "Андора",
        "Armenia": "Арменія",
        "Haiti": "Гаіці",
        "Côte d’Ivoire": "Бераг Слановай Косці",
        "Guinea-Bissau": "Гвінея-Бісаў",
        "Mozambique": "Мазамбік",
        "Poland": "Польшча",
        "French Polynesia": "Французская Палінезія",
        "Jersey": "Джэрсі",
        "Kuwait": "Кувейт",
        "Dominican Republic": "Дамініканская Рэспубліка",
        "Kosovo": "Косава",
        "Kyrgyzstan": "Кіргізія",
        "Syria": "Сірыя",
        "Zambia": "Замбія",
        "Croatia": "Харватыя",
        "Lithuania": "Літва",
        "Albania": "Албанія",
        "Netherlands": "Нідэрланды",
        "France": "Францыя",
        "Tunisia": "Туніс",
        "Bosnia and Herzegovina": "Боснія і Герцагавіна",
        "Bahamas": "Багамы",
        "Somalia": "Самалі",
        "Burundi": "Бурундзі",
        "Barbados": "Барбадас",
        "Malawi": "Малаві",
        "Honduras": "Гандурас",
        "French Guiana": "Французская Гвіяна",
        "Jordan": "Іарданія",
        "Serbia": "Сербія",
        "Vanuatu": "Вануату",
        "Aruba": "Аруба",
        "Guyana": "Гаяна",
        "Lesotho": "Лесота",
        "Taiwan": "Тайвань",
        "Central African Republic": "Цэнтральна-Афрыканская Рэспубліка",
        "Luxembourg": "Люксембург",
        "Trinidad and Tobago": "Трынідад і Табага",
        "Estonia": "Эстонія",
        "Montserrat": "Монсерат",
        "Norway": "Нарвегія",
        "North Korea": "Паўночная Карэя",
        "Myanmar": "М'янма",
        "Sri Lanka": "Шры-Ланка",
        "Faroe Islands": "Фарэрскія Астравы",
        "Dominica": "Дамініка",
        "Kiribati": "Кірыбаці",
        "Falkland Islands": "Фалклендскія Астравы",
        "Namibia": "Намібія",
        "Saint Lucia": "Сэнт-Люсія",
        "Indonesia": "Інданезія",
        "Timor-Leste": "Усходні Тымор",
        "Norfolk Island": "Востраў Норфалк",
        "Bhutan": "Бутан",
        "Iran": "Іран",
        "Turkmenistan": "Туркменістан",
        "Uganda": "Уганда",
        "Kazakhstan": "Казахстан",
        "Cook Islands": "Астравы Кука",
        "Micronesia": "Мікранезія",
        "Sint Maarten": "Сінт-Мартэн",
        "Liberia": "Ліберыя",
        "Panama": "Панама",
        "Malta": "Мальта",
        "Peru": "Перу",
        "Philippines": "Філіпіны",
        "Rwanda": "Руанда",
        "United Kingdom": "Вялікабрытанія",
        "Martinique": "Марцініка",
        "Nepal": "Непал",
        "Guatemala": "Гватэмала",
        "Bermuda": "Бермудскія Астравы",
        "Australia": "Аўстралія",
        "Vatican City": "Ватыкан",
        "Slovenia": "Славенія",
        "Cayman Islands": "Кайманавы Астравы",
        "Hungary": "Венгрыя",
        "American Samoa": "Амерыканскае Самоа",
        "Mauritania": "Маўрытанія",
        "Japan": "Японія",
        "Uzbekistan": "Узбекістан",
        "Cambodia": "Камбоджа",
        "Wallis & Futuna": "Уоліс і Футуна",
        "South Sudan": "Паўднёвы Судан",
        "Morocco": "Марока",
        "Argentina": "Аргенціна",
        "Guadeloupe": "Гвадэлупа",
        "Hong Kong": "Ганконг",
        "Qatar": "Катар",
        "Tanzania": "Танзанія",
        "Mexico": "Мексіка",
        "Russia": "Расія",
        "Iceland": "Ісландыя",
        "Monaco": "Манака",
        "Afghanistan": "Афганістан",
        "Slovakia": "Славакія",
        "Sweden": "Швецыя",
        "Azerbaijan": "Азербайджан",
        "Bangladesh": "Бангладэш",
        "Brazil": "Бразілія",
        "Cuba": "Куба",
        "Ghana": "Гана",
        "Mongolia": "Манголія",
        "Saint Kitts and Nevis": "Сэнт-Кітс і Нэвіс",
        "Burkina Faso": "Буркіна-Фасо",
        "Nicaragua": "Нікарагуа",
        "Malaysia": "Малайзія",
        "Uruguay": "Уругвай",
        "Brunei": "Бруней",
        "Congo": "Конга",
        "Nauru": "Науру",
        "Northern Mariana Islands": "Паўночныя Марыянскія астравы",
        "Pakistan": "Пакістан",
        "Greenland": "Грэнландыя",
        "Mauritius": "Маўрыкій",
        "Caribbean Netherlands": "Карыбскія Нідэрланды",
        "Belize": "Беліз",
        "Liechtenstein": "Ліхтэнштэйн",
        "Sierra Leone": "Сьера-Леонэ",
        "Czech Republic": "Чэхія",
        "Moldova": "Малдова",
        "Singapore": "Сінгапур",
        "Belgium": "Бельгія",
        "Maldives": "Мальдывы",
        "New Zealand": "Новая Зеландыя",
        "South Korea": "Паўднёвая Карэя",
        "Italy": "Італія",
        "Israel": "Ізраіль",
        "Grenada": "Грэнада",
        "Kenya": "Кенія",
        "St. Helena": "Востраў Святой Алены",
        "Guam": "Гуам",
        "Denmark": "Данія",
        "New Caledonia": "Новая Каледонія",
        "Ecuador": "Эквадор",
        "Canada": "Канада",
        "Egypt": "Егіпет",
        "Saudi Arabia": "Саудаўская Аравія",
        "Botswana": "Батсвана",
        "Turks & Caicos Islands": "Тэркс і Кайкас",
        "Latvia": "Латвія",
        "St. Pierre & Miquelon": "Сен-П'ер і Мікелон",
        "Georgia": "Грузія",
        "Laos": "Лаос",
        "Réunion": "Рэюньён",
        "Niue": "Ніуэ",
        "Zimbabwe": "Зімбабвэ",
        "Thailand": "Тайланд",
        "Algeria": "Алжыр",
        "Finland": "Фінляндыя",
        "Macedonia": "Паўночная Македонія",
        "Antigua and Barbuda": "Антыгуа і Барбуда",
        "Nigeria": "Нігерыя",
        "Switzerland": "Швейцарыя",
        "Bulgaria": "Балгарыя",
        "Montenegro": "Чарнагорыя",
        "Tajikistan": "Таджыкістан",
        "Austria": "Аўстрыя",
        "Bolivia": "Балівія",
        "Sudan": "Судан",
        "Suriname": "Сурынам",
        "Iraq": "Ірак",
        "Bahrain": "Бахрэйн",
        "Colombia": "Калумбія",
        "Papua New Guinea": "Папуа-Новая Гвінея",
        "Yemen": "Емен",
        "Venezuela": "Венесуэла",
        "Djibouti": "Джыбуці",
        "British Indian Ocean Territory": "Брытанская тэрыторыя ў Індыйскім акіяне",
        "Chad": "Чад",
        "Germany": "Германія",
        "Fiji": "Фіджы",
        "British Virgin Islands": "Брытанскія Віргінскія астравы",
        "San Marino": "Сан-Марына",
        "Vietnam": "В'етнам",
        "Macau": "Макаа",
        "South Africa": "Паўднёва-Афрыканская Рэспубліка",
        "Eritrea": "Эрытрэя",
        "Greece": "Грэцыя",
        "Ethiopia": "Эфіопія",
        "Madagascar": "Мадагаскар",
        "Marshall Islands": "Маршалавы Астравы",
        "United States": "Злучаныя Штаты Амерыкі",
        "Benin": "Бенін",
        "El Salvador": "Сальвадор",
        "Lebanon": "Ліван",
        "Palestine": "Палесціна",
        "Tuvalu": "Тувалу",
        "Solomon Islands": "Саламонавы Астравы",
        "China": "Кітай",
        "Tonga": "Тонга"
    },
};
export const ukUA = {
    searchNotFound: "Країну не знайдено",
    searchPlaceholder: "Шукати країну",
    countries: {
        "Gibraltar": "Гібралтар",
        "Gambia": "Гамбія",
        "Equatorial Guinea": "Екваторіальна Гвінея",
        "Senegal": "Сенегал",
        "Jamaica": "Ямайка",
        "Seychelles": "Сейшельські острови",
        "Comoros": "Коморські острови",
        "U.S. Virgin Islands": "Американські Віргінські острови",
        "Guinea": "Гвінея",
        "Niger": "Нігер",
        "Libya": "Лівія",
        "Romania": "Румунія",
        "Anguilla": "Ангілья",
        "Togo": "Того",
        "Paraguay": "Парагвай",
        "India": "Індія",
        "Ireland": "Ірландія",
        "Turkey": "Туреччина",
        "Oman": "Оман",
        "Ukraine": "Україна",
        "Spain": "Іспанія",
        "Cameroon": "Камерун",
        "Angola": "Ангола",
        "Mali": "Малі",
        "Saint Vincent and the Grenadines": "Сент-Вінсент і Гренадини",
        "Cyprus": "Кіпр",
        "Belarus": "Білорусь",
        "Gabon": "Габон",
        "Samoa": "Самоа",
        "Chile": "Чилі",
        "United Arab Emirates": "Об'єднані Арабські Емірати",
        "São Tomé and Príncipe": "Сан-Томе і Принсіпі",
        "Palau": "Палау",
        "Tokelau": "Токелау",
        "Puerto Rico": "Пуерто-Рико",
        "Portugal": "Португалія",
        "Costa Rica": "Коста-Рика",
        "Swaziland": "Есватіні",
        "Cape Verde": "Кабо-Верде",
        "Curaçao": "Кюрасао",
        "Andorra": "Андорра",
        "Armenia": "Вірменія",
        "Haiti": "Гаїті",
        "Côte d’Ivoire": "Кот-д'Івуар",
        "Guinea-Bissau": "Гвінея-Бісау",
        "Mozambique": "Мозамбік",
        "Poland": "Польща",
        "French Polynesia": "Французька Полінезія",
        "Jersey": "Джерсі",
        "Kuwait": "Кувейт",
        "Dominican Republic": "Домініканська Республіка",
        "Kosovo": "Косово",
        "Kyrgyzstan": "Киргизстан",
        "Syria": "Сирія",
        "Zambia": "Замбія",
        "Croatia": "Хорватія",
        "Lithuania": "Литва",
        "Albania": "Албанія",
        "Netherlands": "Нідерланди",
        "France": "Франція",
        "Tunisia": "Туніс",
        "Bosnia and Herzegovina": "Боснія і Герцеговина",
        "Bahamas": "Багамські Острови",
        "Somalia": "Сомалі",
        "Burundi": "Бурунді",
        "Barbados": "Барбадос",
        "Malawi": "Малаві",
        "Honduras": "Гондурас",
        "French Guiana": "Французька Гвіана",
        "Jordan": "Йорданія",
        "Serbia": "Сербія",
        "Vanuatu": "Вануату",
        "Aruba": "Аруба",
        "Guyana": "Гаяна",
        "Lesotho": "Лесото",
        "Taiwan": "Тайвань",
        "Central African Republic": "Центральноафриканська Республіка",
        "Luxembourg": "Люксембург",
        "Trinidad and Tobago": "Тринідад і Тобаго",
        "Estonia": "Естонія",
        "Montserrat": "Монсеррат",
        "Norway": "Норвегія",
        "North Korea": "Північна Корея",
        "Myanmar": "М'янма",
        "Sri Lanka": "Шрі Ланка",
        "Faroe Islands": "Фарерські острови",
        "Dominica": "Домініка",
        "Kiribati": "Кірібаті",
        "Falkland Islands": "Фолклендські острови",
        "Namibia": "Намібія",
        "Saint Lucia": "Сент-Люсія",
        "Indonesia": "Індонезія",
        "Timor-Leste": "Східний Тимор",
        "Norfolk Island": "Острів Норфолк",
        "Bhutan": "Бутан",
        "Iran": "Іран",
        "Turkmenistan": "Туркменістан",
        "Uganda": "Уганда",
        "Kazakhstan": "Казахстан",
        "Cook Islands": "Острови Кука",
        "Micronesia": "Мікронезія",
        "Sint Maarten": "Сінт-Мартен",
        "Liberia": "Ліберія",
        "Panama": "Панама",
        "Malta": "Мальта",
        "Peru": "Перу",
        "Philippines": "Філіппіни",
        "Rwanda": "Руанда",
        "United Kingdom": "Велика Британія",
        "Martinique": "Мартиніка",
        "Nepal": "Непал",
        "Guatemala": "Гватемала",
        "Bermuda": "Бермудські острови",
        "Australia": "Австралія",
        "Vatican City": "Ватикан",
        "Slovenia": "Словенія",
        "Cayman Islands": "Кайманові острови",
        "Hungary": "Угорщина",
        "American Samoa": "Американське Самоа",
        "Mauritania": "Мавританія",
        "Japan": "Японія",
        "Uzbekistan": "Узбекистан",
        "Cambodia": "Камбоджа",
        "Wallis & Futuna": "Уолліс і Футуна",
        "South Sudan": "Південний Судан",
        "Morocco": "Марокко",
        "Argentina": "Аргентина",
        "Guadeloupe": "Гваделупа",
        "Hong Kong": "Гонконг",
        "Qatar": "Катар",
        "Tanzania": "Танзанія",
        "Mexico": "Мексика",
        "Russia": "Росія",
        "Iceland": "Ісландія",
        "Monaco": "Монако",
        "Afghanistan": "Афганістан",
        "Slovakia": "Словаччина",
        "Sweden": "Швеція",
        "Azerbaijan": "Азербайджан",
        "Bangladesh": "Бангладеш",
        "Brazil": "Бразилія",
        "Cuba": "Куба",
        "Ghana": "Гана",
        "Mongolia": "Монголія",
        "Saint Kitts and Nevis": "Сент-Кітс і Невіс",
        "Burkina Faso": "Буркіна-Фасо",
        "Nicaragua": "Нікарагуа",
        "Malaysia": "Малайзія",
        "Uruguay": "Уругвай",
        "Brunei": "Бруней",
        "Congo": "Конго",
        "Nauru": "Науру",
        "Northern Mariana Islands": "Північні Маріанські острови",
        "Pakistan": "Пакистан",
        "Greenland": "Гренландія",
        "Mauritius": "Маврикій",
        "Caribbean Netherlands": "Карибські Нідерланди",
        "Belize": "Беліз",
        "Liechtenstein": "Ліхтенштейн",
        "Sierra Leone": "Сьєрра-Леоне",
        "Czech Republic": "Чехія",
        "Moldova": "Молдова",
        "Singapore": "Сінгапур",
        "Belgium": "Бельгія",
        "Maldives": "Мальдіви",
        "New Zealand": "Нова Зеландія",
        "South Korea": "Південна Корея",
        "Italy": "Італія",
        "Israel": "Ізраїль",
        "Grenada": "Гренада",
        "Kenya": "Кенія",
        "St. Helena": "Острів Святої Єлени",
        "Guam": "Гуам",
        "Denmark": "Данія",
        "New Caledonia": "Нова Каледонія",
        "Ecuador": "Еквадор",
        "Canada": "Канада",
        "Egypt": "Єгипет",
        "Saudi Arabia": "Саудівська Аравія",
        "Botswana": "Ботсвана",
        "Turks & Caicos Islands": "Теркс і Кайкос",
        "Latvia": "Латвія",
        "St. Pierre & Miquelon": "Сен-П'єр і Мікелон",
        "Georgia": "Грузія",
        "Laos": "Лаос",
        "Réunion": "Реюньйон",
        "Niue": "Ніуе",
        "Zimbabwe": "Зімбабве",
        "Thailand": "Таїланд",
        "Algeria": "Алжир",
        "Finland": "Фінляндія",
        "Macedonia": "Північна Македонія",
        "Antigua and Barbuda": "Антигуа і Барбуда",
        "Nigeria": "Нігерія",
        "Switzerland": "Швейцарія",
        "Bulgaria": "Болгарія",
        "Montenegro": "Чорногорія",
        "Tajikistan": "Таджикистан",
        "Austria": "Австрія",
        "Bolivia": "Болівія",
        "Sudan": "Судан",
        "Suriname": "Суринам",
        "Iraq": "Ірак",
        "Bahrain": "Бахрейн",
        "Colombia": "Колумбія",
        "Papua New Guinea": "Папуа Нова Гвінея",
        "Yemen": "Ємен",
        "Venezuela": "Венесуела",
        "Djibouti": "Джибуті",
        "British Indian Ocean Territory": "Британська територія в Індійському океані",
        "Chad": "Чад",
        "Germany": "Німеччина",
        "Fiji": "Фіджі",
        "British Virgin Islands": "Британські Віргінські острови",
        "San Marino": "Сан-Марино",
        "Vietnam": "В'єтнам",
        "Macau": "Макао",
        "South Africa": "Південна Африка",
        "Eritrea": "Еритрея",
        "Greece": "Греція",
        "Ethiopia": "Ефіопія",
        "Madagascar": "Мадагаскар",
        "Marshall Islands": "Маршаллові Острови",
        "United States": "Сполучені Штати Америки",
        "Benin": "Бенін",
        "El Salvador": "Сальвадор",
        "Lebanon": "Ліван",
        "Palestine": "Палестина",
        "Tuvalu": "Тувалу",
        "Solomon Islands": "Соломонові Острови",
        "China": "Китай",
        "Tonga": "Тонга"
    },
};
export const hrHR = {
    searchNotFound: "Nijedna država nije pronađena",
    searchPlaceholder: "Traži državu",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambija",
        "Equatorial Guinea": "Ekvatorijalna Gvineja",
        "Senegal": "Senegal",
        "Jamaica": "Jamajka",
        "Seychelles": "Sejšeli",
        "Comoros": "Komori",
        "U.S. Virgin Islands": "Američki Djevičanski Otoci",
        "Guinea": "Gvineja",
        "Niger": "Niger",
        "Libya": "Libija",
        "Romania": "Rumunjska",
        "Anguilla": "Angvila",
        "Togo": "Togo",
        "Paraguay": "Paragvaj",
        "India": "Indija",
        "Ireland": "Irska",
        "Turkey": "Turska",
        "Oman": "Oman",
        "Ukraine": "Ukrajina",
        "Spain": "Španjolska",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Sveti Vincent i Grenadini",
        "Cyprus": "Cipar",
        "Belarus": "Bjelorusija",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Čile",
        "United Arab Emirates": "Ujedinjeni Arapski Emirati",
        "São Tomé and Príncipe": "Sveti Toma i Princip",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Portoriko",
        "Portugal": "Portugal",
        "Costa Rica": "Kostarika",
        "Swaziland": "Esvatini",
        "Cape Verde": "Zeleni Rt",
        "Curaçao": "Curaçao",
        "Andorra": "Andora",
        "Armenia": "Armenija",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Obala Bjelokosti",
        "Guinea-Bissau": "Gvineja-Bisau",
        "Mozambique": "Mozambik",
        "Poland": "Poljska",
        "French Polynesia": "Francuska Polinezija",
        "Jersey": "Jersey",
        "Kuwait": "Kuvajt",
        "Dominican Republic": "Dominikanska Republika",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgistan",
        "Syria": "Sirija",
        "Zambia": "Zambija",
        "Croatia": "Hrvatska",
        "Lithuania": "Litva",
        "Albania": "Albanija",
        "Netherlands": "Nizozemska",
        "France": "Francuska",
        "Tunisia": "Tunis",
        "Bosnia and Herzegovina": "Bosna i Hercegovina",
        "Bahamas": "Bahami",
        "Somalia": "Somalija",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malavi",
        "Honduras": "Honduras",
        "French Guiana": "Francuska Gvajana",
        "Jordan": "Jordan",
        "Serbia": "Srbija",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Gvajana",
        "Lesotho": "Lesoto",
        "Taiwan": "Tajvan",
        "Central African Republic": "Srednjoafrička Republika",
        "Luxembourg": "Luksemburg",
        "Trinidad and Tobago": "Trinidad i Tobago",
        "Estonia": "Estonija",
        "Montserrat": "Montserrat",
        "Norway": "Norveška",
        "North Korea": "Sjeverna Koreja",
        "Myanmar": "Mjanmar",
        "Sri Lanka": "Šri Lanka",
        "Faroe Islands": "Farski Otoci",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandski Otoci",
        "Namibia": "Namibija",
        "Saint Lucia": "Sveta Lucija",
        "Indonesia": "Indonezija",
        "Timor-Leste": "Istočni Timor",
        "Norfolk Island": "Otok Norfolk",
        "Bhutan": "Butan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazahstan",
        "Cook Islands": "Cookovi Otoci",
        "Micronesia": "Mikronezija",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberija",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipini",
        "Rwanda": "Ruanda",
        "United Kingdom": "Ujedinjeno Kraljevstvo",
        "Martinique": "Martinik",
        "Nepal": "Nepal",
        "Guatemala": "Gvatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australija",
        "Vatican City": "Vatikan",
        "Slovenia": "Slovenija",
        "Cayman Islands": "Kajmanski Otoci",
        "Hungary": "Mađarska",
        "American Samoa": "Američka Samoa",
        "Mauritania": "Mauritanija",
        "Japan": "Japan",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kambodža",
        "Wallis & Futuna": "Wallis i Futuna",
        "South Sudan": "Južni Sudan",
        "Morocco": "Maroko",
        "Argentina": "Argentina",
        "Guadeloupe": "Gvadalupa",
        "Hong Kong": "Hong Kong",
        "Qatar": "Katar",
        "Tanzania": "Tanzanija",
        "Mexico": "Meksiko",
        "Russia": "Rusija",
        "Iceland": "Island",
        "Monaco": "Monako",
        "Afghanistan": "Afganistan",
        "Slovakia": "Slovačka",
        "Sweden": "Švedska",
        "Azerbaijan": "Azerbajdžan",
        "Bangladesh": "Bangladeš",
        "Brazil": "Brazil",
        "Cuba": "Kuba",
        "Ghana": "Gana",
        "Mongolia": "Mongolija",
        "Saint Kitts and Nevis": "Sveti Kristofor i Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nikaragva",
        "Malaysia": "Malezija",
        "Uruguay": "Urugvaj",
        "Brunei": "Brunej",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Sjevernomarijanski Otoci",
        "Pakistan": "Pakistan",
        "Greenland": "Grenland",
        "Mauritius": "Mauricijus",
        "Caribbean Netherlands": "Karipska Nizozemska",
        "Belize": "Belize",
        "Liechtenstein": "Lihtenštajn",
        "Sierra Leone": "Sijera Leone",
        "Czech Republic": "Češka",
        "Moldova": "Moldavija",
        "Singapore": "Singapur",
        "Belgium": "Belgija",
        "Maldives": "Maldivi",
        "New Zealand": "Novi Zeland",
        "South Korea": "Južna Koreja",
        "Italy": "Italija",
        "Israel": "Izrael",
        "Grenada": "Grenada",
        "Kenya": "Kenija",
        "St. Helena": "Sveta Helena",
        "Guam": "Guam",
        "Denmark": "Danska",
        "New Caledonia": "Nova Kaledonija",
        "Ecuador": "Ekvador",
        "Canada": "Kanada",
        "Egypt": "Egipat",
        "Saudi Arabia": "Saudijska Arabija",
        "Botswana": "Bocvana",
        "Turks & Caicos Islands": "Otoci Turks i Caicos",
        "Latvia": "Latvija",
        "St. Pierre & Miquelon": "Sveti Petar i Mikelon",
        "Georgia": "Gruzija",
        "Laos": "Laos",
        "Réunion": "Reunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabve",
        "Thailand": "Tajland",
        "Algeria": "Alžir",
        "Finland": "Finska",
        "Macedonia": "Sjeverna Makedonija",
        "Antigua and Barbuda": "Antigva i Barbuda",
        "Nigeria": "Nigerija",
        "Switzerland": "Švicarska",
        "Bulgaria": "Bugarska",
        "Montenegro": "Crna Gora",
        "Tajikistan": "Tadžikistan",
        "Austria": "Austrija",
        "Bolivia": "Bolivija",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrein",
        "Colombia": "Kolumbija",
        "Papua New Guinea": "Papua Nova Gvineja",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Džibuti",
        "British Indian Ocean Territory": "Britanski teritorij Indijskog oceana",
        "Chad": "Čad",
        "Germany": "Njemačka",
        "Fiji": "Fidži",
        "British Virgin Islands": "Britanski Djevičanski Otoci",
        "San Marino": "San Marino",
        "Vietnam": "Vijetnam",
        "Macau": "Makao",
        "South Africa": "Južnoafrička Republika",
        "Eritrea": "Eritreja",
        "Greece": "Grčka",
        "Ethiopia": "Etiopija",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Maršalovi Otoci",
        "United States": "Sjedinjene Američke Države",
        "Benin": "Benin",
        "El Salvador": "Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomonski Otoci",
        "China": "Kina",
        "Tonga": "Tonga"
    },
};
export const skSK = {
    searchNotFound: "Nenašla sa žiadna krajina",
    searchPlaceholder: "Hľadať krajinu",
    countries: {
        "Gibraltar": "Gibraltár",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Rovníková Guinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamajka",
        "Seychelles": "Seychely",
        "Comoros": "Komory",
        "U.S. Virgin Islands": "Americké Panenské ostrovy",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Líbya",
        "Romania": "Rumunsko",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguaj",
        "India": "India",
        "Ireland": "Írsko",
        "Turkey": "Turecko",
        "Oman": "Omán",
        "Ukraine": "Ukrajina",
        "Spain": "Španielsko",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Svätý Vincent a Grenadíny",
        "Cyprus": "Cyprus",
        "Belarus": "Bielorusko",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Čile",
        "United Arab Emirates": "Spojené arabské emiráty",
        "São Tomé and Príncipe": "Svätý Tomáš a Princov ostrov",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Portoriko",
        "Portugal": "Portugalsko",
        "Costa Rica": "Kostarika",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kapverdy",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Arménsko",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Pobrežie Slonoviny",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mozambik",
        "Poland": "Poľsko",
        "French Polynesia": "Francúzska Polynézia",
        "Jersey": "Jersey",
        "Kuwait": "Kuvajt",
        "Dominican Republic": "Dominikánska republika",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgizsko",
        "Syria": "Sýria",
        "Zambia": "Zambia",
        "Croatia": "Chorvátsko",
        "Lithuania": "Litva",
        "Albania": "Albánsko",
        "Netherlands": "Holandsko",
        "France": "Francúzsko",
        "Tunisia": "Tunisko",
        "Bosnia and Herzegovina": "Bosna a Hercegovina",
        "Bahamas": "Bahamy",
        "Somalia": "Somálsko",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Francúzska Guyana",
        "Jordan": "Jordánsko",
        "Serbia": "Srbsko",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Tchaj-wan",
        "Central African Republic": "Stredoafrická republika",
        "Luxembourg": "Luxembursko",
        "Trinidad and Tobago": "Trinidad a Tobago",
        "Estonia": "Estónsko",
        "Montserrat": "Montserrat",
        "Norway": "Nórsko",
        "North Korea": "Severná Kórea",
        "Myanmar": "Mjanmarsko",
        "Sri Lanka": "Srí Lanka",
        "Faroe Islands": "Faerské ostrovy",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandské ostrovy",
        "Namibia": "Namíbia",
        "Saint Lucia": "Svätá Lucia",
        "Indonesia": "Indonézia",
        "Timor-Leste": "Východný Timor",
        "Norfolk Island": "Norfolkské ostrovy",
        "Bhutan": "Bhután",
        "Iran": "Irán",
        "Turkmenistan": "Turkménsko",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazachstan",
        "Cook Islands": "Cookove ostrovy",
        "Micronesia": "Mikronézia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Libéria",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipíny",
        "Rwanda": "Rwanda",
        "United Kingdom": "Spojené kráľovstvo",
        "Martinique": "Martinique",
        "Nepal": "Nepál",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermudy",
        "Australia": "Austrália",
        "Vatican City": "Vatikán",
        "Slovenia": "Slovinsko",
        "Cayman Islands": "Kajmanie ostrovy",
        "Hungary": "Maďarsko",
        "American Samoa": "Americká Samoa",
        "Mauritania": "Mauritánia",
        "Japan": "Japonsko",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kambodža",
        "Wallis & Futuna": "Wallis a Futuna",
        "South Sudan": "Južný Sudán",
        "Morocco": "Maroko",
        "Argentina": "Argentína",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Katar",
        "Tanzania": "Tanzánia",
        "Mexico": "Mexiko",
        "Russia": "Rusko",
        "Iceland": "Island",
        "Monaco": "Monako",
        "Afghanistan": "Afganistan",
        "Slovakia": "Slovensko",
        "Sweden": "Švédsko",
        "Azerbaijan": "Azerbajdžan",
        "Bangladesh": "Bangladéš",
        "Brazil": "Brazília",
        "Cuba": "Kuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolsko",
        "Saint Kitts and Nevis": "Svätý Krištof a Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nikaragua",
        "Malaysia": "Malajzia",
        "Uruguay": "Uruguaj",
        "Brunei": "Brunej",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Severné Mariány",
        "Pakistan": "Pakistan",
        "Greenland": "Grónsko",
        "Mauritius": "Maurícius",
        "Caribbean Netherlands": "Karibské Holandsko",
        "Belize": "Belize",
        "Liechtenstein": "Lichtenštajnsko",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Česká republika",
        "Moldova": "Moldavsko",
        "Singapore": "Singapur",
        "Belgium": "Belgicko",
        "Maldives": "Maldivy",
        "New Zealand": "Nový Zéland",
        "South Korea": "Južná Kórea",
        "Italy": "Taliansko",
        "Israel": "Izrael",
        "Grenada": "Grenada",
        "Kenya": "Keňa",
        "St. Helena": "Sv. Helena",
        "Guam": "Guam",
        "Denmark": "Dánsko",
        "New Caledonia": "Nová Kaledónia",
        "Ecuador": "Ekvádor",
        "Canada": "Kanada",
        "Egypt": "Egypt",
        "Saudi Arabia": "Saudská Arábia",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks a Caicos",
        "Latvia": "Lotyšsko",
        "St. Pierre & Miquelon": "Saint-Pierre a Miquelon",
        "Georgia": "Gruzínsko",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thajsko",
        "Algeria": "Alžírsko",
        "Finland": "Fínsko",
        "Macedonia": "Severné Makedónsko",
        "Antigua and Barbuda": "Antigua a Barbuda",
        "Nigeria": "Nigéria",
        "Switzerland": "Švajčiarsko",
        "Bulgaria": "Bulharsko",
        "Montenegro": "Čierna Hora",
        "Tajikistan": "Tadžikistan",
        "Austria": "Rakúsko",
        "Bolivia": "Bolívia",
        "Sudan": "Sudán",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrajn",
        "Colombia": "Kolumbia",
        "Papua New Guinea": "Papua-Nová Guinea",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Džibutsko",
        "British Indian Ocean Territory": "Britské indickooceánske územie",
        "Chad": "Čad",
        "Germany": "Nemecko",
        "Fiji": "Fidži",
        "British Virgin Islands": "Britské Panenské ostrovy",
        "San Marino": "San Maríno",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Južná Afrika",
        "Eritrea": "Eritrea",
        "Greece": "Grécko",
        "Ethiopia": "Etiópia",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshallove ostrovy",
        "United States": "Spojené štáty",
        "Benin": "Benin",
        "El Salvador": "Salvádor",
        "Lebanon": "Libanon",
        "Palestine": "Palestína",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Šalamúnove ostrovy",
        "China": "Čína",
        "Tonga": "Tonga"
    },
};
export const myMY = {
    searchNotFound: "နိုင်ငံမတွေ့ပါ",
    searchPlaceholder: "နိုင်ငံကို ရှာဖွေပါ",
    countries: {
        "Gibraltar": "ဂျီဘရော်လ်တာ",
        "Gambia": "ဂမ်ဘီရာ",
        "Equatorial Guinea": "အီကွေတာ ဂီနီ",
        "Senegal": "ဆီနီဂေါ",
        "Jamaica": "ဂျမေနီကာ",
        "Seychelles": "ဆေးရှလ်",
        "Comoros": "ကိုမိုရိုဆ",
        "U.S. Virgin Islands": "အမေရိကန် ဗာဂျင်းကျွန်းစု",
        "Guinea": "ဂီနီ",
        "Niger": "နီဂျာ",
        "Libya": "လစ်ဗျား",
        "Romania": "ရိုမေးနီးယား",
        "Anguilla": "အန်ဂွီလာ",
        "Togo": "တိုဂို",
        "Paraguay": "ပါရာဂွေး",
        "India": "အိန္ဒိယ",
        "Ireland": "အိုင်ယာလန်",
        "Turkey": "တူရကီ",
        "Oman": "အိုမန်",
        "Ukraine": "ယူကရိန်း",
        "Spain": "စပိန်",
        "Cameroon": "ကမ္မရွန်း",
        "Angola": "အင်ဂိုလာ",
        "Mali": "မာလီ",
        "Saint Vincent and the Grenadines": "စိန့်ဗင်းဆင့်နှင့် ဂရိနာဒင်း",
        "Cyprus": "ဆိုက်ပရက်စ်",
        "Belarus": "ဘီလာရုစ်",
        "Gabon": "ဂါဘွန်",
        "Samoa": "ဆာမိုအာ",
        "Chile": "ချီလီ",
        "United Arab Emirates": "ယူအေအီး",
        "São Tomé and Príncipe": "ဆာအိုတူမေးနှင့် ပရင်စီပီ",
        "Palau": "ပလာအို",
        "Tokelau": "တိုကီလော",
        "Puerto Rico": "ပေါ်တိုရီကို",
        "Portugal": "ပေါ်တူဂီ",
        "Costa Rica": "ကိုစတာရီကာ",
        "Swaziland": "စဝါဇီလန်းဒ",
        "Cape Verde": "ကိတ်ဗာဒီ",
        "Curaçao": "ကူရာကာအို",
        "Andorra": "အန်ဒိုရာ",
        "Armenia": "အာမေနီးယား",
        "Haiti": "ဟေတီ",
        "Côte d’Ivoire": "ကိုတ်ဒီဗွား",
        "Guinea-Bissau": "ဂီနီ-ဗစ်ဆော",
        "Mozambique": "မိုဇန်ဘစ်",
        "Poland": "ပိုလန်",
        "French Polynesia": "ပြင်သစ်ပိုလီနီရှား",
        "Jersey": "ဂျာစီ",
        "Kuwait": "ကူဝိတ်",
        "Dominican Republic": "ဒိုမီနီကန်",
        "Kosovo": "ကိုဆိုဗို",
        "Kyrgyzstan": "ကာဂျစ္စတန်",
        "Syria": "ဆီးရီးယား",
        "Zambia": "ဇင်ဘာဘွေ",
        "Croatia": "ခရိုအေးရှား",
        "Lithuania": "လစ်သူအေးနီးယား",
        "Albania": "အယ်လ်ဘေးနီးယား",
        "Netherlands": "နယ်သာလန်",
        "France": "ပြင်သစ်",
        "Tunisia": "တူနီးဇီးယား",
        "Bosnia and Herzegovina": "ဘော့စနီးယားနှင့် ဟာဇီဂိုဗီးနား",
        "Bahamas": "ဘဟားမား",
        "Somalia": "ဆိုမာလီယား",
        "Burundi": "ဘူရွန်ဒီ",
        "Barbados": "ဘာဘားဒို့စ်",
        "Malawi": "မာလာဝီ",
        "Honduras": "ဟွန်ဒူးရပ်စ်",
        "French Guiana": "ပြင်သစ် ဂိုင်ယာနာ",
        "Jordan": "ဂျော်ဒန်",
        "Serbia": "ဆားဘီးယား",
        "Vanuatu": "ဗနုအာတူ",
        "Aruba": "အာရုဗာ",
        "Guyana": "ဂယာနာ",
        "Lesotho": "လီဆိုတို",
        "Taiwan": "ထိုင်ဝမ်",
        "Central African Republic": "ဗဟိုအာဖရိကပြည်ထောင်စု",
        "Luxembourg": "လူဇင်ဘတ်",
        "Trinidad and Tobago": "ထရီနီဒက်နှင့် တိုဘာဂို",
        "Estonia": "အက်စတိုးနီးယား",
        "Montserrat": "မွန်ဆာရာ့တ်",
        "Norway": "နော်ဝေ",
        "North Korea": "မြောက်ကိုးရီးယား",
        "Myanmar": "မြန်မာ",
        "Sri Lanka": "သီရိလင်္ကာ",
        "Faroe Islands": "ဖာရိုး ကျွန်းစု",
        "Dominica": "ဒိုမီနီကာ",
        "Kiribati": "ကီရီဘတီ",
        "Falkland Islands": "ဖောက်ကလန် ကျွန်းစု",
        "Namibia": "နမီးဘီးယား",
        "Saint Lucia": "စိန့် လူစီယာ",
        "Indonesia": "အင်ဒိုနီးရှား",
        "Timor-Leste": "အရှေ့တီမော",
        "Norfolk Island": "နော်ဖို့ ကျွန်းစု",
        "Bhutan": "ဘူတန်",
        "Iran": "အီရန်",
        "Turkmenistan": "တူရကမင်နစ္စတန်",
        "Uganda": "ယူဂန္ဓာ",
        "Kazakhstan": "ကာဇက်စတန်",
        "Cook Islands": "ကွတ်ကျွန်းစု",
        "Micronesia": "မိုက်ခရိုနီးရှား",
        "Sint Maarten": "စင့်မာတင်",
        "Liberia": "လိုက်ဘေးရီးယား",
        "Panama": "ပနားမား",
        "Malta": "မောလတာ",
        "Peru": "ပီရူး",
        "Philippines": "ဖိလစ်ပိုင်",
        "Rwanda": "ရဝန်ဒါ",
        "United Kingdom": "ယူနိုက်တက်ကင်းဒမ်း",
        "Martinique": "မာတီနိခ်",
        "Nepal": "နီပေါ",
        "Guatemala": "ဂွာတီမာလာ",
        "Bermuda": "ဘာမူဒါ",
        "Australia": "ဩစတြေးလျ",
        "Vatican City": "ဗာတီကန်",
        "Slovenia": "ဆလိုဗေးနီးယား",
        "Cayman Islands": "ကေးမန် ကျွန်းစု",
        "Hungary": "ဟန်ဂေရီ",
        "American Samoa": "အမေရိကန် ဆာမိုအာ",
        "Mauritania": "မော်ရီတေးနီးယား",
        "Japan": "ဂျပန်",
        "Uzbekistan": "ဥဘက်ကစ္စတန်",
        "Cambodia": "ကမ္ဘောဒီးယား",
        "Wallis & Futuna": "ဝေါလစ်နှင့် ဖူတူနာ",
        "South Sudan": "တောင်ဆိုဒန်",
        "Morocco": "မိုရိုကို",
        "Argentina": "အာဂျင်တီးနား",
        "Guadeloupe": "ဂွာဒယ်လုပ",
        "Hong Kong": "ဟောင်ကောင်",
        "Qatar": "ကာတာ",
        "Tanzania": "တန်ဇန်းနီးယား",
        "Mexico": "မက္ကဆီကို",
        "Russia": "ရုရှား",
        "Iceland": "အိုက်စ်လန်း",
        "Monaco": "မိုနာကို",
        "Afghanistan": "အာဖဂန်နစ္စတန်",
        "Slovakia": "ဆလိုဗက်ကီးယား",
        "Sweden": "ဆွီဒင်",
        "Azerbaijan": "အဇာဘိုင်ဂျန်",
        "Bangladesh": "ဘင်္ဂလားဒေ့ရှ်",
        "Brazil": "ဘရာဇီး",
        "Cuba": "ကျူးဘား",
        "Ghana": "ဂါနာ",
        "Mongolia": "မွန်ဂိုလီးယား",
        "Saint Kitts and Nevis": "စိန့်ကစ်နှင့် နီဗစ်",
        "Burkina Faso": "ဘာကီနာ ဖားဆို",
        "Nicaragua": "နီကာရာဂွာ",
        "Malaysia": "မလေးရှား",
        "Uruguay": "ဥရုဂွေး",
        "Brunei": "ဘရူနိုင်း",
        "Congo": "ကွန်ဂို",
        "Nauru": "နာရွ",
        "Northern Mariana Islands": "မြောက်မာရီအာနာ ကျွန်းစု",
        "Pakistan": "ပါကစ္စတန်",
        "Greenland": "ဂရင်းလန်း",
        "Mauritius": "မောရစ်ရှ",
        "Caribbean Netherlands": "ကာရစ်ဘီယံ နယ်သာလန်",
        "Belize": "ဘလိဇ်",
        "Liechtenstein": "လစ်ခ်တန်စတိန်း",
        "Sierra Leone": "ဆီရာ လီယွန်း",
        "Czech Republic": "ချက် ပြည်ထောင်စု",
        "Moldova": "မောလ်ဒိုဗာ",
        "Singapore": "စင်္ကာပူ",
        "Belgium": "ဘယ်လ်ဂျီယံ",
        "Maldives": "မော်လ်ဒိုက်",
        "New Zealand": "နယူးဇီလန်",
        "South Korea": "တောင်ကိုရီးယား",
        "Italy": "အီတလီ",
        "Israel": "အစ္စရေး",
        "Grenada": "ဂရီနဒါ",
        "Kenya": "ကင်နယာ",
        "St. Helena": "စိန့်ဟယ်လီနာ",
        "Guam": "ဂူအမ်",
        "Denmark": "ဒိန်းမတ်",
        "New Caledonia": "နယူး ကယ်လီဒိုးနီးယား",
        "Ecuador": "အီကွေဒေါ",
        "Canada": "ကနေဒါ",
        "Egypt": "အီဂျစ်",
        "Saudi Arabia": "ဆော်ဒီအာရေးဗီးယား",
        "Botswana": "ဘော့စ်ဝါနာ",
        "Turks & Caicos Islands": "တူ့ခ်နှင့် ကိတ်ကွေး ကျွန်းစု",
        "Latvia": "လတ်ဗီးယား",
        "St. Pierre & Miquelon": "စိန့်ပီအဲနှင့် မီကိုလွန်",
        "Georgia": "ဂျော်ဂျီယာ",
        "Laos": "လာအို",
        "Réunion": "ရေးအူနီယွန်",
        "Niue": "နီယူ",
        "Zimbabwe": "ဇင်ဘာဘွေ",
        "Thailand": "ထိုင်း",
        "Algeria": "အယ်လ်ဂျီးရီးယား",
        "Finland": "ဖင်လန်",
        "Macedonia": "မြောက် မက်ဆီဒိုးနီးယား",
        "Antigua and Barbuda": "အန်တီဂွါနှင့် ဘာဘူဒါ",
        "Nigeria": "နိုင်ဂျီးရီးယား",
        "Switzerland": "ဆွစ်ဇာလန်",
        "Bulgaria": "ဘူဂေးရီးယား",
        "Montenegro": "မွန်တီနိဂရိုး",
        "Tajikistan": "တာဂျစ်ကစ္စတန်",
        "Austria": "ဩစတြီးယား",
        "Bolivia": "ဘိုလီးဘီးယား",
        "Sudan": "ဆူဒန်",
        "Suriname": "ဆူရီနမ်",
        "Iraq": "အီရတ်",
        "Bahrain": "ဘာရိန်း",
        "Colombia": "ကိုလံဘီယာ",
        "Papua New Guinea": "ပါပူအာ နယူးဂီနီ",
        "Yemen": "ယီမင်",
        "Venezuela": "ဗင်နီဇွဲလား",
        "Djibouti": "ဂျီဘူတီ",
        "British Indian Ocean Territory": "ဗြိတိသျှ အိန္ဒိယ သမုဒ္ဒရာ ဒေသ",
        "Chad": "ချဒ်",
        "Germany": "ဂျာမနီ",
        "Fiji": "ဖီဂျီ",
        "British Virgin Islands": "ဗြိတိသျှ ဗာဂျင်း ကျွန်းစု",
        "San Marino": "ဆန်မာရီနို",
        "Vietnam": "ဗီယက်နမ်",
        "Macau": "မကာအို",
        "South Africa": "တောင်အာဖရိက",
        "Eritrea": "အီရီတရီးယား",
        "Greece": "ဂရိ",
        "Ethiopia": "အီသီယိုးပီးယား",
        "Madagascar": "မာဒါဂတ်စကား",
        "Marshall Islands": "မာရှယ် ကျွန်းစု",
        "United States": "အမေရိကန်ပြည်ထောင်စု",
        "Benin": "ဘနင်",
        "El Salvador": "အယ်လ်ဆာဗေးဒိုး",
        "Lebanon": "လက်ဘနွန်",
        "Palestine": "ပါလက်စတိုင်း",
        "Tuvalu": "တူဗားလူ",
        "Solomon Islands": "ဆော်လမွန် ကျွန်းစု",
        "China": "တရုတ်",
        "Tonga": "တွန်းဂါ"
    },
};
export const daDK = {
    searchNotFound: "Ingen lande fundet",
    searchPlaceholder: "Søg efter et land",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Ækvatorialguinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychellerne",
        "Comoros": "Comorerne",
        "U.S. Virgin Islands": "Amerikanske Jomfruøer",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libyen",
        "Romania": "Rumænien",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Indien",
        "Ireland": "Irland",
        "Turkey": "Tyrkiet",
        "Oman": "Oman",
        "Ukraine": "Ukraine",
        "Spain": "Spanien",
        "Cameroon": "Cameroun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent og Grenadinerne",
        "Cyprus": "Cypern",
        "Belarus": "Hviderusland",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Forenede Arabiske Emirater",
        "São Tomé and Príncipe": "São Tomé og Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kap Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenien",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Elfenbenskysten",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mozambique",
        "Poland": "Polen",
        "French Polynesia": "Fransk Polynesien",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Den Dominikanske Republik",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgisistan",
        "Syria": "Syrien",
        "Zambia": "Zambia",
        "Croatia": "Kroatien",
        "Lithuania": "Litauen",
        "Albania": "Albanien",
        "Netherlands": "Holland",
        "France": "Frankrig",
        "Tunisia": "Tunesien",
        "Bosnia and Herzegovina": "Bosnien-Hercegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Fransk Guyana",
        "Jordan": "Jordan",
        "Serbia": "Serbien",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Den Centralafrikanske Republik",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinidad og Tobago",
        "Estonia": "Estland",
        "Montserrat": "Montserrat",
        "Norway": "Norge",
        "North Korea": "Nordkorea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Færøerne",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandsøerne",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesien",
        "Timor-Leste": "Østtimor",
        "Norfolk Island": "Norfolkøen",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kasakhstan",
        "Cook Islands": "Cookøerne",
        "Micronesia": "Mikronesien",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filippinerne",
        "Rwanda": "Rwanda",
        "United Kingdom": "Storbritannien",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australien",
        "Vatican City": "Vatikanstaten",
        "Slovenia": "Slovenien",
        "Cayman Islands": "Caymanøerne",
        "Hungary": "Ungarn",
        "American Samoa": "Amerikansk Samoa",
        "Mauritania": "Mauretanien",
        "Japan": "Japan",
        "Uzbekistan": "Usbekistan",
        "Cambodia": "Cambodja",
        "Wallis & Futuna": "Wallis og Futuna",
        "South Sudan": "Sydsudan",
        "Morocco": "Marokko",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexico",
        "Russia": "Rusland",
        "Iceland": "Island",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovakiet",
        "Sweden": "Sverige",
        "Azerbaijan": "Aserbajdsjan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasilien",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongoliet",
        "Saint Kitts and Nevis": "Saint Kitts og Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Nordmarianerne",
        "Pakistan": "Pakistan",
        "Greenland": "Grønland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Caribiske Nederlande",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Tjekkiet",
        "Moldova": "Moldova",
        "Singapore": "Singapore",
        "Belgium": "Belgien",
        "Maldives": "Maldiverne",
        "New Zealand": "New Zealand",
        "South Korea": "Sydkorea",
        "Italy": "Italien",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Sankt Helena",
        "Guam": "Guam",
        "Denmark": "Danmark",
        "New Caledonia": "Ny Kaledonien",
        "Ecuador": "Ecuador",
        "Canada": "Canada",
        "Egypt": "Egypten",
        "Saudi Arabia": "Saudi-Arabien",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks- og Caicosøerne",
        "Latvia": "Letland",
        "St. Pierre & Miquelon": "Saint Pierre og Miquelon",
        "Georgia": "Georgien",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algeriet",
        "Finland": "Finland",
        "Macedonia": "Nordmakedonien",
        "Antigua and Barbuda": "Antigua og Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Schweiz",
        "Bulgaria": "Bulgarien",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tadsjikistan",
        "Austria": "Østrig",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrain",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papua Ny Guinea",
        "Yemen": "Yemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Det Britiske Territorium i Det Indiske Ocean",
        "Chad": "Tchad",
        "Germany": "Tyskland",
        "Fiji": "Fiji",
        "British Virgin Islands": "De Britiske Jomfruøer",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Sydafrika",
        "Eritrea": "Eritrea",
        "Greece": "Grækenland",
        "Ethiopia": "Etiopien",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshalløerne",
        "United States": "USA",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palæstina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomonøerne",
        "China": "Kina",
        "Tonga": "Tonga"
    },
};
export const fiFI = {
    searchNotFound: "Ei löytynyt maata",
    searchPlaceholder: "Etsi maata",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Päiväntasaajan Guinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaika",
        "Seychelles": "Seychellit",
        "Comoros": "Komorit",
        "U.S. Virgin Islands": "Yhdysvaltain Neitsytsaaret",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libya",
        "Romania": "Romania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Intia",
        "Ireland": "Irlanti",
        "Turkey": "Turkki",
        "Oman": "Oman",
        "Ukraine": "Ukraina",
        "Spain": "Espanja",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent ja Grenadiinit",
        "Cyprus": "Kypros",
        "Belarus": "Valko-Venäjä",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Yhdistyneet arabiemiirikunnat",
        "São Tomé and Príncipe": "São Tomé ja Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugali",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kap Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Norsunluurannikko",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mosambik",
        "Poland": "Puola",
        "French Polynesia": "Ranskan Polynesia",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Dominikaaninen tasavalta",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgisia",
        "Syria": "Syyria",
        "Zambia": "Sambia",
        "Croatia": "Kroatia",
        "Lithuania": "Liettua",
        "Albania": "Albania",
        "Netherlands": "Alankomaat",
        "France": "Ranska",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia ja Hertsegovina",
        "Bahamas": "Bahama",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Ranskan Guayana",
        "Jordan": "Jordania",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Keski-Afrikan tasavalta",
        "Luxembourg": "Luxemburg",
        "Trinidad and Tobago": "Trinidad ja Tobago",
        "Estonia": "Viro",
        "Montserrat": "Montserrat",
        "Norway": "Norja",
        "North Korea": "Pohjois-Korea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Färsaaret",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandinsaaret",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Itä-Timor",
        "Norfolk Island": "Norfolkinsaari",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakstan",
        "Cook Islands": "Cookinsaaret",
        "Micronesia": "Mikronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filippiinit",
        "Rwanda": "Ruanda",
        "United Kingdom": "Yhdistynyt kuningaskunta",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australia",
        "Vatican City": "Vatikaanivaltio",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Caymansaaret",
        "Hungary": "Unkari",
        "American Samoa": "Amerikan Samoa",
        "Mauritania": "Mauritania",
        "Japan": "Japani",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kambodža",
        "Wallis & Futuna": "Wallis ja Futuna",
        "South Sudan": "Etelä-Sudan",
        "Morocco": "Marokko",
        "Argentina": "Argentiina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Qatar",
        "Tanzania": "Tansania",
        "Mexico": "Meksiko",
        "Russia": "Venäjä",
        "Iceland": "Islanti",
        "Monaco": "Monaco",
        "Afghanistan": "Afganistan",
        "Slovakia": "Slovakia",
        "Sweden": "Ruotsi",
        "Azerbaijan": "Azerbaidžan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasilia",
        "Cuba": "Kuuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts ja Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malesia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Kongon demokraattinen tasavalta",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Pohjois-Mariaanit",
        "Pakistan": "Pakistan",
        "Greenland": "Grönlanti",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Karibian Alankomaat",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Tšekki",
        "Moldova": "Moldova",
        "Singapore": "Singapore",
        "Belgium": "Belgia",
        "Maldives": "Malediivit",
        "New Zealand": "Uusi-Seelanti",
        "South Korea": "Etelä-Korea",
        "Italy": "Italia",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenia",
        "St. Helena": "Saint Helena",
        "Guam": "Guam",
        "Denmark": "Tanska",
        "New Caledonia": "Uusi-Kaledonia",
        "Ecuador": "Ecuador",
        "Canada": "Kanada",
        "Egypt": "Egypti",
        "Saudi Arabia": "Saudi-Arabia",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks- ja Caicossaaret",
        "Latvia": "Latvia",
        "St. Pierre & Miquelon": "Saint-Pierre ja Miquelon",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thaimaa",
        "Algeria": "Algeria",
        "Finland": "Suomi",
        "Macedonia": "Pohjois-Makedonia",
        "Antigua and Barbuda": "Antigua ja Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Sveitsi",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tadžikistan",
        "Austria": "Itävalta",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Suriname",
        "Iraq": "Irak",
        "Bahrain": "Bahrain",
        "Colombia": "Kolumbia",
        "Papua New Guinea": "Papua-Uusi-Guinea",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Brittiläinen Intian valtameren alue",
        "Chad": "Tšad",
        "Germany": "Saksa",
        "Fiji": "Fidži",
        "British Virgin Islands": "Brittiläiset Neitsytsaaret",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Etelä-Afrikka",
        "Eritrea": "Eritrea",
        "Greece": "Kreikka",
        "Ethiopia": "Etiopia",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshallinsaaret",
        "United States": "Yhdysvallat",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palestiina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomonsaaret",
        "China": "Kiina",
        "Tonga": "Tonga"
    },
};
export const zhHK = {
    searchNotFound: "找不到國家",
    searchPlaceholder: "搜尋國家",
    countries: {
        "Gibraltar": "直布羅陀",
        "Gambia": "岡比亞",
        "Equatorial Guinea": "赤道幾內亞",
        "Senegal": "塞內加爾",
        "Jamaica": "牙買加",
        "Seychelles": "塞舌爾",
        "Comoros": "科摩羅",
        "U.S. Virgin Islands": "美屬維爾京群島",
        "Guinea": "幾內亞",
        "Niger": "尼日爾",
        "Libya": "利比亞",
        "Romania": "羅馬尼亞",
        "Anguilla": "安圭拉",
        "Togo": "多哥",
        "Paraguay": "巴拉圭",
        "India": "印度",
        "Ireland": "愛爾蘭",
        "Turkey": "土耳其",
        "Oman": "阿曼",
        "Ukraine": "烏克蘭",
        "Spain": "西班牙",
        "Cameroon": "喀麥隆",
        "Angola": "安哥拉",
        "Mali": "馬里",
        "Saint Vincent and the Grenadines": "聖文森及格林納丁斯",
        "Cyprus": "塞浦路斯",
        "Belarus": "白俄羅斯",
        "Gabon": "加蓬",
        "Samoa": "薩摩亞",
        "Chile": "智利",
        "United Arab Emirates": "阿拉伯聯合酋長國",
        "São Tomé and Príncipe": "聖多美和普林西比",
        "Palau": "帛琉",
        "Tokelau": "托克勞",
        "Puerto Rico": "波多黎各",
        "Portugal": "葡萄牙",
        "Costa Rica": "哥斯達黎加",
        "Swaziland": "斯威士蘭",
        "Cape Verde": "佛得角",
        "Curaçao": "庫拉索",
        "Andorra": "安道爾",
        "Armenia": "亞美尼亞",
        "Haiti": "海地",
        "Côte d’Ivoire": "科特迪瓦",
        "Guinea-Bissau": "幾內亞比紹",
        "Mozambique": "莫桑比克",
        "Poland": "波蘭",
        "French Polynesia": "法屬波利尼西亞",
        "Jersey": "澤西島",
        "Kuwait": "科威特",
        "Dominican Republic": "多明尼加共和國",
        "Kosovo": "科索沃",
        "Kyrgyzstan": "吉爾吉斯斯坦",
        "Syria": "敘利亞",
        "Zambia": "贊比亞",
        "Croatia": "克羅地亞",
        "Lithuania": "立陶宛",
        "Albania": "阿爾巴尼亞",
        "Netherlands": "荷蘭",
        "France": "法國",
        "Tunisia": "突尼西亞",
        "Bosnia and Herzegovina": "波士尼亞和黑塞哥維那",
        "Bahamas": "巴哈馬",
        "Somalia": "索馬里",
        "Burundi": "布隆迪",
        "Barbados": "巴巴多斯",
        "Malawi": "馬拉維",
        "Honduras": "洪都拉斯",
        "French Guiana": "法屬圭亞那",
        "Jordan": "約旦",
        "Serbia": "塞爾維亞",
        "Vanuatu": "瓦努阿圖",
        "Aruba": "阿魯巴",
        "Guyana": "圭亞那",
        "Lesotho": "萊索托",
        "Taiwan": "台灣",
        "Central African Republic": "中非共和國",
        "Luxembourg": "盧森堡",
        "Trinidad and Tobago": "特立尼達和多巴哥",
        "Estonia": "愛沙尼亞",
        "Montserrat": "蒙特塞拉特",
        "Norway": "挪威",
        "North Korea": "北韓",
        "Myanmar": "緬甸",
        "Sri Lanka": "斯里蘭卡",
        "Faroe Islands": "法羅群島",
        "Dominica": "多米尼克",
        "Kiribati": "基里巴斯",
        "Falkland Islands": "福克蘭群島",
        "Namibia": "納米比亞",
        "Saint Lucia": "聖盧西亞",
        "Indonesia": "印尼",
        "Timor-Leste": "東帝汶",
        "Norfolk Island": "諾福克島",
        "Bhutan": "不丹",
        "Iran": "伊朗",
        "Turkmenistan": "土庫曼斯坦",
        "Uganda": "烏干達",
        "Kazakhstan": "哈薩克斯坦",
        "Cook Islands": "庫克群島",
        "Micronesia": "密克羅尼西亞",
        "Sint Maarten": "聖馬丁島",
        "Liberia": "利比里亞",
        "Panama": "巴拿馬",
        "Malta": "馬耳他",
        "Peru": "秘魯",
        "Philippines": "菲律賓",
        "Rwanda": "盧旺達",
        "United Kingdom": "英國",
        "Martinique": "馬提尼克",
        "Nepal": "尼泊爾",
        "Guatemala": "危地馬拉",
        "Bermuda": "百慕大",
        "Australia": "澳大利亞",
        "Vatican City": "梵蒂岡",
        "Slovenia": "斯洛文尼亞",
        "Cayman Islands": "開曼群島",
        "Hungary": "匈牙利",
        "American Samoa": "美屬薩摩亞",
        "Mauritania": "毛里塔尼亞",
        "Japan": "日本",
        "Uzbekistan": "烏茲別克斯坦",
        "Cambodia": "柬埔寨",
        "Wallis & Futuna": "瓦利斯和富圖納",
        "South Sudan": "南蘇丹",
        "Morocco": "摩洛哥",
        "Argentina": "阿根廷",
        "Guadeloupe": "瓜德羅普",
        "Hong Kong": "香港",
        "Qatar": "卡塔爾",
        "Tanzania": "坦桑尼亞",
        "Mexico": "墨西哥",
        "Russia": "俄羅斯",
        "Iceland": "冰島",
        "Monaco": "摩納哥",
        "Afghanistan": "阿富汗",
        "Slovakia": "斯洛伐克",
        "Sweden": "瑞典",
        "Azerbaijan": "阿塞拜疆",
        "Bangladesh": "孟加拉國",
        "Brazil": "巴西",
        "Cuba": "古巴",
        "Ghana": "加納",
        "Mongolia": "蒙古",
        "Saint Kitts and Nevis": "聖基茨和尼維斯",
        "Burkina Faso": "布基納法索",
        "Nicaragua": "尼加拉瓜",
        "Malaysia": "馬來西亞",
        "Uruguay": "烏拉圭",
        "Brunei": "文萊",
        "Congo": "剛果",
        "Nauru": "瑙魯",
        "Northern Mariana Islands": "北馬里亞納群島",
        "Pakistan": "巴基斯坦",
        "Greenland": "格陵蘭",
        "Mauritius": "毛里裘斯",
        "Caribbean Netherlands": "荷屬加勒比",
        "Belize": "伯利茲",
        "Liechtenstein": "列支敦士登",
        "Sierra Leone": "塞拉利昂",
        "Czech Republic": "捷克共和國",
        "Moldova": "摩爾多瓦",
        "Singapore": "新加坡",
        "Belgium": "比利時",
        "Maldives": "馬爾代夫",
        "New Zealand": "新西蘭",
        "South Korea": "南韓",
        "Italy": "意大利",
        "Israel": "以色列",
        "Grenada": "格林納達",
        "Kenya": "肯尼亞",
        "St. Helena": "聖赫勒拿島",
        "Guam": "關島",
        "Denmark": "丹麥",
        "New Caledonia": "新喀里多尼亞",
        "Ecuador": "厄瓜多爾",
        "Canada": "加拿大",
        "Egypt": "埃及",
        "Saudi Arabia": "沙特阿拉伯",
        "Botswana": "博茨瓦納",
        "Turks & Caicos Islands": "特克斯和凱科斯群島",
        "Latvia": "拉脫維亞",
        "St. Pierre & Miquelon": "聖皮埃爾和密克隆",
        "Georgia": "格魯吉亞",
        "Laos": "老撾",
        "Réunion": "留尼旺",
        "Niue": "紐埃",
        "Zimbabwe": "津巴布韋",
        "Thailand": "泰國",
        "Algeria": "阿爾及利亞",
        "Finland": "芬蘭",
        "Macedonia": "北馬其頓",
        "Antigua and Barbuda": "安提瓜和巴布達",
        "Nigeria": "尼日利亞",
        "Switzerland": "瑞士",
        "Bulgaria": "保加利亞",
        "Montenegro": "黑山",
        "Tajikistan": "塔吉克斯坦",
        "Austria": "奧地利",
        "Bolivia": "玻利維亞",
        "Sudan": "蘇丹",
        "Suriname": "蘇里南",
        "Iraq": "伊拉克",
        "Bahrain": "巴林",
        "Colombia": "哥倫比亞",
        "Papua New Guinea": "巴布亞新幾內亞",
        "Yemen": "也門",
        "Venezuela": "委內瑞拉",
        "Djibouti": "吉布提",
        "British Indian Ocean Territory": "英屬印度洋領地",
        "Chad": "乍得",
        "Germany": "德國",
        "Fiji": "斐濟",
        "British Virgin Islands": "英屬維爾京群島",
        "San Marino": "聖馬力諾",
        "Vietnam": "越南",
        "Macau": "澳門",
        "South Africa": "南非",
        "Eritrea": "厄立特里亞",
        "Greece": "希臘",
        "Ethiopia": "埃塞俄比亞",
        "Madagascar": "馬達加斯加",
        "Marshall Islands": "馬紹爾群島",
        "United States": "美國",
        "Benin": "貝寧",
        "El Salvador": "薩爾瓦多",
        "Lebanon": "黎巴嫩",
        "Palestine": "巴勒斯坦",
        "Tuvalu": "圖瓦盧",
        "Solomon Islands": "所羅門群島",
        "China": "中國",
        "Tonga": "湯加"
    },
};
export const zhCN = {
    searchNotFound: "找不到国家",
    searchPlaceholder: "搜索国家",
    countries: {
        "Gibraltar": "直布罗陀",
        "Gambia": "冈比亚",
        "Equatorial Guinea": "赤道几内亚",
        "Senegal": "塞内加尔",
        "Jamaica": "牙买加",
        "Seychelles": "塞舌尔",
        "Comoros": "科摩罗",
        "U.S. Virgin Islands": "美属维尔京群岛",
        "Guinea": "几内亚",
        "Niger": "尼日尔",
        "Libya": "利比亚",
        "Romania": "罗马尼亚",
        "Anguilla": "安圭拉",
        "Togo": "多哥",
        "Paraguay": "巴拉圭",
        "India": "印度",
        "Ireland": "爱尔兰",
        "Turkey": "土耳其",
        "Oman": "阿曼",
        "Ukraine": "乌克兰",
        "Spain": "西班牙",
        "Cameroon": "喀麦隆",
        "Angola": "安哥拉",
        "Mali": "马里",
        "Saint Vincent and the Grenadines": "圣文森特和格林纳丁斯",
        "Cyprus": "塞浦路斯",
        "Belarus": "白俄罗斯",
        "Gabon": "加蓬",
        "Samoa": "萨摩亚",
        "Chile": "智利",
        "United Arab Emirates": "阿拉伯联合酋长国",
        "São Tomé and Príncipe": "圣多美和普林西比",
        "Palau": "帕劳",
        "Tokelau": "托克劳",
        "Puerto Rico": "波多黎各",
        "Portugal": "葡萄牙",
        "Costa Rica": "哥斯达黎加",
        "Swaziland": "斯威士兰",
        "Cape Verde": "佛得角",
        "Curaçao": "库拉索",
        "Andorra": "安道尔",
        "Armenia": "亚美尼亚",
        "Haiti": "海地",
        "Côte d’Ivoire": "科特迪瓦",
        "Guinea-Bissau": "几内亚比绍",
        "Mozambique": "莫桑比克",
        "Poland": "波兰",
        "French Polynesia": "法属波利尼西亚",
        "Jersey": "泽西岛",
        "Kuwait": "科威特",
        "Dominican Republic": "多米尼加共和国",
        "Kosovo": "科索沃",
        "Kyrgyzstan": "吉尔吉斯斯坦",
        "Syria": "叙利亚",
        "Zambia": "赞比亚",
        "Croatia": "克罗地亚",
        "Lithuania": "立陶宛",
        "Albania": "阿尔巴尼亚",
        "Netherlands": "荷兰",
        "France": "法国",
        "Tunisia": "突尼斯",
        "Bosnia and Herzegovina": "波斯尼亚和黑塞哥维那",
        "Bahamas": "巴哈马",
        "Somalia": "索马里",
        "Burundi": "布隆迪",
        "Barbados": "巴巴多斯",
        "Malawi": "马拉维",
        "Honduras": "洪都拉斯",
        "French Guiana": "法属圭亚那",
        "Jordan": "约旦",
        "Serbia": "塞尔维亚",
        "Vanuatu": "瓦努阿图",
        "Aruba": "阿鲁巴",
        "Guyana": "圭亚那",
        "Lesotho": "莱索托",
        "Taiwan": "台湾",
        "Central African Republic": "中非共和国",
        "Luxembourg": "卢森堡",
        "Trinidad and Tobago": "特立尼达和多巴哥",
        "Estonia": "爱沙尼亚",
        "Montserrat": "蒙特塞拉特",
        "Norway": "挪威",
        "North Korea": "朝鲜",
        "Myanmar": "缅甸",
        "Sri Lanka": "斯里兰卡",
        "Faroe Islands": "法罗群岛",
        "Dominica": "多米尼克",
        "Kiribati": "基里巴斯",
        "Falkland Islands": "福克兰群岛",
        "Namibia": "纳米比亚",
        "Saint Lucia": "圣卢西亚",
        "Indonesia": "印度尼西亚",
        "Timor-Leste": "东帝汶",
        "Norfolk Island": "诺福克岛",
        "Bhutan": "不丹",
        "Iran": "伊朗",
        "Turkmenistan": "土库曼斯坦",
        "Uganda": "乌干达",
        "Kazakhstan": "哈萨克斯坦",
        "Cook Islands": "库克群岛",
        "Micronesia": "密克罗尼西亚",
        "Sint Maarten": "荷属圣马丁",
        "Liberia": "利比里亚",
        "Panama": "巴拿马",
        "Malta": "马耳他",
        "Peru": "秘鲁",
        "Philippines": "菲律宾",
        "Rwanda": "卢旺达",
        "United Kingdom": "英国",
        "Martinique": "马提尼克",
        "Nepal": "尼泊尔",
        "Guatemala": "危地马拉",
        "Bermuda": "百慕大",
        "Australia": "澳大利亚",
        "Vatican City": "梵蒂冈",
        "Slovenia": "斯洛文尼亚",
        "Cayman Islands": "开曼群岛",
        "Hungary": "匈牙利",
        "American Samoa": "美属萨摩亚",
        "Mauritania": "毛里塔尼亚",
        "Japan": "日本",
        "Uzbekistan": "乌兹别克斯坦",
        "Cambodia": "柬埔寨",
        "Wallis & Futuna": "瓦利斯和富图纳",
        "South Sudan": "南苏丹",
        "Morocco": "摩洛哥",
        "Argentina": "阿根廷",
        "Guadeloupe": "瓜德罗普",
        "Hong Kong": "香港",
        "Qatar": "卡塔尔",
        "Tanzania": "坦桑尼亚",
        "Mexico": "墨西哥",
        "Russia": "俄罗斯",
        "Iceland": "冰岛",
        "Monaco": "摩纳哥",
        "Afghanistan": "阿富汗",
        "Slovakia": "斯洛伐克",
        "Sweden": "瑞典",
        "Azerbaijan": "阿塞拜疆",
        "Bangladesh": "孟加拉国",
        "Brazil": "巴西",
        "Cuba": "古巴",
        "Ghana": "加纳",
        "Mongolia": "蒙古",
        "Saint Kitts and Nevis": "圣基茨和尼维斯",
        "Burkina Faso": "布基纳法索",
        "Nicaragua": "尼加拉瓜",
        "Malaysia": "马来西亚",
        "Uruguay": "乌拉圭",
        "Brunei": "文莱",
        "Congo": "刚果",
        "Nauru": "瑙鲁",
        "Northern Mariana Islands": "北马里亚纳群岛",
        "Pakistan": "巴基斯坦",
        "Greenland": "格陵兰",
        "Mauritius": "毛里求斯",
        "Caribbean Netherlands": "荷属加勒比",
        "Belize": "伯利兹",
        "Liechtenstein": "列支敦士登",
        "Sierra Leone": "塞拉利昂",
        "Czech Republic": "捷克共和国",
        "Moldova": "摩尔多瓦",
        "Singapore": "新加坡",
        "Belgium": "比利时",
        "Maldives": "马尔代夫",
        "New Zealand": "新西兰",
        "South Korea": "韩国",
        "Italy": "意大利",
        "Israel": "以色列",
        "Grenada": "格林纳达",
        "Kenya": "肯尼亚",
        "St. Helena": "圣赫勒拿",
        "Guam": "关岛",
        "Denmark": "丹麦",
        "New Caledonia": "新喀里多尼亚",
        "Ecuador": "厄瓜多尔",
        "Canada": "加拿大",
        "Egypt": "埃及",
        "Saudi Arabia": "沙特阿拉伯",
        "Botswana": "博茨瓦纳",
        "Turks & Caicos Islands": "特克斯和凯科斯群岛",
        "Latvia": "拉脱维亚",
        "St. Pierre & Miquelon": "圣皮埃尔和密克隆",
        "Georgia": "格鲁吉亚",
        "Laos": "老挝",
        "Réunion": "留尼汪",
        "Niue": "纽埃",
        "Zimbabwe": "津巴布韦",
        "Thailand": "泰国",
        "Algeria": "阿尔及利亚",
        "Finland": "芬兰",
        "Macedonia": "北马其顿",
        "Antigua and Barbuda": "安提瓜和巴布达",
        "Nigeria": "尼日利亚",
        "Switzerland": "瑞士",
        "Bulgaria": "保加利亚",
        "Montenegro": "黑山",
        "Tajikistan": "塔吉克斯坦",
        "Austria": "奥地利",
        "Bolivia": "玻利维亚",
        "Sudan": "苏丹",
        "Suriname": "苏里南",
        "Iraq": "伊拉克",
        "Bahrain": "巴林",
        "Colombia": "哥伦比亚",
        "Papua New Guinea": "巴布亚新几内亚",
        "Yemen": "也门",
        "Venezuela": "委内瑞拉",
        "Djibouti": "吉布提",
        "British Indian Ocean Territory": "英属印度洋领地",
        "Chad": "乍得",
        "Germany": "德国",
        "Fiji": "斐济",
        "British Virgin Islands": "英属维尔京群岛",
        "San Marino": "圣马力诺",
        "Vietnam": "越南",
        "Macau": "澳门",
        "South Africa": "南非",
        "Eritrea": "厄立特里亚",
        "Greece": "希腊",
        "Ethiopia": "埃塞俄比亚",
        "Madagascar": "马达加斯加",
        "Marshall Islands": "马绍尔群岛",
        "United States": "美国",
        "Benin": "贝宁",
        "El Salvador": "萨尔瓦多",
        "Lebanon": "黎巴嫩",
        "Palestine": "巴勒斯坦",
        "Tuvalu": "图瓦卢",
        "Solomon Islands": "所罗门群岛",
        "China": "中国",
        "Tonga": "汤加"
    },
};
export const heIL = {
    searchNotFound: "לא נמצאה מדינה",
    searchPlaceholder: "חפש מדינה",
    countries: {
        "Gibraltar": "גיברלטר",
        "Gambia": "גמביה",
        "Equatorial Guinea": "גינאה המשוונית",
        "Senegal": "סנגל",
        "Jamaica": "ג'מייקה",
        "Seychelles": "איי סיישל",
        "Comoros": "קומורו",
        "U.S. Virgin Islands": "איי הבתולה של ארצות הברית",
        "Guinea": "גינאה",
        "Niger": "ניז'ר",
        "Libya": "לוב",
        "Romania": "רומניה",
        "Anguilla": "אנגווילה",
        "Togo": "טוגו",
        "Paraguay": "פרגוואי",
        "India": "הודו",
        "Ireland": "אירלנד",
        "Turkey": "טורקיה",
        "Oman": "עומאן",
        "Ukraine": "אוקראינה",
        "Spain": "ספרד",
        "Cameroon": "קמרון",
        "Angola": "אנגולה",
        "Mali": "מאלי",
        "Saint Vincent and the Grenadines": "סנט וינסנט והגרנדינים",
        "Cyprus": "קפריסין",
        "Belarus": "בלארוס",
        "Gabon": "גבון",
        "Samoa": "סמואה",
        "Chile": "צ'ילה",
        "United Arab Emirates": "איחוד האמירויות הערביות",
        "São Tomé and Príncipe": "סאו טומה ופרינסיפה",
        "Palau": "פלאו",
        "Tokelau": "טוקלאו",
        "Puerto Rico": "פוארטו ריקו",
        "Portugal": "פורטוגל",
        "Costa Rica": "קוסטה ריקה",
        "Swaziland": "אסוואטיני",
        "Cape Verde": "כף ורדה",
        "Curaçao": "קוראסאו",
        "Andorra": "אנדורה",
        "Armenia": "ארמניה",
        "Haiti": "האיטי",
        "Côte d’Ivoire": "חוף השנהב",
        "Guinea-Bissau": "גינאה-ביסאו",
        "Mozambique": "מוזמביק",
        "Poland": "פולין",
        "French Polynesia": "פולינזיה הצרפתית",
        "Jersey": "ג'רזי",
        "Kuwait": "כווית",
        "Dominican Republic": "הרפובליקה הדומיניקנית",
        "Kosovo": "קוסובו",
        "Kyrgyzstan": "קירגיזסטן",
        "Syria": "סוריה",
        "Zambia": "זמביה",
        "Croatia": "קרואטיה",
        "Lithuania": "ליטא",
        "Albania": "אלבניה",
        "Netherlands": "הולנד",
        "France": "צרפת",
        "Tunisia": "תוניסיה",
        "Bosnia and Herzegovina": "בוסניה והרצגובינה",
        "Bahamas": "איי בהאמה",
        "Somalia": "סומליה",
        "Burundi": "בורונדי",
        "Barbados": "ברבדוס",
        "Malawi": "מלאווי",
        "Honduras": "הונדורס",
        "French Guiana": "גיאנה הצרפתית",
        "Jordan": "ירדן",
        "Serbia": "סרביה",
        "Vanuatu": "ונואטו",
        "Aruba": "ארובה",
        "Guyana": "גיאנה",
        "Lesotho": "לסוטו",
        "Taiwan": "טייוואן",
        "Central African Republic": "הרפובליקה המרכז-אפריקאית",
        "Luxembourg": "לוקסמבורג",
        "Trinidad and Tobago": "טרינידד וטובגו",
        "Estonia": "אסטוניה",
        "Montserrat": "מונסראט",
        "Norway": "נורווגיה",
        "North Korea": "צפון קוריאה",
        "Myanmar": "מיאנמר",
        "Sri Lanka": "סרי לנקה",
        "Faroe Islands": "איי פארו",
        "Dominica": "דומיניקה",
        "Kiribati": "קיריבטי",
        "Falkland Islands": "איי פוקלנד",
        "Namibia": "נמיביה",
        "Saint Lucia": "סנט לוסיה",
        "Indonesia": "אינדונזיה",
        "Timor-Leste": "מזרח טימור",
        "Norfolk Island": "האי נורפוק",
        "Bhutan": "בהוטן",
        "Iran": "איראן",
        "Turkmenistan": "טורקמניסטן",
        "Uganda": "אוגנדה",
        "Kazakhstan": "קזחסטן",
        "Cook Islands": "איי קוק",
        "Micronesia": "מיקרונזיה",
        "Sint Maarten": "סנט מרטין",
        "Liberia": "ליבריה",
        "Panama": "פנמה",
        "Malta": "מלטה",
        "Peru": "פרו",
        "Philippines": "הפיליפינים",
        "Rwanda": "רואנדה",
        "United Kingdom": "הממלכה המאוחדת",
        "Martinique": "מרטיניק",
        "Nepal": "נפאל",
        "Guatemala": "גואטמלה",
        "Bermuda": "ברמודה",
        "Australia": "אוסטרליה",
        "Vatican City": "הוותיקן",
        "Slovenia": "סלובניה",
        "Cayman Islands": "איי קיימן",
        "Hungary": "הונגריה",
        "American Samoa": "סמואה האמריקנית",
        "Mauritania": "מאוריטניה",
        "Japan": "יפן",
        "Uzbekistan": "אוזבקיסטן",
        "Cambodia": "קמבודיה",
        "Wallis & Futuna": "איי ווליס ופוטונה",
        "South Sudan": "דרום סודן",
        "Morocco": "מרוקו",
        "Argentina": "ארגנטינה",
        "Guadeloupe": "גוואדלופ",
        "Hong Kong": "הונג קונג",
        "Qatar": "קטאר",
        "Tanzania": "טנזניה",
        "Mexico": "מקסיקו",
        "Russia": "רוסיה",
        "Iceland": "איסלנד",
        "Monaco": "מונקו",
        "Afghanistan": "אפגניסטן",
        "Slovakia": "סלובקיה",
        "Sweden": "שוודיה",
        "Azerbaijan": "אזרבייג'ן",
        "Bangladesh": "בנגלדש",
        "Brazil": "ברזיל",
        "Cuba": "קובה",
        "Ghana": "גאנה",
        "Mongolia": "מונגוליה",
        "Saint Kitts and Nevis": "סנט קיטס ונוויס",
        "Burkina Faso": "בורקינה פאסו",
        "Nicaragua": "ניקרגואה",
        "Malaysia": "מלזיה",
        "Uruguay": "אורוגוואי",
        "Brunei": "ברוניי",
        "Congo": "קונגו",
        "Nauru": "נאורו",
        "Northern Mariana Islands": "איי מריאנה הצפוניים",
        "Pakistan": "פקיסטן",
        "Greenland": "גרינלנד",
        "Mauritius": "מאוריציוס",
        "Caribbean Netherlands": "הולנד הקריבית",
        "Belize": "בליז",
        "Liechtenstein": "ליכטנשטיין",
        "Sierra Leone": "סיירה לאון",
        "Czech Republic": "צ'כיה",
        "Moldova": "מולדובה",
        "Singapore": "סינגפור",
        "Belgium": "בלגיה",
        "Maldives": "האיים המלדיביים",
        "New Zealand": "ניו זילנד",
        "South Korea": "דרום קוריאה",
        "Italy": "איטליה",
        "Israel": "ישראל",
        "Grenada": "גרנדה",
        "Kenya": "קניה",
        "St. Helena": "סנט הלנה",
        "Guam": "גואם",
        "Denmark": "דנמרק",
        "New Caledonia": "קלדוניה החדשה",
        "Ecuador": "אקוודור",
        "Canada": "קנדה",
        "Egypt": "מצרים",
        "Saudi Arabia": "ערב הסעודית",
        "Botswana": "בוטסואנה",
        "Turks & Caicos Islands": "איי טרקס וקייקוס",
        "Latvia": "לטביה",
        "St. Pierre & Miquelon": "סן פייר ומיקלון",
        "Georgia": "גאורגיה",
        "Laos": "לאוס",
        "Réunion": "ראוניון",
        "Niue": "ניווה",
        "Zimbabwe": "זימבבואה",
        "Thailand": "תאילנד",
        "Algeria": "אלג'יריה",
        "Finland": "פינלנד",
        "Macedonia": "מקדוניה הצפונית",
        "Antigua and Barbuda": "אנטיגואה וברבודה",
        "Nigeria": "ניגריה",
        "Switzerland": "שוויץ",
        "Bulgaria": "בולגריה",
        "Montenegro": "מונטנגרו",
        "Tajikistan": "טג'יקיסטן",
        "Austria": "אוסטריה",
        "Bolivia": "בוליביה",
        "Sudan": "סודן",
        "Suriname": "סורינאם",
        "Iraq": "עיראק",
        "Bahrain": "בחריין",
        "Colombia": "קולומביה",
        "Papua New Guinea": "פפואה גינאה החדשה",
        "Yemen": "תימן",
        "Venezuela": "ונצואלה",
        "Djibouti": "ג'יבוטי",
        "British Indian Ocean Territory": "הטריטוריה הבריטית באוקיינוס ההודי",
        "Chad": "צ'אד",
        "Germany": "גרמניה",
        "Fiji": "פיג'י",
        "British Virgin Islands": "איי הבתולה הבריטיים",
        "San Marino": "סן מרינו",
        "Vietnam": "וייטנאם",
        "Macau": "מקאו",
        "South Africa": "דרום אפריקה",
        "Eritrea": "אריתריאה",
        "Greece": "יוון",
        "Ethiopia": "אתיופיה",
        "Madagascar": "מדגסקר",
        "Marshall Islands": "איי מרשל",
        "United States": "ארצות הברית",
        "Benin": "בנין",
        "El Salvador": "אל סלוודור",
        "Lebanon": "לבנון",
        "Palestine": "פלסטין",
        "Tuvalu": "טובלו",
        "Solomon Islands": "איי שלמה",
        "China": "סין",
        "Tonga": "טונגה"
    },
};
export const koKR = {
    searchNotFound: "국가를 찾을 수 없습니다",
    searchPlaceholder: "국가 검색",
    countries: {
        "Gibraltar": "지브롤터",
        "Gambia": "감비아",
        "Equatorial Guinea": "적도 기니",
        "Senegal": "세네갈",
        "Jamaica": "자메이카",
        "Seychelles": "세이셸",
        "Comoros": "코모로",
        "U.S. Virgin Islands": "미국령 버진 아일랜드",
        "Guinea": "기니",
        "Niger": "니제르",
        "Libya": "리비아",
        "Romania": "루마니아",
        "Anguilla": "앵귈라",
        "Togo": "토고",
        "Paraguay": "파라과이",
        "India": "인도",
        "Ireland": "아일랜드",
        "Turkey": "터키",
        "Oman": "오만",
        "Ukraine": "우크라이나",
        "Spain": "스페인",
        "Cameroon": "카메룬",
        "Angola": "앙골라",
        "Mali": "말리",
        "Saint Vincent and the Grenadines": "세인트빈센트 그레나딘",
        "Cyprus": "키프로스",
        "Belarus": "벨라루스",
        "Gabon": "가봉",
        "Samoa": "사모아",
        "Chile": "칠레",
        "United Arab Emirates": "아랍에미리트",
        "São Tomé and Príncipe": "상투메 프린시페",
        "Palau": "팔라우",
        "Tokelau": "토켈라우",
        "Puerto Rico": "푸에르토리코",
        "Portugal": "포르투갈",
        "Costa Rica": "코스타리카",
        "Swaziland": "에스와티니",
        "Cape Verde": "카보베르데",
        "Curaçao": "퀴라소",
        "Andorra": "안도라",
        "Armenia": "아르메니아",
        "Haiti": "아이티",
        "Côte d’Ivoire": "코트디부아르",
        "Guinea-Bissau": "기니비사우",
        "Mozambique": "모잠비크",
        "Poland": "폴란드",
        "French Polynesia": "프랑스령 폴리네시아",
        "Jersey": "저지",
        "Kuwait": "쿠웨이트",
        "Dominican Republic": "도미니카 공화국",
        "Kosovo": "코소보",
        "Kyrgyzstan": "키르기스스탄",
        "Syria": "시리아",
        "Zambia": "잠비아",
        "Croatia": "크로아티아",
        "Lithuania": "리투아니아",
        "Albania": "알바니아",
        "Netherlands": "네덜란드",
        "France": "프랑스",
        "Tunisia": "튀니지",
        "Bosnia and Herzegovina": "보스니아 헤르체고비나",
        "Bahamas": "바하마",
        "Somalia": "소말리아",
        "Burundi": "부룬디",
        "Barbados": "바베이도스",
        "Malawi": "말라위",
        "Honduras": "온두라스",
        "French Guiana": "프랑스령 기아나",
        "Jordan": "요르단",
        "Serbia": "세르비아",
        "Vanuatu": "바누아투",
        "Aruba": "아루바",
        "Guyana": "가이아나",
        "Lesotho": "레소토",
        "Taiwan": "대만",
        "Central African Republic": "중앙아프리카 공화국",
        "Luxembourg": "룩셈부르크",
        "Trinidad and Tobago": "트리니다드 토바고",
        "Estonia": "에스토니아",
        "Montserrat": "몬트세랫",
        "Norway": "노르웨이",
        "North Korea": "북한",
        "Myanmar": "미얀마",
        "Sri Lanka": "스리랑카",
        "Faroe Islands": "페로 제도",
        "Dominica": "도미니카",
        "Kiribati": "키리바시",
        "Falkland Islands": "포클랜드 제도",
        "Namibia": "나미비아",
        "Saint Lucia": "세인트루시아",
        "Indonesia": "인도네시아",
        "Timor-Leste": "동티모르",
        "Norfolk Island": "노퍽섬",
        "Bhutan": "부탄",
        "Iran": "이란",
        "Turkmenistan": "투르크메니스탄",
        "Uganda": "우간다",
        "Kazakhstan": "카자흐스탄",
        "Cook Islands": "쿡 제도",
        "Micronesia": "미크로네시아",
        "Sint Maarten": "신트마르턴",
        "Liberia": "라이베리아",
        "Panama": "파나마",
        "Malta": "몰타",
        "Peru": "페루",
        "Philippines": "필리핀",
        "Rwanda": "르완다",
        "United Kingdom": "영국",
        "Martinique": "마르티니크",
        "Nepal": "네팔",
        "Guatemala": "과테말라",
        "Bermuda": "버뮤다",
        "Australia": "호주",
        "Vatican City": "바티칸 시국",
        "Slovenia": "슬로베니아",
        "Cayman Islands": "케이맨 제도",
        "Hungary": "헝가리",
        "American Samoa": "아메리칸 사모아",
        "Mauritania": "모리타니",
        "Japan": "일본",
        "Uzbekistan": "우즈베키스탄",
        "Cambodia": "캄보디아",
        "Wallis & Futuna": "왈리스 푸투나",
        "South Sudan": "남수단",
        "Morocco": "모로코",
        "Argentina": "아르헨티나",
        "Guadeloupe": "과들루프",
        "Hong Kong": "홍콩",
        "Qatar": "카타르",
        "Tanzania": "탄자니아",
        "Mexico": "멕시코",
        "Russia": "러시아",
        "Iceland": "아이슬란드",
        "Monaco": "모나코",
        "Afghanistan": "아프가니스탄",
        "Slovakia": "슬로바키아",
        "Sweden": "스웨덴",
        "Azerbaijan": "아제르바이잔",
        "Bangladesh": "방글라데시",
        "Brazil": "브라질",
        "Cuba": "쿠바",
        "Ghana": "가나",
        "Mongolia": "몽골",
        "Saint Kitts and Nevis": "세인트키츠 네비스",
        "Burkina Faso": "부르키나파소",
        "Nicaragua": "니카라과",
        "Malaysia": "말레이시아",
        "Uruguay": "우루과이",
        "Brunei": "브루나이",
        "Congo": "콩고",
        "Nauru": "나우루",
        "Northern Mariana Islands": "북마리아나 제도",
        "Pakistan": "파키스탄",
        "Greenland": "그린란드",
        "Mauritius": "모리셔스",
        "Caribbean Netherlands": "카리브 네덜란드",
        "Belize": "벨리즈",
        "Liechtenstein": "리히텐슈타인",
        "Sierra Leone": "시에라리온",
        "Czech Republic": "체코",
        "Moldova": "몰도바",
        "Singapore": "싱가포르",
        "Belgium": "벨기에",
        "Maldives": "몰디브",
        "New Zealand": "뉴질랜드",
        "South Korea": "대한민국",
        "Italy": "이탈리아",
        "Israel": "이스라엘",
        "Grenada": "그레나다",
        "Kenya": "케냐",
        "St. Helena": "세인트헬레나",
        "Guam": "괌",
        "Denmark": "덴마크",
        "New Caledonia": "뉴칼레도니아",
        "Ecuador": "에콰도르",
        "Canada": "캐나다",
        "Egypt": "이집트",
        "Saudi Arabia": "사우디아라비아",
        "Botswana": "보츠와나",
        "Turks & Caicos Islands": "터크스 케이커스 제도",
        "Latvia": "라트비아",
        "St. Pierre & Miquelon": "생피에르 미클롱",
        "Georgia": "조지아",
        "Laos": "라오스",
        "Réunion": "레위니옹",
        "Niue": "니우에",
        "Zimbabwe": "짐바브웨",
        "Thailand": "태국",
        "Algeria": "알제리",
        "Finland": "핀란드",
        "Macedonia": "북마케도니아",
        "Antigua and Barbuda": "앤티가 바부다",
        "Nigeria": "나이지리아",
        "Switzerland": "스위스",
        "Bulgaria": "불가리아",
        "Montenegro": "몬테네그로",
        "Tajikistan": "타지키스탄",
        "Austria": "오스트리아",
        "Bolivia": "볼리비아",
        "Sudan": "수단",
        "Suriname": "수리남",
        "Iraq": "이라크",
        "Bahrain": "바레인",
        "Colombia": "콜롬비아",
        "Papua New Guinea": "파푸아뉴기니",
        "Yemen": "예멘",
        "Venezuela": "베네수엘라",
        "Djibouti": "지부티",
        "British Indian Ocean Territory": "영국령 인도양 지역",
        "Chad": "차드",
        "Germany": "독일",
        "Fiji": "피지",
        "British Virgin Islands": "영국령 버진아일랜드",
        "San Marino": "산마리노",
        "Vietnam": "베트남",
        "Macau": "마카오",
        "South Africa": "남아프리카",
        "Eritrea": "에리트레아",
        "Greece": "그리스",
        "Ethiopia": "에티오피아",
        "Madagascar": "마다가스카르",
        "Marshall Islands": "마셜 제도",
        "United States": "미국",
        "Benin": "베냉",
        "El Salvador": "엘살바도르",
        "Lebanon": "레바논",
        "Palestine": "팔레스타인",
        "Tuvalu": "투발루",
        "Solomon Islands": "솔로몬 제도",
        "China": "중국",
        "Tonga": "통가"
    },
};
export const ptPT = {
    searchNotFound: "Nenhum país encontrado",
    searchPlaceholder: "Pesquisar país",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gâmbia",
        "Equatorial Guinea": "Guiné Equatorial",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seicheles",
        "Comoros": "Comores",
        "U.S. Virgin Islands": "Ilhas Virgens dos EUA",
        "Guinea": "Guiné",
        "Niger": "Níger",
        "Libya": "Líbia",
        "Romania": "Roménia",
        "Anguilla": "Anguila",
        "Togo": "Togo",
        "Paraguay": "Paraguai",
        "India": "Índia",
        "Ireland": "Irlanda",
        "Turkey": "Turquia",
        "Oman": "Omã",
        "Ukraine": "Ucrânia",
        "Spain": "Espanha",
        "Cameroon": "Camarões",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "São Vicente e Granadinas",
        "Cyprus": "Chipre",
        "Belarus": "Bielorrússia",
        "Gabon": "Gabão",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Emirados Árabes Unidos",
        "São Tomé and Príncipe": "São Tomé e Príncipe",
        "Palau": "Palau",
        "Tokelau": "Toquelau",
        "Puerto Rico": "Porto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Essuatíni",
        "Cape Verde": "Cabo Verde",
        "Curaçao": "Curaçau",
        "Andorra": "Andorra",
        "Armenia": "Arménia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Costa do Marfim",
        "Guinea-Bissau": "Guiné-Bissau",
        "Mozambique": "Moçambique",
        "Poland": "Polónia",
        "French Polynesia": "Polinésia Francesa",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "República Dominicana",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Quirguizistão",
        "Syria": "Síria",
        "Zambia": "Zâmbia",
        "Croatia": "Croácia",
        "Lithuania": "Lituânia",
        "Albania": "Albânia",
        "Netherlands": "Países Baixos",
        "France": "França",
        "Tunisia": "Tunísia",
        "Bosnia and Herzegovina": "Bósnia e Herzegovina",
        "Bahamas": "Baamas",
        "Somalia": "Somália",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Maláui",
        "Honduras": "Honduras",
        "French Guiana": "Guiana Francesa",
        "Jordan": "Jordânia",
        "Serbia": "Sérvia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guiana",
        "Lesotho": "Lesoto",
        "Taiwan": "Taiwan",
        "Central African Republic": "República Centro-Africana",
        "Luxembourg": "Luxemburgo",
        "Trinidad and Tobago": "Trindade e Tobago",
        "Estonia": "Estónia",
        "Montserrat": "Montserrat",
        "Norway": "Noruega",
        "North Korea": "Coreia do Norte",
        "Myanmar": "Mianmar",
        "Sri Lanka": "Sri Lanca",
        "Faroe Islands": "Ilhas Faroé",
        "Dominica": "Dominica",
        "Kiribati": "Quiribati",
        "Falkland Islands": "Ilhas Malvinas",
        "Namibia": "Namíbia",
        "Saint Lucia": "Santa Lúcia",
        "Indonesia": "Indonésia",
        "Timor-Leste": "Timor-Leste",
        "Norfolk Island": "Ilha Norfolk",
        "Bhutan": "Butão",
        "Iran": "Irão",
        "Turkmenistan": "Turquemenistão",
        "Uganda": "Uganda",
        "Kazakhstan": "Cazaquistão",
        "Cook Islands": "Ilhas Cook",
        "Micronesia": "Micronésia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Libéria",
        "Panama": "Panamá",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipinas",
        "Rwanda": "Ruanda",
        "United Kingdom": "Reino Unido",
        "Martinique": "Martinica",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermudas",
        "Australia": "Austrália",
        "Vatican City": "Vaticano",
        "Slovenia": "Eslovénia",
        "Cayman Islands": "Ilhas Caimão",
        "Hungary": "Hungria",
        "American Samoa": "Samoa Americana",
        "Mauritania": "Mauritânia",
        "Japan": "Japão",
        "Uzbekistan": "Usbequistão",
        "Cambodia": "Camboja",
        "Wallis & Futuna": "Wallis e Futuna",
        "South Sudan": "Sudão do Sul",
        "Morocco": "Marrocos",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadalupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Catar",
        "Tanzania": "Tanzânia",
        "Mexico": "México",
        "Russia": "Rússia",
        "Iceland": "Islândia",
        "Monaco": "Mónaco",
        "Afghanistan": "Afeganistão",
        "Slovakia": "Eslováquia",
        "Sweden": "Suécia",
        "Azerbaijan": "Azerbaijão",
        "Bangladesh": "Bangladeche",
        "Brazil": "Brasil",
        "Cuba": "Cuba",
        "Ghana": "Gana",
        "Mongolia": "Mongólia",
        "Saint Kitts and Nevis": "São Cristóvão e Neves",
        "Burkina Faso": "Burquina Faso",
        "Nicaragua": "Nicarágua",
        "Malaysia": "Malásia",
        "Uruguay": "Uruguai",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Marianas Setentrionais",
        "Pakistan": "Paquistão",
        "Greenland": "Gronelândia",
        "Mauritius": "Maurícia",
        "Caribbean Netherlands": "Países Baixos Caribenhos",
        "Belize": "Belize",
        "Liechtenstein": "Listenstaine",
        "Sierra Leone": "Serra Leoa",
        "Czech Republic": "Chéquia",
        "Moldova": "Moldávia",
        "Singapore": "Singapura",
        "Belgium": "Bélgica",
        "Maldives": "Maldivas",
        "New Zealand": "Nova Zelândia",
        "South Korea": "Coreia do Sul",
        "Italy": "Itália",
        "Israel": "Israel",
        "Grenada": "Granada",
        "Kenya": "Quénia",
        "St. Helena": "Santa Helena",
        "Guam": "Guão",
        "Denmark": "Dinamarca",
        "New Caledonia": "Nova Caledónia",
        "Ecuador": "Equador",
        "Canada": "Canadá",
        "Egypt": "Egito",
        "Saudi Arabia": "Arábia Saudita",
        "Botswana": "Botsuana",
        "Turks & Caicos Islands": "Ilhas Turcas e Caicos",
        "Latvia": "Letónia",
        "St. Pierre & Miquelon": "São Pedro e Miquelão",
        "Georgia": "Geórgia",
        "Laos": "Laos",
        "Réunion": "Reunião",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabué",
        "Thailand": "Tailândia",
        "Algeria": "Argélia",
        "Finland": "Finlândia",
        "Macedonia": "Macedónia do Norte",
        "Antigua and Barbuda": "Antígua e Barbuda",
        "Nigeria": "Nigéria",
        "Switzerland": "Suíça",
        "Bulgaria": "Bulgária",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tajiquistão",
        "Austria": "Áustria",
        "Bolivia": "Bolívia",
        "Sudan": "Sudão",
        "Suriname": "Suriname",
        "Iraq": "Iraque",
        "Bahrain": "Barém",
        "Colombia": "Colômbia",
        "Papua New Guinea": "Papua-Nova Guiné",
        "Yemen": "Iémen",
        "Venezuela": "Venezuela",
        "Djibouti": "Jibuti",
        "British Indian Ocean Territory": "Território Britânico do Oceano Índico",
        "Chad": "Chade",
        "Germany": "Alemanha",
        "Fiji": "Fiji",
        "British Virgin Islands": "Ilhas Virgens Britânicas",
        "San Marino": "São Marino",
        "Vietnam": "Vietname",
        "Macau": "Macau",
        "South Africa": "África do Sul",
        "Eritrea": "Eritreia",
        "Greece": "Grécia",
        "Ethiopia": "Etiópia",
        "Madagascar": "Madagáscar",
        "Marshall Islands": "Ilhas Marshall",
        "United States": "Estados Unidos",
        "Benin": "Benim",
        "El Salvador": "El Salvador",
        "Lebanon": "Líbano",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Ilhas Salomão",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const nlNL = {
    searchNotFound: "Geen landen gevonden",
    searchPlaceholder: "Zoek een land",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Equatoriaal-Guinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychellen",
        "Comoros": "Comoren",
        "U.S. Virgin Islands": "Amerikaanse Maagdeneilanden",
        "Guinea": "Guinee",
        "Niger": "Niger",
        "Libya": "Libië",
        "Romania": "Roemenië",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Ierland",
        "Turkey": "Turkije",
        "Oman": "Oman",
        "Ukraine": "Oekraïne",
        "Spain": "Spanje",
        "Cameroon": "Kameroen",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent en de Grenadines",
        "Cyprus": "Cyprus",
        "Belarus": "Wit-Rusland",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chili",
        "United Arab Emirates": "Verenigde Arabische Emiraten",
        "São Tomé and Príncipe": "Sao Tomé en Principe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kaapverdië",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenië",
        "Haiti": "Haïti",
        "Côte d’Ivoire": "Ivoorkust",
        "Guinea-Bissau": "Guinee-Bissau",
        "Mozambique": "Mozambique",
        "Poland": "Polen",
        "French Polynesia": "Frans-Polynesië",
        "Jersey": "Jersey",
        "Kuwait": "Koeweit",
        "Dominican Republic": "Dominicaanse Republiek",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgizië",
        "Syria": "Syrië",
        "Zambia": "Zambia",
        "Croatia": "Kroatië",
        "Lithuania": "Litouwen",
        "Albania": "Albanië",
        "Netherlands": "Nederland",
        "France": "Frankrijk",
        "Tunisia": "Tunesië",
        "Bosnia and Herzegovina": "Bosnië en Herzegovina",
        "Bahamas": "Bahama's",
        "Somalia": "Somalië",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Frans-Guyana",
        "Jordan": "Jordanië",
        "Serbia": "Servië",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Centraal-Afrikaanse Republiek",
        "Luxembourg": "Luxemburg",
        "Trinidad and Tobago": "Trinidad en Tobago",
        "Estonia": "Estland",
        "Montserrat": "Montserrat",
        "Norway": "Noorwegen",
        "North Korea": "Noord-Korea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Faeröer",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandeilanden",
        "Namibia": "Namibië",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesië",
        "Timor-Leste": "Oost-Timor",
        "Norfolk Island": "Norfolk",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Oeganda",
        "Kazakhstan": "Kazachstan",
        "Cook Islands": "Cookeilanden",
        "Micronesia": "Micronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipijnen",
        "Rwanda": "Rwanda",
        "United Kingdom": "Verenigd Koninkrijk",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australië",
        "Vatican City": "Vaticaanstad",
        "Slovenia": "Slovenië",
        "Cayman Islands": "Kaaimaneilanden",
        "Hungary": "Hongarije",
        "American Samoa": "Amerikaans-Samoa",
        "Mauritania": "Mauritanië",
        "Japan": "Japan",
        "Uzbekistan": "Oezbekistan",
        "Cambodia": "Cambodja",
        "Wallis & Futuna": "Wallis en Futuna",
        "South Sudan": "Zuid-Soedan",
        "Morocco": "Marokko",
        "Argentina": "Argentinië",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexico",
        "Russia": "Rusland",
        "Iceland": "IJsland",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slowakije",
        "Sweden": "Zweden",
        "Azerbaijan": "Azerbeidzjan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brazilië",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolië",
        "Saint Kitts and Nevis": "Saint Kitts en Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Maleisië",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Noordelijke Marianen",
        "Pakistan": "Pakistan",
        "Greenland": "Groenland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Caribisch Nederland",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Tsjechië",
        "Moldova": "Moldavië",
        "Singapore": "Singapore",
        "Belgium": "België",
        "Maldives": "Maldiven",
        "New Zealand": "Nieuw-Zeeland",
        "South Korea": "Zuid-Korea",
        "Italy": "Italië",
        "Israel": "Israël",
        "Grenada": "Grenada",
        "Kenya": "Kenia",
        "St. Helena": "Sint-Helena",
        "Guam": "Guam",
        "Denmark": "Denemarken",
        "New Caledonia": "Nieuw-Caledonië",
        "Ecuador": "Ecuador",
        "Canada": "Canada",
        "Egypt": "Egypte",
        "Saudi Arabia": "Saoedi-Arabië",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks- en Caicoseilanden",
        "Latvia": "Letland",
        "St. Pierre & Miquelon": "Saint-Pierre en Miquelon",
        "Georgia": "Georgië",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algerije",
        "Finland": "Finland",
        "Macedonia": "Noord-Macedonië",
        "Antigua and Barbuda": "Antigua en Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Zwitserland",
        "Bulgaria": "Bulgarije",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tadzjikistan",
        "Austria": "Oostenrijk",
        "Bolivia": "Bolivië",
        "Sudan": "Soedan",
        "Suriname": "Suriname",
        "Iraq": "Irak",
        "Bahrain": "Bahrein",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papoea-Nieuw-Guinea",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Brits Indische Oceaanterritorium",
        "Chad": "Tsjaad",
        "Germany": "Duitsland",
        "Fiji": "Fiji",
        "British Virgin Islands": "Britse Maagdeneilanden",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macau",
        "South Africa": "Zuid-Afrika",
        "Eritrea": "Eritrea",
        "Greece": "Griekenland",
        "Ethiopia": "Ethiopië",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshalleilanden",
        "United States": "Verenigde Staten",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomonseilanden",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const frBE = {
    searchNotFound: "Aucun pays trouvé",
    searchPlaceholder: "Rechercher un pays",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambie",
        "Equatorial Guinea": "Guinée équatoriale",
        "Senegal": "Sénégal",
        "Jamaica": "Jamaïque",
        "Seychelles": "Seychelles",
        "Comoros": "Comores",
        "U.S. Virgin Islands": "Îles Vierges des États-Unis",
        "Guinea": "Guinée",
        "Niger": "Niger",
        "Libya": "Libye",
        "Romania": "Roumanie",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Inde",
        "Ireland": "Irlande",
        "Turkey": "Turquie",
        "Oman": "Oman",
        "Ukraine": "Ukraine",
        "Spain": "Espagne",
        "Cameroon": "Cameroun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint-Vincent-et-les-Grenadines",
        "Cyprus": "Chypre",
        "Belarus": "Biélorussie",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chili",
        "United Arab Emirates": "Émirats arabes unis",
        "São Tomé and Príncipe": "Sao Tomé-et-Principe",
        "Palau": "Palaos",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Porto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cap-Vert",
        "Curaçao": "Curaçao",
        "Andorra": "Andorre",
        "Armenia": "Arménie",
        "Haiti": "Haïti",
        "Côte d’Ivoire": "Côte d’Ivoire",
        "Guinea-Bissau": "Guinée-Bissau",
        "Mozambique": "Mozambique",
        "Poland": "Pologne",
        "French Polynesia": "Polynésie française",
        "Jersey": "Jersey",
        "Kuwait": "Koweït",
        "Dominican Republic": "République dominicaine",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirghizistan",
        "Syria": "Syrie",
        "Zambia": "Zambie",
        "Croatia": "Croatie",
        "Lithuania": "Lituanie",
        "Albania": "Albanie",
        "Netherlands": "Pays-Bas",
        "France": "France",
        "Tunisia": "Tunisie",
        "Bosnia and Herzegovina": "Bosnie-Herzégovine",
        "Bahamas": "Bahamas",
        "Somalia": "Somalie",
        "Burundi": "Burundi",
        "Barbados": "Barbade",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Guyane française",
        "Jordan": "Jordanie",
        "Serbia": "Serbie",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taïwan",
        "Central African Republic": "République centrafricaine",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinité-et-Tobago",
        "Estonia": "Estonie",
        "Montserrat": "Montserrat",
        "Norway": "Norvège",
        "North Korea": "Corée du Nord",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Îles Féroé",
        "Dominica": "Dominique",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Îles Malouines",
        "Namibia": "Namibie",
        "Saint Lucia": "Sainte-Lucie",
        "Indonesia": "Indonésie",
        "Timor-Leste": "Timor-Leste",
        "Norfolk Island": "Île Norfolk",
        "Bhutan": "Bhoutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkménistan",
        "Uganda": "Ouganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Îles Cook",
        "Micronesia": "Micronésie",
        "Sint Maarten": "Saint-Martin",
        "Liberia": "Libéria",
        "Panama": "Panama",
        "Malta": "Malte",
        "Peru": "Pérou",
        "Philippines": "Philippines",
        "Rwanda": "Rwanda",
        "United Kingdom": "Royaume-Uni",
        "Martinique": "Martinique",
        "Nepal": "Népal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermudes",
        "Australia": "Australie",
        "Vatican City": "Vatican",
        "Slovenia": "Slovénie",
        "Cayman Islands": "Îles Caïmans",
        "Hungary": "Hongrie",
        "American Samoa": "Samoa américaines",
        "Mauritania": "Mauritanie",
        "Japan": "Japon",
        "Uzbekistan": "Ouzbékistan",
        "Cambodia": "Cambodge",
        "Wallis & Futuna": "Wallis-et-Futuna",
        "South Sudan": "Soudan du Sud",
        "Morocco": "Maroc",
        "Argentina": "Argentine",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzanie",
        "Mexico": "Mexique",
        "Russia": "Russie",
        "Iceland": "Islande",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovaquie",
        "Sweden": "Suède",
        "Azerbaijan": "Azerbaïdjan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brésil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolie",
        "Saint Kitts and Nevis": "Saint-Christophe-et-Niévès",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaisie",
        "Uruguay": "Uruguay",
        "Brunei": "Brunéi",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Îles Mariannes du Nord",
        "Pakistan": "Pakistan",
        "Greenland": "Groenland",
        "Mauritius": "Maurice",
        "Caribbean Netherlands": "Pays-Bas caribéens",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "République tchèque",
        "Moldova": "Moldavie",
        "Singapore": "Singapour",
        "Belgium": "Belgique",
        "Maldives": "Maldives",
        "New Zealand": "Nouvelle-Zélande",
        "South Korea": "Corée du Sud",
        "Italy": "Italie",
        "Israel": "Israël",
        "Grenada": "Grenade",
        "Kenya": "Kenya",
        "St. Helena": "Sainte-Hélène",
        "Guam": "Guam",
        "Denmark": "Danemark",
        "New Caledonia": "Nouvelle-Calédonie",
        "Ecuador": "Équateur",
        "Canada": "Canada",
        "Egypt": "Égypte",
        "Saudi Arabia": "Arabie saoudite",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Îles Turques-et-Caïques",
        "Latvia": "Lettonie",
        "St. Pierre & Miquelon": "Saint-Pierre-et-Miquelon",
        "Georgia": "Géorgie",
        "Laos": "Laos",
        "Réunion": "La Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thaïlande",
        "Algeria": "Algérie",
        "Finland": "Finlande",
        "Macedonia": "Macédoine",
        "Antigua and Barbuda": "Antigua-et-Barbuda",
        "Nigeria": "Nigéria",
        "Switzerland": "Suisse",
        "Bulgaria": "Bulgarie",
        "Montenegro": "Monténégro",
        "Tajikistan": "Tadjikistan",
        "Austria": "Autriche",
        "Bolivia": "Bolivie",
        "Sudan": "Soudan",
        "Suriname": "Suriname",
        "Iraq": "Irak",
        "Bahrain": "Bahreïn",
        "Colombia": "Colombie",
        "Papua New Guinea": "Papouasie-Nouvelle-Guinée",
        "Yemen": "Yémen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Territoire britannique de l'océan Indien",
        "Chad": "Tchad",
        "Germany": "Allemagne",
        "Fiji": "Fidji",
        "British Virgin Islands": "Îles Vierges britanniques",
        "San Marino": "Saint-Marin",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Afrique du Sud",
        "Eritrea": "Érythrée",
        "Greece": "Grèce",
        "Ethiopia": "Éthiopie",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Îles Marshall",
        "United States": "États-Unis",
        "Benin": "Bénin",
        "El Salvador": "Salvador",
        "Lebanon": "Liban",
        "Palestine": "Palestine",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Îles Salomon",
        "China": "Chine",
        "Tonga": "Tonga"
    },
};
export const amET = {
    searchNotFound: "ምንም ሀገር አልተገኘም",
    searchPlaceholder: "ሀገርን ፈልግ",
    countries: {
        "Gibraltar": "ጊብራልታር",
        "Gambia": "ጋምቢያ",
        "Equatorial Guinea": "ኢኳቶሪያል ጊኒ",
        "Senegal": "ሴኔጋል",
        "Jamaica": "ጃማይካ",
        "Seychelles": "ሲሼልስ",
        "Comoros": "ኮሞሮስ",
        "U.S. Virgin Islands": "የአሜሪካ ናፍቆት ደሴቶች",
        "Guinea": "ጊኒ",
        "Niger": "ኒጀር",
        "Libya": "ሊቢያ",
        "Romania": "ሮሜኒያ",
        "Anguilla": "አንጉኢላ",
        "Togo": "ቶጎ",
        "Paraguay": "ፓራጓይ",
        "India": "ህንድ",
        "Ireland": "አየርላንድ",
        "Turkey": "ቱርክ",
        "Oman": "ኦማን",
        "Ukraine": "ዩክሬን",
        "Spain": "ስፔን",
        "Cameroon": "ካሜሩን",
        "Angola": "አንጐላ",
        "Mali": "ማሊ",
        "Saint Vincent and the Grenadines": "ሴንት ቪንሴንት እና ግሬናዲንስ",
        "Cyprus": "ሳይፕረስ",
        "Belarus": "ቤላሩስ",
        "Gabon": "ጋቦን",
        "Samoa": "ሳሞአ",
        "Chile": "ቺሌ",
        "United Arab Emirates": "አረብ ኤምሬት",
        "São Tomé and Príncipe": "ሳኦ ቶመ እና ፕሪንሲፔ",
        "Palau": "ፓላው",
        "Tokelau": "ቶክላው",
        "Puerto Rico": "ፖርቶ ሪኮ",
        "Portugal": "ፖርቱጋል",
        "Costa Rica": "ኮስታ ሪካ",
        "Swaziland": "እስዋቲኒ",
        "Cape Verde": "ኬፕ ቬርዴ",
        "Curaçao": "ኩራሳዎ",
        "Andorra": "አንዶራ",
        "Armenia": "አርሜኒያ",
        "Haiti": "ሀይቲ",
        "Côte d’Ivoire": "ኮት ዲቯር",
        "Guinea-Bissau": "ጊኒ-ቢሳው",
        "Mozambique": "ሞዛምቢክ",
        "Poland": "ፖላንድ",
        "French Polynesia": "ፍራንሽ ፖሊኔሲያ",
        "Jersey": "ጀርሲ",
        "Kuwait": "ኩዌት",
        "Dominican Republic": "ዶሚኒክ ሪፓብሊክ",
        "Kosovo": "ኮሶቮ",
        "Kyrgyzstan": "ኪርጊስታን",
        "Syria": "ሲሪያ",
        "Zambia": "ዛምቢያ",
        "Croatia": "ክሮሽያ",
        "Lithuania": "ሊቱዌኒያ",
        "Albania": "አልባኒያ",
        "Netherlands": "ኔዘርላንድ",
        "France": "ፈረንሣይ",
        "Tunisia": "ቱኒዚያ",
        "Bosnia and Herzegovina": "ቦስኒያ እና ሄርዘጎቪና",
        "Bahamas": "ባሃማስ",
        "Somalia": "ሱማሌ",
        "Burundi": "ብሩንዲ",
        "Barbados": "ባርባዶስ",
        "Malawi": "ማላዊ",
        "Honduras": "ሆንዱራስ",
        "French Guiana": "ፍራንሽ ጉይአና",
        "Jordan": "ጆርዳን",
        "Serbia": "ሰርብያ",
        "Vanuatu": "ቫኑአቱ",
        "Aruba": "አሩባ",
        "Guyana": "ጉያና",
        "Lesotho": "ሌሶቶ",
        "Taiwan": "ታይዋን",
        "Central African Republic": "ሴንትራል አፍሪካ ሪፓብሊክ",
        "Luxembourg": "ሉክሰምበርግ",
        "Trinidad and Tobago": "ትሪኒዳድ እና ቶባጎ",
        "Estonia": "ኢስቶኒያ",
        "Montserrat": "ሞንትሰራት",
        "Norway": "ኖርዌይ",
        "North Korea": "ሰሜን ኮሪያ",
        "Myanmar": "ማይናማር",
        "Sri Lanka": "ሲሪላንካ",
        "Faroe Islands": "ደሴቶች ፋሮኤ",
        "Dominica": "ዶሚኒካ",
        "Kiribati": "ኪሪባቲ",
        "Falkland Islands": "ደሴቶች ፎልክላንድ",
        "Namibia": "ናሚቢያ",
        "Saint Lucia": "ሴንት ሉሲያ",
        "Indonesia": "ኢንዶኔዢያ",
        "Timor-Leste": "ምስራቅ ቲሞር",
        "Norfolk Island": "ኖርፎልክ ደሴት",
        "Bhutan": "ቡህታን",
        "Iran": "ኢራን",
        "Turkmenistan": "ቱርክመኒስታን",
        "Uganda": "ዩጋንዳ",
        "Kazakhstan": "ካዛኪስታን",
        "Cook Islands": "ኩክ ደሴቶች",
        "Micronesia": "ሚክሮኔዢያ",
        "Sint Maarten": "ሲንት ማርተን",
        "Liberia": "ላይቤሪያ",
        "Panama": "ፓናማ",
        "Malta": "ማልታ",
        "Peru": "ፔሩ",
        "Philippines": "ፊሊፒንስ",
        "Rwanda": "ሩዋንዳ",
        "United Kingdom": "ተባበሩት መንግሥታት",
        "Martinique": "ማርቲኒክ",
        "Nepal": "ኔፓል",
        "Guatemala": "ጉዋቲማላ",
        "Bermuda": "ቤርሙዳ",
        "Australia": "አውስትሬሊያ",
        "Vatican City": "ቫቲካን ከተማ",
        "Slovenia": "ስሎቬኒያ",
        "Cayman Islands": "ካይማን ደሴቶች",
        "Hungary": "ሃንጋሪ",
        "American Samoa": "አሜሪካ ሳሞአ",
        "Mauritania": "ሞሪታኒያ",
        "Japan": "ጃፓን",
        "Uzbekistan": "ኡዝበኪስታን",
        "Cambodia": "ካምቦዲያ",
        "Wallis & Futuna": "ዋሊስ እና ፉቱና",
        "South Sudan": "ደቡብ ሱዳን",
        "Morocco": "ሞሮኮ",
        "Argentina": "አርጀንቲና",
        "Guadeloupe": "ጉዋዴሉፕ",
        "Hong Kong": "ሆንግ ኮንግ",
        "Qatar": "ኳታር",
        "Tanzania": "ታንዛኒያ",
        "Mexico": "ሜክሲኮ",
        "Russia": "ሩሲያ",
        "Iceland": "አይስላንድ",
        "Monaco": "ሞናኮ",
        "Afghanistan": "አፍጋኒስታን",
        "Slovakia": "ስሎቫኪያ",
        "Sweden": "ስዊድን",
        "Azerbaijan": "አዘርባጃን",
        "Bangladesh": "ባንግላዴሽ",
        "Brazil": "ብራዚል",
        "Cuba": "ኩባ",
        "Ghana": "ጋና",
        "Mongolia": "ሞንጎሊያ",
        "Saint Kitts and Nevis": "ሴንት ኪትስ እና ኔቪስ",
        "Burkina Faso": "ቡርኪና ፋሶ",
        "Nicaragua": "ኒካራጓ",
        "Malaysia": "ማሌዢያ",
        "Uruguay": "ኡራጓይ",
        "Brunei": "ብሩኒ",
        "Congo": "ኮንጎ",
        "Nauru": "ናኡሩ",
        "Northern Mariana Islands": "ሰሜን ማሪያና ደሴቶች",
        "Pakistan": "ፓኪስታን",
        "Greenland": "ግሪንላንድ",
        "Mauritius": "ማውሪሸስ",
        "Caribbean Netherlands": "የካሪቢያን ኔዘርላንድ",
        "Belize": "ቤሊዝ",
        "Liechtenstein": "ሊችተንስታይን",
        "Sierra Leone": "ሲኤራ ሊዮን",
        "Czech Republic": "ቼክ ሪፓብሊክ",
        "Moldova": "ሞልዶቫ",
        "Singapore": "ሲንጋፖር",
        "Belgium": "ቤልጄም",
        "Maldives": "ማልዲቭስ",
        "New Zealand": "ኒው ዚላንድ",
        "South Korea": "ደቡብ ኮሪያ",
        "Italy": "ጣሊያን",
        "Israel": "እስራኤል",
        "Grenada": "ግሬናዳ",
        "Kenya": "ኬንያ",
        "St. Helena": "ሴንት ሄሌና",
        "Guam": "ጉዋም",
        "Denmark": "ዴንማርክ",
        "New Caledonia": "ኒው ካሌዶኒያ",
        "Ecuador": "ኢኳዶር",
        "Canada": "ካናዳ",
        "Egypt": "ግብጽ",
        "Saudi Arabia": "ሳውዲ አረቢያ",
        "Botswana": "ቦትስዋና",
        "Turks & Caicos Islands": "ቱርክ እና ካይኮስ ደሴቶች",
        "Latvia": "ላቲቪያ",
        "St. Pierre & Miquelon": "ሴንት ፒዬር እና ሚክሎን",
        "Georgia": "ጆርጂያ",
        "Laos": "ላኦስ",
        "Réunion": "ሪዩኒየን",
        "Niue": "ኒዌ",
        "Zimbabwe": "ዚምቧቤ",
        "Thailand": "ታይላንድ",
        "Algeria": "አልጄሪያ",
        "Finland": "ፊንላንድ",
        "Macedonia": "ማከዶኒያ",
        "Antigua and Barbuda": "አንቲጓ እና ባርቡዳ",
        "Nigeria": "ናይጄሪያ",
        "Switzerland": "ስዊዘርላንድ",
        "Bulgaria": "ቡልጌሪያ",
        "Montenegro": "ሞንተኔግሮ",
        "Tajikistan": "ታጂኪስታን",
        "Austria": "ኦስትሪያ",
        "Bolivia": "ቦሊቪያ",
        "Sudan": "ሱዳን",
        "Suriname": "ሱሪናም",
        "Iraq": "ኢራቅ",
        "Bahrain": "ባህሬን",
        "Colombia": "ኮሎምቢያ",
        "Papua New Guinea": "ፓፕዋ ኒው ጊኒ",
        "Yemen": "የመን",
        "Venezuela": "ቬኔዝዌላ",
        "Djibouti": "ጂቡቲ",
        "British Indian Ocean Territory": "የብሪቲሽ ኢንድያን ዑቅያንስ ጂዮግራፊያ",
        "Chad": "ቻድ",
        "Germany": "ጀርመን",
        "Fiji": "ፊጂ",
        "British Virgin Islands": "የእንግሊዝ ዓለም ናፍቆት ደሴቶች",
        "San Marino": "ሳን ማሪኖ",
        "Vietnam": "ቬትናም",
        "Macau": "ማካኡ",
        "South Africa": "ደቡብ አፍሪካ",
        "Eritrea": "ኤርትራ",
        "Greece": "ግሪክ",
        "Ethiopia": "ኢትዮጵያ",
        "Madagascar": "ማዳጋስካር",
        "Marshall Islands": "ደሴቶች ማርሻል",
        "United States": "አሜሪካ",
        "Benin": "ቤኒን",
        "El Salvador": "ኤል ሳልቫዶር",
        "Lebanon": "ሊባኖስ",
        "Palestine": "ፓሌስቲን",
        "Tuvalu": "ቱቫሉ",
        "Solomon Islands": "ሰሎሞን ደሴቶች",
        "China": "ቻይና",
        "Tonga": "ቶንጋ"
    },
};
export const esES = {
    searchNotFound: "No se encontró ningún país",
    searchPlaceholder: "Buscar un país",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Guinea Ecuatorial",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychelles",
        "Comoros": "Comoras",
        "U.S. Virgin Islands": "Islas Vírgenes de EE.UU.",
        "Guinea": "Guinea",
        "Niger": "Níger",
        "Libya": "Libia",
        "Romania": "Rumanía",
        "Anguilla": "Anguila",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Irlanda",
        "Turkey": "Turquía",
        "Oman": "Omán",
        "Ukraine": "Ucrania",
        "Spain": "España",
        "Cameroon": "Camerún",
        "Angola": "Angola",
        "Mali": "Malí",
        "Saint Vincent and the Grenadines": "San Vicente y las Granadinas",
        "Cyprus": "Chipre",
        "Belarus": "Bielorrusia",
        "Gabon": "Gabón",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Emiratos Árabes Unidos",
        "São Tomé and Príncipe": "Santo Tomé y Príncipe",
        "Palau": "Palaos",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cabo Verde",
        "Curaçao": "Curazao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haití",
        "Côte d’Ivoire": "Costa de Marfil",
        "Guinea-Bissau": "Guinea-Bisáu",
        "Mozambique": "Mozambique",
        "Poland": "Polonia",
        "French Polynesia": "Polinesia Francesa",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "República Dominicana",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirguistán",
        "Syria": "Siria",
        "Zambia": "Zambia",
        "Croatia": "Croacia",
        "Lithuania": "Lituania",
        "Albania": "Albania",
        "Netherlands": "Países Bajos",
        "France": "Francia",
        "Tunisia": "Túnez",
        "Bosnia and Herzegovina": "Bosnia y Herzegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malaui",
        "Honduras": "Honduras",
        "French Guiana": "Guayana Francesa",
        "Jordan": "Jordania",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesoto",
        "Taiwan": "Taiwán",
        "Central African Republic": "República Centroafricana",
        "Luxembourg": "Luxemburgo",
        "Trinidad and Tobago": "Trinidad y Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Noruega",
        "North Korea": "Corea del Norte",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Islas Feroe",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Islas Malvinas",
        "Namibia": "Namibia",
        "Saint Lucia": "Santa Lucía",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Timor Oriental",
        "Norfolk Island": "Isla Norfolk",
        "Bhutan": "Bután",
        "Iran": "Irán",
        "Turkmenistan": "Turkmenistán",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazajistán",
        "Cook Islands": "Islas Cook",
        "Micronesia": "Micronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panamá",
        "Malta": "Malta",
        "Peru": "Perú",
        "Philippines": "Filipinas",
        "Rwanda": "Ruanda",
        "United Kingdom": "Reino Unido",
        "Martinique": "Martinica",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermudas",
        "Australia": "Australia",
        "Vatican City": "Ciudad del Vaticano",
        "Slovenia": "Eslovenia",
        "Cayman Islands": "Islas Caimán",
        "Hungary": "Hungría",
        "American Samoa": "Samoa Americana",
        "Mauritania": "Mauritania",
        "Japan": "Japón",
        "Uzbekistan": "Uzbekistán",
        "Cambodia": "Camboya",
        "Wallis & Futuna": "Wallis y Futuna",
        "South Sudan": "Sudán del Sur",
        "Morocco": "Marruecos",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadalupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Catar",
        "Tanzania": "Tanzania",
        "Mexico": "México",
        "Russia": "Rusia",
        "Iceland": "Islandia",
        "Monaco": "Mónaco",
        "Afghanistan": "Afganistán",
        "Slovakia": "Eslovaquia",
        "Sweden": "Suecia",
        "Azerbaijan": "Azerbaiyán",
        "Bangladesh": "Bangladés",
        "Brazil": "Brasil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "San Cristóbal y Nieves",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malasia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunéi",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Islas Marianas del Norte",
        "Pakistan": "Pakistán",
        "Greenland": "Groenlandia",
        "Mauritius": "Mauricio",
        "Caribbean Netherlands": "Caribe Neerlandés",
        "Belize": "Belice",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leona",
        "Czech Republic": "República Checa",
        "Moldova": "Moldavia",
        "Singapore": "Singapur",
        "Belgium": "Bélgica",
        "Maldives": "Maldivas",
        "New Zealand": "Nueva Zelanda",
        "South Korea": "Corea del Sur",
        "Italy": "Italia",
        "Israel": "Israel",
        "Grenada": "Granada",
        "Kenya": "Kenia",
        "St. Helena": "Santa Elena",
        "Guam": "Guam",
        "Denmark": "Dinamarca",
        "New Caledonia": "Nueva Caledonia",
        "Ecuador": "Ecuador",
        "Canada": "Canadá",
        "Egypt": "Egipto",
        "Saudi Arabia": "Arabia Saudita",
        "Botswana": "Botsuana",
        "Turks & Caicos Islands": "Islas Turcas y Caicos",
        "Latvia": "Letonia",
        "St. Pierre & Miquelon": "San Pedro y Miquelón",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Reunión",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabue",
        "Thailand": "Tailandia",
        "Algeria": "Argelia",
        "Finland": "Finlandia",
        "Macedonia": "Macedonia del Norte",
        "Antigua and Barbuda": "Antigua y Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Suiza",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tayikistán",
        "Austria": "Austria",
        "Bolivia": "Bolivia",
        "Sudan": "Sudán",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Baréin",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papúa Nueva Guinea",
        "Yemen": "Yemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Yibuti",
        "British Indian Ocean Territory": "Territorio Británico del Océano Índico",
        "Chad": "Chad",
        "Germany": "Alemania",
        "Fiji": "Fiyi",
        "British Virgin Islands": "Islas Vírgenes Británicas",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Sudáfrica",
        "Eritrea": "Eritrea",
        "Greece": "Grecia",
        "Ethiopia": "Etiopía",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Islas Marshall",
        "United States": "Estados Unidos",
        "Benin": "Benín",
        "El Salvador": "El Salvador",
        "Lebanon": "Líbano",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Islas Salomón",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const arSA = {
    searchNotFound: "لم يتم العثور على أي بلد",
    searchPlaceholder: "البحث عن بلد",
    countries: {
        "Gibraltar": "جبل طارق",
        "Gambia": "غامبيا",
        "Equatorial Guinea": "غينيا الاستوائية",
        "Senegal": "السنغال",
        "Jamaica": "جامايكا",
        "Seychelles": "سيشل",
        "Comoros": "جزر القمر",
        "U.S. Virgin Islands": "جزر العذراء الأمريكية",
        "Guinea": "غينيا",
        "Niger": "النيجر",
        "Libya": "ليبيا",
        "Romania": "رومانيا",
        "Anguilla": "أنغويلا",
        "Togo": "توغو",
        "Paraguay": "باراغواي",
        "India": "الهند",
        "Ireland": "أيرلندا",
        "Turkey": "تركيا",
        "Oman": "عمان",
        "Ukraine": "أوكرانيا",
        "Spain": "إسبانيا",
        "Cameroon": "الكاميرون",
        "Angola": "أنغولا",
        "Mali": "مالي",
        "Saint Vincent and the Grenadines": "سانت فينسنت والغرينادين",
        "Cyprus": "قبرص",
        "Belarus": "بيلاروسيا",
        "Gabon": "الغابون",
        "Samoa": "ساموا",
        "Chile": "تشيلي",
        "United Arab Emirates": "الإمارات العربية المتحدة",
        "São Tomé and Príncipe": "ساو تومي وبرينسيبي",
        "Palau": "بالاو",
        "Tokelau": "توكيلاو",
        "Puerto Rico": "بورتوريكو",
        "Portugal": "البرتغال",
        "Costa Rica": "كوستاريكا",
        "Swaziland": "إسواتيني",
        "Cape Verde": "الرأس الأخضر",
        "Curaçao": "كوراساو",
        "Andorra": "أندورا",
        "Armenia": "أرمينيا",
        "Haiti": "هايتي",
        "Côte d’Ivoire": "ساحل العاج",
        "Guinea-Bissau": "غينيا بيساو",
        "Mozambique": "موزمبيق",
        "Poland": "بولندا",
        "French Polynesia": "بولينيزيا الفرنسية",
        "Jersey": "جيرسي",
        "Kuwait": "الكويت",
        "Dominican Republic": "جمهورية الدومينيكان",
        "Kosovo": "كوسوفو",
        "Kyrgyzstan": "قيرغيزستان",
        "Syria": "سوريا",
        "Zambia": "زامبيا",
        "Croatia": "كرواتيا",
        "Lithuania": "ليتوانيا",
        "Albania": "ألبانيا",
        "Netherlands": "هولندا",
        "France": "فرنسا",
        "Tunisia": "تونس",
        "Bosnia and Herzegovina": "البوسنة والهرسك",
        "Bahamas": "جزر البهاما",
        "Somalia": "الصومال",
        "Burundi": "بوروندي",
        "Barbados": "باربادوس",
        "Malawi": "مالاوي",
        "Honduras": "هندوراس",
        "French Guiana": "غيانا الفرنسية",
        "Jordan": "الأردن",
        "Serbia": "صربيا",
        "Vanuatu": "فانواتو",
        "Aruba": "أروبا",
        "Guyana": "غيانا",
        "Lesotho": "ليسوتو",
        "Taiwan": "تايوان",
        "Central African Republic": "جمهورية أفريقيا الوسطى",
        "Luxembourg": "لوكسمبورغ",
        "Trinidad and Tobago": "ترينيداد وتوباغو",
        "Estonia": "إستونيا",
        "Montserrat": "مونتسرات",
        "Norway": "النرويج",
        "North Korea": "كوريا الشمالية",
        "Myanmar": "ميانمار",
        "Sri Lanka": "سريلانكا",
        "Faroe Islands": "جزر فارو",
        "Dominica": "دومينيكا",
        "Kiribati": "كيريباس",
        "Falkland Islands": "جزر فوكلاند",
        "Namibia": "ناميبيا",
        "Saint Lucia": "سانت لوسيا",
        "Indonesia": "إندونيسيا",
        "Timor-Leste": "تيمور الشرقية",
        "Norfolk Island": "جزيرة نورفولك",
        "Bhutan": "بوتان",
        "Iran": "إيران",
        "Turkmenistan": "تركمانستان",
        "Uganda": "أوغندا",
        "Kazakhstan": "كازاخستان",
        "Cook Islands": "جزر كوك",
        "Micronesia": "ميكرونيزيا",
        "Sint Maarten": "سينت مارتن",
        "Liberia": "ليبيريا",
        "Panama": "بنما",
        "Malta": "مالطا",
        "Peru": "بيرو",
        "Philippines": "الفلبين",
        "Rwanda": "رواندا",
        "United Kingdom": "المملكة المتحدة",
        "Martinique": "مارتينيك",
        "Nepal": "نيبال",
        "Guatemala": "غواتيمالا",
        "Bermuda": "برمودا",
        "Australia": "أستراليا",
        "Vatican City": "مدينة الفاتيكان",
        "Slovenia": "سلوفينيا",
        "Cayman Islands": "جزر كايمان",
        "Hungary": "المجر",
        "American Samoa": "ساموا الأمريكية",
        "Mauritania": "موريتانيا",
        "Japan": "اليابان",
        "Uzbekistan": "أوزبكستان",
        "Cambodia": "كمبوديا",
        "Wallis & Futuna": "واليس وفوتونا",
        "South Sudan": "جنوب السودان",
        "Morocco": "المغرب",
        "Argentina": "الأرجنتين",
        "Guadeloupe": "جوادلوب",
        "Hong Kong": "هونغ كونغ",
        "Qatar": "قطر",
        "Tanzania": "تنزانيا",
        "Mexico": "المكسيك",
        "Russia": "روسيا",
        "Iceland": "أيسلندا",
        "Monaco": "موناكو",
        "Afghanistan": "أفغانستان",
        "Slovakia": "سلوفاكيا",
        "Sweden": "السويد",
        "Azerbaijan": "أذربيجان",
        "Bangladesh": "بنغلاديش",
        "Brazil": "البرازيل",
        "Cuba": "كوبا",
        "Ghana": "غانا",
        "Mongolia": "منغوليا",
        "Saint Kitts and Nevis": "سانت كيتس ونيفيس",
        "Burkina Faso": "بوركينا فاسو",
        "Nicaragua": "نيكاراغوا",
        "Malaysia": "ماليزيا",
        "Uruguay": "أوروغواي",
        "Brunei": "بروناي",
        "Congo": "الكونغو",
        "Nauru": "ناورو",
        "Northern Mariana Islands": "جزر ماريانا الشمالية",
        "Pakistan": "باكستان",
        "Greenland": "جرينلاند",
        "Mauritius": "موريشيوس",
        "Caribbean Netherlands": "جزر الكاريبي الهولندية",
        "Belize": "بليز",
        "Liechtenstein": "ليختنشتاين",
        "Sierra Leone": "سيراليون",
        "Czech Republic": "جمهورية التشيك",
        "Moldova": "مولدوفا",
        "Singapore": "سنغافورة",
        "Belgium": "بلجيكا",
        "Maldives": "جزر المالديف",
        "New Zealand": "نيوزيلندا",
        "South Korea": "كوريا الجنوبية",
        "Italy": "إيطاليا",
        "Israel": "إسرائيل",
        "Grenada": "غرينادا",
        "Kenya": "كينيا",
        "St. Helena": "سانت هيلانة",
        "Guam": "غوام",
        "Denmark": "الدنمارك",
        "New Caledonia": "كاليدونيا الجديدة",
        "Ecuador": "الإكوادور",
        "Canada": "كندا",
        "Egypt": "مصر",
        "Saudi Arabia": "المملكة العربية السعودية",
        "Botswana": "بوتسوانا",
        "Turks & Caicos Islands": "جزر تركس وكايكوس",
        "Latvia": "لاتفيا",
        "St. Pierre & Miquelon": "سان بيير وميكلون",
        "Georgia": "جورجيا",
        "Laos": "لاوس",
        "Réunion": "لا ريونيون",
        "Niue": "نييوي",
        "Zimbabwe": "زيمبابوي",
        "Thailand": "تايلاند",
        "Algeria": "الجزائر",
        "Finland": "فنلندا",
        "Macedonia": "مقدونيا الشمالية",
        "Antigua and Barbuda": "أنتيغوا وبربودا",
        "Nigeria": "نيجيريا",
        "Switzerland": "سويسرا",
        "Bulgaria": "بلغاريا",
        "Montenegro": "الجبل الأسود",
        "Tajikistan": "طاجيكستان",
        "Austria": "النمسا",
        "Bolivia": "بوليفيا",
        "Sudan": "السودان",
        "Suriname": "سورينام",
        "Iraq": "العراق",
        "Bahrain": "البحرين",
        "Colombia": "كولومبيا",
        "Papua New Guinea": "بابوا غينيا الجديدة",
        "Yemen": "اليمن",
        "Venezuela": "فنزويلا",
        "Djibouti": "جيبوتي",
        "British Indian Ocean Territory": "إقليم المحيط البريطاني الهندي",
        "Chad": "تشاد",
        "Germany": "ألمانيا",
        "Fiji": "فيجي",
        "British Virgin Islands": "جزر العذراء البريطانية",
        "San Marino": "سان مارينو",
        "Vietnam": "فيتنام",
        "Macau": "ماكاو",
        "South Africa": "جنوب أفريقيا",
        "Eritrea": "إريتريا",
        "Greece": "اليونان",
        "Ethiopia": "إثيوبيا",
        "Madagascar": "مدغشقر",
        "Marshall Islands": "جزر مارشال",
        "United States": "الولايات المتحدة",
        "Benin": "بنين",
        "El Salvador": "السلفادور",
        "Lebanon": "لبنان",
        "Palestine": "فلسطين",
        "Tuvalu": "توفالو",
        "Solomon Islands": "جزر سليمان",
        "China": "الصين",
        "Tonga": "تونغا"
    },
};
export const srRS = {
    searchNotFound: "Nije pronađena nijedna zemlja",
    searchPlaceholder: "Pretraži zemlju",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambija",
        "Equatorial Guinea": "Ekvatorijalna Gvineja",
        "Senegal": "Senegal",
        "Jamaica": "Jamajka",
        "Seychelles": "Sejšeli",
        "Comoros": "Komori",
        "U.S. Virgin Islands": "Američka Devičanska Ostrva",
        "Guinea": "Gvineja",
        "Niger": "Niger",
        "Libya": "Libija",
        "Romania": "Rumunija",
        "Anguilla": "Angvila",
        "Togo": "Togo",
        "Paraguay": "Paragvaj",
        "India": "Indija",
        "Ireland": "Irska",
        "Turkey": "Turska",
        "Oman": "Oman",
        "Ukraine": "Ukrajina",
        "Spain": "Španija",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Sveti Vinsent i Grenadini",
        "Cyprus": "Kipar",
        "Belarus": "Belorusija",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Čile",
        "United Arab Emirates": "Ujedinjeni Arapski Emirati",
        "São Tomé and Príncipe": "Sao Tome i Principe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Portoriko",
        "Portugal": "Portugal",
        "Costa Rica": "Kostarika",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kabo Verde",
        "Curaçao": "Kurasao",
        "Andorra": "Andora",
        "Armenia": "Jermenija",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Obala Slonovače",
        "Guinea-Bissau": "Gvineja-Bisao",
        "Mozambique": "Mozambik",
        "Poland": "Poljska",
        "French Polynesia": "Francuska Polinezija",
        "Jersey": "Džersi",
        "Kuwait": "Kuvajt",
        "Dominican Republic": "Dominikanska Republika",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgistan",
        "Syria": "Sirija",
        "Zambia": "Zambija",
        "Croatia": "Hrvatska",
        "Lithuania": "Litvanija",
        "Albania": "Albanija",
        "Netherlands": "Holandija",
        "France": "Francuska",
        "Tunisia": "Tunis",
        "Bosnia and Herzegovina": "Bosna i Hercegovina",
        "Bahamas": "Bahami",
        "Somalia": "Somalija",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malavi",
        "Honduras": "Honduras",
        "French Guiana": "Francuska Gvajana",
        "Jordan": "Jordan",
        "Serbia": "Srbija",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Gvajana",
        "Lesotho": "Lesoto",
        "Taiwan": "Tajvan",
        "Central African Republic": "Centralnoafrička Republika",
        "Luxembourg": "Luksemburg",
        "Trinidad and Tobago": "Trinidad i Tobago",
        "Estonia": "Estonija",
        "Montserrat": "Monserat",
        "Norway": "Norveška",
        "North Korea": "Severna Koreja",
        "Myanmar": "Mjanmar",
        "Sri Lanka": "Šri Lanka",
        "Faroe Islands": "Farska Ostrva",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Foklandska Ostrva",
        "Namibia": "Namibija",
        "Saint Lucia": "Sveti Lucija",
        "Indonesia": "Indonezija",
        "Timor-Leste": "Istočni Timor",
        "Norfolk Island": "Norfolk Ostrvo",
        "Bhutan": "Butan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazahstan",
        "Cook Islands": "Kukova Ostrva",
        "Micronesia": "Mikronezija",
        "Sint Maarten": "Sint Marten",
        "Liberia": "Liberija",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipini",
        "Rwanda": "Ruanda",
        "United Kingdom": "Ujedinjeno Kraljevstvo",
        "Martinique": "Martinik",
        "Nepal": "Nepal",
        "Guatemala": "Gvatemala",
        "Bermuda": "Bermudi",
        "Australia": "Australija",
        "Vatican City": "Vatikan",
        "Slovenia": "Slovenija",
        "Cayman Islands": "Kajmanska Ostrva",
        "Hungary": "Mađarska",
        "American Samoa": "Američka Samoa",
        "Mauritania": "Mauritanija",
        "Japan": "Japan",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kambodža",
        "Wallis & Futuna": "Valis i Futuna",
        "South Sudan": "Južni Sudan",
        "Morocco": "Maroko",
        "Argentina": "Argentina",
        "Guadeloupe": "Gvadelup",
        "Hong Kong": "Hong Kong",
        "Qatar": "Katar",
        "Tanzania": "Tanzanija",
        "Mexico": "Meksiko",
        "Russia": "Rusija",
        "Iceland": "Island",
        "Monaco": "Monako",
        "Afghanistan": "Avganistan",
        "Slovakia": "Slovačka",
        "Sweden": "Švedska",
        "Azerbaijan": "Azerbejdžan",
        "Bangladesh": "Bangladeš",
        "Brazil": "Brazil",
        "Cuba": "Kuba",
        "Ghana": "Gana",
        "Mongolia": "Mongolija",
        "Saint Kitts and Nevis": "Sveti Kits i Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nikaragva",
        "Malaysia": "Malezija",
        "Uruguay": "Urugvaj",
        "Brunei": "Brunej",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Severna Marijanska Ostrva",
        "Pakistan": "Pakistan",
        "Greenland": "Grenland",
        "Mauritius": "Mauricijus",
        "Caribbean Netherlands": "Karipska Holandija",
        "Belize": "Beliz",
        "Liechtenstein": "Lihtenštajn",
        "Sierra Leone": "Sijera Leone",
        "Czech Republic": "Češka Republika",
        "Moldova": "Moldavija",
        "Singapore": "Singapur",
        "Belgium": "Belgija",
        "Maldives": "Maldivi",
        "New Zealand": "Novi Zeland",
        "South Korea": "Južna Koreja",
        "Italy": "Italija",
        "Israel": "Izrael",
        "Grenada": "Grenada",
        "Kenya": "Kenija",
        "St. Helena": "Sveti Helena",
        "Guam": "Guam",
        "Denmark": "Danska",
        "New Caledonia": "Nova Kaledonija",
        "Ecuador": "Ekvador",
        "Canada": "Kanada",
        "Egypt": "Egipat",
        "Saudi Arabia": "Saudijska Arabija",
        "Botswana": "Bocvana",
        "Turks & Caicos Islands": "Turks i Kajkos Ostrva",
        "Latvia": "Letonija",
        "St. Pierre & Miquelon": "Sen Pjer i Mikelon",
        "Georgia": "Gruzija",
        "Laos": "Laos",
        "Réunion": "Reunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabve",
        "Thailand": "Tajland",
        "Algeria": "Alžir",
        "Finland": "Finska",
        "Macedonia": "Severna Makedonija",
        "Antigua and Barbuda": "Antigva i Barbuda",
        "Nigeria": "Nigerija",
        "Switzerland": "Švajcarska",
        "Bulgaria": "Bugarska",
        "Montenegro": "Crna Gora",
        "Tajikistan": "Tadžikistan",
        "Austria": "Austrija",
        "Bolivia": "Bolivija",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrein",
        "Colombia": "Kolumbija",
        "Papua New Guinea": "Papua Nova Gvineja",
        "Yemen": "Jemen",
        "Venezuela": "Venecuela",
        "Djibouti": "Džibuti",
        "British Indian Ocean Territory": "Britanska Teritorija Indijskog Okeana",
        "Chad": "Čad",
        "Germany": "Nemačka",
        "Fiji": "Fidži",
        "British Virgin Islands": "Britanska Devičanska Ostrva",
        "San Marino": "San Marino",
        "Vietnam": "Vijetnam",
        "Macau": "Makao",
        "South Africa": "Južna Afrika",
        "Eritrea": "Eritreja",
        "Greece": "Grčka",
        "Ethiopia": "Etiopija",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Maršalska Ostrva",
        "United States": "Sjedinjene Američke Države",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Liban",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Solomonska Ostrva",
        "China": "Kina",
        "Tonga": "Tonga"
    },
};
export const tlTL = {
    searchNotFound: "Walang nahanap na bansa",
    searchPlaceholder: "Maghanap ng bansa",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Equatorial Guinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychelles",
        "Comoros": "Comoros",
        "U.S. Virgin Islands": "Mga Isla ng Birhen ng U.S.",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libya",
        "Romania": "Romania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Ireland",
        "Turkey": "Turkey",
        "Oman": "Oman",
        "Ukraine": "Ukraine",
        "Spain": "Spain",
        "Cameroon": "Cameroon",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent at ang Grenadines",
        "Cyprus": "Cyprus",
        "Belarus": "Belarus",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "United Arab Emirates",
        "São Tomé and Príncipe": "São Tomé at Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cape Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Côte d'Ivoire",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mozambique",
        "Poland": "Poland",
        "French Polynesia": "French Polynesia",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Dominican Republic",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kyrgyzstan",
        "Syria": "Syria",
        "Zambia": "Zambia",
        "Croatia": "Croatia",
        "Lithuania": "Lithuania",
        "Albania": "Albania",
        "Netherlands": "Netherlands",
        "France": "France",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia at Herzegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "French Guiana",
        "Jordan": "Jordan",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Central African Republic",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinidad at Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Norway",
        "North Korea": "North Korea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Faroe Islands",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falkland Islands",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Timor-Leste",
        "Norfolk Island": "Norfolk Island",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Cook Islands",
        "Micronesia": "Micronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Pilipinas",
        "Rwanda": "Rwanda",
        "United Kingdom": "United Kingdom",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australia",
        "Vatican City": "Lungsod ng Vatican",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Cayman Islands",
        "Hungary": "Hungary",
        "American Samoa": "American Samoa",
        "Mauritania": "Mauritania",
        "Japan": "Japan",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Cambodia",
        "Wallis & Futuna": "Wallis at Futuna",
        "South Sudan": "Timog Sudan",
        "Morocco": "Morocco",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexico",
        "Russia": "Russia",
        "Iceland": "Iceland",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovakia",
        "Sweden": "Sweden",
        "Azerbaijan": "Azerbaijan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brazil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts at Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Hilagang Kapuluang Mariana",
        "Pakistan": "Pakistan",
        "Greenland": "Greenland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Mga Isla ng Karibik ng Netherlands",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Czech Republic",
        "Moldova": "Moldova",
        "Singapore": "Singapore",
        "Belgium": "Belgium",
        "Maldives": "Maldives",
        "New Zealand": "New Zealand",
        "South Korea": "South Korea",
        "Italy": "Italy",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Saint Helena",
        "Guam": "Guam",
        "Denmark": "Denmark",
        "New Caledonia": "New Caledonia",
        "Ecuador": "Ecuador",
        "Canada": "Canada",
        "Egypt": "Egypt",
        "Saudi Arabia": "Saudi Arabia",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Mga Isla ng Turks at Caicos",
        "Latvia": "Latvia",
        "St. Pierre & Miquelon": "Saint Pierre at Miquelon",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algeria",
        "Finland": "Finland",
        "Macedonia": "Hilagang Makedonia",
        "Antigua and Barbuda": "Antigua at Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Switzerland",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tajikistan",
        "Austria": "Austria",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Suriname",
        "Iraq": "Iraq",
        "Bahrain": "Bahrain",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papua New Guinea",
        "Yemen": "Yemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Teritoryo ng Britanya ng Karagatang Indian",
        "Chad": "Chad",
        "Germany": "Germany",
        "Fiji": "Fiji",
        "British Virgin Islands": "Mga Birheng Isla ng Britanya",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macau",
        "South Africa": "Timog Aprika",
        "Eritrea": "Eritrea",
        "Greece": "Greece",
        "Ethiopia": "Ethiopia",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Marshall Islands",
        "United States": "Estados Unidos",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Lebanon",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Mga Isla ng Solomon",
        "China": "Tsina",
        "Tonga": "Tonga"
    },
};
export const itIT = {
    searchNotFound: "Nessun paese trovato",
    searchPlaceholder: "Cerca un paese",
    countries: {
        "Gibraltar": "Gibilterra",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Guinea Equatoriale",
        "Senegal": "Senegal",
        "Jamaica": "Giamaica",
        "Seychelles": "Seychelles",
        "Comoros": "Comore",
        "U.S. Virgin Islands": "Isole Vergini Americane",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libia",
        "Romania": "Romania",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Irlanda",
        "Turkey": "Turchia",
        "Oman": "Oman",
        "Ukraine": "Ucraina",
        "Spain": "Spagna",
        "Cameroon": "Camerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent e Grenadine",
        "Cyprus": "Cipro",
        "Belarus": "Bielorussia",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Cile",
        "United Arab Emirates": "Emirati Arabi Uniti",
        "São Tomé and Príncipe": "São Tomé e Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Porto Rico",
        "Portugal": "Portogallo",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Capo Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Costa d'Avorio",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mozambico",
        "Poland": "Polonia",
        "French Polynesia": "Polinesia Francese",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Repubblica Dominicana",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirghizistan",
        "Syria": "Siria",
        "Zambia": "Zambia",
        "Croatia": "Croazia",
        "Lithuania": "Lituania",
        "Albania": "Albania",
        "Netherlands": "Paesi Bassi",
        "France": "Francia",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia ed Erzegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Guyana Francese",
        "Jordan": "Giordania",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Repubblica Centrafricana",
        "Luxembourg": "Lussemburgo",
        "Trinidad and Tobago": "Trinidad e Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Norvegia",
        "North Korea": "Corea del Nord",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Isole Fær Øer",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Isole Falkland",
        "Namibia": "Namibia",
        "Saint Lucia": "Santa Lucia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Timor Est",
        "Norfolk Island": "Isola Norfolk",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakistan",
        "Cook Islands": "Isole Cook",
        "Micronesia": "Micronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Perù",
        "Philippines": "Filippine",
        "Rwanda": "Ruanda",
        "United Kingdom": "Regno Unito",
        "Martinique": "Martinica",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australia",
        "Vatican City": "Città del Vaticano",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Isole Cayman",
        "Hungary": "Ungheria",
        "American Samoa": "Samoa Americane",
        "Mauritania": "Mauritania",
        "Japan": "Giappone",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Cambogia",
        "Wallis & Futuna": "Wallis e Futuna",
        "South Sudan": "Sudan del Sud",
        "Morocco": "Marocco",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadalupa",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Messico",
        "Russia": "Russia",
        "Iceland": "Islanda",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovacchia",
        "Sweden": "Svezia",
        "Azerbaijan": "Azerbaigian",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasile",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts e Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malesia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Isole Marianne Settentrionali",
        "Pakistan": "Pakistan",
        "Greenland": "Groenlandia",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Caraibi olandesi",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Repubblica Ceca",
        "Moldova": "Moldavia",
        "Singapore": "Singapore",
        "Belgium": "Belgio",
        "Maldives": "Maldive",
        "New Zealand": "Nuova Zelanda",
        "South Korea": "Corea del Sud",
        "Italy": "Italia",
        "Israel": "Israele",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Sant'Elena",
        "Guam": "Guam",
        "Denmark": "Danimarca",
        "New Caledonia": "Nuova Caledonia",
        "Ecuador": "Ecuador",
        "Canada": "Canada",
        "Egypt": "Egitto",
        "Saudi Arabia": "Arabia Saudita",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Isole Turks e Caicos",
        "Latvia": "Lettonia",
        "St. Pierre & Miquelon": "Saint Pierre e Miquelon",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Riunione",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailandia",
        "Algeria": "Algeria",
        "Finland": "Finlandia",
        "Macedonia": "Macedonia del Nord",
        "Antigua and Barbuda": "Antigua e Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Svizzera",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tagikistan",
        "Austria": "Austria",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Suriname",
        "Iraq": "Iraq",
        "Bahrain": "Bahrein",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papua Nuova Guinea",
        "Yemen": "Yemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Gibuti",
        "British Indian Ocean Territory": "Territorio britannico dell'Oceano Indiano",
        "Chad": "Ciad",
        "Germany": "Germania",
        "Fiji": "Figi",
        "British Virgin Islands": "Isole Vergini Britanniche",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Sud Africa",
        "Eritrea": "Eritrea",
        "Greece": "Grecia",
        "Ethiopia": "Etiopia",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Isole Marshall",
        "United States": "Stati Uniti",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libano",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Isole Salomone",
        "China": "Cina",
        "Tonga": "Tonga"
    },
};
export const nlBE = {
    searchNotFound: "Geen landen gevonden",
    searchPlaceholder: "Zoek een land",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Equatoriaal-Guinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychellen",
        "Comoros": "Comoren",
        "U.S. Virgin Islands": "Amerikaanse Maagdeneilanden",
        "Guinea": "Guinee",
        "Niger": "Niger",
        "Libya": "Libië",
        "Romania": "Roemenië",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Ierland",
        "Turkey": "Turkije",
        "Oman": "Oman",
        "Ukraine": "Oekraïne",
        "Spain": "Spanje",
        "Cameroon": "Kameroen",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent en de Grenadines",
        "Cyprus": "Cyprus",
        "Belarus": "Wit-Rusland",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chili",
        "United Arab Emirates": "Verenigde Arabische Emiraten",
        "São Tomé and Príncipe": "Sao Tomé en Principe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kaapverdië",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenië",
        "Haiti": "Haïti",
        "Côte d’Ivoire": "Ivoorkust",
        "Guinea-Bissau": "Guinee-Bissau",
        "Mozambique": "Mozambique",
        "Poland": "Polen",
        "French Polynesia": "Frans-Polynesië",
        "Jersey": "Jersey",
        "Kuwait": "Koeweit",
        "Dominican Republic": "Dominicaanse Republiek",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgizië",
        "Syria": "Syrië",
        "Zambia": "Zambia",
        "Croatia": "Kroatië",
        "Lithuania": "Litouwen",
        "Albania": "Albanië",
        "Netherlands": "Nederland",
        "France": "Frankrijk",
        "Tunisia": "Tunesië",
        "Bosnia and Herzegovina": "Bosnië en Herzegovina",
        "Bahamas": "Bahama's",
        "Somalia": "Somalië",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Frans-Guyana",
        "Jordan": "Jordanië",
        "Serbia": "Servië",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Centraal-Afrikaanse Republiek",
        "Luxembourg": "Luxemburg",
        "Trinidad and Tobago": "Trinidad en Tobago",
        "Estonia": "Estland",
        "Montserrat": "Montserrat",
        "Norway": "Noorwegen",
        "North Korea": "Noord-Korea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Faeröer",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandeilanden",
        "Namibia": "Namibië",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesië",
        "Timor-Leste": "Oost-Timor",
        "Norfolk Island": "Norfolk",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Oeganda",
        "Kazakhstan": "Kazachstan",
        "Cook Islands": "Cookeilanden",
        "Micronesia": "Micronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipijnen",
        "Rwanda": "Rwanda",
        "United Kingdom": "Verenigd Koninkrijk",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australië",
        "Vatican City": "Vaticaanstad",
        "Slovenia": "Slovenië",
        "Cayman Islands": "Kaaimaneilanden",
        "Hungary": "Hongarije",
        "American Samoa": "Amerikaans-Samoa",
        "Mauritania": "Mauritanië",
        "Japan": "Japan",
        "Uzbekistan": "Oezbekistan",
        "Cambodia": "Cambodja",
        "Wallis & Futuna": "Wallis en Futuna",
        "South Sudan": "Zuid-Soedan",
        "Morocco": "Marokko",
        "Argentina": "Argentinië",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexico",
        "Russia": "Rusland",
        "Iceland": "IJsland",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slowakije",
        "Sweden": "Zweden",
        "Azerbaijan": "Azerbeidzjan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brazilië",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolië",
        "Saint Kitts and Nevis": "Saint Kitts en Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Maleisië",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Noordelijke Marianen",
        "Pakistan": "Pakistan",
        "Greenland": "Groenland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Caribisch Nederland",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Tsjechië",
        "Moldova": "Moldavië",
        "Singapore": "Singapore",
        "Belgium": "België",
        "Maldives": "Maldiven",
        "New Zealand": "Nieuw-Zeeland",
        "South Korea": "Zuid-Korea",
        "Italy": "Italië",
        "Israel": "Israël",
        "Grenada": "Grenada",
        "Kenya": "Kenia",
        "St. Helena": "Sint-Helena",
        "Guam": "Guam",
        "Denmark": "Denemarken",
        "New Caledonia": "Nieuw-Caledonië",
        "Ecuador": "Ecuador",
        "Canada": "Canada",
        "Egypt": "Egypte",
        "Saudi Arabia": "Saoedi-Arabië",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks- en Caicoseilanden",
        "Latvia": "Letland",
        "St. Pierre & Miquelon": "Saint-Pierre en Miquelon",
        "Georgia": "Georgië",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algerije",
        "Finland": "Finland",
        "Macedonia": "Noord-Macedonië",
        "Antigua and Barbuda": "Antigua en Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Zwitserland",
        "Bulgaria": "Bulgarije",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tadzjikistan",
        "Austria": "Oostenrijk",
        "Bolivia": "Bolivië",
        "Sudan": "Soedan",
        "Suriname": "Suriname",
        "Iraq": "Irak",
        "Bahrain": "Bahrein",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papoea-Nieuw-Guinea",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Brits Indische Oceaanterritorium",
        "Chad": "Tsjaad",
        "Germany": "Duitsland",
        "Fiji": "Fiji",
        "British Virgin Islands": "Britse Maagdeneilanden",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macau",
        "South Africa": "Zuid-Afrika",
        "Eritrea": "Eritrea",
        "Greece": "Griekenland",
        "Ethiopia": "Ethiopië",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshalleilanden",
        "United States": "Verenigde Staten",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomonseilanden",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const huHU = {
    searchNotFound: "Nem található ország",
    searchPlaceholder: "Keresés egy országban",
    countries: {
        "Gibraltar": "Gibraltár",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Egyenlítői-Guinea",
        "Senegal": "Szenegál",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychelle-szigetek",
        "Comoros": "Comore-szigetek",
        "U.S. Virgin Islands": "Amerikai Virgin-szigetek",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Líbia",
        "Romania": "Románia",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Írország",
        "Turkey": "Törökország",
        "Oman": "Omán",
        "Ukraine": "Ukrajna",
        "Spain": "Spanyolország",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent és a Grenadine-szigetek",
        "Cyprus": "Ciprus",
        "Belarus": "Fehéroroszország",
        "Gabon": "Gabon",
        "Samoa": "Szamoa",
        "Chile": "Chile",
        "United Arab Emirates": "Egyesült Arab Emírségek",
        "São Tomé and Príncipe": "São Tomé és Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugália",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Zöld-foki Köztársaság",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Örményország",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Elefántcsontpart",
        "Guinea-Bissau": "Bissau-Guinea",
        "Mozambique": "Mozambik",
        "Poland": "Lengyelország",
        "French Polynesia": "Francia Polinézia",
        "Jersey": "Jersey",
        "Kuwait": "Kuvait",
        "Dominican Republic": "Dominikai Köztársaság",
        "Kosovo": "Koszovó",
        "Kyrgyzstan": "Kirgizisztán",
        "Syria": "Szíria",
        "Zambia": "Zambia",
        "Croatia": "Horvátország",
        "Lithuania": "Litvánia",
        "Albania": "Albánia",
        "Netherlands": "Hollandia",
        "France": "Franciaország",
        "Tunisia": "Tunézia",
        "Bosnia and Herzegovina": "Bosznia-Hercegovina",
        "Bahamas": "Bahamák",
        "Somalia": "Szomália",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Francia Guyana",
        "Jordan": "Jordánia",
        "Serbia": "Szerbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Tajvan",
        "Central African Republic": "Közép-afrikai Köztársaság",
        "Luxembourg": "Luxemburg",
        "Trinidad and Tobago": "Trinidad és Tobago",
        "Estonia": "Észtország",
        "Montserrat": "Montserrat",
        "Norway": "Norvégia",
        "North Korea": "Észak-Korea",
        "Myanmar": "Mianmar",
        "Sri Lanka": "Srí Lanka",
        "Faroe Islands": "Feröer-szigetek",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falkland-szigetek",
        "Namibia": "Namíbia",
        "Saint Lucia": "Szent Lucia",
        "Indonesia": "Indonézia",
        "Timor-Leste": "Kelet-Timor",
        "Norfolk Island": "Norfolk-sziget",
        "Bhutan": "Bhután",
        "Iran": "Irán",
        "Turkmenistan": "Türkmenisztán",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazahsztán",
        "Cook Islands": "Cook-szigetek",
        "Micronesia": "Mikronézia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Libéria",
        "Panama": "Panama",
        "Malta": "Málta",
        "Peru": "Peru",
        "Philippines": "Fülöp-szigetek",
        "Rwanda": "Ruanda",
        "United Kingdom": "Egyesült Királyság",
        "Martinique": "Martinique",
        "Nepal": "Nepál",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Ausztrália",
        "Vatican City": "Vatikán",
        "Slovenia": "Szlovénia",
        "Cayman Islands": "Kajmán-szigetek",
        "Hungary": "Magyarország",
        "American Samoa": "Amerikai Szamoa",
        "Mauritania": "Mauritánia",
        "Japan": "Japán",
        "Uzbekistan": "Üzbegisztán",
        "Cambodia": "Kambodzsa",
        "Wallis & Futuna": "Wallis és Futuna",
        "South Sudan": "Dél-Szudán",
        "Morocco": "Marokkó",
        "Argentina": "Argentína",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Katar",
        "Tanzania": "Tanzánia",
        "Mexico": "Mexikó",
        "Russia": "Oroszország",
        "Iceland": "Izland",
        "Monaco": "Monaco",
        "Afghanistan": "Afganisztán",
        "Slovakia": "Szlovákia",
        "Sweden": "Svédország",
        "Azerbaijan": "Azerbajdzsán",
        "Bangladesh": "Banglades",
        "Brazil": "Brazília",
        "Cuba": "Kuba",
        "Ghana": "Ghána",
        "Mongolia": "Mongólia",
        "Saint Kitts and Nevis": "Saint Kitts és Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malajzia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Kongó",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Északi-Mariana-szigetek",
        "Pakistan": "Pakisztán",
        "Greenland": "Grönland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Holland Karib-térség",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Csehország",
        "Moldova": "Moldova",
        "Singapore": "Szingapúr",
        "Belgium": "Belgium",
        "Maldives": "Maldív-szigetek",
        "New Zealand": "Új-Zéland",
        "South Korea": "Dél-Korea",
        "Italy": "Olaszország",
        "Israel": "Izrael",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Szent Ilona-sziget",
        "Guam": "Guam",
        "Denmark": "Dánia",
        "New Caledonia": "Új-Kaledónia",
        "Ecuador": "Ecuador",
        "Canada": "Kanada",
        "Egypt": "Egyiptom",
        "Saudi Arabia": "Szaúd-Arábia",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks- és Caicos-szigetek",
        "Latvia": "Lettország",
        "St. Pierre & Miquelon": "Saint Pierre és Miquelon",
        "Georgia": "Grúzia",
        "Laos": "Laosz",
        "Réunion": "Reunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thaiföld",
        "Algeria": "Algéria",
        "Finland": "Finnország",
        "Macedonia": "Észak-Macedónia",
        "Antigua and Barbuda": "Antigua és Barbuda",
        "Nigeria": "Nigéria",
        "Switzerland": "Svájc",
        "Bulgaria": "Bulgária",
        "Montenegro": "Montenegró",
        "Tajikistan": "Tádzsikisztán",
        "Austria": "Ausztria",
        "Bolivia": "Bolívia",
        "Sudan": "Szudán",
        "Suriname": "Suriname",
        "Iraq": "Irak",
        "Bahrain": "Bahrein",
        "Colombia": "Kolumbia",
        "Papua New Guinea": "Pápua Új-Guinea",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Dzsibuti",
        "British Indian Ocean Territory": "Brit Indiai-óceáni Terület",
        "Chad": "Csád",
        "Germany": "Németország",
        "Fiji": "Fidzsi",
        "British Virgin Islands": "Brit Virgin-szigetek",
        "San Marino": "San Marino",
        "Vietnam": "Vietnám",
        "Macau": "Makaó",
        "South Africa": "Dél-Afrika",
        "Eritrea": "Eritrea",
        "Greece": "Görögország",
        "Ethiopia": "Etiópia",
        "Madagascar": "Madagaszkár",
        "Marshall Islands": "Marshall-szigetek",
        "United States": "Egyesült Államok",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palesztina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salamon-szigetek",
        "China": "Kína",
        "Tonga": "Tonga"
    },
};
export const kuCKB = {
    searchNotFound: "هیچ وڵاتێک نەدۆزرایەوە",
    searchPlaceholder: "بگەڕێ بۆ وڵات",
    countries: {
        "Gibraltar": "گبرالتار",
        "Gambia": "گامبیا",
        "Equatorial Guinea": "گینەی ئیكواتۆری",
        "Senegal": "سێنێگال",
        "Jamaica": "جامایكا",
        "Seychelles": "سیشێلس",
        "Comoros": "كۆمۆرۆس",
        "U.S. Virgin Islands": "دوورگەکانی ویرجینیای ئه‌مریكا",
        "Guinea": "گینە",
        "Niger": "نیجەر",
        "Libya": "لیبیا",
        "Romania": "ڕۆمانیا",
        "Anguilla": "ئانگویلە",
        "Togo": "تۆگۆ",
        "Paraguay": "پارەگوای",
        "India": "هیندستان",
        "Ireland": "ئیرلەندا",
        "Turkey": "توركیا",
        "Oman": "عومان",
        "Ukraine": "ئۆكراینە",
        "Spain": "ئیسپانیا",
        "Cameroon": "كامیرۆن",
        "Angola": "ئەنگۆلا",
        "Mali": "مالی",
        "Saint Vincent and the Grenadines": "سەینت ڤینسێنت و گڕناداینز",
        "Cyprus": "قبرس",
        "Belarus": "بیلاروس",
        "Gabon": "گابۆن",
        "Samoa": "ساموا",
        "Chile": "چیلی",
        "United Arab Emirates": "میراتە عەرەبیە یەکگرتووەکان",
        "São Tomé and Príncipe": "ساوتۆمێ و پڕنسێپ",
        "Palau": "پالاو",
        "Tokelau": "تۆکێلاو",
        "Puerto Rico": "پورتۆ ڕیکۆ",
        "Portugal": "پورتوگال",
        "Costa Rica": "کۆستاریکا",
        "Swaziland": "ئیسواتینی",
        "Cape Verde": "کەیپ ڤەرد",
        "Curaçao": "کوراسائۆ",
        "Andorra": "ئاندۆرا",
        "Armenia": "ئەرمەنستان",
        "Haiti": "هایتی",
        "Côte d’Ivoire": "کۆت دیڤوار",
        "Guinea-Bissau": "گینە-بیسائو",
        "Mozambique": "مۆزامبیک",
        "Poland": "پۆڵەندا",
        "French Polynesia": "پۆلینیزیای فەڕەنسی",
        "Jersey": "جێرسی",
        "Kuwait": "کویت",
        "Dominican Republic": "کۆماری دۆمینیکان",
        "Kosovo": "کۆسۆڤۆ",
        "Kyrgyzstan": "قیرقیزستان",
        "Syria": "سوریا",
        "Zambia": "زامبیا",
        "Croatia": "كرواتیا",
        "Lithuania": "لیتوانیا",
        "Albania": "ئەلبانیا",
        "Netherlands": "ھۆڵەندا",
        "France": "فەڕەنسا",
        "Tunisia": "توونس",
        "Bosnia and Herzegovina": "بۆسنیا و ھەرسەك",
        "Bahamas": "باهاماس",
        "Somalia": "سۆمالیا",
        "Burundi": "بوروندی",
        "Barbados": "باربادۆس",
        "Malawi": "مالاوی",
        "Honduras": "ھۆندۆراس",
        "French Guiana": "گویانای فەڕەنسی",
        "Jordan": "ئۆردن",
        "Serbia": "سربیا",
        "Vanuatu": "ڤانواتوو",
        "Aruba": "ئاروبا",
        "Guyana": "گویانا",
        "Lesotho": "لێسۆتۆ",
        "Taiwan": "تایوان",
        "Central African Republic": "کۆماری ئێفریقای ناوەڕاست",
        "Luxembourg": "لوكسەمبوورگ",
        "Trinidad and Tobago": "ترینیداد و تۆباگو",
        "Estonia": "ئیستۆنیا",
        "Montserrat": "مۆنتسێرات",
        "Norway": "نۆرویژ",
        "North Korea": "کۆریای باكوور",
        "Myanmar": "میانمار",
        "Sri Lanka": "سریلانكا",
        "Faroe Islands": "دوورگەکانی فاروو",
        "Dominica": "دۆمینیکا",
        "Kiribati": "کیریباس",
        "Falkland Islands": "دوورگەکانی فالكلاند",
        "Namibia": "نامیبیا",
        "Saint Lucia": "سەینت لووسیا",
        "Indonesia": "ئیندۆنیزیا",
        "Timor-Leste": "تیمۆر لێستە",
        "Norfolk Island": "دوورگەی نۆرفۆلك",
        "Bhutan": "بوتان",
        "Iran": "ئیڕان",
        "Turkmenistan": "تورکمەنیستان",
        "Uganda": "ئوگاندا",
        "Kazakhstan": "کازاخستان",
        "Cook Islands": "دوورگەکانی كووك",
        "Micronesia": "میکڕۆنیزیا",
        "Sint Maarten": "سینت مارتن",
        "Liberia": "لیبەریا",
        "Panama": "پاناما",
        "Malta": "ماڵتا",
        "Peru": "پێرو",
        "Philippines": "فلیپین",
        "Rwanda": "ڕواندا",
        "United Kingdom": "شانشینی یەکگرتوو",
        "Martinique": "مارتینیك",
        "Nepal": "نێپال",
        "Guatemala": "گوواتیمالا",
        "Bermuda": "بێرموودا",
        "Australia": "ئوسترالیا",
        "Vatican City": "شارەکەی ڤاتیکان",
        "Slovenia": "سلۆڤێنیا",
        "Cayman Islands": "دوورگەکانی کەیمان",
        "Hungary": "مەجارسـتان",
        "American Samoa": "ساموای ئەمەریکای",
        "Mauritania": "مەوریتانیا",
        "Japan": "ژاپۆن",
        "Uzbekistan": "ئۆزبەکستان",
        "Cambodia": "کەمبۆدیا",
        "Wallis & Futuna": "والیس و فۆتونا",
        "South Sudan": "سوودانی باشوور",
        "Morocco": "مەغرەب",
        "Argentina": "ئەرژەنتین",
        "Guadeloupe": "گووادەلۆوپ",
        "Hong Kong": "ھۆنگ کۆنگ",
        "Qatar": "قەتەر",
        "Tanzania": "تانزانیا",
        "Mexico": "مەکسیک",
        "Russia": "ڕووسیا",
        "Iceland": "ئایسلەند",
        "Monaco": "مۆناکۆ",
        "Afghanistan": "ئەفغانستان",
        "Slovakia": "سلۆڤاكیا",
        "Sweden": "سووید",
        "Azerbaijan": "ئازەربایجان",
        "Bangladesh": "بەنگلادیش",
        "Brazil": "برۆزیل",
        "Cuba": "كوبا",
        "Ghana": "غانا",
        "Mongolia": "مۆنگۆلیا",
        "Saint Kitts and Nevis": "سەینت كیتس و نیڤیس",
        "Burkina Faso": "بوركینافاسۆ",
        "Nicaragua": "نیكاراگوا",
        "Malaysia": "مالیزیا",
        "Uruguay": "ئوروگوای",
        "Brunei": "برونای",
        "Congo": "کۆنگۆ",
        "Nauru": "ناوروو",
        "Northern Mariana Islands": "دوورگەکانی ماریانای باکوور",
        "Pakistan": "پاکستان",
        "Greenland": "گرینلاند",
        "Mauritius": "ماوریتانیا",
        "Caribbean Netherlands": "ھۆڵەندای کەریبین",
        "Belize": "بێلیز",
        "Liechtenstein": "لیختنشتاین",
        "Sierra Leone": "سیرا لیۆن",
        "Czech Republic": "کۆماری چێک",
        "Moldova": "مۆلدۆڤا",
        "Singapore": "سینگاپور",
        "Belgium": "بەڵژیک",
        "Maldives": "مالدیڤ",
        "New Zealand": "نیوزیلاند",
        "South Korea": "کۆریای باشوور",
        "Italy": "ئیتاڵیا",
        "Israel": "ئیسرائیل",
        "Grenada": "گرینادا",
        "Kenya": "کینیا",
        "St. Helena": "سەینت هێلێنا",
        "Guam": "گوام",
        "Denmark": "دانمارك",
        "New Caledonia": "کالێدۆنیای نوێ",
        "Ecuador": "ئیکوادۆر",
        "Canada": "کانەدا",
        "Egypt": "میسر",
        "Saudi Arabia": "عەرەبستانی سەعوودی",
        "Botswana": "بۆتسوانا",
        "Turks & Caicos Islands": "دوورگەکانی توركس و كایکۆس",
        "Latvia": "لاتڤیا",
        "St. Pierre & Miquelon": "سەینت پیەر و میكێلۆن",
        "Georgia": "گورجستان",
        "Laos": "لاووس",
        "Réunion": "ڕێیونیۆن",
        "Niue": "نیووی",
        "Zimbabwe": "زیمباوبی",
        "Thailand": "تەیلاند",
        "Algeria": "ئەڵجیریا",
        "Finland": "فینلاند",
        "Macedonia": "ماكەدۆنیا",
        "Antigua and Barbuda": "ئانتیگوا و باربودا",
        "Nigeria": "نیجێریا",
        "Switzerland": "سویسرا",
        "Bulgaria": "بۆڵگاریا",
        "Montenegro": "مۆنتینیگرو",
        "Tajikistan": "تاجیکستان",
        "Austria": "نەمسە",
        "Bolivia": "بۆلیڤیا",
        "Sudan": "سوودان",
        "Suriname": "سورینام",
        "Iraq": "عێراق",
        "Bahrain": "بەحرەین",
        "Colombia": "کۆلۆمبیا",
        "Papua New Guinea": "پاپوا گینەی نوێ",
        "Yemen": "یەمەن",
        "Venezuela": "ڤەنزوێلا",
        "Djibouti": "جیبووتی",
        "British Indian Ocean Territory": "هەرێمی بەریتانیی ئیندۆنیزیای ناوەراست",
        "Chad": "چاڵ",
        "Germany": "ئەڵمانیا",
        "Fiji": "فیدجی",
        "British Virgin Islands": "دوورگەکانی ویرجینیای بەریتانی",
        "San Marino": "سان مارینۆ",
        "Vietnam": "ڤیەتنام",
        "Macau": "ماكەو",
        "South Africa": "ئافریقای باشوور",
        "Eritrea": "ئەریتریا",
        "Greece": "یۆنان",
        "Ethiopia": "ئەتیۆپیا",
        "Madagascar": "مەداگاسكار",
        "Marshall Islands": "دوورگەکانی مارشاڵ",
        "United States": "وڵاتە یەکگرتووەکان",
        "Benin": "بینن",
        "El Salvador": "ئەڵ سەلڤادۆر",
        "Lebanon": "لەبنان",
        "Palestine": "فەلەستین",
        "Tuvalu": "تووڤاڵوو",
        "Solomon Islands": "دوورگەکانی سۆڵەمۆن",
        "China": "چین",
        "Tonga": "تۆنگا"
    },
};
export const ltLT = {
    searchNotFound: "Šalis nerasta",
    searchPlaceholder: "Ieškoti šalies",
    countries: {
        "Gibraltar": "Gibraltaras",
        "Gambia": "Gambija",
        "Equatorial Guinea": "Pusiaujo Gvinėja",
        "Senegal": "Senegalas",
        "Jamaica": "Jamaika",
        "Seychelles": "Seišeliai",
        "Comoros": "Komorai",
        "U.S. Virgin Islands": "JAV Mergelių Salos",
        "Guinea": "Gvinėja",
        "Niger": "Nigeris",
        "Libya": "Libija",
        "Romania": "Rumunija",
        "Anguilla": "Angilija",
        "Togo": "Togas",
        "Paraguay": "Paragvajus",
        "India": "Indija",
        "Ireland": "Airija",
        "Turkey": "Turkija",
        "Oman": "Omanas",
        "Ukraine": "Ukraina",
        "Spain": "Ispanija",
        "Cameroon": "Kamerūnas",
        "Angola": "Angola",
        "Mali": "Malis",
        "Saint Vincent and the Grenadines": "Sent Vinsentas ir Grenadinai",
        "Cyprus": "Kipras",
        "Belarus": "Baltarusija",
        "Gabon": "Gabonas",
        "Samoa": "Samoa",
        "Chile": "Čilė",
        "United Arab Emirates": "Jungtiniai Arabų Emyratai",
        "São Tomé and Príncipe": "San Tomė ir Prinsipė",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rikas",
        "Portugal": "Portugalija",
        "Costa Rica": "Kosta Rika",
        "Swaziland": "Svazilandas",
        "Cape Verde": "Žaliasis Kyšulys",
        "Curaçao": "Kiurasao",
        "Andorra": "Andora",
        "Armenia": "Armėnija",
        "Haiti": "Haitis",
        "Côte d’Ivoire": "Dramblio Kaulo Krantas",
        "Guinea-Bissau": "Bisau Gvinėja",
        "Mozambique": "Mozambikas",
        "Poland": "Lenkija",
        "French Polynesia": "Prancūzijos Polinezija",
        "Jersey": "Džersis",
        "Kuwait": "Kuveitas",
        "Dominican Republic": "Dominikos Respublika",
        "Kosovo": "Kosovas",
        "Kyrgyzstan": "Kirgizija",
        "Syria": "Sirija",
        "Zambia": "Zambija",
        "Croatia": "Kroatija",
        "Lithuania": "Lietuva",
        "Albania": "Albanija",
        "Netherlands": "Nyderlandai",
        "France": "Prancūzija",
        "Tunisia": "Tunisas",
        "Bosnia and Herzegovina": "Bosnija ir Hercegovina",
        "Bahamas": "Bahamos",
        "Somalia": "Somalis",
        "Burundi": "Burundis",
        "Barbados": "Barbadosas",
        "Malawi": "Malavis",
        "Honduras": "Hondūras",
        "French Guiana": "Prancūzijos Gviana",
        "Jordan": "Jordanija",
        "Serbia": "Serbija",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Gajana",
        "Lesotho": "Lesotas",
        "Taiwan": "Taivanas",
        "Central African Republic": "Centrinės Afrikos Respublika",
        "Luxembourg": "Liuksemburgas",
        "Trinidad and Tobago": "Trinidadas ir Tobagas",
        "Estonia": "Estija",
        "Montserrat": "Montseratas",
        "Norway": "Norvegija",
        "North Korea": "Šiaurės Korėja",
        "Myanmar": "Mianmaras",
        "Sri Lanka": "Šri Lanka",
        "Faroe Islands": "Farerų Salos",
        "Dominica": "Dominika",
        "Kiribati": "Kiribatis",
        "Falkland Islands": "Falklandų Salos",
        "Namibia": "Namibija",
        "Saint Lucia": "Šventoji Liucija",
        "Indonesia": "Indonezija",
        "Timor-Leste": "Rytų Timoras",
        "Norfolk Island": "Norfolko Sala",
        "Bhutan": "Butanas",
        "Iran": "Iranas",
        "Turkmenistan": "Turkmėnistanas",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazachstanas",
        "Cook Islands": "Kuko Salos",
        "Micronesia": "Mikronezija",
        "Sint Maarten": "Sint Martenas",
        "Liberia": "Liberija",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipinai",
        "Rwanda": "Ruanda",
        "United Kingdom": "Jungtinė Karalystė",
        "Martinique": "Martinika",
        "Nepal": "Nepalas",
        "Guatemala": "Gvatemala",
        "Bermuda": "Bermudai",
        "Australia": "Australija",
        "Vatican City": "Vatikano Miestas",
        "Slovenia": "Slovėnija",
        "Cayman Islands": "Kaimanų Salos",
        "Hungary": "Vengrija",
        "American Samoa": "Amerikos Samoa",
        "Mauritania": "Mauritanija",
        "Japan": "Japonija",
        "Uzbekistan": "Uzbekistanas",
        "Cambodia": "Kambodža",
        "Wallis & Futuna": "Volis ir Futuna",
        "South Sudan": "Pietų Sudanas",
        "Morocco": "Marokas",
        "Argentina": "Argentina",
        "Guadeloupe": "Gvadelupa",
        "Hong Kong": "Honkongas",
        "Qatar": "Kataras",
        "Tanzania": "Tanzanija",
        "Mexico": "Meksika",
        "Russia": "Rusija",
        "Iceland": "Islandija",
        "Monaco": "Monakas",
        "Afghanistan": "Afganistanas",
        "Slovakia": "Slovakija",
        "Sweden": "Švedija",
        "Azerbaijan": "Azerbaidžanas",
        "Bangladesh": "Bangladešas",
        "Brazil": "Brazilija",
        "Cuba": "Kuba",
        "Ghana": "Gana",
        "Mongolia": "Mongolija",
        "Saint Kitts and Nevis": "Sent Kitsas ir Nevis",
        "Burkina Faso": "Burkina Fasas",
        "Nicaragua": "Nikaragva",
        "Malaysia": "Malaizija",
        "Uruguay": "Urugvajus",
        "Brunei": "Brunėjus",
        "Congo": "Kongas",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Šiaurės Marianų Salos",
        "Pakistan": "Pakistanas",
        "Greenland": "Grenlandija",
        "Mauritius": "Mauricijus",
        "Caribbean Netherlands": "Karibų Nyderlandai",
        "Belize": "Belizas",
        "Liechtenstein": "Lichtenšteinas",
        "Sierra Leone": "Siera Leonė",
        "Czech Republic": "Čekija",
        "Moldova": "Moldova",
        "Singapore": "Singapūras",
        "Belgium": "Belgija",
        "Maldives": "Maldyvai",
        "New Zealand": "Naujoji Zelandija",
        "South Korea": "Pietų Korėja",
        "Italy": "Italija",
        "Israel": "Izraelis",
        "Grenada": "Grenada",
        "Kenya": "Kenija",
        "St. Helena": "Šventoji Elena",
        "Guam": "Guamas",
        "Denmark": "Danija",
        "New Caledonia": "Naujoji Kaledonija",
        "Ecuador": "Ekvadoras",
        "Canada": "Kanada",
        "Egypt": "Egiptas",
        "Saudi Arabia": "Saudo Arabija",
        "Botswana": "Botsvana",
        "Turks & Caicos Islands": "Turkso ir Kaikoso Salos",
        "Latvia": "Latvija",
        "St. Pierre & Miquelon": "Sen Pjeras ir Mikelonas",
        "Georgia": "Gruzija",
        "Laos": "Laosas",
        "Réunion": "Reunjonas",
        "Niue": "Niujė",
        "Zimbabwe": "Zimbabvė",
        "Thailand": "Tailandas",
        "Algeria": "Alžyras",
        "Finland": "Suomija",
        "Macedonia": "Makedonija",
        "Antigua and Barbuda": "Antigva ir Barbuda",
        "Nigeria": "Nigerija",
        "Switzerland": "Šveicarija",
        "Bulgaria": "Bulgarija",
        "Montenegro": "Juodkalnija",
        "Tajikistan": "Tadžikistanas",
        "Austria": "Austrija",
        "Bolivia": "Bolivija",
        "Sudan": "Sudanas",
        "Suriname": "Surinamas",
        "Iraq": "Irakas",
        "Bahrain": "Bahreinas",
        "Colombia": "Kolumbija",
        "Papua New Guinea": "Papua Naujoji Gvinėja",
        "Yemen": "Jemenas",
        "Venezuela": "Venesuela",
        "Djibouti": "Džibutis",
        "British Indian Ocean Territory": "Didžiosios Britanijos Indijos vandenyno teritorija",
        "Chad": "Čadas",
        "Germany": "Vokietija",
        "Fiji": "Fidžis",
        "British Virgin Islands": "Britų Mergelių Salos",
        "San Marino": "San Marinas",
        "Vietnam": "Vietnamas",
        "Macau": "Makao",
        "South Africa": "Pietų Afrika",
        "Eritrea": "Eritrėja",
        "Greece": "Graikija",
        "Ethiopia": "Etiopija",
        "Madagascar": "Madagaskaras",
        "Marshall Islands": "Maršalo Salos",
        "United States": "Jungtinės Valstijos",
        "Benin": "Beninas",
        "El Salvador": "Salvadoras",
        "Lebanon": "Libanas",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Saliamono Salos",
        "China": "Kinija",
        "Tonga": "Tonga"
    },
};
export const jaJP = {
    searchNotFound: "国が見つかりません",
    searchPlaceholder: "国を探す",
    countries: {
        "Gibraltar": "ジブラルタル",
        "Gambia": "ガンビア",
        "Equatorial Guinea": "赤道ギニア",
        "Senegal": "セネガル",
        "Jamaica": "ジャマイカ",
        "Seychelles": "セーシェル",
        "Comoros": "コモロ",
        "U.S. Virgin Islands": "米領ヴァージン諸島",
        "Guinea": "ギニア",
        "Niger": "ニジェール",
        "Libya": "リビア",
        "Romania": "ルーマニア",
        "Anguilla": "アンギラ",
        "Togo": "トーゴ",
        "Paraguay": "パラグアイ",
        "India": "インド",
        "Ireland": "アイルランド",
        "Turkey": "トルコ",
        "Oman": "オマーン",
        "Ukraine": "ウクライナ",
        "Spain": "スペイン",
        "Cameroon": "カメルーン",
        "Angola": "アンゴラ",
        "Mali": "マリ",
        "Saint Vincent and the Grenadines": "セントビンセントおよびグレナディーン諸島",
        "Cyprus": "キプロス",
        "Belarus": "ベラルーシ",
        "Gabon": "ガボン",
        "Samoa": "サモア",
        "Chile": "チリ",
        "United Arab Emirates": "アラブ首長国連邦",
        "São Tomé and Príncipe": "サントメ・プリンシペ",
        "Palau": "パラオ",
        "Tokelau": "トケラウ",
        "Puerto Rico": "プエルトリコ",
        "Portugal": "ポルトガル",
        "Costa Rica": "コスタリカ",
        "Swaziland": "エスワティニ",
        "Cape Verde": "カーボベルデ",
        "Curaçao": "キュラソー",
        "Andorra": "アンドラ",
        "Armenia": "アルメニア",
        "Haiti": "ハイチ",
        "Côte d’Ivoire": "コートジボワール",
        "Guinea-Bissau": "ギニアビサウ",
        "Mozambique": "モザンビーク",
        "Poland": "ポーランド",
        "French Polynesia": "仏領ポリネシア",
        "Jersey": "ジャージー",
        "Kuwait": "クウェート",
        "Dominican Republic": "ドミニカ共和国",
        "Kosovo": "コソボ",
        "Kyrgyzstan": "キルギス",
        "Syria": "シリア",
        "Zambia": "ザンビア",
        "Croatia": "クロアチア",
        "Lithuania": "リトアニア",
        "Albania": "アルバニア",
        "Netherlands": "オランダ",
        "France": "フランス",
        "Tunisia": "チュニジア",
        "Bosnia and Herzegovina": "ボスニア・ヘルツェゴビナ",
        "Bahamas": "バハマ",
        "Somalia": "ソマリア",
        "Burundi": "ブルンジ",
        "Barbados": "バルバドス",
        "Malawi": "マラウイ",
        "Honduras": "ホンジュラス",
        "French Guiana": "仏領ギアナ",
        "Jordan": "ヨルダン",
        "Serbia": "セルビア",
        "Vanuatu": "バヌアツ",
        "Aruba": "アルバ",
        "Guyana": "ガイアナ",
        "Lesotho": "レソト",
        "Taiwan": "台湾",
        "Central African Republic": "中央アフリカ共和国",
        "Luxembourg": "ルクセンブルク",
        "Trinidad and Tobago": "トリニダード・トバゴ",
        "Estonia": "エストニア",
        "Montserrat": "モントセラト",
        "Norway": "ノルウェー",
        "North Korea": "北朝鮮",
        "Myanmar": "ミャンマー",
        "Sri Lanka": "スリランカ",
        "Faroe Islands": "フェロー諸島",
        "Dominica": "ドミニカ",
        "Kiribati": "キリバス",
        "Falkland Islands": "フォークランド諸島",
        "Namibia": "ナミビア",
        "Saint Lucia": "セントルシア",
        "Indonesia": "インドネシア",
        "Timor-Leste": "東ティモール",
        "Norfolk Island": "ノーフォーク島",
        "Bhutan": "ブータン",
        "Iran": "イラン",
        "Turkmenistan": "トルクメニスタン",
        "Uganda": "ウガンダ",
        "Kazakhstan": "カザフスタン",
        "Cook Islands": "クック諸島",
        "Micronesia": "ミクロネシア",
        "Sint Maarten": "シント・マールテン",
        "Liberia": "リベリア",
        "Panama": "パナマ",
        "Malta": "マルタ",
        "Peru": "ペルー",
        "Philippines": "フィリピン",
        "Rwanda": "ルワンダ",
        "United Kingdom": "イギリス",
        "Martinique": "マルティニーク",
        "Nepal": "ネパール",
        "Guatemala": "グアテマラ",
        "Bermuda": "バミューダ",
        "Australia": "オーストラリア",
        "Vatican City": "バチカン市国",
        "Slovenia": "スロベニア",
        "Cayman Islands": "ケイマン諸島",
        "Hungary": "ハンガリー",
        "American Samoa": "米領サモア",
        "Mauritania": "モーリタニア",
        "Japan": "日本",
        "Uzbekistan": "ウズベキスタン",
        "Cambodia": "カンボジア",
        "Wallis & Futuna": "ウォリス・フツナ",
        "South Sudan": "南スーダン",
        "Morocco": "モロッコ",
        "Argentina": "アルゼンチン",
        "Guadeloupe": "グアドループ",
        "Hong Kong": "香港",
        "Qatar": "カタール",
        "Tanzania": "タンザニア",
        "Mexico": "メキシコ",
        "Russia": "ロシア",
        "Iceland": "アイスランド",
        "Monaco": "モナコ",
        "Afghanistan": "アフガニスタン",
        "Slovakia": "スロバキア",
        "Sweden": "スウェーデン",
        "Azerbaijan": "アゼルバイジャン",
        "Bangladesh": "バングラデシュ",
        "Brazil": "ブラジル",
        "Cuba": "キューバ",
        "Ghana": "ガーナ",
        "Mongolia": "モンゴル",
        "Saint Kitts and Nevis": "セントクリストファー・ネイビス",
        "Burkina Faso": "ブルキナファソ",
        "Nicaragua": "ニカラグア",
        "Malaysia": "マレーシア",
        "Uruguay": "ウルグアイ",
        "Brunei": "ブルネイ",
        "Congo": "コンゴ",
        "Nauru": "ナウル",
        "Northern Mariana Islands": "北マリアナ諸島",
        "Pakistan": "パキスタン",
        "Greenland": "グリーンランド",
        "Mauritius": "モーリシャス",
        "Caribbean Netherlands": "カリブオランダ",
        "Belize": "ベリーズ",
        "Liechtenstein": "リヒテンシュタイン",
        "Sierra Leone": "シエラレオネ",
        "Czech Republic": "チェコ",
        "Moldova": "モルドバ",
        "Singapore": "シンガポール",
        "Belgium": "ベルギー",
        "Maldives": "モルディブ",
        "New Zealand": "ニュージーランド",
        "South Korea": "韓国",
        "Italy": "イタリア",
        "Israel": "イスラエル",
        "Grenada": "グレナダ",
        "Kenya": "ケニア",
        "St. Helena": "セントヘレナ",
        "Guam": "グアム",
        "Denmark": "デンマーク",
        "New Caledonia": "ニューカレドニア",
        "Ecuador": "エクアドル",
        "Canada": "カナダ",
        "Egypt": "エジプト",
        "Saudi Arabia": "サウジアラビア",
        "Botswana": "ボツワナ",
        "Turks & Caicos Islands": "タークス・カイコス諸島",
        "Latvia": "ラトビア",
        "St. Pierre & Miquelon": "サンピエール島・ミクロン島",
        "Georgia": "ジョージア",
        "Laos": "ラオス",
        "Réunion": "レユニオン",
        "Niue": "ニウエ",
        "Zimbabwe": "ジンバブエ",
        "Thailand": "タイ",
        "Algeria": "アルジェリア",
        "Finland": "フィンランド",
        "Macedonia": "北マケドニア",
        "Antigua and Barbuda": "アンティグア・バーブーダ",
        "Nigeria": "ナイジェリア",
        "Switzerland": "スイス",
        "Bulgaria": "ブルガリア",
        "Montenegro": "モンテネグロ",
        "Tajikistan": "タジキスタン",
        "Austria": "オーストリア",
        "Bolivia": "ボリビア",
        "Sudan": "スーダン",
        "Suriname": "スリナム",
        "Iraq": "イラク",
        "Bahrain": "バーレーン",
        "Colombia": "コロンビア",
        "Papua New Guinea": "パプアニューギニア",
        "Yemen": "イエメン",
        "Venezuela": "ベネズエラ",
        "Djibouti": "ジブチ",
        "British Indian Ocean Territory": "英領インド洋地域",
        "Chad": "チャド",
        "Germany": "ドイツ",
        "Fiji": "フィジー",
        "British Virgin Islands": "英領ヴァージン諸島",
        "San Marino": "サンマリノ",
        "Vietnam": "ベトナム",
        "Macau": "マカオ",
        "South Africa": "南アフリカ",
        "Eritrea": "エリトリア",
        "Greece": "ギリシャ",
        "Ethiopia": "エチオピア",
        "Madagascar": "マダガスカル",
        "Marshall Islands": "マーシャル諸島",
        "United States": "アメリカ合衆国",
        "Benin": "ベナン",
        "El Salvador": "エルサルバドル",
        "Lebanon": "レバノン",
        "Palestine": "パレスチナ",
        "Tuvalu": "ツバル",
        "Solomon Islands": "ソロモン諸島",
        "China": "中国",
        "Tonga": "トンガ"
    },
};
export const arEG = {
    searchNotFound: "لم يتم العثور على أي بلد",
    searchPlaceholder: "ابحث عن بلد",
    countries: {
        "Gibraltar": "جبل طارق",
        "Gambia": "غامبيا",
        "Equatorial Guinea": "غينيا الاستوائية",
        "Senegal": "السنغال",
        "Jamaica": "جامايكا",
        "Seychelles": "سيشل",
        "Comoros": "جزر القمر",
        "U.S. Virgin Islands": "جزر فيرجن الأمريكية",
        "Guinea": "غينيا",
        "Niger": "النيجر",
        "Libya": "ليبيا",
        "Romania": "رومانيا",
        "Anguilla": "أنغويلا",
        "Togo": "توغو",
        "Paraguay": "باراغواي",
        "India": "الهند",
        "Ireland": "أيرلندا",
        "Turkey": "تركيا",
        "Oman": "عمان",
        "Ukraine": "أوكرانيا",
        "Spain": "إسبانيا",
        "Cameroon": "الكاميرون",
        "Angola": "أنغولا",
        "Mali": "مالي",
        "Saint Vincent and the Grenadines": "سانت فينسنت والغرينادين",
        "Cyprus": "قبرص",
        "Belarus": "بيلاروسيا",
        "Gabon": "الغابون",
        "Samoa": "ساموا",
        "Chile": "تشيلي",
        "United Arab Emirates": "الإمارات العربية المتحدة",
        "São Tomé and Príncipe": "ساو تومي وبرينسيبي",
        "Palau": "بالاو",
        "Tokelau": "توكيلاو",
        "Puerto Rico": "بورتوريكو",
        "Portugal": "البرتغال",
        "Costa Rica": "كوستاريكا",
        "Swaziland": "إسواتيني",
        "Cape Verde": "الرأس الأخضر",
        "Curaçao": "كوراساو",
        "Andorra": "أندورا",
        "Armenia": "أرمينيا",
        "Haiti": "هايتي",
        "Côte d’Ivoire": "ساحل العاج",
        "Guinea-Bissau": "غينيا بيساو",
        "Mozambique": "موزمبيق",
        "Poland": "بولندا",
        "French Polynesia": "بولينيزيا الفرنسية",
        "Jersey": "جيرسي",
        "Kuwait": "الكويت",
        "Dominican Republic": "جمهورية الدومينيكان",
        "Kosovo": "كوسوفو",
        "Kyrgyzstan": "قيرغيزستان",
        "Syria": "سوريا",
        "Zambia": "زامبيا",
        "Croatia": "كرواتيا",
        "Lithuania": "ليتوانيا",
        "Albania": "ألبانيا",
        "Netherlands": "هولندا",
        "France": "فرنسا",
        "Tunisia": "تونس",
        "Bosnia and Herzegovina": "البوسنة والهرسك",
        "Bahamas": "الباهاما",
        "Somalia": "الصومال",
        "Burundi": "بوروندي",
        "Barbados": "باربادوس",
        "Malawi": "مالاوي",
        "Honduras": "هندوراس",
        "French Guiana": "غويانا الفرنسية",
        "Jordan": "الأردن",
        "Serbia": "صربيا",
        "Vanuatu": "فانواتو",
        "Aruba": "أروبا",
        "Guyana": "غيانا",
        "Lesotho": "ليسوتو",
        "Taiwan": "تايوان",
        "Central African Republic": "جمهورية أفريقيا الوسطى",
        "Luxembourg": "لوكسمبورغ",
        "Trinidad and Tobago": "ترينيداد وتوباغو",
        "Estonia": "إستونيا",
        "Montserrat": "مونتسرات",
        "Norway": "النرويج",
        "North Korea": "كوريا الشمالية",
        "Myanmar": "ميانمار",
        "Sri Lanka": "سريلانكا",
        "Faroe Islands": "جزر فارو",
        "Dominica": "دومينيكا",
        "Kiribati": "كيريباتي",
        "Falkland Islands": "جزر فوكلاند",
        "Namibia": "ناميبيا",
        "Saint Lucia": "سانت لوسيا",
        "Indonesia": "إندونيسيا",
        "Timor-Leste": "تيمور الشرقية",
        "Norfolk Island": "جزيرة نورفولك",
        "Bhutan": "بوتان",
        "Iran": "إيران",
        "Turkmenistan": "تركمانستان",
        "Uganda": "أوغندا",
        "Kazakhstan": "كازاخستان",
        "Cook Islands": "جزر كوك",
        "Micronesia": "ميكرونيزيا",
        "Sint Maarten": "سينت مارتن",
        "Liberia": "ليبيريا",
        "Panama": "بنما",
        "Malta": "مالطا",
        "Peru": "بيرو",
        "Philippines": "الفلبين",
        "Rwanda": "رواندا",
        "United Kingdom": "المملكة المتحدة",
        "Martinique": "مارتينيك",
        "Nepal": "نيبال",
        "Guatemala": "غواتيمالا",
        "Bermuda": "برمودا",
        "Australia": "أستراليا",
        "Vatican City": "الفاتيكان",
        "Slovenia": "سلوفينيا",
        "Cayman Islands": "جزر كايمان",
        "Hungary": "هنغاريا",
        "American Samoa": "ساموا الأمريكية",
        "Mauritania": "موريتانيا",
        "Japan": "اليابان",
        "Uzbekistan": "أوزبكستان",
        "Cambodia": "كمبوديا",
        "Wallis & Futuna": "واليس وفوتونا",
        "South Sudan": "جنوب السودان",
        "Morocco": "المغرب",
        "Argentina": "الأرجنتين",
        "Guadeloupe": "جوادلوب",
        "Hong Kong": "هونغ كونغ",
        "Qatar": "قطر",
        "Tanzania": "تنزانيا",
        "Mexico": "المكسيك",
        "Russia": "روسيا",
        "Iceland": "آيسلندا",
        "Monaco": "موناكو",
        "Afghanistan": "أفغانستان",
        "Slovakia": "سلوفاكيا",
        "Sweden": "السويد",
        "Azerbaijan": "أذربيجان",
        "Bangladesh": "بنغلاديش",
        "Brazil": "البرازيل",
        "Cuba": "كوبا",
        "Ghana": "غانا",
        "Mongolia": "منغوليا",
        "Saint Kitts and Nevis": "سانت كيتس ونيفيس",
        "Burkina Faso": "بوركينا فاسو",
        "Nicaragua": "نيكاراغوا",
        "Malaysia": "ماليزيا",
        "Uruguay": "أوروغواي",
        "Brunei": "بروناي",
        "Congo": "الكونغو",
        "Nauru": "ناورو",
        "Northern Mariana Islands": "جزر ماريانا الشمالية",
        "Pakistan": "باكستان",
        "Greenland": "غرينلاند",
        "Mauritius": "موريشيوس",
        "Caribbean Netherlands": "هولندا الكاريبية",
        "Belize": "بليز",
        "Liechtenstein": "ليختنشتاين",
        "Sierra Leone": "سيراليون",
        "Czech Republic": "جمهورية التشيك",
        "Moldova": "مولدوفا",
        "Singapore": "سنغافورة",
        "Belgium": "بلجيكا",
        "Maldives": "المالديف",
        "New Zealand": "نيوزيلندا",
        "South Korea": "كوريا الجنوبية",
        "Italy": "إيطاليا",
        "Israel": "إسرائيل",
        "Grenada": "غرينادا",
        "Kenya": "كينيا",
        "St. Helena": "سانت هيلينا",
        "Guam": "غوام",
        "Denmark": "الدنمارك",
        "New Caledonia": "كاليدونيا الجديدة",
        "Ecuador": "الإكوادور",
        "Canada": "كندا",
        "Egypt": "مصر",
        "Saudi Arabia": "المملكة العربية السعودية",
        "Botswana": "بوتسوانا",
        "Turks & Caicos Islands": "جزر توركس وكايكوس",
        "Latvia": "لاتفيا",
        "St. Pierre & Miquelon": "سان بيير وميكلون",
        "Georgia": "جورجيا",
        "Laos": "لاوس",
        "Réunion": "ريونيون",
        "Niue": "نيوي",
        "Zimbabwe": "زيمبابوي",
        "Thailand": "تايلاند",
        "Algeria": "الجزائر",
        "Finland": "فنلندا",
        "Macedonia": "مقدونيا الشمالية",
        "Antigua and Barbuda": "أنتيغوا وباربودا",
        "Nigeria": "نيجيريا",
        "Switzerland": "سويسرا",
        "Bulgaria": "بلغاريا",
        "Montenegro": "الجبل الأسود",
        "Tajikistan": "طاجيكستان",
        "Austria": "النمسا",
        "Bolivia": "بوليفيا",
        "Sudan": "السودان",
        "Suriname": "سورينام",
        "Iraq": "العراق",
        "Bahrain": "البحرين",
        "Colombia": "كولومبيا",
        "Papua New Guinea": "بابوا غينيا الجديدة",
        "Yemen": "اليمن",
        "Venezuela": "فنزويلا",
        "Djibouti": "جيبوتي",
        "British Indian Ocean Territory": "إقليم المحيط الهندي البريطاني",
        "Chad": "تشاد",
        "Germany": "ألمانيا",
        "Fiji": "فيجي",
        "British Virgin Islands": "جزر فيرجن البريطانية",
        "San Marino": "سان مارينو",
        "Vietnam": "فيتنام",
        "Macau": "ماكاو",
        "South Africa": "جنوب أفريقيا",
        "Eritrea": "إريتريا",
        "Greece": "اليونان",
        "Ethiopia": "إثيوبيا",
        "Madagascar": "مدغشقر",
        "Marshall Islands": "جزر مارشال",
        "United States": "الولايات المتحدة",
        "Benin": "بنين",
        "El Salvador": "السلفادور",
        "Lebanon": "لبنان",
        "Palestine": "فلسطين",
        "Tuvalu": "توفالو",
        "Solomon Islands": "جزر سليمان",
        "China": "الصين",
        "Tonga": "تونغا"
    },
};
export const kmKH = {
    searchNotFound: "រកមិនឃើញប្រទេស",
    searchPlaceholder: "ស្វែងរកប្រទេស",
    countries: {
        "Gibraltar": "ហ្គីប្រាល់តា",
        "Gambia": "ហ្គាម្ប៊ី",
        "Equatorial Guinea": "ហ្គីណេអេក្វាទ័រ",
        "Senegal": "សេនេហ្គាល់",
        "Jamaica": "ហ្សាម៉ាអ៊ីក",
        "Seychelles": "សីស៊ីលី",
        "Comoros": "កូម័រ",
        "U.S. Virgin Islands": "កោះវឺជីនអាមេរិក",
        "Guinea": "ហ្គីណេ",
        "Niger": "នីហ្សេ",
        "Libya": "លីប៊ី",
        "Romania": "រូម៉ានី",
        "Anguilla": "អង់ហ្គីឡា",
        "Togo": "តូហ្គោ",
        "Paraguay": "ប៉ារ៉ាហ្គាយ",
        "India": "ឥណ្ឌា",
        "Ireland": "អៀរឡង់",
        "Turkey": "តួកគី",
        "Oman": "អូម៉ង់",
        "Ukraine": "អ៊ុយក្រែន",
        "Spain": "អេស្ប៉ាញ",
        "Cameroon": "កាមេរូន",
        "Angola": "អង់ហ្គោឡា",
        "Mali": "ម៉ាលី",
        "Saint Vincent and the Grenadines": "សាំង វ៉ាំងសង់ និងក្រុណាឌីន",
        "Cyprus": "ស៊ីប",
        "Belarus": "បេឡារុស្ស",
        "Gabon": "ហ្គាបុង",
        "Samoa": "សាមូរ៉ា",
        "Chile": "ជីលី",
        "United Arab Emirates": "អេមីរ៉ាតអារ៉ាប់រួម",
        "São Tomé and Príncipe": "សៅតូម៉េ និងប្រាំងស៊ីបេ",
        "Palau": "ប៉ាលាវ",
        "Tokelau": "តូខេឡាវ",
        "Puerto Rico": "ព័រតូរីកូ",
        "Portugal": "ព័រទុយហ្គាល់",
        "Costa Rica": "កូស្តារីកា",
        "Swaziland": "ស្វាស៊ីឡង់",
        "Cape Verde": "កាប វែរ",
        "Curaçao": "គូរ៉ាសៅ",
        "Andorra": "អង់ដូរ៉ា",
        "Armenia": "អាមេនី",
        "Haiti": "ហៃទី",
        "Côte d’Ivoire": "កូតឌីវ័រ",
        "Guinea-Bissau": "ហ្គីណេ-ប៊ីសាវ",
        "Mozambique": "ម៉ូសាំប៊ិក",
        "Poland": "ប៉ូឡូញ",
        "French Polynesia": "ប៉ូលីនេស៊ីបារាំង",
        "Jersey": "ជឺស៊ី",
        "Kuwait": "គុយវ៉ែត",
        "Dominican Republic": "សាធារណរដ្ឋដូមីនីកាំង",
        "Kosovo": "កូសូវ៉ូ",
        "Kyrgyzstan": "កៀហ្ស៊ីស៊ីស្តង់",
        "Syria": "ស៊ីរី",
        "Zambia": "សាំប៊ី",
        "Croatia": "ក្រូអាស៊ី",
        "Lithuania": "លីទុយអានី",
        "Albania": "អាល់បានី",
        "Netherlands": "ហូឡង់",
        "France": "បារាំង",
        "Tunisia": "ទុយនេស៊ី",
        "Bosnia and Herzegovina": "បូស្នី និង ហឺហ្សេហ្គូវីណា",
        "Bahamas": "បាហាម៉ា",
        "Somalia": "សូម៉ាលី",
        "Burundi": "ប៊ូរុនឌី",
        "Barbados": "បាបាដូស",
        "Malawi": "ម៉ាឡាវី",
        "Honduras": "ហុងឌូរ៉ាស់",
        "French Guiana": "ហ្វ្រេនប៊្យូហ្គីណា",
        "Jordan": "ហ្ស៊កដានី",
        "Serbia": "ស៊ែប៊ី",
        "Vanuatu": "វ៉ានូទូ",
        "Aruba": "អារូបា",
        "Guyana": "ហ្គីយ៉ាណា",
        "Lesotho": "លេសូតូ",
        "Taiwan": "តៃវ៉ាន់",
        "Central African Republic": "សាធារណរដ្ឋអាហ្វ្រិកកណ្តាល",
        "Luxembourg": "លុចសំបួរ",
        "Trinidad and Tobago": "ទ្រីនីដាត និងតូបាហ្គោ",
        "Estonia": "អេស្តូនី",
        "Montserrat": "ម៉ុងសេរ៉ាត",
        "Norway": "ន័រវ៉េ",
        "North Korea": "កូរ៉េខាងជើង",
        "Myanmar": "មីយ៉ាន់ម៉ា",
        "Sri Lanka": "ស្រីលង្កា",
        "Faroe Islands": "កោះ ហ្វារ៉ូ",
        "Dominica": "ដូមីនីកា",
        "Kiribati": "គិរីបាទី",
        "Falkland Islands": "កោះ ហ្វុកឡែន",
        "Namibia": "ណាមីប៊ី",
        "Saint Lucia": "សាំង លុសុយ",
        "Indonesia": "ឥណ្ឌូណេស៊ី",
        "Timor-Leste": "ទីម័រ-លេស្ដេ",
        "Norfolk Island": "កោះណូហ្វលក់",
        "Bhutan": "ប៊ូតាន",
        "Iran": "អ៊ីរ៉ង់",
        "Turkmenistan": "ទួគម៉េនីស្តង់",
        "Uganda": "អ៊ូហ្គង់ដា",
        "Kazakhstan": "កាហ្សាក់ស្តង់",
        "Cook Islands": "កោះខូក",
        "Micronesia": "មីក្រូនេស៊ី",
        "Sint Maarten": "សិន ម៉ាទីន",
        "Liberia": "លីបេរីយ៉ា",
        "Panama": "ប៉ាណាម៉ា",
        "Malta": "ម៉ាល់តា",
        "Peru": "ប៉េរូ",
        "Philippines": "ហ្វីលីពីន",
        "Rwanda": "រវ៉ាន់ដា",
        "United Kingdom": "ចក្រភព​អង់គ្លេស",
        "Martinique": "ម៉ាទីនីក",
        "Nepal": "នេប៉ាល់",
        "Guatemala": "ហ្គាតេម៉ាឡា",
        "Bermuda": "ប៊ឺមុយដា",
        "Australia": "អូស្រ្តាលី",
        "Vatican City": "ទីក្រុងវ៉ាទីកង់",
        "Slovenia": "ស្លូវេនី",
        "Cayman Islands": "កោះខៃម៉ែន",
        "Hungary": "ហុងគ្រី",
        "American Samoa": "សាមូអាមេរិកាំង",
        "Mauritania": "ម៉ូរីតានី",
        "Japan": "ជប៉ុន",
        "Uzbekistan": "អ៊ូហ្សបេគីស្តង់",
        "Cambodia": "កម្ពុជា",
        "Wallis & Futuna": "វ៉ាលី និងហ្វូទូណា",
        "South Sudan": "ស៊ូដង់​ខាង​ត្បូង",
        "Morocco": "ម៉ារ៉ុក",
        "Argentina": "អាហ្សង់ទីន",
        "Guadeloupe": "ហ្គាវ៉ាដលូប",
        "Hong Kong": "ហុងកុង",
        "Qatar": "កាតា",
        "Tanzania": "តង់សានី",
        "Mexico": "ម៉ិចស៊ិក",
        "Russia": "រុស្ស៊ី",
        "Iceland": "អ៊ីស្លង់",
        "Monaco": "ម៉ូណាកូ",
        "Afghanistan": "អាហ្វហ្គានីស្ថាន",
        "Slovakia": "ស្លូវ៉ាគី",
        "Sweden": "ស៊ុយអែត",
        "Azerbaijan": "អាស៊ែបៃហ្សង់",
        "Bangladesh": "បង់ក្លាដែស",
        "Brazil": "ប្រេស៊ីល",
        "Cuba": "គុយបា",
        "Ghana": "ហ្គាណា",
        "Mongolia": "ម៉ុងហ្គោលី",
        "Saint Kitts and Nevis": "សាំងគីត និង នីវីស",
        "Burkina Faso": "ប៊ូរគីណាហ្វាសូ",
        "Nicaragua": "នីការហ្គាវ៉ា",
        "Malaysia": "ម៉ាឡេស៊ី",
        "Uruguay": "អ៊ុយរូហ្គាយ",
        "Brunei": "ប្រ៊ូណេ",
        "Congo": "កុងហ្គោ",
        "Nauru": "ណូរូ",
        "Northern Mariana Islands": "កោះម៉ារីណាភាគខាងជើង",
        "Pakistan": "ប៉ាគីស្ថាន",
        "Greenland": "ហ្គ្រោនឡង់",
        "Mauritius": "ម៉ូរីទុស",
        "Caribbean Netherlands": "ហូល្លង់ការ៉ាប៊ី",
        "Belize": "បេលី",
        "Liechtenstein": "លីចទិនស្ទេន",
        "Sierra Leone": "សៀរ៉ាឡេអូន",
        "Czech Republic": "សាធារណរដ្ឋឆែក",
        "Moldova": "ម៉ុលដាវី",
        "Singapore": "សិង្ហបុរី",
        "Belgium": "បែលហ្ស៊ីក",
        "Maldives": "ម៉ាល់ឌីវ",
        "New Zealand": "នូវែលសេឡង់",
        "South Korea": "កូរ៉េខាងត្បូង",
        "Italy": "អ៊ីតាលី",
        "Israel": "អ៊ីស្រាអែល",
        "Grenada": "ហ្គ្រេណាដា",
        "Kenya": "កេនយ៉ា",
        "St. Helena": "សាំងហេលេណា",
        "Guam": "ហ្គាម",
        "Denmark": "ដាណឺម៉ាក",
        "New Caledonia": "នូវែលកាឡេដូនី",
        "Ecuador": "អេក្វាឌ័រ",
        "Canada": "កាណាដា",
        "Egypt": "អេហ្ស៊ីប",
        "Saudi Arabia": "អារ៉ាប៊ីសាអ៊ូឌីត",
        "Botswana": "បុតស្វាណា",
        "Turks & Caicos Islands": "កោះទួគ និងខៃកូស",
        "Latvia": "ឡាតវី",
        "St. Pierre & Miquelon": "សាំងពីវ និង មីគេឡុង",
        "Georgia": "ហ្សកហ្ស៉ា",
        "Laos": "ឡាវ",
        "Réunion": "រេអុយណុង",
        "Niue": "នីយ៉ូ",
        "Zimbabwe": "ហ្ស៊ីមបាប៊េ",
        "Thailand": "ថៃ",
        "Algeria": "អាល់ហ្សេរី",
        "Finland": "ហ្វាំងឡង់",
        "Macedonia": "ម៉ាសេដូនី",
        "Antigua and Barbuda": "អង់ទីហ្គា និងបារបុយដា",
        "Nigeria": "នីហ្សេរីយ៉ា",
        "Switzerland": "ស្វីស",
        "Bulgaria": "ប៊ុលហ្គារី",
        "Montenegro": "ម៉ុងតេណេក្រោ",
        "Tajikistan": "តាហ្ស៊ីគីស្តង់",
        "Austria": "អូទ្រីស",
        "Bolivia": "បូលីវី",
        "Sudan": "ស៊ូដង់",
        "Suriname": "ស៊ូរីណាម",
        "Iraq": "អ៊ីរ៉ាក់",
        "Bahrain": "បារ៉ែន",
        "Colombia": "កូឡុំប៊ី",
        "Papua New Guinea": "ប៉ាពួញីហ្គីណេ",
        "Yemen": "យេម៉ែន",
        "Venezuela": "វេណេហ្ស៊ុយឡា",
        "Djibouti": "ជីប៊ូទី",
        "British Indian Ocean Territory": "ដែនដីមហាសមុទ្រឥណ្ឌាប្រេស",
        "Chad": "ឆាដ",
        "Germany": "អាល្លឺម៉ង់",
        "Fiji": "ហ្វ៊ីជី",
        "British Virgin Islands": "កោះ វឺជីនប្រេស",
        "San Marino": "សាន់ម៉ារីណូ",
        "Vietnam": "វៀតណាម",
        "Macau": "ម៉ាកាវ",
        "South Africa": "អាហ្វ្រិកខាងត្បូង",
        "Eritrea": "អេរីទ្រា",
        "Greece": "ក្រិច",
        "Ethiopia": "អេត្យូពី",
        "Madagascar": "ម៉ាដាហ្គាស្ការ",
        "Marshall Islands": "កោះ ម៉ាស្ហល",
        "United States": "សហរដ្ឋអាមេរិក",
        "Benin": "បេណាំង",
        "El Salvador": "អែលសាល់វ៉ាឌ័រ",
        "Lebanon": "លីបង់",
        "Palestine": "ប៉ាលេស្ទីន",
        "Tuvalu": "ទុយវ៉ាលូ",
        "Solomon Islands": "កោះ សូលូម៉ុន",
        "China": "ចិន",
        "Tonga": "តុងហ្គា"
    },
};
export const elGR = {
    searchNotFound: "Δεν βρέθηκε χώρα",
    searchPlaceholder: "Αναζήτηση χώρας",
    countries: {
        "Gibraltar": "Γιβραλτάρ",
        "Gambia": "Γκάμπια",
        "Equatorial Guinea": "Ισημερινή Γουινέα",
        "Senegal": "Σενεγάλη",
        "Jamaica": "Τζαμάικα",
        "Seychelles": "Σεϋχέλλες",
        "Comoros": "Κομόρες",
        "U.S. Virgin Islands": "Αμερικανικές Παρθένοι Νήσοι",
        "Guinea": "Γουινέα",
        "Niger": "Νίγηρας",
        "Libya": "Λιβύη",
        "Romania": "Ρουμανία",
        "Anguilla": "Ανγκουίλα",
        "Togo": "Τόγκο",
        "Paraguay": "Παραγουάη",
        "India": "Ινδία",
        "Ireland": "Ιρλανδία",
        "Turkey": "Τουρκία",
        "Oman": "Ομάν",
        "Ukraine": "Ουκρανία",
        "Spain": "Ισπανία",
        "Cameroon": "Καμερούν",
        "Angola": "Ανγκόλα",
        "Mali": "Μάλι",
        "Saint Vincent and the Grenadines": "Άγιος Βικέντιος και Γρεναδίνες",
        "Cyprus": "Κύπρος",
        "Belarus": "Λευκορωσία",
        "Gabon": "Γκαμπόν",
        "Samoa": "Σαμόα",
        "Chile": "Χιλή",
        "United Arab Emirates": "Ηνωμένα Αραβικά Εμιράτα",
        "São Tomé and Príncipe": "Σάο Τομέ και Πρίνσιπε",
        "Palau": "Παλάου",
        "Tokelau": "Τοκελάου",
        "Puerto Rico": "Πουέρτο Ρίκο",
        "Portugal": "Πορτογαλία",
        "Costa Rica": "Κόστα Ρίκα",
        "Swaziland": "Εσουατίνι",
        "Cape Verde": "Πράσινο Ακρωτήριο",
        "Curaçao": "Κουρασάο",
        "Andorra": "Ανδόρα",
        "Armenia": "Αρμενία",
        "Haiti": "Αϊτή",
        "Côte d’Ivoire": "Ακτή Ελεφαντοστού",
        "Guinea-Bissau": "Γουινέα-Μπισσάου",
        "Mozambique": "Μοζαμβίκη",
        "Poland": "Πολωνία",
        "French Polynesia": "Γαλλική Πολυνησία",
        "Jersey": "Τζέρσεϊ",
        "Kuwait": "Κουβέιτ",
        "Dominican Republic": "Δομινικανή Δημοκρατία",
        "Kosovo": "Κόσοβο",
        "Kyrgyzstan": "Κιργιζία",
        "Syria": "Συρία",
        "Zambia": "Ζάμπια",
        "Croatia": "Κροατία",
        "Lithuania": "Λιθουανία",
        "Albania": "Αλβανία",
        "Netherlands": "Ολλανδία",
        "France": "Γαλλία",
        "Tunisia": "Τυνησία",
        "Bosnia and Herzegovina": "Βοσνία-Ερζεγοβίνη",
        "Bahamas": "Μπαχάμες",
        "Somalia": "Σομαλία",
        "Burundi": "Μπουρούντι",
        "Barbados": "Μπαρμπάντος",
        "Malawi": "Μαλάουι",
        "Honduras": "Ονδούρα",
        "French Guiana": "Γαλλική Γουιάνα",
        "Jordan": "Ιορδανία",
        "Serbia": "Σερβία",
        "Vanuatu": "Βανουάτου",
        "Aruba": "Αρούμπα",
        "Guyana": "Γουιάνα",
        "Lesotho": "Λεσότο",
        "Taiwan": "Ταϊβάν",
        "Central African Republic": "Κεντροαφρικανική Δημοκρατία",
        "Luxembourg": "Λουξεμβούργο",
        "Trinidad and Tobago": "Τρινιντάντ και Τομπάγκο",
        "Estonia": "Εσθονία",
        "Montserrat": "Μοντσερράτ",
        "Norway": "Νορβηγία",
        "North Korea": "Βόρεια Κορέα",
        "Myanmar": "Μιανμάρ",
        "Sri Lanka": "Σρι Λάνκα",
        "Faroe Islands": "Νήσοι Φερόες",
        "Dominica": "Ντομίνικα",
        "Kiribati": "Κιριμπάτι",
        "Falkland Islands": "Νήσοι Φώκλαντ",
        "Namibia": "Ναμίμπια",
        "Saint Lucia": "Αγία Λουκία",
        "Indonesia": "Ινδονησία",
        "Timor-Leste": "Ανατολικό Τιμόρ",
        "Norfolk Island": "Νησί Νόρφολκ",
        "Bhutan": "Μπουτάν",
        "Iran": "Ιράν",
        "Turkmenistan": "Τουρκμενιστάν",
        "Uganda": "Ουγκάντα",
        "Kazakhstan": "Καζακστάν",
        "Cook Islands": "Νήσοι Κουκ",
        "Micronesia": "Μικρονησία",
        "Sint Maarten": "Άγιος Μαρτίνος",
        "Liberia": "Λιβερία",
        "Panama": "Παναμάς",
        "Malta": "Μάλτα",
        "Peru": "Περού",
        "Philippines": "Φιλιππίνες",
        "Rwanda": "Ρουάντα",
        "United Kingdom": "Ηνωμένο Βασίλειο",
        "Martinique": "Μαρτινίκα",
        "Nepal": "Νεπάλ",
        "Guatemala": "Γουατεμάλα",
        "Bermuda": "Βερμούδες",
        "Australia": "Αυστραλία",
        "Vatican City": "Πόλη του Βατικανού",
        "Slovenia": "Σλοβενία",
        "Cayman Islands": "Νήσοι Κέιμαν",
        "Hungary": "Ουγγαρία",
        "American Samoa": "Αμερικανική Σαμόα",
        "Mauritania": "Μαυριτανία",
        "Japan": "Ιαπωνία",
        "Uzbekistan": "Ουζμπεκιστάν",
        "Cambodia": "Καμπότζη",
        "Wallis & Futuna": "Ουόλις και Φουτούνα",
        "South Sudan": "Νότιο Σουδάν",
        "Morocco": "Μαρόκο",
        "Argentina": "Αργεντινή",
        "Guadeloupe": "Γουαδελούπη",
        "Hong Kong": "Χονγκ Κονγκ",
        "Qatar": "Κατάρ",
        "Tanzania": "Τανζανία",
        "Mexico": "Μεξικό",
        "Russia": "Ρωσία",
        "Iceland": "Ισλανδία",
        "Monaco": "Μονακό",
        "Afghanistan": "Αφγανιστάν",
        "Slovakia": "Σλοβακία",
        "Sweden": "Σουηδία",
        "Azerbaijan": "Αζερμπαϊτζάν",
        "Bangladesh": "Μπανγκλαντές",
        "Brazil": "Βραζιλία",
        "Cuba": "Κούβα",
        "Ghana": "Γκάνα",
        "Mongolia": "Μογγολία",
        "Saint Kitts and Nevis": "Άγιος Χριστόφορος και Νέβις",
        "Burkina Faso": "Μπουρκίνα Φάσο",
        "Nicaragua": "Νικαράγουα",
        "Malaysia": "Μαλαισία",
        "Uruguay": "Ουρουγουάη",
        "Brunei": "Μπρουνέι",
        "Congo": "Κονγκό",
        "Nauru": "Ναουρού",
        "Northern Mariana Islands": "Βόρειες Μαριάνες Νήσοι",
        "Pakistan": "Πακιστάν",
        "Greenland": "Γροιλανδία",
        "Mauritius": "Μαυρίκιος",
        "Caribbean Netherlands": "Καραϊβική Ολλανδία",
        "Belize": "Μπελίζ",
        "Liechtenstein": "Λιχτενστάιν",
        "Sierra Leone": "Σιέρα Λεόνε",
        "Czech Republic": "Τσεχική Δημοκρατία",
        "Moldova": "Μολδαβία",
        "Singapore": "Σιγκαπούρη",
        "Belgium": "Βέλγιο",
        "Maldives": "Μαλδίβες",
        "New Zealand": "Νέα Ζηλανδία",
        "South Korea": "Νότια Κορέα",
        "Italy": "Ιταλία",
        "Israel": "Ισραήλ",
        "Grenada": "Γρενάδα",
        "Kenya": "Κένυα",
        "St. Helena": "Αγία Ελένη",
        "Guam": "Γκουάμ",
        "Denmark": "Δανία",
        "New Caledonia": "Νέα Καληδονία",
        "Ecuador": "Ισημερινός",
        "Canada": "Καναδάς",
        "Egypt": "Αίγυπτος",
        "Saudi Arabia": "Σαουδική Αραβία",
        "Botswana": "Μποτσουάνα",
        "Turks & Caicos Islands": "Νήσοι Τερκς και Κάικος",
        "Latvia": "Λετονία",
        "St. Pierre & Miquelon": "Άγιος Πέτρος και Μικελόν",
        "Georgia": "Γεωργία",
        "Laos": "Λάος",
        "Réunion": "Ρεϊνιόν",
        "Niue": "Νιούε",
        "Zimbabwe": "Ζιμπάμπουε",
        "Thailand": "Ταϊλάνδη",
        "Algeria": "Αλγερία",
        "Finland": "Φινλανδία",
        "Macedonia": "Βόρεια Μακεδονία",
        "Antigua and Barbuda": "Αντίγκουα και Μπαρμπούντα",
        "Nigeria": "Νιγηρία",
        "Switzerland": "Ελβετία",
        "Bulgaria": "Βουλγαρία",
        "Montenegro": "Μαυροβούνιο",
        "Tajikistan": "Τατζικιστάν",
        "Austria": "Αυστρία",
        "Bolivia": "Βολιβία",
        "Sudan": "Σουδάν",
        "Suriname": "Σουρινάμ",
        "Iraq": "Ιράκ",
        "Bahrain": "Μπαχρέιν",
        "Colombia": "Κολομβία",
        "Papua New Guinea": "Παπούα Νέα Γουινέα",
        "Yemen": "Υεμένη",
        "Venezuela": "Βενεζουέλα",
        "Djibouti": "Τζιμπουτί",
        "British Indian Ocean Territory": "Βρετανικά Εδάφη Ινδικού Ωκεανού",
        "Chad": "Τσαντ",
        "Germany": "Γερμανία",
        "Fiji": "Φίτζι",
        "British Virgin Islands": "Βρετανικές Παρθένοι Νήσοι",
        "San Marino": "Άγιος Μαρίνος",
        "Vietnam": "Βιετνάμ",
        "Macau": "Μακάο",
        "South Africa": "Νότια Αφρική",
        "Eritrea": "Ερυθραία",
        "Greece": "Ελλάδα",
        "Ethiopia": "Αιθιοπία",
        "Madagascar": "Μαδαγασκάρη",
        "Marshall Islands": "Νήσοι Μάρσαλ",
        "United States": "Ηνωμένες Πολιτείες",
        "Benin": "Μπενίν",
        "El Salvador": "Ελ Σαλβαδόρ",
        "Lebanon": "Λίβανος",
        "Palestine": "Παλαιστίνη",
        "Tuvalu": "Τουβαλού",
        "Solomon Islands": "Νήσοι Σολομώντος",
        "China": "Κίνα",
        "Tonga": "Τόνγκα"
    },
};
export const csCZ = {
    searchNotFound: "Země nenalezena",
    searchPlaceholder: "Vyhledat zemi",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambie",
        "Equatorial Guinea": "Rovníková Guinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamajka",
        "Seychelles": "Seychely",
        "Comoros": "Komory",
        "U.S. Virgin Islands": "Americké Panenské ostrovy",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libye",
        "Romania": "Rumunsko",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Indie",
        "Ireland": "Irsko",
        "Turkey": "Turecko",
        "Oman": "Omán",
        "Ukraine": "Ukrajina",
        "Spain": "Španělsko",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Svatý Vincenc a Grenadiny",
        "Cyprus": "Kypr",
        "Belarus": "Bělorusko",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Spojené arabské emiráty",
        "São Tomé and Príncipe": "Svatý Tomáš a Princův ostrov",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Portoriko",
        "Portugal": "Portugalsko",
        "Costa Rica": "Kostarika",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kapverdy",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Arménie",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Pobřeží slonoviny",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mosambik",
        "Poland": "Polsko",
        "French Polynesia": "Francouzská Polynésie",
        "Jersey": "Jersey",
        "Kuwait": "Kuvajt",
        "Dominican Republic": "Dominikánská republika",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kyrgyzstán",
        "Syria": "Sýrie",
        "Zambia": "Zambie",
        "Croatia": "Chorvatsko",
        "Lithuania": "Litva",
        "Albania": "Albánie",
        "Netherlands": "Nizozemsko",
        "France": "Francie",
        "Tunisia": "Tunisko",
        "Bosnia and Herzegovina": "Bosna a Hercegovina",
        "Bahamas": "Bahamy",
        "Somalia": "Somálsko",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Francouzská Guyana",
        "Jordan": "Jordánsko",
        "Serbia": "Srbsko",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Tchaj-wan",
        "Central African Republic": "Středoafrická republika",
        "Luxembourg": "Lucembursko",
        "Trinidad and Tobago": "Trinidad a Tobago",
        "Estonia": "Estonsko",
        "Montserrat": "Montserrat",
        "Norway": "Norsko",
        "North Korea": "Severní Korea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Srí Lanka",
        "Faroe Islands": "Faerské ostrovy",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandy",
        "Namibia": "Namibie",
        "Saint Lucia": "Svatá Lucie",
        "Indonesia": "Indonésie",
        "Timor-Leste": "Východní Timor",
        "Norfolk Island": "Norfolk",
        "Bhutan": "Bhútán",
        "Iran": "Írán",
        "Turkmenistan": "Turkmenistán",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazachstán",
        "Cook Islands": "Cookovy ostrovy",
        "Micronesia": "Mikronésie",
        "Sint Maarten": "Svatý Martin",
        "Liberia": "Libérie",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipíny",
        "Rwanda": "Rwanda",
        "United Kingdom": "Spojené království",
        "Martinique": "Martinik",
        "Nepal": "Nepál",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermudy",
        "Australia": "Austrálie",
        "Vatican City": "Vatikán",
        "Slovenia": "Slovinsko",
        "Cayman Islands": "Kajmanské ostrovy",
        "Hungary": "Maďarsko",
        "American Samoa": "Americká Samoa",
        "Mauritania": "Mauritánie",
        "Japan": "Japonsko",
        "Uzbekistan": "Uzbekistán",
        "Cambodia": "Kambodža",
        "Wallis & Futuna": "Wallis a Futuna",
        "South Sudan": "Jižní Súdán",
        "Morocco": "Maroko",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Katar",
        "Tanzania": "Tanzanie",
        "Mexico": "Mexiko",
        "Russia": "Rusko",
        "Iceland": "Island",
        "Monaco": "Monako",
        "Afghanistan": "Afghánistán",
        "Slovakia": "Slovensko",
        "Sweden": "Švédsko",
        "Azerbaijan": "Ázerbájdžán",
        "Bangladesh": "Bangladéš",
        "Brazil": "Brazílie",
        "Cuba": "Kuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolsko",
        "Saint Kitts and Nevis": "Svatý Kryštof a Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nikaragua",
        "Malaysia": "Malajsie",
        "Uruguay": "Uruguay",
        "Brunei": "Brunej",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Severní Mariany",
        "Pakistan": "Pákistán",
        "Greenland": "Grónsko",
        "Mauritius": "Mauricius",
        "Caribbean Netherlands": "Karibské Nizozemsko",
        "Belize": "Belize",
        "Liechtenstein": "Lichtenštejnsko",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Česká republika",
        "Moldova": "Moldavsko",
        "Singapore": "Singapur",
        "Belgium": "Belgie",
        "Maldives": "Maledivy",
        "New Zealand": "Nový Zéland",
        "South Korea": "Jižní Korea",
        "Italy": "Itálie",
        "Israel": "Izrael",
        "Grenada": "Grenada",
        "Kenya": "Keňa",
        "St. Helena": "Svatá Helena",
        "Guam": "Guam",
        "Denmark": "Dánsko",
        "New Caledonia": "Nová Kaledonie",
        "Ecuador": "Ekvádor",
        "Canada": "Kanada",
        "Egypt": "Egypt",
        "Saudi Arabia": "Saúdská Arábie",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks a Caicos",
        "Latvia": "Lotyšsko",
        "St. Pierre & Miquelon": "Saint Pierre a Miquelon",
        "Georgia": "Gruzie",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thajsko",
        "Algeria": "Alžírsko",
        "Finland": "Finsko",
        "Macedonia": "Severní Makedonie",
        "Antigua and Barbuda": "Antigua a Barbuda",
        "Nigeria": "Nigérie",
        "Switzerland": "Švýcarsko",
        "Bulgaria": "Bulharsko",
        "Montenegro": "Černá Hora",
        "Tajikistan": "Tádžikistán",
        "Austria": "Rakousko",
        "Bolivia": "Bolívie",
        "Sudan": "Súdán",
        "Suriname": "Surinam",
        "Iraq": "Irák",
        "Bahrain": "Bahrajn",
        "Colombia": "Kolumbie",
        "Papua New Guinea": "Papua-Nová Guinea",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Džibutsko",
        "British Indian Ocean Territory": "Britské indickooceánské území",
        "Chad": "Čad",
        "Germany": "Německo",
        "Fiji": "Fidži",
        "British Virgin Islands": "Britské Panenské ostrovy",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Jihoafrická republika",
        "Eritrea": "Eritrea",
        "Greece": "Řecko",
        "Ethiopia": "Etiopie",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshallovy ostrovy",
        "United States": "Spojené státy",
        "Benin": "Benin",
        "El Salvador": "Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Šalamounovy ostrovy",
        "China": "Čína",
        "Tonga": "Tonga"
    },
};
export const trTR = {
    searchNotFound: "Ülke bulunamadı",
    searchPlaceholder: "Ülke arayın",
    countries: {
        "Gibraltar": "Cebelitarık",
        "Gambia": "Gambiya",
        "Equatorial Guinea": "Ekvator Ginesi",
        "Senegal": "Senegal",
        "Jamaica": "Jamaika",
        "Seychelles": "Seyşeller",
        "Comoros": "Komorlar",
        "U.S. Virgin Islands": "ABD Virgin Adaları",
        "Guinea": "Gine",
        "Niger": "Nijer",
        "Libya": "Libya",
        "Romania": "Romanya",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Hindistan",
        "Ireland": "İrlanda",
        "Turkey": "Türkiye",
        "Oman": "Umman",
        "Ukraine": "Ukrayna",
        "Spain": "İspanya",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent ve Grenadinler",
        "Cyprus": "Kıbrıs",
        "Belarus": "Beyaz Rusya",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Şili",
        "United Arab Emirates": "Birleşik Arap Emirlikleri",
        "São Tomé and Príncipe": "São Tomé ve Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Porto Riko",
        "Portugal": "Portekiz",
        "Costa Rica": "Kosta Rika",
        "Swaziland": "Esvatini",
        "Cape Verde": "Yeşil Burun Adaları",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Ermenistan",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Fildişi Sahili",
        "Guinea-Bissau": "Gine-Bissau",
        "Mozambique": "Mozambik",
        "Poland": "Polonya",
        "French Polynesia": "Fransız Polinezyası",
        "Jersey": "Jersey",
        "Kuwait": "Kuveyt",
        "Dominican Republic": "Dominik Cumhuriyeti",
        "Kosovo": "Kosova",
        "Kyrgyzstan": "Kırgızistan",
        "Syria": "Suriye",
        "Zambia": "Zambiya",
        "Croatia": "Hırvatistan",
        "Lithuania": "Litvanya",
        "Albania": "Arnavutluk",
        "Netherlands": "Hollanda",
        "France": "Fransa",
        "Tunisia": "Tunus",
        "Bosnia and Herzegovina": "Bosna-Hersek",
        "Bahamas": "Bahamalar",
        "Somalia": "Somali",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malavi",
        "Honduras": "Honduras",
        "French Guiana": "Fransız Guyanası",
        "Jordan": "Ürdün",
        "Serbia": "Sırbistan",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesoto",
        "Taiwan": "Tayvan",
        "Central African Republic": "Orta Afrika Cumhuriyeti",
        "Luxembourg": "Lüksemburg",
        "Trinidad and Tobago": "Trinidad ve Tobago",
        "Estonia": "Estonya",
        "Montserrat": "Montserrat",
        "Norway": "Norveç",
        "North Korea": "Kuzey Kore",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Faroe Adaları",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falkland Adaları",
        "Namibia": "Namibya",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Endonezya",
        "Timor-Leste": "Doğu Timor",
        "Norfolk Island": "Norfolk Adası",
        "Bhutan": "Butan",
        "Iran": "İran",
        "Turkmenistan": "Türkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakistan",
        "Cook Islands": "Cook Adaları",
        "Micronesia": "Mikronezya",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberya",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipinler",
        "Rwanda": "Ruanda",
        "United Kingdom": "Birleşik Krallık",
        "Martinique": "Martinik",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Avustralya",
        "Vatican City": "Vatikan",
        "Slovenia": "Slovenya",
        "Cayman Islands": "Cayman Adaları",
        "Hungary": "Macaristan",
        "American Samoa": "Amerikan Samoası",
        "Mauritania": "Moritanya",
        "Japan": "Japonya",
        "Uzbekistan": "Özbekistan",
        "Cambodia": "Kamboçya",
        "Wallis & Futuna": "Wallis ve Futuna",
        "South Sudan": "Güney Sudan",
        "Morocco": "Fas",
        "Argentina": "Arjantin",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Katar",
        "Tanzania": "Tanzanya",
        "Mexico": "Meksika",
        "Russia": "Rusya",
        "Iceland": "İzlanda",
        "Monaco": "Monako",
        "Afghanistan": "Afganistan",
        "Slovakia": "Slovakya",
        "Sweden": "İsveç",
        "Azerbaijan": "Azerbaycan",
        "Bangladesh": "Bangladeş",
        "Brazil": "Brezilya",
        "Cuba": "Küba",
        "Ghana": "Gana",
        "Mongolia": "Moğolistan",
        "Saint Kitts and Nevis": "Saint Kitts ve Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nikaragua",
        "Malaysia": "Malezya",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Kuzey Mariana Adaları",
        "Pakistan": "Pakistan",
        "Greenland": "Grönland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Karayip Hollanda",
        "Belize": "Belize",
        "Liechtenstein": "Lihtenştayn",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Çek Cumhuriyeti",
        "Moldova": "Moldova",
        "Singapore": "Singapur",
        "Belgium": "Belçika",
        "Maldives": "Maldivler",
        "New Zealand": "Yeni Zelanda",
        "South Korea": "Güney Kore",
        "Italy": "İtalya",
        "Israel": "İsrail",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Saint Helena",
        "Guam": "Guam",
        "Denmark": "Danimarka",
        "New Caledonia": "Yeni Kaledonya",
        "Ecuador": "Ekvador",
        "Canada": "Kanada",
        "Egypt": "Mısır",
        "Saudi Arabia": "Suudi Arabistan",
        "Botswana": "Botsvana",
        "Turks & Caicos Islands": "Turks ve Caicos Adaları",
        "Latvia": "Letonya",
        "St. Pierre & Miquelon": "Saint Pierre ve Miquelon",
        "Georgia": "Gürcistan",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabve",
        "Thailand": "Tayland",
        "Algeria": "Cezayir",
        "Finland": "Finlandiya",
        "Macedonia": "Kuzey Makedonya",
        "Antigua and Barbuda": "Antigua ve Barbuda",
        "Nigeria": "Nijerya",
        "Switzerland": "İsviçre",
        "Bulgaria": "Bulgaristan",
        "Montenegro": "Karadağ",
        "Tajikistan": "Tacikistan",
        "Austria": "Avusturya",
        "Bolivia": "Bolivya",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahreyn",
        "Colombia": "Kolombiya",
        "Papua New Guinea": "Papua Yeni Gine",
        "Yemen": "Yemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Cibuti",
        "British Indian Ocean Territory": "Britanya Hint Okyanusu Toprağı",
        "Chad": "Çad",
        "Germany": "Almanya",
        "Fiji": "Fiji",
        "British Virgin Islands": "Britanya Virjin Adaları",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Makao",
        "South Africa": "Güney Afrika",
        "Eritrea": "Eritre",
        "Greece": "Yunanistan",
        "Ethiopia": "Etiyopya",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshall Adaları",
        "United States": "Amerika Birleşik Devletleri",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Lübnan",
        "Palestine": "Filistin",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Solomon Adaları",
        "China": "Çin",
        "Tonga": "Tonga"
    },
};
export const viVN = {
    searchNotFound: "Không tìm thấy quốc gia",
    searchPlaceholder: "Tìm kiếm quốc gia",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Guinea Xích Đạo",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychelles",
        "Comoros": "Comoros",
        "U.S. Virgin Islands": "Quần đảo Virgin thuộc Mỹ",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libya",
        "Romania": "Rumani",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Ấn Độ",
        "Ireland": "Ireland",
        "Turkey": "Thổ Nhĩ Kỳ",
        "Oman": "Oman",
        "Ukraine": "Ukraine",
        "Spain": "Tây Ban Nha",
        "Cameroon": "Cameroon",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent và Grenadines",
        "Cyprus": "Síp",
        "Belarus": "Belarus",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Các Tiểu Vương quốc Ả Rập Thống nhất",
        "São Tomé and Príncipe": "São Tomé và Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Bồ Đào Nha",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cabo Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Bờ Biển Ngà",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mozambique",
        "Poland": "Ba Lan",
        "French Polynesia": "Polynesia thuộc Pháp",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Cộng hòa Dominica",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kyrgyzstan",
        "Syria": "Syria",
        "Zambia": "Zambia",
        "Croatia": "Croatia",
        "Lithuania": "Litva",
        "Albania": "Albania",
        "Netherlands": "Hà Lan",
        "France": "Pháp",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosna và Herzegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Guiana thuộc Pháp",
        "Jordan": "Jordan",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Đài Loan",
        "Central African Republic": "Cộng hòa Trung Phi",
        "Luxembourg": "Luxembourg",
        "Trinidad and Tobago": "Trinidad và Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Na Uy",
        "North Korea": "Triều Tiên",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Quần đảo Faroe",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Quần đảo Falkland",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Đông Timor",
        "Norfolk Island": "Đảo Norfolk",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakhstan",
        "Cook Islands": "Quần đảo Cook",
        "Micronesia": "Micronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Philippines",
        "Rwanda": "Rwanda",
        "United Kingdom": "Vương quốc Anh",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Úc",
        "Vatican City": "Vatican",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Quần đảo Cayman",
        "Hungary": "Hungary",
        "American Samoa": "Samoa thuộc Mỹ",
        "Mauritania": "Mauritania",
        "Japan": "Nhật Bản",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Campuchia",
        "Wallis & Futuna": "Wallis và Futuna",
        "South Sudan": "Nam Sudan",
        "Morocco": "Maroc",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hồng Kông",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexico",
        "Russia": "Nga",
        "Iceland": "Iceland",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovakia",
        "Sweden": "Thụy Điển",
        "Azerbaijan": "Azerbaijan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brazil",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mông Cổ",
        "Saint Kitts and Nevis": "Saint Kitts và Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Quần đảo Bắc Mariana",
        "Pakistan": "Pakistan",
        "Greenland": "Greenland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Caribbean Hà Lan",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Cộng hòa Séc",
        "Moldova": "Moldova",
        "Singapore": "Singapore",
        "Belgium": "Bỉ",
        "Maldives": "Maldives",
        "New Zealand": "New Zealand",
        "South Korea": "Hàn Quốc",
        "Italy": "Ý",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Saint Helena",
        "Guam": "Guam",
        "Denmark": "Đan Mạch",
        "New Caledonia": "New Caledonia",
        "Ecuador": "Ecuador",
        "Canada": "Canada",
        "Egypt": "Ai Cập",
        "Saudi Arabia": "Ả Rập Xê Út",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Quần đảo Turks và Caicos",
        "Latvia": "Latvia",
        "St. Pierre & Miquelon": "Saint Pierre và Miquelon",
        "Georgia": "Gruzia",
        "Laos": "Lào",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thái Lan",
        "Algeria": "Algeria",
        "Finland": "Phần Lan",
        "Macedonia": "Bắc Macedonia",
        "Antigua and Barbuda": "Antigua và Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Thụy Sĩ",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tajikistan",
        "Austria": "Áo",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Suriname",
        "Iraq": "Iraq",
        "Bahrain": "Bahrain",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papua New Guinea",
        "Yemen": "Yemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Lãnh thổ Ấn Độ Dương thuộc Anh",
        "Chad": "Chad",
        "Germany": "Đức",
        "Fiji": "Fiji",
        "British Virgin Islands": "Quần đảo Virgin thuộc Anh",
        "San Marino": "San Marino",
        "Vietnam": "Việt Nam",
        "Macau": "Ma Cao",
        "South Africa": "Nam Phi",
        "Eritrea": "Eritrea",
        "Greece": "Hy Lạp",
        "Ethiopia": "Ethiopia",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Quần đảo Marshall",
        "United States": "Hoa Kỳ",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Liban",
        "Palestine": "Palestine",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Quần đảo Solomon",
        "China": "Trung Quốc",
        "Tonga": "Tonga"
    },
};
export const arSD = {
    searchNotFound: "لم يتم العثور على أي بلد",
    searchPlaceholder: "ابحث عن بلد",
    countries: {
        "Gibraltar": "جبل طارق",
        "Gambia": "غامبيا",
        "Equatorial Guinea": "غينيا الاستوائية",
        "Senegal": "السنغال",
        "Jamaica": "جامايكا",
        "Seychelles": "سيشل",
        "Comoros": "جزر القمر",
        "U.S. Virgin Islands": "جزر فيرجن الأمريكية",
        "Guinea": "غينيا",
        "Niger": "النيجر",
        "Libya": "ليبيا",
        "Romania": "رومانيا",
        "Anguilla": "أنغويلا",
        "Togo": "توغو",
        "Paraguay": "باراغواي",
        "India": "الهند",
        "Ireland": "أيرلندا",
        "Turkey": "تركيا",
        "Oman": "عمان",
        "Ukraine": "أوكرانيا",
        "Spain": "إسبانيا",
        "Cameroon": "الكاميرون",
        "Angola": "أنغولا",
        "Mali": "مالي",
        "Saint Vincent and the Grenadines": "سانت فينسنت والغرينادين",
        "Cyprus": "قبرص",
        "Belarus": "بيلاروسيا",
        "Gabon": "الغابون",
        "Samoa": "ساموا",
        "Chile": "تشيلي",
        "United Arab Emirates": "الإمارات العربية المتحدة",
        "São Tomé and Príncipe": "ساو تومي وبرينسيبي",
        "Palau": "بالاو",
        "Tokelau": "توكيلاو",
        "Puerto Rico": "بورتوريكو",
        "Portugal": "البرتغال",
        "Costa Rica": "كوستاريكا",
        "Swaziland": "إسواتيني",
        "Cape Verde": "الرأس الأخضر",
        "Curaçao": "كوراساو",
        "Andorra": "أندورا",
        "Armenia": "أرمينيا",
        "Haiti": "هايتي",
        "Côte d’Ivoire": "ساحل العاج",
        "Guinea-Bissau": "غينيا بيساو",
        "Mozambique": "موزمبيق",
        "Poland": "بولندا",
        "French Polynesia": "بولينيزيا الفرنسية",
        "Jersey": "جيرسي",
        "Kuwait": "الكويت",
        "Dominican Republic": "جمهورية الدومينيكان",
        "Kosovo": "كوسوفو",
        "Kyrgyzstan": "قيرغيزستان",
        "Syria": "سوريا",
        "Zambia": "زامبيا",
        "Croatia": "كرواتيا",
        "Lithuania": "ليتوانيا",
        "Albania": "ألبانيا",
        "Netherlands": "هولندا",
        "France": "فرنسا",
        "Tunisia": "تونس",
        "Bosnia and Herzegovina": "البوسنة والهرسك",
        "Bahamas": "الباهاما",
        "Somalia": "الصومال",
        "Burundi": "بوروندي",
        "Barbados": "باربادوس",
        "Malawi": "مالاوي",
        "Honduras": "هندوراس",
        "French Guiana": "غويانا الفرنسية",
        "Jordan": "الأردن",
        "Serbia": "صربيا",
        "Vanuatu": "فانواتو",
        "Aruba": "أروبا",
        "Guyana": "غيانا",
        "Lesotho": "ليسوتو",
        "Taiwan": "تايوان",
        "Central African Republic": "جمهورية أفريقيا الوسطى",
        "Luxembourg": "لوكسمبورغ",
        "Trinidad and Tobago": "ترينيداد وتوباغو",
        "Estonia": "إستونيا",
        "Montserrat": "مونتسرات",
        "Norway": "النرويج",
        "North Korea": "كوريا الشمالية",
        "Myanmar": "ميانمار",
        "Sri Lanka": "سريلانكا",
        "Faroe Islands": "جزر فارو",
        "Dominica": "دومينيكا",
        "Kiribati": "كيريباتي",
        "Falkland Islands": "جزر فوكلاند",
        "Namibia": "ناميبيا",
        "Saint Lucia": "سانت لوسيا",
        "Indonesia": "إندونيسيا",
        "Timor-Leste": "تيمور الشرقية",
        "Norfolk Island": "جزيرة نورفولك",
        "Bhutan": "بوتان",
        "Iran": "إيران",
        "Turkmenistan": "تركمانستان",
        "Uganda": "أوغندا",
        "Kazakhstan": "كازاخستان",
        "Cook Islands": "جزر كوك",
        "Micronesia": "ميكرونيزيا",
        "Sint Maarten": "سينت مارتن",
        "Liberia": "ليبيريا",
        "Panama": "بنما",
        "Malta": "مالطا",
        "Peru": "بيرو",
        "Philippines": "الفلبين",
        "Rwanda": "رواندا",
        "United Kingdom": "المملكة المتحدة",
        "Martinique": "مارتينيك",
        "Nepal": "نيبال",
        "Guatemala": "غواتيمالا",
        "Bermuda": "برمودا",
        "Australia": "أستراليا",
        "Vatican City": "الفاتيكان",
        "Slovenia": "سلوفينيا",
        "Cayman Islands": "جزر كايمان",
        "Hungary": "هنغاريا",
        "American Samoa": "ساموا الأمريكية",
        "Mauritania": "موريتانيا",
        "Japan": "اليابان",
        "Uzbekistan": "أوزبكستان",
        "Cambodia": "كمبوديا",
        "Wallis & Futuna": "واليس وفوتونا",
        "South Sudan": "جنوب السودان",
        "Morocco": "المغرب",
        "Argentina": "الأرجنتين",
        "Guadeloupe": "جوادلوب",
        "Hong Kong": "هونغ كونغ",
        "Qatar": "قطر",
        "Tanzania": "تنزانيا",
        "Mexico": "المكسيك",
        "Russia": "روسيا",
        "Iceland": "آيسلندا",
        "Monaco": "موناكو",
        "Afghanistan": "أفغانستان",
        "Slovakia": "سلوفاكيا",
        "Sweden": "السويد",
        "Azerbaijan": "أذربيجان",
        "Bangladesh": "بنغلاديش",
        "Brazil": "البرازيل",
        "Cuba": "كوبا",
        "Ghana": "غانا",
        "Mongolia": "منغوليا",
        "Saint Kitts and Nevis": "سانت كيتس ونيفيس",
        "Burkina Faso": "بوركينا فاسو",
        "Nicaragua": "نيكاراغوا",
        "Malaysia": "ماليزيا",
        "Uruguay": "أوروغواي",
        "Brunei": "بروناي",
        "Congo": "الكونغو",
        "Nauru": "ناورو",
        "Northern Mariana Islands": "جزر ماريانا الشمالية",
        "Pakistan": "باكستان",
        "Greenland": "غرينلاند",
        "Mauritius": "موريشيوس",
        "Caribbean Netherlands": "هولندا الكاريبية",
        "Belize": "بليز",
        "Liechtenstein": "ليختنشتاين",
        "Sierra Leone": "سيراليون",
        "Czech Republic": "جمهورية التشيك",
        "Moldova": "مولدوفا",
        "Singapore": "سنغافورة",
        "Belgium": "بلجيكا",
        "Maldives": "المالديف",
        "New Zealand": "نيوزيلندا",
        "South Korea": "كوريا الجنوبية",
        "Italy": "إيطاليا",
        "Israel": "إسرائيل",
        "Grenada": "غرينادا",
        "Kenya": "كينيا",
        "St. Helena": "سانت هيلينا",
        "Guam": "غوام",
        "Denmark": "الدنمارك",
        "New Caledonia": "كاليدونيا الجديدة",
        "Ecuador": "الإكوادور",
        "Canada": "كندا",
        "Egypt": "مصر",
        "Saudi Arabia": "المملكة العربية السعودية",
        "Botswana": "بوتسوانا",
        "Turks & Caicos Islands": "جزر توركس وكايكوس",
        "Latvia": "لاتفيا",
        "St. Pierre & Miquelon": "سان بيير وميكلون",
        "Georgia": "جورجيا",
        "Laos": "لاوس",
        "Réunion": "ريونيون",
        "Niue": "نيوي",
        "Zimbabwe": "زيمبابوي",
        "Thailand": "تايلاند",
        "Algeria": "الجزائر",
        "Finland": "فنلندا",
        "Macedonia": "مقدونيا الشمالية",
        "Antigua and Barbuda": "أنتيغوا وباربودا",
        "Nigeria": "نيجيريا",
        "Switzerland": "سويسرا",
        "Bulgaria": "بلغاريا",
        "Montenegro": "الجبل الأسود",
        "Tajikistan": "طاجيكستان",
        "Austria": "النمسا",
        "Bolivia": "بوليفيا",
        "Sudan": "السودان",
        "Suriname": "سورينام",
        "Iraq": "العراق",
        "Bahrain": "البحرين",
        "Colombia": "كولومبيا",
        "Papua New Guinea": "بابوا غينيا الجديدة",
        "Yemen": "اليمن",
        "Venezuela": "فنزويلا",
        "Djibouti": "جيبوتي",
        "British Indian Ocean Territory": "إقليم المحيط الهندي البريطاني",
        "Chad": "تشاد",
        "Germany": "ألمانيا",
        "Fiji": "فيجي",
        "British Virgin Islands": "جزر فيرجن البريطانية",
        "San Marino": "سان مارينو",
        "Vietnam": "فيتنام",
        "Macau": "ماكاو",
        "South Africa": "جنوب أفريقيا",
        "Eritrea": "إريتريا",
        "Greece": "اليونان",
        "Ethiopia": "إثيوبيا",
        "Madagascar": "مدغشقر",
        "Marshall Islands": "جزر مارشال",
        "United States": "الولايات المتحدة",
        "Benin": "بنين",
        "El Salvador": "السلفادور",
        "Lebanon": "لبنان",
        "Palestine": "فلسطين",
        "Tuvalu": "توفالو",
        "Solomon Islands": "جزر سليمان",
        "China": "الصين",
        "Tonga": "تونغا"
    },
};
export const urPK = {
    searchNotFound: "کوئی ملک نہیں ملا",
    searchPlaceholder: "ملک تلاش کریں",
    countries: {
        "Gibraltar": "جبل الطارق",
        "Gambia": "گیمبیا",
        "Equatorial Guinea": "استوائی گنی",
        "Senegal": "سینیگال",
        "Jamaica": "جمیکا",
        "Seychelles": "سیشل",
        "Comoros": "کوموروس",
        "U.S. Virgin Islands": "امریکی ورجن آئی لینڈز",
        "Guinea": "گنی",
        "Niger": "نائیجر",
        "Libya": "لیبیا",
        "Romania": "رومانیہ",
        "Anguilla": "انگوئلا",
        "Togo": "ٹوگو",
        "Paraguay": "پیراگوئے",
        "India": "بھارت",
        "Ireland": "آئرلینڈ",
        "Turkey": "ترکی",
        "Oman": "عمان",
        "Ukraine": "یوکرین",
        "Spain": "اسپین",
        "Cameroon": "کیمرون",
        "Angola": "انگولا",
        "Mali": "مالی",
        "Saint Vincent and the Grenadines": "سینٹ ونسنٹ اور گریناڈائنز",
        "Cyprus": "قبرص",
        "Belarus": "بیلاروس",
        "Gabon": "گبون",
        "Samoa": "ساموا",
        "Chile": "چلی",
        "United Arab Emirates": "متحدہ عرب امارات",
        "São Tomé and Príncipe": "ساؤ ٹومے اور پرنسپے",
        "Palau": "پالا",
        "Tokelau": "ٹوکیلاؤ",
        "Puerto Rico": "پیورٹو ریکو",
        "Portugal": "پرتگال",
        "Costa Rica": "کوسٹا ریکا",
        "Swaziland": "سواتینی",
        "Cape Verde": "کیپ وردے",
        "Curaçao": "کیوراساؤ",
        "Andorra": "انڈورا",
        "Armenia": "آرمینیا",
        "Haiti": "ہیٹی",
        "Côte d’Ivoire": "آئیوری کوسٹ",
        "Guinea-Bissau": "گنی بساؤ",
        "Mozambique": "موزمبیق",
        "Poland": "پولینڈ",
        "French Polynesia": "فرانسیسی پولینیشیا",
        "Jersey": "جرسی",
        "Kuwait": "کویت",
        "Dominican Republic": "جمہوریہ ڈومینیکن",
        "Kosovo": "کوسوو",
        "Kyrgyzstan": "کرغزستان",
        "Syria": "شام",
        "Zambia": "زامبیا",
        "Croatia": "کروشیا",
        "Lithuania": "لیتھوانیا",
        "Albania": "البانیا",
        "Netherlands": "نیدرلینڈز",
        "France": "فرانس",
        "Tunisia": "تونس",
        "Bosnia and Herzegovina": "بوسنیا اور ہرزیگووینا",
        "Bahamas": "بہاماس",
        "Somalia": "صومالیہ",
        "Burundi": "برونڈی",
        "Barbados": "بارباڈوس",
        "Malawi": "مالاوی",
        "Honduras": "ہونڈوراس",
        "French Guiana": "فرانسیسی گیانا",
        "Jordan": "اردن",
        "Serbia": "سربیا",
        "Vanuatu": "وانواتو",
        "Aruba": "اروبا",
        "Guyana": "گیانا",
        "Lesotho": "لیسوتھو",
        "Taiwan": "تائیوان",
        "Central African Republic": "وسطی افریقی جمہوریہ",
        "Luxembourg": "لکسمبرگ",
        "Trinidad and Tobago": "ترینیداد اور ٹوباگو",
        "Estonia": "اسٹونیا",
        "Montserrat": "مانٹسیرات",
        "Norway": "ناروے",
        "North Korea": "شمالی کوریا",
        "Myanmar": "میانمار",
        "Sri Lanka": "سری لنکا",
        "Faroe Islands": "جزائر فارو",
        "Dominica": "ڈومینیکا",
        "Kiribati": "کریباتی",
        "Falkland Islands": "جزائر فاک لینڈ",
        "Namibia": "نمیبیا",
        "Saint Lucia": "سینٹ لوشیا",
        "Indonesia": "انڈونیشیا",
        "Timor-Leste": "مشرقی تیمور",
        "Norfolk Island": "جزیرہ نورفولک",
        "Bhutan": "بھوٹان",
        "Iran": "ایران",
        "Turkmenistan": "ترکمانستان",
        "Uganda": "یوگنڈا",
        "Kazakhstan": "قازقستان",
        "Cook Islands": "جزائر کک",
        "Micronesia": "مائکرونیشیا",
        "Sint Maarten": "سنٹ مارٹن",
        "Liberia": "لائبیریا",
        "Panama": "پانامہ",
        "Malta": "مالٹا",
        "Peru": "پیرو",
        "Philippines": "فلپائن",
        "Rwanda": "روانڈا",
        "United Kingdom": "برطانیہ",
        "Martinique": "مارٹینیک",
        "Nepal": "نیپال",
        "Guatemala": "گواٹے مالا",
        "Bermuda": "برمودا",
        "Australia": "آسٹریلیا",
        "Vatican City": "ویٹیکن سٹی",
        "Slovenia": "سلووینیا",
        "Cayman Islands": "جزائر کیمین",
        "Hungary": "ہنگری",
        "American Samoa": "امریکی ساموا",
        "Mauritania": "موریطانیہ",
        "Japan": "جاپان",
        "Uzbekistan": "ازبکستان",
        "Cambodia": "کمبوڈیا",
        "Wallis & Futuna": "ویلس اور فتونہ",
        "South Sudan": "جنوبی سوڈان",
        "Morocco": "مراکش",
        "Argentina": "ارجنٹائن",
        "Guadeloupe": "گواڈیلوپ",
        "Hong Kong": "ہانگ کانگ",
        "Qatar": "قطر",
        "Tanzania": "تنزانیہ",
        "Mexico": "میکسیکو",
        "Russia": "روس",
        "Iceland": "آئس لینڈ",
        "Monaco": "موناکو",
        "Afghanistan": "افغانستان",
        "Slovakia": "سلوواکیہ",
        "Sweden": "سویڈن",
        "Azerbaijan": "آذربائیجان",
        "Bangladesh": "بنگلہ دیش",
        "Brazil": "برازیل",
        "Cuba": "کیوبا",
        "Ghana": "گھانا",
        "Mongolia": "منگولیا",
        "Saint Kitts and Nevis": "سینٹ کٹس اور نیوس",
        "Burkina Faso": "برکینا فاسو",
        "Nicaragua": "نکاراگوا",
        "Malaysia": "ملائیشیا",
        "Uruguay": "یوروگوئے",
        "Brunei": "برونائی",
        "Congo": "کانگو",
        "Nauru": "ناؤرو",
        "Northern Mariana Islands": "شمالی ماریانا آئلینڈز",
        "Pakistan": "پاکستان",
        "Greenland": "گرین لینڈ",
        "Mauritius": "ماریشس",
        "Caribbean Netherlands": "کیریبین نیدرلینڈ",
        "Belize": "بیلیز",
        "Liechtenstein": "لیچٹنسٹائن",
        "Sierra Leone": "سیرا لیون",
        "Czech Republic": "چیک جمہوریہ",
        "Moldova": "مالدووا",
        "Singapore": "سنگاپور",
        "Belgium": "بیلجیم",
        "Maldives": "مالدیپ",
        "New Zealand": "نیوزی لینڈ",
        "South Korea": "جنوبی کوریا",
        "Italy": "اٹلی",
        "Israel": "اسرائیل",
        "Grenada": "گریناڈا",
        "Kenya": "کینیا",
        "St. Helena": "سینٹ ہیلینا",
        "Guam": "گوام",
        "Denmark": "ڈنمارک",
        "New Caledonia": "نیو کیلیڈونیا",
        "Ecuador": "ایکواڈور",
        "Canada": "کینیڈا",
        "Egypt": "مصر",
        "Saudi Arabia": "سعودی عرب",
        "Botswana": "بوٹسوانا",
        "Turks & Caicos Islands": "ترکس اور کیکوس آئلینڈز",
        "Latvia": "لیٹویا",
        "St. Pierre & Miquelon": "سینٹ پیئر اور میکلون",
        "Georgia": "جارجیا",
        "Laos": "لاؤس",
        "Réunion": "ری یونین",
        "Niue": "نیوے",
        "Zimbabwe": "زمبابوے",
        "Thailand": "تھائی لینڈ",
        "Algeria": "الجزائر",
        "Finland": "فن لینڈ",
        "Macedonia": "شمالی مقدونیہ",
        "Antigua and Barbuda": "انٹیگوا اور باربوڈا",
        "Nigeria": "نائجیریا",
        "Switzerland": "سوئٹزرلینڈ",
        "Bulgaria": "بلغاریہ",
        "Montenegro": "مونٹینیگرو",
        "Tajikistan": "تاجکستان",
        "Austria": "آسٹریا",
        "Bolivia": "بولیویا",
        "Sudan": "سوڈان",
        "Suriname": "سورینام",
        "Iraq": "عراق",
        "Bahrain": "بحرین",
        "Colombia": "کولمبیا",
        "Papua New Guinea": "پاپوا نیو گنی",
        "Yemen": "یمن",
        "Venezuela": "وینزویلا",
        "Djibouti": "جبوتی",
        "British Indian Ocean Territory": "برطانوی بحرہند کا علاقہ",
        "Chad": "چاڈ",
        "Germany": "جرمنی",
        "Fiji": "فجی",
        "British Virgin Islands": "برطانوی ورجن آئی لینڈز",
        "San Marino": "سان مارینو",
        "Vietnam": "ویتنام",
        "Macau": "مکاؤ",
        "South Africa": "جنوبی افریقہ",
        "Eritrea": "اریٹیریا",
        "Greece": "یونان",
        "Ethiopia": "ایتھوپیا",
        "Madagascar": "مڈغاسکر",
        "Marshall Islands": "جزائر مارشل",
        "United States": "ریاستہائے متحدہ",
        "Benin": "بینن",
        "El Salvador": "ال سلواڈور",
        "Lebanon": "لبنان",
        "Palestine": "فلسطین",
        "Tuvalu": "توالو",
        "Solomon Islands": "جزائر سلیمان",
        "China": "چین",
        "Tonga": "ٹونگا"
    },
};
export const roRO = {
    searchNotFound: "Țara nu a fost găsită",
    searchPlaceholder: "Căutați o țară",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Guineea Ecuatorială",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychelles",
        "Comoros": "Comore",
        "U.S. Virgin Islands": "Insulele Virgine Americane",
        "Guinea": "Guineea",
        "Niger": "Niger",
        "Libya": "Libia",
        "Romania": "România",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Irlanda",
        "Turkey": "Turcia",
        "Oman": "Oman",
        "Ukraine": "Ucraina",
        "Spain": "Spania",
        "Cameroon": "Camerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Sfântul Vincențiu și Grenadine",
        "Cyprus": "Cipru",
        "Belarus": "Belarus",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Emiratele Arabe Unite",
        "São Tomé and Príncipe": "São Tomé și Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugalia",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Capul Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Côte d'Ivoire",
        "Guinea-Bissau": "Guineea-Bissau",
        "Mozambique": "Mozambic",
        "Poland": "Polonia",
        "French Polynesia": "Polinezia Franceză",
        "Jersey": "Jersey",
        "Kuwait": "Kuweit",
        "Dominican Republic": "Republica Dominicană",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kârgâzstan",
        "Syria": "Siria",
        "Zambia": "Zambia",
        "Croatia": "Croația",
        "Lithuania": "Lituania",
        "Albania": "Albania",
        "Netherlands": "Țările de Jos",
        "France": "Franța",
        "Tunisia": "Tunisia",
        "Bosnia and Herzegovina": "Bosnia și Herțegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Guyana Franceză",
        "Jordan": "Iordania",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Republica Centrafricană",
        "Luxembourg": "Luxemburg",
        "Trinidad and Tobago": "Trinidad și Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Norvegia",
        "North Korea": "Coreea de Nord",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Insulele Feroe",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Insulele Falkland",
        "Namibia": "Namibia",
        "Saint Lucia": "Sfânta Lucia",
        "Indonesia": "Indonezia",
        "Timor-Leste": "Timorul de Est",
        "Norfolk Island": "Insula Norfolk",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazahstan",
        "Cook Islands": "Insulele Cook",
        "Micronesia": "Micronezia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipine",
        "Rwanda": "Rwanda",
        "United Kingdom": "Regatul Unit",
        "Martinique": "Martinica",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermude",
        "Australia": "Australia",
        "Vatican City": "Orașul Vatican",
        "Slovenia": "Slovenia",
        "Cayman Islands": "Insulele Cayman",
        "Hungary": "Ungaria",
        "American Samoa": "Samoa Americană",
        "Mauritania": "Mauritania",
        "Japan": "Japonia",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Cambodgia",
        "Wallis & Futuna": "Wallis și Futuna",
        "South Sudan": "Sudanul de Sud",
        "Morocco": "Maroc",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadelupa",
        "Hong Kong": "Hong Kong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexic",
        "Russia": "Rusia",
        "Iceland": "Islanda",
        "Monaco": "Monaco",
        "Afghanistan": "Afganistan",
        "Slovakia": "Slovacia",
        "Sweden": "Suedia",
        "Azerbaijan": "Azerbaidjan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brazilia",
        "Cuba": "Cuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Sfântul Kitts și Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaezia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Insulele Mariane de Nord",
        "Pakistan": "Pakistan",
        "Greenland": "Groenlanda",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Țările de Jos Caraibe",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Republica Cehă",
        "Moldova": "Moldova",
        "Singapore": "Singapore",
        "Belgium": "Belgia",
        "Maldives": "Maldive",
        "New Zealand": "Noua Zeelandă",
        "South Korea": "Coreea de Sud",
        "Italy": "Italia",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Sfânta Elena",
        "Guam": "Guam",
        "Denmark": "Danemarca",
        "New Caledonia": "Noua Caledonie",
        "Ecuador": "Ecuador",
        "Canada": "Canada",
        "Egypt": "Egipt",
        "Saudi Arabia": "Arabia Saudită",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Insulele Turks și Caicos",
        "Latvia": "Letonia",
        "St. Pierre & Miquelon": "Saint Pierre și Miquelon",
        "Georgia": "Georgia",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailanda",
        "Algeria": "Algeria",
        "Finland": "Finlanda",
        "Macedonia": "Macedonia de Nord",
        "Antigua and Barbuda": "Antigua și Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Elveția",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Muntenegru",
        "Tajikistan": "Tadjikistan",
        "Austria": "Austria",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrein",
        "Colombia": "Columbia",
        "Papua New Guinea": "Papua Noua Guinee",
        "Yemen": "Yemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Teritoriul Britanic al Oceanului Indian",
        "Chad": "Ciad",
        "Germany": "Germania",
        "Fiji": "Fiji",
        "British Virgin Islands": "Insulele Virgine Britanice",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Africa de Sud",
        "Eritrea": "Eritreea",
        "Greece": "Grecia",
        "Ethiopia": "Etiopia",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Insulele Marshall",
        "United States": "Statele Unite",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Liban",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Insulele Solomon",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const slSI = {
    searchNotFound: "Država ni bila najdena",
    searchPlaceholder: "Išči državo",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambija",
        "Equatorial Guinea": "Ekvatorialna Gvineja",
        "Senegal": "Senegal",
        "Jamaica": "Jamajka",
        "Seychelles": "Sejšeli",
        "Comoros": "Komori",
        "U.S. Virgin Islands": "Ameriški Deviški otoki",
        "Guinea": "Gvineja",
        "Niger": "Niger",
        "Libya": "Libija",
        "Romania": "Romunija",
        "Anguilla": "Angvila",
        "Togo": "Togo",
        "Paraguay": "Paragvaj",
        "India": "Indija",
        "Ireland": "Irska",
        "Turkey": "Turčija",
        "Oman": "Oman",
        "Ukraine": "Ukrajina",
        "Spain": "Španija",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Sveti Vincent in Grenadine",
        "Cyprus": "Ciper",
        "Belarus": "Belorusija",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Čile",
        "United Arab Emirates": "Združeni arabski emirati",
        "São Tomé and Príncipe": "Sao Tome in Principe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Portoriko",
        "Portugal": "Portugalska",
        "Costa Rica": "Kostarika",
        "Swaziland": "Esvatini",
        "Cape Verde": "Zelenortski otoki",
        "Curaçao": "Curacao",
        "Andorra": "Andora",
        "Armenia": "Armenija",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Slonokoščena obala",
        "Guinea-Bissau": "Gvineja Bissau",
        "Mozambique": "Mozambik",
        "Poland": "Poljska",
        "French Polynesia": "Francoska Polinezija",
        "Jersey": "Jersey",
        "Kuwait": "Kuvajt",
        "Dominican Republic": "Dominikanska republika",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgizistan",
        "Syria": "Sirija",
        "Zambia": "Zambija",
        "Croatia": "Hrvaška",
        "Lithuania": "Litva",
        "Albania": "Albanija",
        "Netherlands": "Nizozemska",
        "France": "Francija",
        "Tunisia": "Tunizija",
        "Bosnia and Herzegovina": "Bosna in Hercegovina",
        "Bahamas": "Bahami",
        "Somalia": "Somalija",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malavi",
        "Honduras": "Honduras",
        "French Guiana": "Francoska Gvajana",
        "Jordan": "Jordanija",
        "Serbia": "Srbija",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Gvajana",
        "Lesotho": "Lesoto",
        "Taiwan": "Tajvan",
        "Central African Republic": "Srednjeafriška republika",
        "Luxembourg": "Luksemburg",
        "Trinidad and Tobago": "Trinidad in Tobago",
        "Estonia": "Estonija",
        "Montserrat": "Montserrat",
        "Norway": "Norveška",
        "North Korea": "Severna Koreja",
        "Myanmar": "Mjanmar",
        "Sri Lanka": "Šrilanka",
        "Faroe Islands": "Ferski otoki",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandski otoki",
        "Namibia": "Namibija",
        "Saint Lucia": "Sveta Lucija",
        "Indonesia": "Indonezija",
        "Timor-Leste": "Vzhodni Timor",
        "Norfolk Island": "Norfolški otok",
        "Bhutan": "Butan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazahstan",
        "Cook Islands": "Cookovi otoki",
        "Micronesia": "Mikronezija",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberija",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filipini",
        "Rwanda": "Ruanda",
        "United Kingdom": "Združeno kraljestvo",
        "Martinique": "Martinik",
        "Nepal": "Nepal",
        "Guatemala": "Gvatemala",
        "Bermuda": "Bermudi",
        "Australia": "Avstralija",
        "Vatican City": "Vatikan",
        "Slovenia": "Slovenija",
        "Cayman Islands": "Kajmanski otoki",
        "Hungary": "Madžarska",
        "American Samoa": "Ameriška Samoa",
        "Mauritania": "Mavretanija",
        "Japan": "Japonska",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kambodža",
        "Wallis & Futuna": "Wallis in Futuna",
        "South Sudan": "Južni Sudan",
        "Morocco": "Maroko",
        "Argentina": "Argentina",
        "Guadeloupe": "Gvadalupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Katar",
        "Tanzania": "Tanzanija",
        "Mexico": "Mehika",
        "Russia": "Rusija",
        "Iceland": "Islandija",
        "Monaco": "Monako",
        "Afghanistan": "Afganistan",
        "Slovakia": "Slovaška",
        "Sweden": "Švedska",
        "Azerbaijan": "Azerbajdžan",
        "Bangladesh": "Bangladeš",
        "Brazil": "Brazilija",
        "Cuba": "Kuba",
        "Ghana": "Gana",
        "Mongolia": "Mongolija",
        "Saint Kitts and Nevis": "Saint Kitts in Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nikaragva",
        "Malaysia": "Malezija",
        "Uruguay": "Urugvaj",
        "Brunei": "Brunej",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Severni Marianski otoki",
        "Pakistan": "Pakistan",
        "Greenland": "Grenlandija",
        "Mauritius": "Mavricij",
        "Caribbean Netherlands": "Nizozemski Karibi",
        "Belize": "Belize",
        "Liechtenstein": "Lihtenštajn",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Češka republika",
        "Moldova": "Moldavija",
        "Singapore": "Singapur",
        "Belgium": "Belgija",
        "Maldives": "Maldivi",
        "New Zealand": "Nova Zelandija",
        "South Korea": "Južna Koreja",
        "Italy": "Italija",
        "Israel": "Izrael",
        "Grenada": "Grenada",
        "Kenya": "Kenija",
        "St. Helena": "Sveta Helena",
        "Guam": "Guam",
        "Denmark": "Danska",
        "New Caledonia": "Nova Kaledonija",
        "Ecuador": "Ekvador",
        "Canada": "Kanada",
        "Egypt": "Egipt",
        "Saudi Arabia": "Savdska Arabija",
        "Botswana": "Bocvana",
        "Turks & Caicos Islands": "Otoki Turks in Caicos",
        "Latvia": "Latvija",
        "St. Pierre & Miquelon": "Saint Pierre in Miquelon",
        "Georgia": "Gruzija",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabve",
        "Thailand": "Tajska",
        "Algeria": "Alžirija",
        "Finland": "Finska",
        "Macedonia": "Severna Makedonija",
        "Antigua and Barbuda": "Antigva in Barbuda",
        "Nigeria": "Nigerija",
        "Switzerland": "Švica",
        "Bulgaria": "Bolgarija",
        "Montenegro": "Črna gora",
        "Tajikistan": "Tadžikistan",
        "Austria": "Avstrija",
        "Bolivia": "Bolivija",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrajn",
        "Colombia": "Kolumbija",
        "Papua New Guinea": "Papua Nova Gvineja",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Džibuti",
        "British Indian Ocean Territory": "Britansko ozemlje v Indijskem oceanu",
        "Chad": "Čad",
        "Germany": "Nemčija",
        "Fiji": "Fidži",
        "British Virgin Islands": "Britanski Deviški otoki",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Južna Afrika",
        "Eritrea": "Eritreja",
        "Greece": "Grčija",
        "Ethiopia": "Etiopija",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshallovi otoki",
        "United States": "Združene države",
        "Benin": "Benin",
        "El Salvador": "Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomonovi otoki",
        "China": "Kitajska",
        "Tonga": "Tonga"
    },
};
export const siLK = {
    searchNotFound: "රට සොයා ගැනීමට නොමැත",
    searchPlaceholder: "රටක් සෙවීමට",
    countries: {
        "Gibraltar": "ගිබ්රෝල්ටා",
        "Gambia": "ගැම්බියා",
        "Equatorial Guinea": "සමක අග්නිදිග ගිනියාව",
        "Senegal": "සෙනගාල්",
        "Jamaica": "ජැමෙයිකා",
        "Seychelles": "සීෂෙල්ස්",
        "Comoros": "කොමොරෝස්",
        "U.S. Virgin Islands": "අමෙරිකානු වර්ජින් දිවයින්",
        "Guinea": "ගිනියාව",
        "Niger": "නයිජර්",
        "Libya": "ලිබියාව",
        "Romania": "රුමේනියාව",
        "Anguilla": "ඇන්ගුයිලා",
        "Togo": "ටෝගෝ",
        "Paraguay": "පැරගුවේ",
        "India": "ඉන්දියාව",
        "Ireland": "අයර්ලන්තය",
        "Turkey": "තුර්කිය",
        "Oman": "ඕමානය",
        "Ukraine": "යුක්රේනය",
        "Spain": "ස්පාඤ්ඤය",
        "Cameroon": "කැමරූන්",
        "Angola": "ඇන්ගෝලා",
        "Mali": "මාලි",
        "Saint Vincent and the Grenadines": "ශාන්ත වින්සන්ට් සහ ග්රෙනඩින්ස්",
        "Cyprus": "සයිප්රසය",
        "Belarus": "බෙලරුසියාව",
        "Gabon": "ගැබෝන්",
        "Samoa": "සැමෝවා",
        "Chile": "චිලි",
        "United Arab Emirates": "එක්සත් අරාබි එමිරේට්ස්",
        "São Tomé and Príncipe": "සානෝ තෝමේ සහ ප්රීන්සිප්",
        "Palau": "පලාව",
        "Tokelau": "ටොකෙලාව",
        "Puerto Rico": "පුවර්ටෝ රිකෝ",
        "Portugal": "පෘතුගාලය",
        "Costa Rica": "කොස්ට රිකාව",
        "Swaziland": "එස්වතීනි",
        "Cape Verde": "කේප් වර්ඩ්",
        "Curaçao": "කුරකාවෝ",
        "Andorra": "ඇන්ඩෝරා",
        "Armenia": "ආර්මේනියාව",
        "Haiti": "හෙයිටි",
        "Côte d’Ivoire": "කෝට් දයිවරේ",
        "Guinea-Bissau": "ගිනියාව-බිස්සාව්",
        "Mozambique": "මොසැම්බික්",
        "Poland": "පෝලන්තය",
        "French Polynesia": "ප්රංශ පොලිනීසියාව",
        "Jersey": "ජර්සි",
        "Kuwait": "කුවේටය",
        "Dominican Republic": "ඩොමිනිකානු ජනරජය",
        "Kosovo": "කොසෝවෝ",
        "Kyrgyzstan": "කිරිගිස්ථානය",
        "Syria": "සිරියාව",
        "Zambia": "සැම්බියාව",
        "Croatia": "ක්රොඒෂියාව",
        "Lithuania": "ලිතුවේනියාව",
        "Albania": "ඇල්බේනියාව",
        "Netherlands": "නෙදර්ලන්තය",
        "France": "ප්රංශය",
        "Tunisia": "ටියුනීසියාව",
        "Bosnia and Herzegovina": "බොස්නියාව සහ හර්සගොවීනාව",
        "Bahamas": "බහමාස්",
        "Somalia": "සෝමාලියාව",
        "Burundi": "බුරුන්ඩි",
        "Barbados": "බාබඩෝස්",
        "Malawi": "මලාවි",
        "Honduras": "හොන්ඩුරාස්",
        "French Guiana": "ප්රංශ ගයිනාව",
        "Jordan": "ජෝර්දානය",
        "Serbia": "සර්බියාව",
        "Vanuatu": "වනුවාටු",
        "Aruba": "අරුබා",
        "Guyana": "ගයනාව",
        "Lesotho": "ලෙසෝතෝ",
        "Taiwan": "තායිවානය",
        "Central African Republic": "මධ්යම අප්රිකානු ජනරජය",
        "Luxembourg": "ලක්සැම්බර්ග්",
        "Trinidad and Tobago": "ට්රිනිඩෑඩ් සහ ටොබැගෝ",
        "Estonia": "ඉස්තෝනියාව",
        "Montserrat": "මොන්ට්සරට්",
        "Norway": "නෝර්වේ",
        "North Korea": "උතුරු කොරියාව",
        "Myanmar": "මියන්මාරය",
        "Sri Lanka": "ශ්රී ලංකාව",
        "Faroe Islands": "ෆැරෝ දූපත්",
        "Dominica": "ඩොමිනිකාව",
        "Kiribati": "කිරිබටි",
        "Falkland Islands": "ෆෝක්ලන්ත දූපත්",
        "Namibia": "නැමීබියාව",
        "Saint Lucia": "ශාන්ත ලුසියා",
        "Indonesia": "ඉන්දෝනීසියාව",
        "Timor-Leste": "නැගෙනහිර ටිමෝර්",
        "Norfolk Island": "නෝෆෝක් දූපත",
        "Bhutan": "භූතානය",
        "Iran": "ඉරානය",
        "Turkmenistan": "තර්කමෙන්ස්ථානය",
        "Uganda": "උගන්ඩාව",
        "Kazakhstan": "කසාකස්ථානය",
        "Cook Islands": "කුක් දූපත්",
        "Micronesia": "මයික්රොනීසියාව",
        "Sint Maarten": "සින්ට් මාර්ටන්",
        "Liberia": "ලයිබීරියාව",
        "Panama": "පැනමාව",
        "Malta": "මෝල්ටාව",
        "Peru": "පේරු",
        "Philippines": "පිලිපීන",
        "Rwanda": "රුවන්ඩාව",
        "United Kingdom": "එක්සත් රාජධානිය",
        "Martinique": "මාටිනිකුව",
        "Nepal": "නේපාලය",
        "Guatemala": "ගුවාතමාලාව",
        "Bermuda": "බර්මියුඩාව",
        "Australia": "ඔස්ට්රේලියාව",
        "Vatican City": "වතිකානු නගරය",
        "Slovenia": "ස්ලෝවේනියාව",
        "Cayman Islands": "කේමන් දූපත්",
        "Hungary": "හංගේරියාව",
        "American Samoa": "ඇමෙරිකානු සැමෝවා",
        "Mauritania": "මෝරිටේනියාව",
        "Japan": "ජපානය",
        "Uzbekistan": "උස්බෙක්ස්ථානය",
        "Cambodia": "කම්බෝජය",
        "Wallis & Futuna": "වැලිස් සහ ෆුටුනා",
        "South Sudan": "දකුණු සුඩානය",
        "Morocco": "මොරොක්කෝ",
        "Argentina": "ආර්ජන්ටිනාව",
        "Guadeloupe": "ගුවාඩේලෝප්",
        "Hong Kong": "හොංකොං",
        "Qatar": "කටාර්",
        "Tanzania": "ටැන්සානියාව",
        "Mexico": "මෙක්සිකෝව",
        "Russia": "රුසියාව",
        "Iceland": "අයිස්ලන්තය",
        "Monaco": "මොනැකෝ",
        "Afghanistan": "අෆ්ගනිස්ථානය",
        "Slovakia": "ස්ලෝවැකියාව",
        "Sweden": "ස්වීඩනය",
        "Azerbaijan": "අසර්බයිජානය",
        "Bangladesh": "බංග්ලාදේශය",
        "Brazil": "බ්රසීලය",
        "Cuba": "කියුබාව",
        "Ghana": "ඝානාව",
        "Mongolia": "මොංගෝලියාව",
        "Saint Kitts and Nevis": "ශාන්ත කිට්ස් සහ නේවිස්",
        "Burkina Faso": "බූර්කීනා ෆාසෝ",
        "Nicaragua": "නිකරගුවා",
        "Malaysia": "මැලේසියාව",
        "Uruguay": "උරුගුවේ",
        "Brunei": "බෘනායි",
        "Congo": "කොංගෝ",
        "Nauru": "නාවුරු",
        "Northern Mariana Islands": "උතුරු මරියානා දූපත්",
        "Pakistan": "පාකිස්ථානය",
        "Greenland": "ග්රීන්ලන්තය",
        "Mauritius": "මුරුසියාව",
        "Caribbean Netherlands": "කැරිබියානු නෙදර්ලන්තය",
        "Belize": "බෙලීස්",
        "Liechtenstein": "ලිචට්ටෙන්ස්ටයින්",
        "Sierra Leone": "සියරා ලියෝන්",
        "Czech Republic": "චෙක් ජනරජය",
        "Moldova": "මෝල්ඩෝවාව",
        "Singapore": "සිංගප්පූරුව",
        "Belgium": "බෙල්ජියම",
        "Maldives": "මාලදිවයින",
        "New Zealand": "නවසීලන්තය",
        "South Korea": "දකුණු කොරියාව",
        "Italy": "ඉතාලිය",
        "Israel": "ඉස්රායෙලය",
        "Grenada": "ග්රෙනඩා",
        "Kenya": "කෙන්යාව",
        "St. Helena": "ශාන්ත හෙලේනාව",
        "Guam": "ගුවාම්",
        "Denmark": "ඩෙන්මාර්කය",
        "New Caledonia": "නව කැලිඩෝනියාව",
        "Ecuador": "ඉක්වදෝරය",
        "Canada": "කැනඩාව",
        "Egypt": "ඊජිප්තුව",
        "Saudi Arabia": "සවුදි අරාබිය",
        "Botswana": "බොට්ස්වානා",
        "Turks & Caicos Islands": "ටර්ක්ස් සහ කැකොස් දූපත්",
        "Latvia": "ලැට්වියාව",
        "St. Pierre & Miquelon": "ශාන්ත පියර් සහ මිකෙලෝන්",
        "Georgia": "ජෝර්ජියාව",
        "Laos": "ලාඕසය",
        "Réunion": "රෙයුනියන්",
        "Niue": "නියු",
        "Zimbabwe": "සිම්බාබ්වේ",
        "Thailand": "තායිලන්තය",
        "Algeria": "ඇල්ජීරියාව",
        "Finland": "ෆින්ලන්තය",
        "Macedonia": "උතුරු මැසිඩෝනියාව",
        "Antigua and Barbuda": "ඇන්ටිගුවා සහ බාබුඩා",
        "Nigeria": "නයිජීරියාව",
        "Switzerland": "ස්විට්සර්ලන්තය",
        "Bulgaria": "බල්ගේරියාව",
        "Montenegro": "මොන්ටෙනේග්රෝ",
        "Tajikistan": "තාජිකිස්ථානය",
        "Austria": "ඔස්ට්රියාව",
        "Bolivia": "බොලිවියාව",
        "Sudan": "සුඩානය",
        "Suriname": "සුරිනාමය",
        "Iraq": "ඉරාකය",
        "Bahrain": "බහරේන්",
        "Colombia": "කොලොම්බියාව",
        "Papua New Guinea": "පැපුවා නිව් ගිනියාව",
        "Yemen": "යේමනය",
        "Venezuela": "වෙනිසියුලාව",
        "Djibouti": "ජිබුටි",
        "British Indian Ocean Territory": "බ්රිතාන්ය ඊන්දීය සාගර බල ප්රදේශය",
        "Chad": "චැඩ්",
        "Germany": "ජර්මනිය",
        "Fiji": "ෆීජි",
        "British Virgin Islands": "බ්රිතාන්ය වර්ජින් දූපත්",
        "San Marino": "සැන් මරීනෝ",
        "Vietnam": "වියට්නාමය",
        "Macau": "මකාව",
        "South Africa": "දකුණු අප්රිකාව",
        "Eritrea": "එරිත්රියාව",
        "Greece": "ග්රීසිය",
        "Ethiopia": "ඉතියෝපියාව",
        "Madagascar": "මඩගස්කරය",
        "Marshall Islands": "මාෂල් දූපත්",
        "United States": "එක්සත් ජනපදය",
        "Benin": "බෙනින්",
        "El Salvador": "එල් සැල්වදෝර්",
        "Lebanon": "ලෙබනනය",
        "Palestine": "පලස්තීනය",
        "Tuvalu": "ටුවාලු",
        "Solomon Islands": "සොලමන් දූපත්",
        "China": "චීනය",
        "Tonga": "ටොංගා"
    },
};
export const gaIE = {
    searchNotFound: "Ní bhfuarthas tír",
    searchPlaceholder: "Cuardaigh tír",
    countries: {
        "Gibraltar": "Giobrálta",
        "Gambia": "An Ghaimbia",
        "Equatorial Guinea": "An Ghuine Mheánchiorclach",
        "Senegal": "An tSeineagáil",
        "Jamaica": "Iamáice",
        "Seychelles": "Na Séiséil",
        "Comoros": "Oileáin Chomóra",
        "U.S. Virgin Islands": "Oileáin Mhaighdean Mheiriceá",
        "Guinea": "An Ghuine",
        "Niger": "An Nígir",
        "Libya": "An Libia",
        "Romania": "An Rómáin",
        "Anguilla": "Angaíle",
        "Togo": "Tóga",
        "Paraguay": "Paragua",
        "India": "An India",
        "Ireland": "Éire",
        "Turkey": "An Tuirc",
        "Oman": "Óman",
        "Ukraine": "An Úcráin",
        "Spain": "An Spáinn",
        "Cameroon": "Camarún",
        "Angola": "Angóla",
        "Mali": "Mailí",
        "Saint Vincent and the Grenadines": "San Uinseann agus na Greanáidíní",
        "Cyprus": "An Chipir",
        "Belarus": "An Bhealarúis",
        "Gabon": "An Ghabúin",
        "Samoa": "Samó",
        "Chile": "An tSile",
        "United Arab Emirates": "Aontas na nÉimíríochtaí Arabacha",
        "São Tomé and Príncipe": "São Tomé agus Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Pórtó Ríce",
        "Portugal": "An Phortaingéil",
        "Costa Rica": "Cósta Ríce",
        "Swaziland": "An tSuasalainn",
        "Cape Verde": "Rinn Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andóra",
        "Armenia": "An Airméin",
        "Haiti": "Háítí",
        "Côte d’Ivoire": "Cósta Eabhair",
        "Guinea-Bissau": "An Ghuine-Bhissáú",
        "Mozambique": "Mósaimbíc",
        "Poland": "An Pholainn",
        "French Polynesia": "Polainéis na Fraince",
        "Jersey": "Geirsí",
        "Kuwait": "Cuáit",
        "Dominican Republic": "Poblacht Dhoiminiceach",
        "Kosovo": "An Chosaiv",
        "Kyrgyzstan": "An Chirgeastáin",
        "Syria": "An tSiria",
        "Zambia": "An tSaimbia",
        "Croatia": "An Chróit",
        "Lithuania": "An Liotuáin",
        "Albania": "An Albáin",
        "Netherlands": "An Ísiltír",
        "France": "An Fhrainc",
        "Tunisia": "An Túinéis",
        "Bosnia and Herzegovina": "An Bhoisnia agus an Heirseagaivéin",
        "Bahamas": "Na Bahámaí",
        "Somalia": "An tSomáil",
        "Burundi": "An Bhurúin",
        "Barbados": "Barbadós",
        "Malawi": "An Mhaláiv",
        "Honduras": "Hondúras",
        "French Guiana": "An Ghuáin Fhrancach",
        "Jordan": "An Iordáin",
        "Serbia": "An tSeirbia",
        "Vanuatu": "Vanuatú",
        "Aruba": "Arúba",
        "Guyana": "An Ghuáin",
        "Lesotho": "Leosóta",
        "Taiwan": "An Téaváin",
        "Central African Republic": "Poblacht na hAfraice Láir",
        "Luxembourg": "Lucsamburg",
        "Trinidad and Tobago": "Oileán na Tríonóide agus Tobága",
        "Estonia": "An Eastóin",
        "Montserrat": "Montsarat",
        "Norway": "An Iorua",
        "North Korea": "An Chóiré Thuaidh",
        "Myanmar": "Maenmar",
        "Sri Lanka": "Srí Lanca",
        "Faroe Islands": "Oileáin Fharó",
        "Dominica": "Doiminice",
        "Kiribati": "Cireabaití",
        "Falkland Islands": "Oileáin Fháclainne",
        "Namibia": "An Namaib",
        "Saint Lucia": "San Lúise",
        "Indonesia": "An Indinéis",
        "Timor-Leste": "Tíomór Thoir",
        "Norfolk Island": "Oileán Norfolk",
        "Bhutan": "An Bhútáin",
        "Iran": "An Iaráin",
        "Turkmenistan": "An Tuircméanastáin",
        "Uganda": "Úganda",
        "Kazakhstan": "An Chasacstáin",
        "Cook Islands": "Oileáin Cook",
        "Micronesia": "An Mhicrinéis",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "An Libéir",
        "Panama": "Panama",
        "Malta": "Málta",
        "Peru": "Peiriú",
        "Philippines": "Na hOileáin Fhilipíneacha",
        "Rwanda": "Ruanda",
        "United Kingdom": "An Ríocht Aontaithe",
        "Martinique": "Martinique",
        "Nepal": "Neipeal",
        "Guatemala": "Guatamala",
        "Bermuda": "Beirmiúda",
        "Australia": "An Astráil",
        "Vatican City": "Cathair na Vatacáine",
        "Slovenia": "An tSlóivéin",
        "Cayman Islands": "Oileáin Cayman",
        "Hungary": "An Ungáir",
        "American Samoa": "Samó Mheiriceá",
        "Mauritania": "An Mháratáin",
        "Japan": "An tSeapáin",
        "Uzbekistan": "Úisbéiceastáin",
        "Cambodia": "An Chambóid",
        "Wallis & Futuna": "Vailís agus Futúna",
        "South Sudan": "Poblacht na Súdáine Theas",
        "Morocco": "Maracó",
        "Argentina": "An Airgintín",
        "Guadeloupe": "Guadalúip",
        "Hong Kong": "Hong Cong",
        "Qatar": "Catar",
        "Tanzania": "An Tansáin",
        "Mexico": "Meicsiceo",
        "Russia": "An Rúis",
        "Iceland": "An Íoslainn",
        "Monaco": "Monacó",
        "Afghanistan": "An Afganastáin",
        "Slovakia": "An tSlóvaic",
        "Sweden": "An tSualainn",
        "Azerbaijan": "An Asarbaiseáin",
        "Bangladesh": "An Bhanglaidéis",
        "Brazil": "An Bhrasaíl",
        "Cuba": "Cúba",
        "Ghana": "Gána",
        "Mongolia": "An Mhongóil",
        "Saint Kitts and Nevis": "San Críostóir agus Néibhis",
        "Burkina Faso": "Buircíne Fasó",
        "Nicaragua": "Nicearagua",
        "Malaysia": "An Mhalaeisia",
        "Uruguay": "Uragua",
        "Brunei": "Brúiné",
        "Congo": "An Congó",
        "Nauru": "Nárú",
        "Northern Mariana Islands": "Oileáin Mháirianacha Thuaidh",
        "Pakistan": "An Phacastáin",
        "Greenland": "An Ghraonlainn",
        "Mauritius": "Oileán Mhuirís",
        "Caribbean Netherlands": "An Ísiltír Chairibeach",
        "Belize": "An Bheilís",
        "Liechtenstein": "Lichtinstéin",
        "Sierra Leone": "Siarra Leon",
        "Czech Republic": "Poblacht na Seice",
        "Moldova": "An Mholdóiv",
        "Singapore": "Singeapór",
        "Belgium": "An Bheilg",
        "Maldives": "Oileáin Mhaildíve",
        "New Zealand": "An Nua-Shéalainn",
        "South Korea": "An Chóiré Theas",
        "Italy": "An Iodáil",
        "Israel": "Iosrael",
        "Grenada": "Greanáid",
        "Kenya": "An Chéinia",
        "St. Helena": "San Héilin",
        "Guam": "Guam",
        "Denmark": "An Danmhairg",
        "New Caledonia": "An Nua-Chaladóin",
        "Ecuador": "Eacuadór",
        "Canada": "Ceanada",
        "Egypt": "An Éigipt",
        "Saudi Arabia": "An Araib Shádach",
        "Botswana": "An Bhotsuáin",
        "Turks & Caicos Islands": "Oileáin Turks agus Caicos",
        "Latvia": "An Laitvia",
        "St. Pierre & Miquelon": "Saint-Pierre-et-Miquelon",
        "Georgia": "An tSeoirsia",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Nua-Chór",
        "Zimbabwe": "An tSiombáib",
        "Thailand": "An Téalainn",
        "Algeria": "An Ailgéir",
        "Finland": "An Fhionlainn",
        "Macedonia": "An Mhacadóin Thuaidh",
        "Antigua and Barbuda": "Antigua agus Barbúda",
        "Nigeria": "An Nigéir",
        "Switzerland": "An Eilvéis",
        "Bulgaria": "An Bhulgáir",
        "Montenegro": "Montainéagró",
        "Tajikistan": "An Táidsíceastáin",
        "Austria": "An Ostair",
        "Bolivia": "An Bholaiv",
        "Sudan": "An tSúdáin",
        "Suriname": "Suranam",
        "Iraq": "An Iaráic",
        "Bahrain": "Bairéin",
        "Colombia": "An Cholóim",
        "Papua New Guinea": "Nua-Ghuine Phapua",
        "Yemen": "Éimin",
        "Venezuela": "Veiniséala",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Críoch Aigéan Indiach na Breataine",
        "Chad": "Sead",
        "Germany": "An Ghearmáin",
        "Fiji": "Fidsí",
        "British Virgin Islands": "Oileáin Bhriodeacha na Breataine",
        "San Marino": "San Mairíne",
        "Vietnam": "Vítneam",
        "Macau": "Macao",
        "South Africa": "An Afraic Theas",
        "Eritrea": "Eiritré",
        "Greece": "An Ghréig",
        "Ethiopia": "An Aetóip",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Oileáin Marshall",
        "United States": "Stáit Aontaithe Mheiriceá",
        "Benin": "Beinin",
        "El Salvador": "An tSalvadóir",
        "Lebanon": "An Liobáin",
        "Palestine": "An Phalaistín",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Oileáin Sholomón",
        "China": "An tSín",
        "Tonga": "Tonga"
    },
};
export const hyAM = {
    searchNotFound: "Երկիրը չի գտնվել",
    searchPlaceholder: "Որոնել երկիր",
    countries: {
        "Gibraltar": "Ջիբրալթար",
        "Gambia": "Գամբիա",
        "Equatorial Guinea": "Հասարակածային Գվինեա",
        "Senegal": "Սենեգալ",
        "Jamaica": "Ջամայկա",
        "Seychelles": "Սեյշելներ",
        "Comoros": "Կոմորոս",
        "U.S. Virgin Islands": "ԱՄՆ Վիրջինյան կղզիներ",
        "Guinea": "Գվինեա",
        "Niger": "Նիգեր",
        "Libya": "Լիբիա",
        "Romania": "Ռումինիա",
        "Anguilla": "Անգուիլա",
        "Togo": "Տոգո",
        "Paraguay": "Պարագվայ",
        "India": "Հնդկաստան",
        "Ireland": "Իռլանդիա",
        "Turkey": "Թուրքիա",
        "Oman": "Օման",
        "Ukraine": "Ուկրաինա",
        "Spain": "Իսպանիա",
        "Cameroon": "Կամերուն",
        "Angola": "Անգոլա",
        "Mali": "Մալի",
        "Saint Vincent and the Grenadines": "Սենթ Վինսենթ և Գրենադիններ",
        "Cyprus": "Կիպրոս",
        "Belarus": "Բելառուս",
        "Gabon": "Գաբոն",
        "Samoa": "Սամոա",
        "Chile": "Չիլի",
        "United Arab Emirates": "Միացյալ Արաբական Էմիրություններ",
        "São Tomé and Príncipe": "Սան Տոմե և Պրինսիպի",
        "Palau": "Պալաու",
        "Tokelau": "Տոկելաու",
        "Puerto Rico": "Պուերտո Ռիկո",
        "Portugal": "Պորտուգալիա",
        "Costa Rica": "Կոստա Ռիկա",
        "Swaziland": "Էսվատինի",
        "Cape Verde": "Կաբո Վերդե",
        "Curaçao": "Կուրասաո",
        "Andorra": "Անդորրա",
        "Armenia": "Հայաստան",
        "Haiti": "Հաիթի",
        "Côte d’Ivoire": "Փղոսկրի Ափ",
        "Guinea-Bissau": "Գվինեա-Բիսաու",
        "Mozambique": "Մոզամբիկ",
        "Poland": "Լեհաստան",
        "French Polynesia": "Ֆրանսիական Պոլինեզիա",
        "Jersey": "Ջերսի",
        "Kuwait": "Քուվեյթ",
        "Dominican Republic": "Դոմինիկյան Հանրապետություն",
        "Kosovo": "Կոսովո",
        "Kyrgyzstan": "Ղրղզստան",
        "Syria": "Սիրիա",
        "Zambia": "Զամբիա",
        "Croatia": "Խորվաթիա",
        "Lithuania": "Լիտվա",
        "Albania": "Ալբանիա",
        "Netherlands": "Նիդեռլանդներ",
        "France": "Ֆրանսիա",
        "Tunisia": "Թունիս",
        "Bosnia and Herzegovina": "Բոսնիա և Հերցեգովինա",
        "Bahamas": "Բահամներ",
        "Somalia": "Սոմալի",
        "Burundi": "Բուրունդի",
        "Barbados": "Բարբադոս",
        "Malawi": "Մալավի",
        "Honduras": "Հոնդուրաս",
        "French Guiana": "Ֆրանսիական Գվիանա",
        "Jordan": "Հորդանան",
        "Serbia": "Սերբիա",
        "Vanuatu": "Վանուատու",
        "Aruba": "Արուբա",
        "Guyana": "Գայանա",
        "Lesotho": "Լեսոտո",
        "Taiwan": "Թայվան",
        "Central African Republic": "Կենտրոնական Աֆրիկյան Հանրապետություն",
        "Luxembourg": "Լյուքսեմբուրգ",
        "Trinidad and Tobago": "Տրինիդադ և Տոբագո",
        "Estonia": "Էստոնիա",
        "Montserrat": "Մոնսեռատ",
        "Norway": "Նորվեգիա",
        "North Korea": "Հյուսիսային Կորեա",
        "Myanmar": "Մյանմար",
        "Sri Lanka": "Շրի Լանկա",
        "Faroe Islands": "Ֆարերյան կղզիներ",
        "Dominica": "Դոմինիկա",
        "Kiribati": "Կիրիբատի",
        "Falkland Islands": "Ֆոլքլենդյան կղզիներ",
        "Namibia": "Նամիբիա",
        "Saint Lucia": "Սենթ Լյուսիա",
        "Indonesia": "Ինդոնեզիա",
        "Timor-Leste": "Թիմոր-Լեստե",
        "Norfolk Island": "Նորֆոլկ կղզի",
        "Bhutan": "Բութան",
        "Iran": "Իրան",
        "Turkmenistan": "Թուրքմենստան",
        "Uganda": "Ուգանդա",
        "Kazakhstan": "Ղազախստան",
        "Cook Islands": "Կուկի կղզիներ",
        "Micronesia": "Միկրոնեզիա",
        "Sint Maarten": "Սինտ Մարտեն",
        "Liberia": "Լիբերիա",
        "Panama": "Պանամա",
        "Malta": "Մալթա",
        "Peru": "Պերու",
        "Philippines": "Ֆիլիպիններ",
        "Rwanda": "Ռուանդա",
        "United Kingdom": "Միացյալ Թագավորություն",
        "Martinique": "Մարտինիկա",
        "Nepal": "Նեպալ",
        "Guatemala": "Գվատեմալա",
        "Bermuda": "Բերմուդա",
        "Australia": "Ավստրալիա",
        "Vatican City": "Վատիկանի քաղաք",
        "Slovenia": "Սլովենիա",
        "Cayman Islands": "Կայմանյան կղզիներ",
        "Hungary": "Հունգարիա",
        "American Samoa": "Ամերիկյան Սամոա",
        "Mauritania": "Մավրիտանիա",
        "Japan": "Ճապոնիա",
        "Uzbekistan": "Ուզբեկստան",
        "Cambodia": "Կամբոջա",
        "Wallis & Futuna": "Ուոլիս և Ֆուտունա",
        "South Sudan": "Հարավային Սուդան",
        "Morocco": "Մարոկկո",
        "Argentina": "Արգենտինա",
        "Guadeloupe": "Գվադելուպա",
        "Hong Kong": "Հոնկոնգ",
        "Qatar": "Կատար",
        "Tanzania": "Տանզանիա",
        "Mexico": "Մեքսիկա",
        "Russia": "Ռուսաստան",
        "Iceland": "Իսլանդիա",
        "Monaco": "Մոնակո",
        "Afghanistan": "Աֆղանստան",
        "Slovakia": "Սլովակիա",
        "Sweden": "Շվեդիա",
        "Azerbaijan": "Ադրբեջան",
        "Bangladesh": "Բանգլադեշ",
        "Brazil": "Բրազիլիա",
        "Cuba": "Կուբա",
        "Ghana": "Գանա",
        "Mongolia": "Մոնղոլիա",
        "Saint Kitts and Nevis": "Սենթ Կիտս և Նևիս",
        "Burkina Faso": "Բուրկինա Ֆասո",
        "Nicaragua": "Նիկարագուա",
        "Malaysia": "Մալայզիա",
        "Uruguay": "Ուրուգվայ",
        "Brunei": "Բրունեյ",
        "Congo": "Կոնգո",
        "Nauru": "Նաուրու",
        "Northern Mariana Islands": "Հյուսիսային Մարիանյան կղզիներ",
        "Pakistan": "Պակիստան",
        "Greenland": "Գրենլանդիա",
        "Mauritius": "Մավրիկիոս",
        "Caribbean Netherlands": "Կարիբյան Նիդերլանդներ",
        "Belize": "Բելիզ",
        "Liechtenstein": "Լիխտենշտեյն",
        "Sierra Leone": "Սիերա Լեոնե",
        "Czech Republic": "Չեխիայի Հանրապետություն",
        "Moldova": "Մոլդովա",
        "Singapore": "Սինգապուր",
        "Belgium": "Բելգիա",
        "Maldives": "Մալդիվներ",
        "New Zealand": "Նոր Զելանդիա",
        "South Korea": "Հարավային Կորեա",
        "Italy": "Իտալիա",
        "Israel": "Իսրայել",
        "Grenada": "Գրենադա",
        "Kenya": "Քենիա",
        "St. Helena": "Սուրբ Հեղինե",
        "Guam": "Գուամ",
        "Denmark": "Դանիա",
        "New Caledonia": "Նոր Կալեդոնիա",
        "Ecuador": "Էկվադոր",
        "Canada": "Կանադա",
        "Egypt": "Եգիպտոս",
        "Saudi Arabia": "Սաուդյան Արաբիա",
        "Botswana": "Բոթսվանա",
        "Turks & Caicos Islands": "Թուրքերի և Կայկոս կղզիներ",
        "Latvia": "Լատվիա",
        "St. Pierre & Miquelon": "Սեն Պյեռ և Միքելոն",
        "Georgia": "Վրաստան",
        "Laos": "Լաոս",
        "Réunion": "Ռեյունիոն",
        "Niue": "Նիուե",
        "Zimbabwe": "Զիմբաբվե",
        "Thailand": "Թայլանդ",
        "Algeria": "Ալժիր",
        "Finland": "Ֆինլանդիա",
        "Macedonia": "Հյուսիսային Մակեդոնիա",
        "Antigua and Barbuda": "Անտիգուա և Բարբուդա",
        "Nigeria": "Նիգերիա",
        "Switzerland": "Շվեյցարիա",
        "Bulgaria": "Բուլղարիա",
        "Montenegro": "Չեռնոգորիա",
        "Tajikistan": "Տաջիկստան",
        "Austria": "Ավստրիա",
        "Bolivia": "Բոլիվիա",
        "Sudan": "Սուդան",
        "Suriname": "Սուրինամ",
        "Iraq": "Իրաք",
        "Bahrain": "Բահրեյն",
        "Colombia": "Կոլումբիա",
        "Papua New Guinea": "Պապուա Նոր Գվինեա",
        "Yemen": "Եմեն",
        "Venezuela": "Վենեսուելա",
        "Djibouti": "Ջիբութի",
        "British Indian Ocean Territory": "Բրիտանական Հնդկական օվկիանոսի տարածք",
        "Chad": "Չադ",
        "Germany": "Գերմանիա",
        "Fiji": "Ֆիջի",
        "British Virgin Islands": "Բրիտանական Վիրջինյան կղզիներ",
        "San Marino": "Սան Մարինո",
        "Vietnam": "Վիետնամ",
        "Macau": "Մակաո",
        "South Africa": "Հարավային Աֆրիկա",
        "Eritrea": "Էրիթրեա",
        "Greece": "Հունաստան",
        "Ethiopia": "Եթովպիա",
        "Madagascar": "Մադագասկար",
        "Marshall Islands": "Մարշալյան կղզիներ",
        "United States": "Միացյալ Նահանգներ",
        "Benin": "Բենին",
        "El Salvador": "Էլ Սալվադոր",
        "Lebanon": "Լիբանան",
        "Palestine": "Պաղեստին",
        "Tuvalu": "Տուվալու",
        "Solomon Islands": "Սողոմոնյան կղզիներ",
        "China": "Չինաստան",
        "Tonga": "Տոնգա"
    },
};
export const etEE = {
    searchNotFound: "Riiki ei leitud",
    searchPlaceholder: "Otsi riiki",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Ekvatoriaal-Guinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seišellid",
        "Comoros": "Komoorid",
        "U.S. Virgin Islands": "USA Neitsisaared",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Liibüa",
        "Romania": "Rumeenia",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "India",
        "Ireland": "Iirimaa",
        "Turkey": "Türgi",
        "Oman": "Omaan",
        "Ukraine": "Ukraina",
        "Spain": "Hispaania",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent ja Grenadiinid",
        "Cyprus": "Küpros",
        "Belarus": "Valgevene",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Tšiili",
        "United Arab Emirates": "Araabia Ühendemiraadid",
        "São Tomé and Príncipe": "São Tomé ja Príncipe",
        "Palau": "Belau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Esvatini",
        "Cape Verde": "Roheneemesaared",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armeenia",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Elevandiluurannik",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mosambiik",
        "Poland": "Poola",
        "French Polynesia": "Prantsuse Polüneesia",
        "Jersey": "Jersey",
        "Kuwait": "Kuveit",
        "Dominican Republic": "Dominikaani Vabariik",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kõrgõzstan",
        "Syria": "Süüria",
        "Zambia": "Sambia",
        "Croatia": "Horvaatia",
        "Lithuania": "Leedu",
        "Albania": "Albaania",
        "Netherlands": "Holland",
        "France": "Prantsusmaa",
        "Tunisia": "Tuneesia",
        "Bosnia and Herzegovina": "Bosnia ja Hertsegoviina",
        "Bahamas": "Bahama",
        "Somalia": "Somaalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Prantsuse Guajaana",
        "Jordan": "Jordaania",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Kesk-Aafrika Vabariik",
        "Luxembourg": "Luksemburg",
        "Trinidad and Tobago": "Trinidad ja Tobago",
        "Estonia": "Eesti",
        "Montserrat": "Montserrat",
        "Norway": "Norra",
        "North Korea": "Põhja-Korea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Fääri saared",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandi saared",
        "Namibia": "Namiibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indoneesia",
        "Timor-Leste": "Ida-Timor",
        "Norfolk Island": "Norfolki saar",
        "Bhutan": "Bhutan",
        "Iran": "Iraan",
        "Turkmenistan": "Türkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kasahstan",
        "Cook Islands": "Cooki saared",
        "Micronesia": "Mikroneesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Libeeria",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peruu",
        "Philippines": "Filipiinid",
        "Rwanda": "Rwanda",
        "United Kingdom": "Ühendkuningriik",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Austraalia",
        "Vatican City": "Vatikan",
        "Slovenia": "Sloveenia",
        "Cayman Islands": "Kaimanisaared",
        "Hungary": "Ungari",
        "American Samoa": "Ameerika Samoa",
        "Mauritania": "Mauritaania",
        "Japan": "Jaapan",
        "Uzbekistan": "Usbekistan",
        "Cambodia": "Kambodža",
        "Wallis & Futuna": "Wallis ja Futuna",
        "South Sudan": "Lõuna-Sudaan",
        "Morocco": "Maroko",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Katar",
        "Tanzania": "Tansaania",
        "Mexico": "Mehhiko",
        "Russia": "Venemaa",
        "Iceland": "Island",
        "Monaco": "Monaco",
        "Afghanistan": "Afganistan",
        "Slovakia": "Slovakkia",
        "Sweden": "Rootsi",
        "Azerbaijan": "Aserbaidžaan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasiilia",
        "Cuba": "Kuuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongoolia",
        "Saint Kitts and Nevis": "Saint Kitts ja Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaisia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Põhja-Mariaani saared",
        "Pakistan": "Pakistan",
        "Greenland": "Gröönimaa",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Kariibi mere Madalmaad",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Tšehhi",
        "Moldova": "Moldova",
        "Singapore": "Singapur",
        "Belgium": "Belgia",
        "Maldives": "Maldiivid",
        "New Zealand": "Uus-Meremaa",
        "South Korea": "Lõuna-Korea",
        "Italy": "Itaalia",
        "Israel": "Iisrael",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Saint Helena",
        "Guam": "Guam",
        "Denmark": "Taani",
        "New Caledonia": "Uus-Kaledoonia",
        "Ecuador": "Ecuador",
        "Canada": "Kanada",
        "Egypt": "Egiptus",
        "Saudi Arabia": "Saudi Araabia",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks ja Caicos",
        "Latvia": "Läti",
        "St. Pierre & Miquelon": "Saint Pierre ja Miquelon",
        "Georgia": "Gruusia",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Tai",
        "Algeria": "Alžeeria",
        "Finland": "Soome",
        "Macedonia": "Põhja-Makedoonia",
        "Antigua and Barbuda": "Antigua ja Barbuda",
        "Nigeria": "Nigeeria",
        "Switzerland": "Šveits",
        "Bulgaria": "Bulgaaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tadžikistan",
        "Austria": "Austria",
        "Bolivia": "Boliivia",
        "Sudan": "Sudaan",
        "Suriname": "Suriname",
        "Iraq": "Iraak",
        "Bahrain": "Bahrein",
        "Colombia": "Colombia",
        "Papua New Guinea": "Paapua Uus-Guinea",
        "Yemen": "Jeemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Briti India ookeani ala",
        "Chad": "Tšaad",
        "Germany": "Saksamaa",
        "Fiji": "Fidži",
        "British Virgin Islands": "Briti Neitsisaared",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macau",
        "South Africa": "Lõuna-Aafrika",
        "Eritrea": "Eritrea",
        "Greece": "Kreeka",
        "Ethiopia": "Etioopia",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshalli Saared",
        "United States": "Ameerika Ühendriigid",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Liibanon",
        "Palestine": "Palestiina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Saalomoni Saared",
        "China": "Hiina",
        "Tonga": "Tonga"
    },
};
export const zhTW = {
    searchNotFound: "找不到國家",
    searchPlaceholder: "搜尋國家",
    countries: {
        "Gibraltar": "直布羅陀",
        "Gambia": "甘比亞",
        "Equatorial Guinea": "赤道幾內亞",
        "Senegal": "塞內加爾",
        "Jamaica": "牙買加",
        "Seychelles": "塞舌爾",
        "Comoros": "葛摩",
        "U.S. Virgin Islands": "美屬維爾京群島",
        "Guinea": "幾內亞",
        "Niger": "尼日",
        "Libya": "利比亞",
        "Romania": "羅馬尼亞",
        "Anguilla": "安圭拉",
        "Togo": "多哥",
        "Paraguay": "巴拉圭",
        "India": "印度",
        "Ireland": "愛爾蘭",
        "Turkey": "土耳其",
        "Oman": "阿曼",
        "Ukraine": "烏克蘭",
        "Spain": "西班牙",
        "Cameroon": "喀麥隆",
        "Angola": "安哥拉",
        "Mali": "馬里",
        "Saint Vincent and the Grenadines": "聖文森及格瑞那丁",
        "Cyprus": "賽普勒斯",
        "Belarus": "白俄羅斯",
        "Gabon": "加彭",
        "Samoa": "薩摩亞",
        "Chile": "智利",
        "United Arab Emirates": "阿拉伯聯合大公國",
        "São Tomé and Príncipe": "聖多美及普林西比",
        "Palau": "帛琉",
        "Tokelau": "托克勞",
        "Puerto Rico": "波多黎各",
        "Portugal": "葡萄牙",
        "Costa Rica": "哥斯大黎加",
        "Swaziland": "史瓦帝尼",
        "Cape Verde": "維德角",
        "Curaçao": "庫拉索",
        "Andorra": "安道爾",
        "Armenia": "亞美尼亞",
        "Haiti": "海地",
        "Côte d’Ivoire": "象牙海岸",
        "Guinea-Bissau": "幾內亞比紹",
        "Mozambique": "莫三比克",
        "Poland": "波蘭",
        "French Polynesia": "法屬玻里尼西亞",
        "Jersey": "澤西",
        "Kuwait": "科威特",
        "Dominican Republic": "多明尼加共和國",
        "Kosovo": "科索沃",
        "Kyrgyzstan": "吉爾吉斯",
        "Syria": "敘利亞",
        "Zambia": "尚比亞",
        "Croatia": "克羅埃西亞",
        "Lithuania": "立陶宛",
        "Albania": "阿爾巴尼亞",
        "Netherlands": "荷蘭",
        "France": "法國",
        "Tunisia": "突尼西亞",
        "Bosnia and Herzegovina": "波士尼亞與赫塞哥維納",
        "Bahamas": "巴哈馬",
        "Somalia": "索馬利亞",
        "Burundi": "蒲隆地",
        "Barbados": "巴貝多",
        "Malawi": "馬拉威",
        "Honduras": "宏都拉斯",
        "French Guiana": "法屬蓋亞那",
        "Jordan": "約旦",
        "Serbia": "塞爾維亞",
        "Vanuatu": "萬那杜",
        "Aruba": "阿魯巴",
        "Guyana": "蓋亞那",
        "Lesotho": "賴索托",
        "Taiwan": "台灣",
        "Central African Republic": "中非共和國",
        "Luxembourg": "盧森堡",
        "Trinidad and Tobago": "千里達及托巴哥",
        "Estonia": "愛沙尼亞",
        "Montserrat": "蒙特色拉特",
        "Norway": "挪威",
        "North Korea": "北韓",
        "Myanmar": "緬甸",
        "Sri Lanka": "斯里蘭卡",
        "Faroe Islands": "法羅群島",
        "Dominica": "多明尼克",
        "Kiribati": "吉里巴斯",
        "Falkland Islands": "福克蘭群島",
        "Namibia": "納米比亞",
        "Saint Lucia": "聖露西亞",
        "Indonesia": "印尼",
        "Timor-Leste": "東帝汶",
        "Norfolk Island": "諾福克島",
        "Bhutan": "不丹",
        "Iran": "伊朗",
        "Turkmenistan": "土庫曼",
        "Uganda": "烏干達",
        "Kazakhstan": "哈薩克",
        "Cook Islands": "庫克群島",
        "Micronesia": "密克羅尼西亞",
        "Sint Maarten": "荷屬聖馬丁",
        "Liberia": "賴比瑞亞",
        "Panama": "巴拿馬",
        "Malta": "馬爾他",
        "Peru": "秘魯",
        "Philippines": "菲律賓",
        "Rwanda": "盧安達",
        "United Kingdom": "英國",
        "Martinique": "馬丁尼克",
        "Nepal": "尼泊爾",
        "Guatemala": "瓜地馬拉",
        "Bermuda": "百慕達",
        "Australia": "澳洲",
        "Vatican City": "梵蒂岡",
        "Slovenia": "斯洛維尼亞",
        "Cayman Islands": "開曼群島",
        "Hungary": "匈牙利",
        "American Samoa": "美屬薩摩亞",
        "Mauritania": "茅利塔尼亞",
        "Japan": "日本",
        "Uzbekistan": "烏茲別克",
        "Cambodia": "柬埔寨",
        "Wallis & Futuna": "瓦利斯和富圖納群島",
        "South Sudan": "南蘇丹",
        "Morocco": "摩洛哥",
        "Argentina": "阿根廷",
        "Guadeloupe": "瓜德羅普",
        "Hong Kong": "香港",
        "Qatar": "卡達",
        "Tanzania": "坦尚尼亞",
        "Mexico": "墨西哥",
        "Russia": "俄羅斯",
        "Iceland": "冰島",
        "Monaco": "摩納哥",
        "Afghanistan": "阿富汗",
        "Slovakia": "斯洛伐克",
        "Sweden": "瑞典",
        "Azerbaijan": "亞塞拜然",
        "Bangladesh": "孟加拉",
        "Brazil": "巴西",
        "Cuba": "古巴",
        "Ghana": "迦納",
        "Mongolia": "蒙古",
        "Saint Kitts and Nevis": "聖克里斯多福及尼維斯",
        "Burkina Faso": "布吉納法索",
        "Nicaragua": "尼加拉瓜",
        "Malaysia": "馬來西亞",
        "Uruguay": "烏拉圭",
        "Brunei": "汶萊",
        "Congo": "剛果",
        "Nauru": "諾魯",
        "Northern Mariana Islands": "北馬利安納群島",
        "Pakistan": "巴基斯坦",
        "Greenland": "格陵蘭",
        "Mauritius": "模里西斯",
        "Caribbean Netherlands": "荷屬加勒比",
        "Belize": "貝里斯",
        "Liechtenstein": "列支敦士登",
        "Sierra Leone": "獅子山",
        "Czech Republic": "捷克",
        "Moldova": "摩爾多瓦",
        "Singapore": "新加坡",
        "Belgium": "比利時",
        "Maldives": "馬爾地夫",
        "New Zealand": "紐西蘭",
        "South Korea": "南韓",
        "Italy": "義大利",
        "Israel": "以色列",
        "Grenada": "格瑞那達",
        "Kenya": "肯亞",
        "St. Helena": "聖赫勒拿",
        "Guam": "關島",
        "Denmark": "丹麥",
        "New Caledonia": "新喀里多尼亞",
        "Ecuador": "厄瓜多",
        "Canada": "加拿大",
        "Egypt": "埃及",
        "Saudi Arabia": "沙烏地阿拉伯",
        "Botswana": "波札那",
        "Turks & Caicos Islands": "特克斯和凱科斯群島",
        "Latvia": "拉脫維亞",
        "St. Pierre & Miquelon": "聖皮埃爾和密克隆群島",
        "Georgia": "喬治亞",
        "Laos": "寮國",
        "Réunion": "留尼旺",
        "Niue": "紐埃",
        "Zimbabwe": "辛巴威",
        "Thailand": "泰國",
        "Algeria": "阿爾及利亞",
        "Finland": "芬蘭",
        "Macedonia": "北馬其頓",
        "Antigua and Barbuda": "安地卡及巴布達",
        "Nigeria": "奈及利亞",
        "Switzerland": "瑞士",
        "Bulgaria": "保加利亞",
        "Montenegro": "蒙特內哥羅",
        "Tajikistan": "塔吉克",
        "Austria": "奧地利",
        "Bolivia": "玻利維亞",
        "Sudan": "蘇丹",
        "Suriname": "蘇利南",
        "Iraq": "伊拉克",
        "Bahrain": "巴林",
        "Colombia": "哥倫比亞",
        "Papua New Guinea": "巴布亞紐幾內亞",
        "Yemen": "葉門",
        "Venezuela": "委內瑞拉",
        "Djibouti": "吉布地",
        "British Indian Ocean Territory": "英屬印度洋領地",
        "Chad": "查德",
        "Germany": "德國",
        "Fiji": "斐濟",
        "British Virgin Islands": "英屬維爾京群島",
        "San Marino": "聖馬利諾",
        "Vietnam": "越南",
        "Macau": "澳門",
        "South Africa": "南非",
        "Eritrea": "厄立特里亞",
        "Greece": "希臘",
        "Ethiopia": "衣索比亞",
        "Madagascar": "馬達加斯加",
        "Marshall Islands": "馬紹爾群島",
        "United States": "美國",
        "Benin": "貝南",
        "El Salvador": "薩爾瓦多",
        "Lebanon": "黎巴嫩",
        "Palestine": "巴勒斯坦",
        "Tuvalu": "吐瓦魯",
        "Solomon Islands": "索羅門群島",
        "China": "中國",
        "Tonga": "東加"
    },
};
export const uzUZ = {
    searchNotFound: "Davlat topilmadi",
    searchPlaceholder: "Davlat qidiring",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambiya",
        "Equatorial Guinea": "Ekvatorial Gvineya",
        "Senegal": "Senegal",
        "Jamaica": "Yamayka",
        "Seychelles": "Seyshel orollari",
        "Comoros": "Komor orollari",
        "U.S. Virgin Islands": "AQSh Virjiniya orollari",
        "Guinea": "Gvineya",
        "Niger": "Niger",
        "Libya": "Liviya",
        "Romania": "Ruminiya",
        "Anguilla": "Angilya",
        "Togo": "Togo",
        "Paraguay": "Paragvay",
        "India": "Hindiston",
        "Ireland": "Irlandiya",
        "Turkey": "Turkiya",
        "Oman": "Ummon",
        "Ukraine": "Ukraina",
        "Spain": "Ispaniya",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Sent-Vinsent va Grenadin orollari",
        "Cyprus": "Kipr",
        "Belarus": "Belarus",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chili",
        "United Arab Emirates": "Birlashgan Arab Amirliklari",
        "São Tomé and Príncipe": "San-Tome va Prinsipi",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto-Riko",
        "Portugal": "Portugaliya",
        "Costa Rica": "Kosta-Rika",
        "Swaziland": "Esvatini",
        "Cape Verde": "Kabo-Verde",
        "Curaçao": "Kurasao",
        "Andorra": "Andorra",
        "Armenia": "Armaniston",
        "Haiti": "Gaiti",
        "Côte d’Ivoire": "Kot-d'Ivuar",
        "Guinea-Bissau": "Gvineya-Bisau",
        "Mozambique": "Mozambik",
        "Poland": "Polsha",
        "French Polynesia": "Frantsuz Polineziyasi",
        "Jersey": "Jersi",
        "Kuwait": "Quvayt",
        "Dominican Republic": "Dominikan Respublikasi",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Qirg'iziston",
        "Syria": "Suriya",
        "Zambia": "Zambiya",
        "Croatia": "Xorvatiya",
        "Lithuania": "Litva",
        "Albania": "Albaniya",
        "Netherlands": "Niderlandiya",
        "France": "Frantsiya",
        "Tunisia": "Tunis",
        "Bosnia and Herzegovina": "Bosniya va Gertsegovina",
        "Bahamas": "Bagama orollari",
        "Somalia": "Somali",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malavi",
        "Honduras": "Gonduras",
        "French Guiana": "Frantsuz Gvianasi",
        "Jordan": "Iordaniya",
        "Serbia": "Serbiya",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Gayana",
        "Lesotho": "Lesoto",
        "Taiwan": "Tayvan",
        "Central African Republic": "Markaziy Afrika Respublikasi",
        "Luxembourg": "Lyuksemburg",
        "Trinidad and Tobago": "Trinidad va Tobago",
        "Estonia": "Estoniya",
        "Montserrat": "Montserrat",
        "Norway": "Norvegiya",
        "North Korea": "Shimoliy Koreya",
        "Myanmar": "Myanma",
        "Sri Lanka": "Shri-Lanka",
        "Faroe Islands": "Farer orollari",
        "Dominica": "Dominika",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Folklend orollari",
        "Namibia": "Namibiya",
        "Saint Lucia": "Sent-Lyusiya",
        "Indonesia": "Indoneziya",
        "Timor-Leste": "Sharqiy Timor",
        "Norfolk Island": "Norfolk oroli",
        "Bhutan": "Butan",
        "Iran": "Eron",
        "Turkmenistan": "Turkmaniston",
        "Uganda": "Uganda",
        "Kazakhstan": "Qozog'iston",
        "Cook Islands": "Kuk orollari",
        "Micronesia": "Mikroneziya",
        "Sint Maarten": "Sint-Marten",
        "Liberia": "Liberiya",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filippin",
        "Rwanda": "Ruanda",
        "United Kingdom": "Buyuk Britaniya",
        "Martinique": "Martinika",
        "Nepal": "Nepal",
        "Guatemala": "Gvatemala",
        "Bermuda": "Bermuda",
        "Australia": "Avstraliya",
        "Vatican City": "Vatikan",
        "Slovenia": "Sloveniya",
        "Cayman Islands": "Kayman orollari",
        "Hungary": "Vengriya",
        "American Samoa": "Amerika Samoasi",
        "Mauritania": "Mavritaniya",
        "Japan": "Yaponiya",
        "Uzbekistan": "O'zbekiston",
        "Cambodia": "Kambodja",
        "Wallis & Futuna": "Uollis va Futuna",
        "South Sudan": "Janubiy Sudan",
        "Morocco": "Marokash",
        "Argentina": "Argentina",
        "Guadeloupe": "Gvadelupe",
        "Hong Kong": "Gonkong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzaniya",
        "Mexico": "Meksika",
        "Russia": "Rossiya",
        "Iceland": "Islandiya",
        "Monaco": "Monako",
        "Afghanistan": "Afg'oniston",
        "Slovakia": "Slovakiya",
        "Sweden": "Shvetsiya",
        "Azerbaijan": "Ozarbayjon",
        "Bangladesh": "Bangladesh",
        "Brazil": "Braziliya",
        "Cuba": "Kuba",
        "Ghana": "Gana",
        "Mongolia": "Mongoliya",
        "Saint Kitts and Nevis": "Sent-Kits va Nevis",
        "Burkina Faso": "Burkina-Faso",
        "Nicaragua": "Nikaragua",
        "Malaysia": "Malayziya",
        "Uruguay": "Urugvay",
        "Brunei": "Bruney",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Shimoliy Mariana orollari",
        "Pakistan": "Pokiston",
        "Greenland": "Grenlandiya",
        "Mauritius": "Mavrikiy",
        "Caribbean Netherlands": "Kariyb Niderlandiya",
        "Belize": "Beliz",
        "Liechtenstein": "Lixtenshteyn",
        "Sierra Leone": "Syerra-Leone",
        "Czech Republic": "Chexiya",
        "Moldova": "Moldova",
        "Singapore": "Singapur",
        "Belgium": "Belgiya",
        "Maldives": "Maldiv orollari",
        "New Zealand": "Yangi Zelandiya",
        "South Korea": "Janubiy Koreya",
        "Italy": "Italiya",
        "Israel": "Isroil",
        "Grenada": "Grenada",
        "Kenya": "Keniya",
        "St. Helena": "Muqaddas Yelena",
        "Guam": "Guam",
        "Denmark": "Daniya",
        "New Caledonia": "Yangi Kaledoniya",
        "Ecuador": "Ekvador",
        "Canada": "Kanada",
        "Egypt": "Misr",
        "Saudi Arabia": "Saudiya Arabistoni",
        "Botswana": "Botsvana",
        "Turks & Caicos Islands": "Turks va Kaykos orollari",
        "Latvia": "Latviya",
        "St. Pierre & Miquelon": "Sent-Pyer va Mikelon",
        "Georgia": "Gruziya",
        "Laos": "Laos",
        "Réunion": "Reyunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabve",
        "Thailand": "Tailand",
        "Algeria": "Jazoir",
        "Finland": "Finlyandiya",
        "Macedonia": "Shimoliy Makedoniya",
        "Antigua and Barbuda": "Antigua va Barbuda",
        "Nigeria": "Nigeriya",
        "Switzerland": "Shveytsariya",
        "Bulgaria": "Bolgariya",
        "Montenegro": "Chernogoriya",
        "Tajikistan": "Tojikiston",
        "Austria": "Avstriya",
        "Bolivia": "Boliviya",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Iroq",
        "Bahrain": "Bahrayn",
        "Colombia": "Kolumbiya",
        "Papua New Guinea": "Papua-Yangi Gvineya",
        "Yemen": "Yaman",
        "Venezuela": "Venesuela",
        "Djibouti": "Jibuti",
        "British Indian Ocean Territory": "Britaniya Hind okeani hududi",
        "Chad": "Chad",
        "Germany": "Germaniya",
        "Fiji": "Fiji",
        "British Virgin Islands": "Britaniya Virjiniya orollari",
        "San Marino": "San-Marino",
        "Vietnam": "Vyetnam",
        "Macau": "Makao",
        "South Africa": "Janubiy Afrika",
        "Eritrea": "Eritreya",
        "Greece": "Gretsiya",
        "Ethiopia": "Efiopiya",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshall orollari",
        "United States": "Qo'shma Shtatlar",
        "Benin": "Benin",
        "El Salvador": "Salvador",
        "Lebanon": "Livan",
        "Palestine": "Falastin",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Solomon orollari",
        "China": "Xitoy",
        "Tonga": "Tonga"
    },
};
export const neNP = {
    searchNotFound: "देश फेला परेन",
    searchPlaceholder: "देश खोज्नुहोस्",
    countries: {
        "Gibraltar": "जिब्राल्टर",
        "Gambia": "गाम्बिया",
        "Equatorial Guinea": "भू-मध्यरेखीय गिनी",
        "Senegal": "सेनेगल",
        "Jamaica": "जमैका",
        "Seychelles": "सेचेलेस",
        "Comoros": "कोमोरोस",
        "U.S. Virgin Islands": "अमेरिकी भर्जिन टापुहरू",
        "Guinea": "गिनी",
        "Niger": "नाइजेर",
        "Libya": "लिबिया",
        "Romania": "रोमानिया",
        "Anguilla": "आङ्गुइला",
        "Togo": "टोगो",
        "Paraguay": "पाराग्वे",
        "India": "भारत",
        "Ireland": "आयरल्यान्ड",
        "Turkey": "टर्की",
        "Oman": "ओमान",
        "Ukraine": "युक्रेन",
        "Spain": "स्पेन",
        "Cameroon": "क्यामरून",
        "Angola": "अङ्गोला",
        "Mali": "माली",
        "Saint Vincent and the Grenadines": "सेन्ट भिन्सेन्ट र ग्रेनाडिन्स",
        "Cyprus": "साइप्रस",
        "Belarus": "बेलारुस",
        "Gabon": "गाबोन",
        "Samoa": "सामोआ",
        "Chile": "चिली",
        "United Arab Emirates": "संयुक्त अरब एमिरेट्स",
        "São Tomé and Príncipe": "साओ टोमे र प्रिन्सिपे",
        "Palau": "पलाऊ",
        "Tokelau": "टोकेलाउ",
        "Puerto Rico": "पुएर्टो रिको",
        "Portugal": "पोर्चुगल",
        "Costa Rica": "कोष्टारिका",
        "Swaziland": "स्वाजिल्याण्ड",
        "Cape Verde": "केप भर्डे",
        "Curaçao": "कुरासाओ",
        "Andorra": "एन्डोरा",
        "Armenia": "आर्मेनिया",
        "Haiti": "हैटी",
        "Côte d’Ivoire": "कोट दिभोइर",
        "Guinea-Bissau": "गिनी-बिसाउ",
        "Mozambique": "मोजाम्बिक",
        "Poland": "पोल्याण्ड",
        "French Polynesia": "फ्रान्सेली पोलिनेसिया",
        "Jersey": "जर्सी",
        "Kuwait": "कुवेत",
        "Dominican Republic": "डोमिनिकन गणराज्य",
        "Kosovo": "कोसोभो",
        "Kyrgyzstan": "किर्गिस्तान",
        "Syria": "सिरिया",
        "Zambia": "जाम्बिया",
        "Croatia": "क्रोएसिया",
        "Lithuania": "लिथुआनिया",
        "Albania": "अल्बानिया",
        "Netherlands": "नेदरल्याण्ड",
        "France": "फ्रान्स",
        "Tunisia": "ट्युनिसिया",
        "Bosnia and Herzegovina": "बोस्निया र हर्जगोभिना",
        "Bahamas": "बहामास",
        "Somalia": "सोमालिया",
        "Burundi": "बुरूण्डी",
        "Barbados": "बार्बाडोस",
        "Malawi": "मलावी",
        "Honduras": "हन्डुरस",
        "French Guiana": "फ्रान्सेली गायना",
        "Jordan": "जोर्डन",
        "Serbia": "सर्बिया",
        "Vanuatu": "भानुआतु",
        "Aruba": "अरूबा",
        "Guyana": "गयाना",
        "Lesotho": "लेसोथो",
        "Taiwan": "ताइवान",
        "Central African Republic": "केन्द्रीय अफ्रिकी गणराज्य",
        "Luxembourg": "लक्जमबर्ग",
        "Trinidad and Tobago": "त्रिनिदाद र टोबागो",
        "Estonia": "एस्टोनिया",
        "Montserrat": "मोन्टसेराट",
        "Norway": "नर्वे",
        "North Korea": "उत्तर कोरिया",
        "Myanmar": "म्यानमार",
        "Sri Lanka": "श्रीलंका",
        "Faroe Islands": "फारो टापुहरू",
        "Dominica": "डोमिनिका",
        "Kiribati": "किरिबाटी",
        "Falkland Islands": "फाकल्याण्ड टापुहरू",
        "Namibia": "नामिबिया",
        "Saint Lucia": "सेन्ट लुसिया",
        "Indonesia": "इन्डोनेसिया",
        "Timor-Leste": "टिमोर-लेस्टे",
        "Norfolk Island": "नरफोल्क टापु",
        "Bhutan": "भुटान",
        "Iran": "ईरान",
        "Turkmenistan": "तुर्कमेनिस्तान",
        "Uganda": "युगान्डा",
        "Kazakhstan": "कजाकिस्तान",
        "Cook Islands": "कुक टापुहरू",
        "Micronesia": "माइक्रोनेसिया",
        "Sint Maarten": "सिन्ट मार्टेन",
        "Liberia": "लाइबेरिया",
        "Panama": "पनामा",
        "Malta": "माल्टा",
        "Peru": "पेरू",
        "Philippines": "फिलिपिन्स",
        "Rwanda": "रवाण्डा",
        "United Kingdom": "संयुक्त अधिराज्य",
        "Martinique": "मार्टिनिक",
        "Nepal": "नेपाल",
        "Guatemala": "ग्वाटेमाला",
        "Bermuda": "बर्मुडा",
        "Australia": "अष्ट्रेलिया",
        "Vatican City": "भेटिकन सिटी",
        "Slovenia": "स्लोभेनिया",
        "Cayman Islands": "केमन टापुहरू",
        "Hungary": "हङ्गेरी",
        "American Samoa": "अमेरिकी सामोआ",
        "Mauritania": "माउरिटानिया",
        "Japan": "जापान",
        "Uzbekistan": "उजबेकिस्तान",
        "Cambodia": "कम्बोडिया",
        "Wallis & Futuna": "वालिस र फुटुना",
        "South Sudan": "दक्षिण सुडान",
        "Morocco": "मोरक्को",
        "Argentina": "अर्जेन्टिना",
        "Guadeloupe": "ग्वाडेलुप",
        "Hong Kong": "हङकङ",
        "Qatar": "कतार",
        "Tanzania": "तान्जानिया",
        "Mexico": "मेक्सिको",
        "Russia": "रूस",
        "Iceland": "आइसल्याण्ड",
        "Monaco": "मोनाको",
        "Afghanistan": "अफगानिस्तान",
        "Slovakia": "स्लोभाकिया",
        "Sweden": "स्वीडेन",
        "Azerbaijan": "अजरबैजान",
        "Bangladesh": "बङ्गलादेश",
        "Brazil": "ब्राजिल",
        "Cuba": "क्युबा",
        "Ghana": "घाना",
        "Mongolia": "मङ्गोलिया",
        "Saint Kitts and Nevis": "सेन्ट किट्स र नेभिस",
        "Burkina Faso": "बुर्किना फासो",
        "Nicaragua": "निकारागुवा",
        "Malaysia": "मलेशिया",
        "Uruguay": "उरुग्वे",
        "Brunei": "ब्रुनाइ",
        "Congo": "कङ्गो",
        "Nauru": "नाउरु",
        "Northern Mariana Islands": "उत्तर मारीयाना टापुहरू",
        "Pakistan": "पाकिस्तान",
        "Greenland": "ग्रिनल्याण्ड",
        "Mauritius": "माउरिसियस",
        "Caribbean Netherlands": "क्यारिबियन नेदरल्याण्ड",
        "Belize": "बेलिज",
        "Liechtenstein": "लिक्टेनस्टाइन",
        "Sierra Leone": "सिएरा लिओन",
        "Czech Republic": "चेक गणराज्य",
        "Moldova": "माल्डोभा",
        "Singapore": "सिङ्गापुर",
        "Belgium": "बेल्जियम",
        "Maldives": "माल्दिभ्स",
        "New Zealand": "न्युजिल्यान्ड",
        "South Korea": "दक्षिण कोरिया",
        "Italy": "इटाली",
        "Israel": "इजरायल",
        "Grenada": "ग्रेनाडा",
        "Kenya": "केन्या",
        "St. Helena": "सेन्ट हेलेना",
        "Guam": "गुआम",
        "Denmark": "डेनमार्क",
        "New Caledonia": "नयाँ कालेडोनिया",
        "Ecuador": "इक्वेडर",
        "Canada": "क्यानडा",
        "Egypt": "इजिप्ट",
        "Saudi Arabia": "साउदी अरेबिया",
        "Botswana": "बोट्सवाना",
        "Turks & Caicos Islands": "टर्क्स र काइकोस टापुहरू",
        "Latvia": "लाट्भिया",
        "St. Pierre & Miquelon": "सेन्ट पियरे र मिक्वेलोन",
        "Georgia": "जर्जिया",
        "Laos": "लाओस",
        "Réunion": "रियुनियन",
        "Niue": "निउ",
        "Zimbabwe": "जिम्बावे",
        "Thailand": "थाइल्याण्ड",
        "Algeria": "अल्जेरिया",
        "Finland": "फिनल्याण्ड",
        "Macedonia": "उत्तर म्यासेडोनिया",
        "Antigua and Barbuda": "एन्टिगुआ र बारबुडा",
        "Nigeria": "नाइजेरिया",
        "Switzerland": "स्विजरल्याण्ड",
        "Bulgaria": "बुल्गेरिया",
        "Montenegro": "मोन्टेनेग्रो",
        "Tajikistan": "ताजिकिस्तान",
        "Austria": "अष्ट्रिया",
        "Bolivia": "बोलिभिया",
        "Sudan": "सुडान",
        "Suriname": "सुरिनाम",
        "Iraq": "इराक",
        "Bahrain": "बहराइन",
        "Colombia": "कोलम्बिया",
        "Papua New Guinea": "पपुआ न्यू गिनी",
        "Yemen": "येमेन",
        "Venezuela": "भेनेजुएला",
        "Djibouti": "जिबोटी",
        "British Indian Ocean Territory": "बेलायती हिन्द महासागर क्षेत्र",
        "Chad": "चाड",
        "Germany": "जर्मनी",
        "Fiji": "फिजी",
        "British Virgin Islands": "बेलायती भर्जिन टापुहरू",
        "San Marino": "सान मारिनो",
        "Vietnam": "भियतनाम",
        "Macau": "मकाउ",
        "South Africa": "दक्षिण अफ्रिका",
        "Eritrea": "एरित्रिया",
        "Greece": "ग्रिस",
        "Ethiopia": "इथियोपिया",
        "Madagascar": "माडागास्कर",
        "Marshall Islands": "मार्शल टापुहरू",
        "United States": "संयुक्त राज्य",
        "Benin": "बेनिन",
        "El Salvador": "एल साल्भाडोर",
        "Lebanon": "लेबनान",
        "Palestine": "फिलिस्तिन",
        "Tuvalu": "तुभालु",
        "Solomon Islands": "सोलोमन टापुहरू",
        "China": "चीन",
        "Tonga": "टोंगा"
    },
};
export const deDE = {
    searchNotFound: "Land nicht gefunden",
    searchPlaceholder: "Land suchen",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Äquatorialguinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaika",
        "Seychelles": "Seychellen",
        "Comoros": "Komoren",
        "U.S. Virgin Islands": "Amerikanische Jungferninseln",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libyen",
        "Romania": "Rumänien",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Indien",
        "Ireland": "Irland",
        "Turkey": "Türkei",
        "Oman": "Oman",
        "Ukraine": "Ukraine",
        "Spain": "Spanien",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "St. Vincent und die Grenadinen",
        "Cyprus": "Zypern",
        "Belarus": "Weißrussland",
        "Gabon": "Gabun",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Vereinigte Arabische Emirate",
        "São Tomé and Príncipe": "São Tomé und Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Kap Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenien",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Elfenbeinküste",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Mosambik",
        "Poland": "Polen",
        "French Polynesia": "Französisch-Polynesien",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Dominikanische Republik",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgisistan",
        "Syria": "Syrien",
        "Zambia": "Sambia",
        "Croatia": "Kroatien",
        "Lithuania": "Litauen",
        "Albania": "Albanien",
        "Netherlands": "Niederlande",
        "France": "Frankreich",
        "Tunisia": "Tunesien",
        "Bosnia and Herzegovina": "Bosnien und Herzegowina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Französisch-Guayana",
        "Jordan": "Jordanien",
        "Serbia": "Serbien",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Zentralafrikanische Republik",
        "Luxembourg": "Luxemburg",
        "Trinidad and Tobago": "Trinidad und Tobago",
        "Estonia": "Estland",
        "Montserrat": "Montserrat",
        "Norway": "Norwegen",
        "North Korea": "Nordkorea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Färöer-Inseln",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandinseln",
        "Namibia": "Namibia",
        "Saint Lucia": "St. Lucia",
        "Indonesia": "Indonesien",
        "Timor-Leste": "Osttimor",
        "Norfolk Island": "Norfolkinsel",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kasachstan",
        "Cook Islands": "Cookinseln",
        "Micronesia": "Mikronesien",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Philippinen",
        "Rwanda": "Ruanda",
        "United Kingdom": "Vereinigtes Königreich",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australien",
        "Vatican City": "Vatikanstadt",
        "Slovenia": "Slowenien",
        "Cayman Islands": "Kaimaninseln",
        "Hungary": "Ungarn",
        "American Samoa": "Amerikanisch-Samoa",
        "Mauritania": "Mauretanien",
        "Japan": "Japan",
        "Uzbekistan": "Usbekistan",
        "Cambodia": "Kambodscha",
        "Wallis & Futuna": "Wallis und Futuna",
        "South Sudan": "Südsudan",
        "Morocco": "Marokko",
        "Argentina": "Argentinien",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Katar",
        "Tanzania": "Tansania",
        "Mexico": "Mexiko",
        "Russia": "Russland",
        "Iceland": "Island",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slowakei",
        "Sweden": "Schweden",
        "Azerbaijan": "Aserbaidschan",
        "Bangladesh": "Bangladesch",
        "Brazil": "Brasilien",
        "Cuba": "Kuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongolei",
        "Saint Kitts and Nevis": "St. Kitts und Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Nördliche Marianen",
        "Pakistan": "Pakistan",
        "Greenland": "Grönland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Karibische Niederlande",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Tschechien",
        "Moldova": "Moldau",
        "Singapore": "Singapur",
        "Belgium": "Belgien",
        "Maldives": "Malediven",
        "New Zealand": "Neuseeland",
        "South Korea": "Südkorea",
        "Italy": "Italien",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenia",
        "St. Helena": "St. Helena",
        "Guam": "Guam",
        "Denmark": "Dänemark",
        "New Caledonia": "Neukaledonien",
        "Ecuador": "Ecuador",
        "Canada": "Kanada",
        "Egypt": "Ägypten",
        "Saudi Arabia": "Saudi-Arabien",
        "Botswana": "Botsuana",
        "Turks & Caicos Islands": "Turks- und Caicosinseln",
        "Latvia": "Lettland",
        "St. Pierre & Miquelon": "Saint-Pierre und Miquelon",
        "Georgia": "Georgien",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Simbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algerien",
        "Finland": "Finnland",
        "Macedonia": "Nordmazedonien",
        "Antigua and Barbuda": "Antigua und Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Schweiz",
        "Bulgaria": "Bulgarien",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tadschikistan",
        "Austria": "Österreich",
        "Bolivia": "Bolivien",
        "Sudan": "Sudan",
        "Suriname": "Suriname",
        "Iraq": "Irak",
        "Bahrain": "Bahrain",
        "Colombia": "Kolumbien",
        "Papua New Guinea": "Papua-Neuguinea",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Dschibuti",
        "British Indian Ocean Territory": "Britisches Territorium im Indischen Ozean",
        "Chad": "Tschad",
        "Germany": "Deutschland",
        "Fiji": "Fidschi",
        "British Virgin Islands": "Britische Jungferninseln",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Südafrika",
        "Eritrea": "Eritrea",
        "Greece": "Griechenland",
        "Ethiopia": "Äthiopien",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshallinseln",
        "United States": "Vereinigte Staaten",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palästina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomonen",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const glES = {
    searchNotFound: "Non se atopou o país",
    searchPlaceholder: "Buscar país",
    countries: {
        "Gibraltar": "Xibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Guinea Ecuatorial",
        "Senegal": "Senegal",
        "Jamaica": "Xamaica",
        "Seychelles": "Seixeles",
        "Comoros": "Comores",
        "U.S. Virgin Islands": "Illas Virxes dos EUA",
        "Guinea": "Guinea",
        "Niger": "Níxer",
        "Libya": "Libia",
        "Romania": "Romanía",
        "Anguilla": "Anguila",
        "Togo": "Togo",
        "Paraguay": "Paraguai",
        "India": "India",
        "Ireland": "Irlanda",
        "Turkey": "Turquía",
        "Oman": "Omán",
        "Ukraine": "Ucraína",
        "Spain": "España",
        "Cameroon": "Camerún",
        "Angola": "Angola",
        "Mali": "Malí",
        "Saint Vincent and the Grenadines": "San Vicente e as Granadinas",
        "Cyprus": "Chipre",
        "Belarus": "Belarús",
        "Gabon": "Gabón",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Emiratos Árabes Unidos",
        "São Tomé and Príncipe": "San Tomé e Príncipe",
        "Palau": "Palaos",
        "Tokelau": "Toquelau",
        "Puerto Rico": "Porto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Eswatini",
        "Cape Verde": "Cabo Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenia",
        "Haiti": "Haití",
        "Côte d’Ivoire": "Costa de Marfil",
        "Guinea-Bissau": "Guinea-Bisau",
        "Mozambique": "Mozambique",
        "Poland": "Polonia",
        "French Polynesia": "Polinesia Francesa",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "República Dominicana",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirguizistán",
        "Syria": "Siria",
        "Zambia": "Zambia",
        "Croatia": "Croacia",
        "Lithuania": "Lituania",
        "Albania": "Albania",
        "Netherlands": "Países Baixos",
        "France": "Francia",
        "Tunisia": "Tunes",
        "Bosnia and Herzegovina": "Bosnia e Hercegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malaui",
        "Honduras": "Honduras",
        "French Guiana": "Güiana Francesa",
        "Jordan": "Xordania",
        "Serbia": "Serbia",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Güiana",
        "Lesotho": "Lesoto",
        "Taiwan": "Taiwán",
        "Central African Republic": "República Centroafricana",
        "Luxembourg": "Luxemburgo",
        "Trinidad and Tobago": "Trindade e Tobago",
        "Estonia": "Estonia",
        "Montserrat": "Montserrat",
        "Norway": "Noruega",
        "North Korea": "Corea do Norte",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Illas Feroe",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Illas Malvinas",
        "Namibia": "Namibia",
        "Saint Lucia": "Santa Lucía",
        "Indonesia": "Indonesia",
        "Timor-Leste": "Timor Leste",
        "Norfolk Island": "Illa Norfolk",
        "Bhutan": "Bután",
        "Iran": "Irán",
        "Turkmenistan": "Turkmenistán",
        "Uganda": "Uganda",
        "Kazakhstan": "Casaquistán",
        "Cook Islands": "Illas Cook",
        "Micronesia": "Micronesia",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panamá",
        "Malta": "Malta",
        "Peru": "Perú",
        "Philippines": "Filipinas",
        "Rwanda": "Ruanda",
        "United Kingdom": "Reino Unido",
        "Martinique": "Martinica",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermudas",
        "Australia": "Australia",
        "Vatican City": "Cidade do Vaticano",
        "Slovenia": "Eslovenia",
        "Cayman Islands": "Illas Caimán",
        "Hungary": "Hungría",
        "American Samoa": "Samoa Americana",
        "Mauritania": "Mauritania",
        "Japan": "Xapón",
        "Uzbekistan": "Uzbekistán",
        "Cambodia": "Camboxa",
        "Wallis & Futuna": "Wallis e Futuna",
        "South Sudan": "Sudán do Sur",
        "Morocco": "Marrocos",
        "Argentina": "Arxentina",
        "Guadeloupe": "Guadalupe",
        "Hong Kong": "Hong Kong",
        "Qatar": "Catar",
        "Tanzania": "Tanzania",
        "Mexico": "México",
        "Russia": "Rusia",
        "Iceland": "Islandia",
        "Monaco": "Mónaco",
        "Afghanistan": "Afganistán",
        "Slovakia": "Eslovaquia",
        "Sweden": "Suecia",
        "Azerbaijan": "Acerbaixán",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasil",
        "Cuba": "Cuba",
        "Ghana": "Gana",
        "Mongolia": "Mongolia",
        "Saint Kitts and Nevis": "Saint Kitts e Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaisia",
        "Uruguay": "Uruguai",
        "Brunei": "Brunei",
        "Congo": "Congo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Illas Marianas do Norte",
        "Pakistan": "Paquistán",
        "Greenland": "Groenlandia",
        "Mauritius": "Mauricio",
        "Caribbean Netherlands": "Países Baixos Caribeños",
        "Belize": "Belice",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Serra Leoa",
        "Czech Republic": "Chequia",
        "Moldova": "Moldavia",
        "Singapore": "Singapur",
        "Belgium": "Bélxica",
        "Maldives": "Maldivas",
        "New Zealand": "Nova Celandia",
        "South Korea": "Corea do Sur",
        "Italy": "Italia",
        "Israel": "Israel",
        "Grenada": "Granada",
        "Kenya": "Quenia",
        "St. Helena": "Santa Helena",
        "Guam": "Guam",
        "Denmark": "Dinamarca",
        "New Caledonia": "Nova Caledonia",
        "Ecuador": "Ecuador",
        "Canada": "Canadá",
        "Egypt": "Exipto",
        "Saudi Arabia": "Arabia Saudita",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Illas Turks e Caicos",
        "Latvia": "Letonia",
        "St. Pierre & Miquelon": "Saint-Pierre e Miquelon",
        "Georgia": "Xeorxia",
        "Laos": "Laos",
        "Réunion": "Reunión",
        "Niue": "Niue",
        "Zimbabwe": "Cimbabue",
        "Thailand": "Tailandia",
        "Algeria": "Arxelia",
        "Finland": "Finlandia",
        "Macedonia": "Macedonia do Norte",
        "Antigua and Barbuda": "Antiga e Barbuda",
        "Nigeria": "Nixeria",
        "Switzerland": "Suíza",
        "Bulgaria": "Bulgaria",
        "Montenegro": "Montenegro",
        "Tajikistan": "Taxiquistán",
        "Austria": "Austria",
        "Bolivia": "Bolivia",
        "Sudan": "Sudán",
        "Suriname": "Surinam",
        "Iraq": "Iraq",
        "Bahrain": "Bahrein",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papúa-Nova Guinea",
        "Yemen": "Iemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Xibutí",
        "British Indian Ocean Territory": "Territorio Británico do Océano Índico",
        "Chad": "Chad",
        "Germany": "Alemaña",
        "Fiji": "Fixi",
        "British Virgin Islands": "Illas Virxes Británicas",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macau",
        "South Africa": "Sudáfrica",
        "Eritrea": "Eritrea",
        "Greece": "Grecia",
        "Ethiopia": "Etiopía",
        "Madagascar": "Madagascar",
        "Marshall Islands": "Illas Marshall",
        "United States": "Estados Unidos",
        "Benin": "Benín",
        "El Salvador": "O Salvador",
        "Lebanon": "Líbano",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Illas Salomón",
        "China": "China",
        "Tonga": "Tonga"
    },
};
export const knIN = {
    searchNotFound: "ದೇಶ ಕಂಡುಬಂದಿಲ್ಲ",
    searchPlaceholder: "ದೇಶವನ್ನು ಹುಡುಕಿ",
    countries: {
        "Gibraltar": "ಜಿಬ್ರಾಲ್ಟರ್",
        "Gambia": "ಗ್ಯಾಂಬಿಯಾ",
        "Equatorial Guinea": "ಭೂಮಧ್ಯ ರೇಖೀಯ ಗಿನಿ",
        "Senegal": "ಸೆನೆಗಲ್",
        "Jamaica": "ಜಮೈಕಾ",
        "Seychelles": "ಸೆಚೆಲ್ಲೆಸ್",
        "Comoros": "ಕೊಮೊರೊಸ್",
        "U.S. Virgin Islands": "ಯು.ಎಸ್. ವರ್ಜಿನ್ ಐಲೆಂಡ್ಸ್",
        "Guinea": "ಗಿನಿ",
        "Niger": "ನೈಜರ್",
        "Libya": "ಲಿಬಿಯಾ",
        "Romania": "ರೊಮೇನಿಯಾ",
        "Anguilla": "ಆಂಗ್ವಿಲ್ಲಾ",
        "Togo": "ಟೋಗೋ",
        "Paraguay": "ಪರಾಗ್ವೇ",
        "India": "ಭಾರತ",
        "Ireland": "ಐರ್ಲೆಂಡ್",
        "Turkey": "ತುರ್ಕಿ",
        "Oman": "ಒಮನ್",
        "Ukraine": "ಉಕ್ರೈನ್",
        "Spain": "ಸ್ಪೇನ್",
        "Cameroon": "ಕ್ಯಾಮರೂನ್",
        "Angola": "ಅಂಗೋಲಾ",
        "Mali": "ಮಾಲಿ",
        "Saint Vincent and the Grenadines": "ಸೇಂಟ್ ವಿನ್ಸೆಂಟ್ ಮತ್ತು ಗ್ರೆನಡೈನ್ಸ್",
        "Cyprus": "ಸೈಪ್ರಸ್",
        "Belarus": "ಬೆಲಾರುಸ್",
        "Gabon": "ಗ್ಯಾಬನ್",
        "Samoa": "ಸಮೋವಾ",
        "Chile": "ಚಿಲಿ",
        "United Arab Emirates": "ಸಂಯುಕ್ತ ಅರಬ್ ಎಮಿರೇಟ್ಸ್",
        "São Tomé and Príncipe": "ಸಾವೋ ಟೋಮ್ ಮತ್ತು ಪ್ರಿನ್ಸಿಪೆ",
        "Palau": "ಪಾಲಾವು",
        "Tokelau": "ಟೊಕೆಲಾವು",
        "Puerto Rico": "ಪ್ಯೂಟೋ ರಿಕೋ",
        "Portugal": "ಪೋರ್ಚುಗಲ್",
        "Costa Rica": "ಕೋಸ್ಟಾ ರಿಕಾ",
        "Swaziland": "ಸ್ವಾಜಿಲ್ಯಾಂಡ್",
        "Cape Verde": "ಕೇಪ್ ವರ್ಡೆ",
        "Curaçao": "ಕುರಸಾವ್",
        "Andorra": "ಅಂಡೊರ್ರಾ",
        "Armenia": "ಅರ್ಮೇನಿಯಾ",
        "Haiti": "ಹೈಟಿ",
        "Côte d’Ivoire": "ಐವರಿ ಕೋಸ್ಟ್",
        "Guinea-Bissau": "ಗಿನಿ-ಬಿಸ್ಸಾವ್",
        "Mozambique": "ಮೋಜಾಂಬಿಕ್",
        "Poland": "ಪೋಲೆಂಡ್",
        "French Polynesia": "ಫ್ರೆಂಚ್ ಪೊಲಿನೇಶಿಯಾ",
        "Jersey": "ಜರ್ಸಿ",
        "Kuwait": "ಕುವೈತ್",
        "Dominican Republic": "ಡೊಮಿನಿಕನ್ ರಿಪಬ್ಲಿಕ್",
        "Kosovo": "ಕೊಸೊವೊ",
        "Kyrgyzstan": "ಕಿರ್ಗಿಸ್ಥಾನ್",
        "Syria": "ಸಿರಿಯ",
        "Zambia": "ಜಾಂಬಿಯಾ",
        "Croatia": "ಕ್ರೊಯೇಶಿಯ",
        "Lithuania": "ಲಿಥುವೇನಿಯಾ",
        "Albania": "ಅಲ್ಬೇನಿಯಾ",
        "Netherlands": "ನೆದರ್‌ಲ್ಯಾಂಡ್ಸ್",
        "France": "ಫ್ರಾನ್ಸ್",
        "Tunisia": "ಟುನಿಶಿಯಾ",
        "Bosnia and Herzegovina": "ಬೋಸ್ನಿಯಾ ಮತ್ತು ಹರ್ಝೆಗೊವಿನಾ",
        "Bahamas": "ಬಹಾಮಾಸ್",
        "Somalia": "ಸೋಮಾಲಿಯಾ",
        "Burundi": "ಬುರೂಂಡಿ",
        "Barbados": "ಬಾರ್ಬಡೋಸ್",
        "Malawi": "ಮಲಾವಿ",
        "Honduras": "ಹೋಂಡುರಾಸ್",
        "French Guiana": "ಫ್ರೆಂಚ್ ಗಯಾನಾ",
        "Jordan": "ಜೋರ್ಡಾನ್",
        "Serbia": "ಸರ್ಬಿಯಾ",
        "Vanuatu": "ವನೌಟು",
        "Aruba": "ಅರುಬಾ",
        "Guyana": "ಗಯಾನಾ",
        "Lesotho": "ಲೆಸೊಥೋ",
        "Taiwan": "ತೈವಾನ್",
        "Central African Republic": "ಮಧ್ಯ ಆಫ್ರಿಕಾ ಗಣರಾಜ್ಯ",
        "Luxembourg": "ಲಕ್ಸೆಂಬರ್ಗ್",
        "Trinidad and Tobago": "ಟ್ರಿನಿಡಾಡ್ ಮತ್ತು ಟೊಬಾಗೊ",
        "Estonia": "ಎಸ್ಟೋನಿಯಾ",
        "Montserrat": "ಮಾಂಟ್‌ಸೆರಾಟ್",
        "Norway": "ನಾರ್ವೆ",
        "North Korea": "ಉತ್ತರ ಕೊರಿಯಾ",
        "Myanmar": "ಮ್ಯಾನ್ಮಾರ್",
        "Sri Lanka": "ಶ್ರೀಲಂಕಾ",
        "Faroe Islands": "ಫಾರೋ ದ್ವೀಪಗಳು",
        "Dominica": "ಡೊಮಿನಿಕಾ",
        "Kiribati": "ಕಿರಿಬಾಟಿ",
        "Falkland Islands": "ಫಾಕ್ಲ್ಯಾಂಡ್ ದ್ವೀಪಗಳು",
        "Namibia": "ನಮೀಬಿಯಾ",
        "Saint Lucia": "ಸೇಂಟ್ ಲೂಸಿಯಾ",
        "Indonesia": "ಇಂಡೋನೇಶಿಯಾ",
        "Timor-Leste": "ಟಿಮೋರ್-ಲೆಸ್ಟೆ",
        "Norfolk Island": "ನಾರ್ಫೋಕ್ ದ್ವೀಪ",
        "Bhutan": "ಭೂತಾನ್",
        "Iran": "ಇರಾನ್",
        "Turkmenistan": "ತುರ್ಕಮೆನಿಸ್ತಾನ್",
        "Uganda": "ಉಗಾಂಡಾ",
        "Kazakhstan": "ಕಝಾಕಿಸ್ತಾನ",
        "Cook Islands": "ಕುಕ್ ದ್ವೀಪಗಳು",
        "Micronesia": "ಮೈಕ್ರೋನೇಶಿಯಾ",
        "Sint Maarten": "ಸಿಂಟ್ ಮಾರ್ಟೆನ್",
        "Liberia": "ಲಿಬೇರಿಯಾ",
        "Panama": "ಪನಾಮಾ",
        "Malta": "ಮಾಲ್ಟಾ",
        "Peru": "ಪೆರು",
        "Philippines": "ಫಿಲಿಫೈನ್ಸ್",
        "Rwanda": "ರುವಾಂಡಾ",
        "United Kingdom": "ಯುನೈಟೆಡ್ ಕಿಂಗ್ಡಮ್",
        "Martinique": "ಮಾರ್ಟಿನಿಕ್",
        "Nepal": "ನೇಪಾಳ",
        "Guatemala": "ಗ್ವಾಟೆಮಾಲಾ",
        "Bermuda": "ಬರ್ಮುಡಾ",
        "Australia": "ಆಸ್ಟ್ರೇಲಿಯಾ",
        "Vatican City": "ವ್ಯಾಟಿಕನ್ ನಗರ",
        "Slovenia": "ಸ್ಲೋವೇನಿಯಾ",
        "Cayman Islands": "ಕೇಮನ್ ದ್ವೀಪಗಳು",
        "Hungary": "ಹಂಗೇರಿ",
        "American Samoa": "ಅಮೇರಿಕನ್ ಸಾಮೋವಾ",
        "Mauritania": "ಮಾರಿಟಾನಿಯಾ",
        "Japan": "ಜಪಾನ್",
        "Uzbekistan": "ಉಜ್ಬೇಕಿಸ್ತಾನ್",
        "Cambodia": "ಕಾಂಬೋಡಿಯಾ",
        "Wallis & Futuna": "ವಾಲಿಸ್ ಮತ್ತು ಫುಟುನಾ",
        "South Sudan": "ದಕ್ಷಿಣ ಸುಡಾನ್",
        "Morocco": "ಮೊರಾಕ್ಕೊ",
        "Argentina": "ಅರ್ಜೆಂಟಿನಾ",
        "Guadeloupe": "ಗ್ವಾಡೆಲೂಪ್",
        "Hong Kong": "ಹಾಂಗ್ ಕಾಂಗ್",
        "Qatar": "ಖತಾರ್",
        "Tanzania": "ತಾಂಜಾನಿಯಾ",
        "Mexico": "ಮೆಕ್ಸಿಕೊ",
        "Russia": "ರಷ್ಯಾ",
        "Iceland": "ಐಸ್ಲ್ಯಾಂಡ್",
        "Monaco": "ಮೊನಾಕೋ",
        "Afghanistan": "ಅಫ್ಘಾನಿಸ್ತಾನ",
        "Slovakia": "ಸ್ಲೋವಾಕಿಯಾ",
        "Sweden": "ಸ್ವೀಡನ್",
        "Azerbaijan": "ಅಜೆರ್ಬೈಜಾನ್",
        "Bangladesh": "ಬಾಂಗ್ಲಾದೇಶ",
        "Brazil": "ಬ್ರೆಜಿಲ್",
        "Cuba": "ಕ್ಯೂಬಾ",
        "Ghana": "ಘಾನಾ",
        "Mongolia": "ಮೊಂಗೋಲಿಯಾ",
        "Saint Kitts and Nevis": "ಸೇಂಟ್ ಕಿಟ್ಸ್ ಮತ್ತು ನೆವಿಸ್",
        "Burkina Faso": "ಬುರ್ಕಿನಾ ಫಾಸೋ",
        "Nicaragua": "ನಿಕಾರಾಗುವ",
        "Malaysia": "ಮಲೇಶಿಯಾ",
        "Uruguay": "ಉರುಗ್ವೇ",
        "Brunei": "ಬ್ರೂನಿ",
        "Congo": "ಕಾಂಗೋ",
        "Nauru": "ನೌರು",
        "Northern Mariana Islands": "ಉತ್ತರ ಮರಿಯಾನಾ ದ್ವೀಪಗಳು",
        "Pakistan": "ಪಾಕಿಸ್ತಾನ",
        "Greenland": "ಗ್ರಿನ್ಲ್ಯಾಂಡ್",
        "Mauritius": "ಮಾರಿಷಸ್",
        "Caribbean Netherlands": "ಕೆರಿಬಿಯನ್ ನೆದರ್ಲ್ಯಾಂಡ್ಸ್",
        "Belize": "ಬೆಲಿಜ್",
        "Liechtenstein": "ಲಿಚೆಟೆನ್ಸ್ಟೈನ್",
        "Sierra Leone": "ಸಿಯೆರ್ರಾ ಲಿಯೋನ್",
        "Czech Republic": "ಜೆಕ್ ಗಣರಾಜ್ಯ",
        "Moldova": "ಮೊಲ್ಡೋವಾ",
        "Singapore": "ಸಿಂಗಾಪುರ್",
        "Belgium": "ಬೆಲ್ಜಿಯಮ್",
        "Maldives": "ಮಾಲ್ಡೀವ್ಸ್",
        "New Zealand": "ನ್ಯೂಜಿಲ್ಯಾಂಡ್",
        "South Korea": "ದಕ್ಷಿಣ ಕೊರಿಯಾ",
        "Italy": "ಇಟಲಿ",
        "Israel": "ಇಸ್ರೇಲ್",
        "Grenada": "ಗ್ರೆನಡಾ",
        "Kenya": "ಕೆನ್ಯಾ",
        "St. Helena": "ಸೇಂಟ್ ಹೆಲೆನಾ",
        "Guam": "ಗ್ವಾಮ್",
        "Denmark": "ಡೆನ್ಮಾರ್ಕ್",
        "New Caledonia": "ನ್ಯೂ ಕ್ಯಾಲಿಡೋನಿಯಾ",
        "Ecuador": "ಈಕ್ವೆಡಾರ್",
        "Canada": "ಕಾನಡಾ",
        "Egypt": "ಈಜಿಪ್ಟ್",
        "Saudi Arabia": "ಸೌದಿ ಅರೇಬಿಯಾ",
        "Botswana": "ಬೋಟ್ಸ್‌ವಾನಾ",
        "Turks & Caicos Islands": "ಟರ್ಕ್ಸ್ ಮತ್ತು ಕೈಕೋಸ್ ದ್ವೀಪಗಳು",
        "Latvia": "ಲಾಟ್ವಿಯಾ",
        "St. Pierre & Miquelon": "ಸೇಂಟ್ ಪಿಯರೆ ಮತ್ತು ಮಿಕ್ವೆಲೋನ್",
        "Georgia": "ಜಾರ್ಜಿಯಾ",
        "Laos": "ಲಾವೋಸ್",
        "Réunion": "ರಿಯೂನಿಯನ್",
        "Niue": "ನಿಯು",
        "Zimbabwe": "ಜಿಂಬಾಬ್ವೆ",
        "Thailand": "ಥೈಲ್ಯಾಂಡ್",
        "Algeria": "ಅಲ್ಜೀರಿಯಾ",
        "Finland": "ಫಿನ್ಲ್ಯಾಂಡ್",
        "Macedonia": "ಉತ್ತರ ಮ್ಯಾಸಿಡೋನಿಯಾ",
        "Antigua and Barbuda": "ಆಂಟಿಗುವಾ ಮತ್ತು ಬಾರ್ಬುಡಾ",
        "Nigeria": "ನೈಜೀರಿಯಾ",
        "Switzerland": "ಸ್ವಿಟ್ಜರ್ಲ್ಯಾಂಡ್",
        "Bulgaria": "ಬಲ್ಗೇರಿಯಾ",
        "Montenegro": "ಮೊಂಟೆನೆಗ್ರೋ",
        "Tajikistan": "ತಜಿಕಿಸ್ತಾನ್",
        "Austria": "ಆಸ್ಟ್ರಿಯಾ",
        "Bolivia": "ಬೊಲಿವಿಯಾ",
        "Sudan": "ಸುಡಾನ್",
        "Suriname": "ಸುರಿನಾಮೆ",
        "Iraq": "ಇರಾಕ್",
        "Bahrain": "ಬಹರೈನ್",
        "Colombia": "ಕೊಲೊಂಬಿಯಾ",
        "Papua New Guinea": "ಪಪುವಾ ನ್ಯೂ ಗಿನಿ",
        "Yemen": "ಯೆಮನ್",
        "Venezuela": "ವೆನೆಜುವೆಲಾ",
        "Djibouti": "ಜಿಬೌಟಿ",
        "British Indian Ocean Territory": "ಬ್ರಿಟಿಷ್ ಹಿಂದೂ ಮಹಾಸಾಗರ ಪ್ರದೇಶ",
        "Chad": "ಚಾಡ್",
        "Germany": "ಜರ್ಮನಿ",
        "Fiji": "ಫಿಜಿ",
        "British Virgin Islands": "ಬ್ರಿಟಿಷ್ ವರ್ಜಿನ್ ಐಲೆಂಡ್ಸ್",
        "San Marino": "ಸ್ಯಾನ್ ಮರಿನೊ",
        "Vietnam": "ವಿಯೆಟ್ನಾಮ್",
        "Macau": "ಮಕಾವು",
        "South Africa": "ದಕ್ಷಿಣ ಆಫ್ರಿಕಾ",
        "Eritrea": "ಎರಿಟ್ರಿಯಾ",
        "Greece": "ಗ್ರೀಸ್",
        "Ethiopia": "ಎಥಿಯೋಪಿಯಾ",
        "Madagascar": "ಮಡಗಾಸ್ಕರ್",
        "Marshall Islands": "ಮಾರ್ಶಲ್ ದ್ವೀಪಗಳು",
        "United States": "ಯುನೈಟೆಡ್ ಸ್ಟೇಟ್ಸ್",
        "Benin": "ಬೆನಿನ್",
        "El Salvador": "ಎಲ್ ಸಲ್ವೆಡಾರ್",
        "Lebanon": "ಲೆಬನಾನ್",
        "Palestine": "ಪ್ಯಾಲೆಸ್ಟೈನ್",
        "Tuvalu": "ಟುವಾಲು",
        "Solomon Islands": "ಸಾಲೊಮನ್ ದ್ವೀಪಗಳು",
        "China": "ಚೀನಾ",
        "Tonga": "ಟೋಂಗಾ"
    },
};
export const svSE = {
    searchNotFound: "Land hittades inte",
    searchPlaceholder: "Sök land",
    countries: {
        "Gibraltar": "Gibraltar",
        "Gambia": "Gambia",
        "Equatorial Guinea": "Ekvatorialguinea",
        "Senegal": "Senegal",
        "Jamaica": "Jamaica",
        "Seychelles": "Seychellerna",
        "Comoros": "Komorerna",
        "U.S. Virgin Islands": "Amerikanska Jungfruöarna",
        "Guinea": "Guinea",
        "Niger": "Niger",
        "Libya": "Libyen",
        "Romania": "Rumänien",
        "Anguilla": "Anguilla",
        "Togo": "Togo",
        "Paraguay": "Paraguay",
        "India": "Indien",
        "Ireland": "Irland",
        "Turkey": "Turkiet",
        "Oman": "Oman",
        "Ukraine": "Ukraina",
        "Spain": "Spanien",
        "Cameroon": "Kamerun",
        "Angola": "Angola",
        "Mali": "Mali",
        "Saint Vincent and the Grenadines": "Saint Vincent och Grenadinerna",
        "Cyprus": "Cypern",
        "Belarus": "Vitryssland",
        "Gabon": "Gabon",
        "Samoa": "Samoa",
        "Chile": "Chile",
        "United Arab Emirates": "Förenade Arabemiraten",
        "São Tomé and Príncipe": "São Tomé och Príncipe",
        "Palau": "Palau",
        "Tokelau": "Tokelau",
        "Puerto Rico": "Puerto Rico",
        "Portugal": "Portugal",
        "Costa Rica": "Costa Rica",
        "Swaziland": "Swaziland",
        "Cape Verde": "Kap Verde",
        "Curaçao": "Curaçao",
        "Andorra": "Andorra",
        "Armenia": "Armenien",
        "Haiti": "Haiti",
        "Côte d’Ivoire": "Elfenbenskusten",
        "Guinea-Bissau": "Guinea-Bissau",
        "Mozambique": "Moçambique",
        "Poland": "Polen",
        "French Polynesia": "Franska Polynesien",
        "Jersey": "Jersey",
        "Kuwait": "Kuwait",
        "Dominican Republic": "Dominikanska republiken",
        "Kosovo": "Kosovo",
        "Kyrgyzstan": "Kirgizistan",
        "Syria": "Syrien",
        "Zambia": "Zambia",
        "Croatia": "Kroatien",
        "Lithuania": "Litauen",
        "Albania": "Albanien",
        "Netherlands": "Nederländerna",
        "France": "Frankrike",
        "Tunisia": "Tunisien",
        "Bosnia and Herzegovina": "Bosnien och Hercegovina",
        "Bahamas": "Bahamas",
        "Somalia": "Somalia",
        "Burundi": "Burundi",
        "Barbados": "Barbados",
        "Malawi": "Malawi",
        "Honduras": "Honduras",
        "French Guiana": "Franska Guyana",
        "Jordan": "Jordanien",
        "Serbia": "Serbien",
        "Vanuatu": "Vanuatu",
        "Aruba": "Aruba",
        "Guyana": "Guyana",
        "Lesotho": "Lesotho",
        "Taiwan": "Taiwan",
        "Central African Republic": "Centralafrikanska republiken",
        "Luxembourg": "Luxemburg",
        "Trinidad and Tobago": "Trinidad och Tobago",
        "Estonia": "Estland",
        "Montserrat": "Montserrat",
        "Norway": "Norge",
        "North Korea": "Nordkorea",
        "Myanmar": "Myanmar",
        "Sri Lanka": "Sri Lanka",
        "Faroe Islands": "Färöarna",
        "Dominica": "Dominica",
        "Kiribati": "Kiribati",
        "Falkland Islands": "Falklandsöarna",
        "Namibia": "Namibia",
        "Saint Lucia": "Saint Lucia",
        "Indonesia": "Indonesien",
        "Timor-Leste": "Östtimor",
        "Norfolk Island": "Norfolkön",
        "Bhutan": "Bhutan",
        "Iran": "Iran",
        "Turkmenistan": "Turkmenistan",
        "Uganda": "Uganda",
        "Kazakhstan": "Kazakstan",
        "Cook Islands": "Cooköarna",
        "Micronesia": "Mikronesien",
        "Sint Maarten": "Sint Maarten",
        "Liberia": "Liberia",
        "Panama": "Panama",
        "Malta": "Malta",
        "Peru": "Peru",
        "Philippines": "Filippinerna",
        "Rwanda": "Rwanda",
        "United Kingdom": "Storbritannien",
        "Martinique": "Martinique",
        "Nepal": "Nepal",
        "Guatemala": "Guatemala",
        "Bermuda": "Bermuda",
        "Australia": "Australien",
        "Vatican City": "Vatikanstaten",
        "Slovenia": "Slovenien",
        "Cayman Islands": "Caymanöarna",
        "Hungary": "Ungern",
        "American Samoa": "Amerikanska Samoa",
        "Mauritania": "Mauretanien",
        "Japan": "Japan",
        "Uzbekistan": "Uzbekistan",
        "Cambodia": "Kambodja",
        "Wallis & Futuna": "Wallis- och Futunaöarna",
        "South Sudan": "Sydsudan",
        "Morocco": "Marocko",
        "Argentina": "Argentina",
        "Guadeloupe": "Guadeloupe",
        "Hong Kong": "Hongkong",
        "Qatar": "Qatar",
        "Tanzania": "Tanzania",
        "Mexico": "Mexiko",
        "Russia": "Ryssland",
        "Iceland": "Island",
        "Monaco": "Monaco",
        "Afghanistan": "Afghanistan",
        "Slovakia": "Slovakien",
        "Sweden": "Sverige",
        "Azerbaijan": "Azerbajdzjan",
        "Bangladesh": "Bangladesh",
        "Brazil": "Brasilien",
        "Cuba": "Kuba",
        "Ghana": "Ghana",
        "Mongolia": "Mongoliet",
        "Saint Kitts and Nevis": "Saint Kitts och Nevis",
        "Burkina Faso": "Burkina Faso",
        "Nicaragua": "Nicaragua",
        "Malaysia": "Malaysia",
        "Uruguay": "Uruguay",
        "Brunei": "Brunei",
        "Congo": "Kongo",
        "Nauru": "Nauru",
        "Northern Mariana Islands": "Nordmarianerna",
        "Pakistan": "Pakistan",
        "Greenland": "Grönland",
        "Mauritius": "Mauritius",
        "Caribbean Netherlands": "Karibiska Nederländerna",
        "Belize": "Belize",
        "Liechtenstein": "Liechtenstein",
        "Sierra Leone": "Sierra Leone",
        "Czech Republic": "Tjeckien",
        "Moldova": "Moldavien",
        "Singapore": "Singapore",
        "Belgium": "Belgien",
        "Maldives": "Maldiverna",
        "New Zealand": "Nya Zeeland",
        "South Korea": "Sydkorea",
        "Italy": "Italien",
        "Israel": "Israel",
        "Grenada": "Grenada",
        "Kenya": "Kenya",
        "St. Helena": "Sankta Helena",
        "Guam": "Guam",
        "Denmark": "Danmark",
        "New Caledonia": "Nya Kaledonien",
        "Ecuador": "Ecuador",
        "Canada": "Kanada",
        "Egypt": "Egypten",
        "Saudi Arabia": "Saudiarabien",
        "Botswana": "Botswana",
        "Turks & Caicos Islands": "Turks- och Caicosöarna",
        "Latvia": "Lettland",
        "St. Pierre & Miquelon": "Saint-Pierre och Miquelon",
        "Georgia": "Georgien",
        "Laos": "Laos",
        "Réunion": "Réunion",
        "Niue": "Niue",
        "Zimbabwe": "Zimbabwe",
        "Thailand": "Thailand",
        "Algeria": "Algeriet",
        "Finland": "Finland",
        "Macedonia": "Nordmakedonien",
        "Antigua and Barbuda": "Antigua och Barbuda",
        "Nigeria": "Nigeria",
        "Switzerland": "Schweiz",
        "Bulgaria": "Bulgarien",
        "Montenegro": "Montenegro",
        "Tajikistan": "Tadzjikistan",
        "Austria": "Österrike",
        "Bolivia": "Bolivia",
        "Sudan": "Sudan",
        "Suriname": "Surinam",
        "Iraq": "Irak",
        "Bahrain": "Bahrain",
        "Colombia": "Colombia",
        "Papua New Guinea": "Papua Nya Guinea",
        "Yemen": "Jemen",
        "Venezuela": "Venezuela",
        "Djibouti": "Djibouti",
        "British Indian Ocean Territory": "Brittiska territoriet i Indiska oceanen",
        "Chad": "Tchad",
        "Germany": "Tyskland",
        "Fiji": "Fiji",
        "British Virgin Islands": "Brittiska Jungfruöarna",
        "San Marino": "San Marino",
        "Vietnam": "Vietnam",
        "Macau": "Macao",
        "South Africa": "Sydafrika",
        "Eritrea": "Eritrea",
        "Greece": "Grekland",
        "Ethiopia": "Etiopien",
        "Madagascar": "Madagaskar",
        "Marshall Islands": "Marshallöarna",
        "United States": "USA",
        "Benin": "Benin",
        "El Salvador": "El Salvador",
        "Lebanon": "Libanon",
        "Palestine": "Palestina",
        "Tuvalu": "Tuvalu",
        "Solomon Islands": "Salomonöarna",
        "China": "Kina",
        "Tonga": "Tonga"
    },
};
export const bnBD = {
    searchNotFound: "দেশ পাওয়া যায়নি",
    searchPlaceholder: "দেশ অনুসন্ধান করুন",
    countries: {
        "Gibraltar": "জিব্রালটার",
        "Gambia": "গাম্বিয়া",
        "Equatorial Guinea": "নিরক্ষীয় গিনি",
        "Senegal": "সেনেগাল",
        "Jamaica": "জামাইকা",
        "Seychelles": "সিসিলি",
        "Comoros": "কমোরোস",
        "U.S. Virgin Islands": "ইউএস ভার্জিন দ্বীপপুঞ্জ",
        "Guinea": "গিনি",
        "Niger": "নাইজার",
        "Libya": "লিবিয়া",
        "Romania": "রোমানিয়া",
        "Anguilla": "অ্যাঙ্গুইলা",
        "Togo": "টোঙ্গো",
        "Paraguay": "প্যারাগুয়ে",
        "India": "ভারত",
        "Ireland": "আয়ারল্যান্ড",
        "Turkey": "তুরস্ক",
        "Oman": "ওমান",
        "Ukraine": "ইউক্রেন",
        "Spain": "স্পেন",
        "Cameroon": "ক্যামেরুন",
        "Angola": "অ্যাঙ্গোলা",
        "Mali": "মালি",
        "Saint Vincent and the Grenadines": "সেন্ট ভিনসেন্ট এবং গ্রেনাডাইনস",
        "Cyprus": "সাইপ্রাস",
        "Belarus": "বেলারুশ",
        "Gabon": "গ্যাবন",
        "Samoa": "সামোয়া",
        "Chile": "চিলি",
        "United Arab Emirates": "সংযুক্ত আরব আমিরাত",
        "São Tomé and Príncipe": "সাও টোমি ও প্রিনসিপি",
        "Palau": "পালাউ",
        "Tokelau": "টোকেলাউ",
        "Puerto Rico": "পুয়ের্তো রিকো",
        "Portugal": "পর্তুগাল",
        "Costa Rica": "কোস্টারিকা",
        "Swaziland": "সোয়াজিল্যান্ড",
        "Cape Verde": "কেপ ভার্দে",
        "Curaçao": "কুরাসাও",
        "Andorra": "অ্যান্ডোরা",
        "Armenia": "আর্মেনিয়া",
        "Haiti": "হাইতি",
        "Côte d’Ivoire": "আইভরি কোস্ট",
        "Guinea-Bissau": "গিনি-বিসাউ",
        "Mozambique": "মোজাম্বিক",
        "Poland": "পোল্যান্ড",
        "French Polynesia": "ফরাসী পলিনেশিয়া",
        "Jersey": "জার্সি",
        "Kuwait": "কুয়েত",
        "Dominican Republic": "ডোমিনিকান প্রজাতন্ত্র",
        "Kosovo": "কসোভো",
        "Kyrgyzstan": "কিরগিজস্তান",
        "Syria": "সিরিয়া",
        "Zambia": "জাম্বিয়া",
        "Croatia": "ক্রোয়েশিয়া",
        "Lithuania": "লিথুয়ানিয়া",
        "Albania": "আলবেনিয়া",
        "Netherlands": "নেদারল্যান্ডস",
        "France": "ফ্রান্স",
        "Tunisia": "তিউনিসিয়া",
        "Bosnia and Herzegovina": "বসনিয়া এবং হার্জেগোভিনা",
        "Bahamas": "বাহামাস",
        "Somalia": "সোমালিয়া",
        "Burundi": "বুরুন্ডি",
        "Barbados": "বার্বাডোস",
        "Malawi": "মালাওয়ি",
        "Honduras": "হন্ডুরাস",
        "French Guiana": "ফরাসী গিয়ানা",
        "Jordan": "জর্ডান",
        "Serbia": "সার্বিয়া",
        "Vanuatu": "ভানুয়াতু",
        "Aruba": "আরুবা",
        "Guyana": "গায়ানা",
        "Lesotho": "লেসোথো",
        "Taiwan": "তাইওয়ান",
        "Central African Republic": "মধ্য আফ্রিকান প্রজাতন্ত্র",
        "Luxembourg": "লুক্সেমবার্গ",
        "Trinidad and Tobago": "ত্রিনিদাদ ও টোবাগো",
        "Estonia": "এস্তোনিয়া",
        "Montserrat": "মন্টসেরাট",
        "Norway": "নরওয়ে",
        "North Korea": "উত্তর কোরিয়া",
        "Myanmar": "মায়ানমার",
        "Sri Lanka": "শ্রীলঙ্কা",
        "Faroe Islands": "ফ্যারো দ্বীপপুঞ্জ",
        "Dominica": "ডোমিনিকা",
        "Kiribati": "কিরিবাতি",
        "Falkland Islands": "ফকল্যান্ড দ্বীপপুঞ্জ",
        "Namibia": "নামিবিয়া",
        "Saint Lucia": "সেন্ট লুসিয়া",
        "Indonesia": "ইন্দোনেশিয়া",
        "Timor-Leste": "তিমুর-লেস্তে",
        "Norfolk Island": "নরফোক দ্বীপ",
        "Bhutan": "ভুটান",
        "Iran": "ইরান",
        "Turkmenistan": "তুর্কমেনিস্তান",
        "Uganda": "উগান্ডা",
        "Kazakhstan": "কাজাখস্তান",
        "Cook Islands": "কুক দ্বীপপুঞ্জ",
        "Micronesia": "মাইক্রোনেশিয়া",
        "Sint Maarten": "সিন্ট মার্টেন",
        "Liberia": "লাইবেরিয়া",
        "Panama": "পানামা",
        "Malta": "মাল্টা",
        "Peru": "পেরু",
        "Philippines": "ফিলিপাইন",
        "Rwanda": "রুয়ান্ডা",
        "United Kingdom": "যুক্তরাজ্য",
        "Martinique": "মার্টিনিক",
        "Nepal": "নেপাল",
        "Guatemala": "গুয়াতেমালা",
        "Bermuda": "বারমুডা",
        "Australia": "অস্ট্রেলিয়া",
        "Vatican City": "ভ্যাটিকান সিটি",
        "Slovenia": "স্লোভেনিয়া",
        "Cayman Islands": "কেম্যান দ্বীপপুঞ্জ",
        "Hungary": "হাঙ্গেরি",
        "American Samoa": "আমেরিকান সামোয়া",
        "Mauritania": "মৌরিতানিয়া",
        "Japan": "জাপান",
        "Uzbekistan": "উজবেকিস্তান",
        "Cambodia": "কম্বোডিয়া",
        "Wallis & Futuna": "ওয়ালিস এবং ফুটুনা",
        "South Sudan": "দক্ষিণ সুদান",
        "Morocco": "মরক্কো",
        "Argentina": "আর্জেন্টিনা",
        "Guadeloupe": "গুয়াডেলুপ",
        "Hong Kong": "হংকং",
        "Qatar": "কাতার",
        "Tanzania": "তানজানিয়া",
        "Mexico": "মেক্সিকো",
        "Russia": "রাশিয়া",
        "Iceland": "আইসল্যান্ড",
        "Monaco": "মোনাকো",
        "Afghanistan": "আফগানিস্তান",
        "Slovakia": "স্লোভাকিয়া",
        "Sweden": "সুইডেন",
        "Azerbaijan": "আজারবাইজান",
        "Bangladesh": "বাংলাদেশ",
        "Brazil": "ব্রাজিল",
        "Cuba": "কিউবা",
        "Ghana": "ঘানা",
        "Mongolia": "মঙ্গোলিয়া",
        "Saint Kitts and Nevis": "সেন্ট কিটস এবং নেভিস",
        "Burkina Faso": "বুর্কিনা ফাসো",
        "Nicaragua": "নিকারাগুয়া",
        "Malaysia": "মালয়েশিয়া",
        "Uruguay": "উরুগুয়ে",
        "Brunei": "ব্রুনেই",
        "Congo": "কঙ্গো",
        "Nauru": "নাউরু",
        "Northern Mariana Islands": "উত্তর মারিয়ানা দ্বীপপুঞ্জ",
        "Pakistan": "পাকিস্তান",
        "Greenland": "গ্রীনল্যান্ড",
        "Mauritius": "মরিশাস",
        "Caribbean Netherlands": "ক্যারিবিয়ান নেদারল্যান্ডস",
        "Belize": "বেলিজ",
        "Liechtenstein": "লিচেনস্টেইন",
        "Sierra Leone": "সিয়েরা লিওন",
        "Czech Republic": "চেক প্রজাতন্ত্র",
        "Moldova": "মোল্দাভিয়া",
        "Singapore": "সিঙ্গাপুর",
        "Belgium": "বেলজিয়াম",
        "Maldives": "মালদ্বীপ",
        "New Zealand": "নিউজিল্যান্ড",
        "South Korea": "দক্ষিণ কোরিয়া",
        "Italy": "ইতালি",
        "Israel": "ইস্রায়েল",
        "Grenada": "গ্রেনাডা",
        "Kenya": "কেনিয়া",
        "St. Helena": "সেন্ট হেলেনা",
        "Guam": "গুয়াম",
        "Denmark": "ডেনমার্ক",
        "New Caledonia": "নিউ ক্যালিডোনিয়া",
        "Ecuador": "ইকুয়েডর",
        "Canada": "কানাডা",
        "Egypt": "মিশর",
        "Saudi Arabia": "সৌদি আরব",
        "Botswana": "বতসোয়ানা",
        "Turks & Caicos Islands": "টার্কস ও কাইকোস দ্বীপপুঞ্জ",
        "Latvia": "লাটভিয়া",
        "St. Pierre & Miquelon": "সেন্ট পিয়েরে ও মিকেলন",
        "Georgia": "জর্জিয়া",
        "Laos": "লাওস",
        "Réunion": "রিইউনিয়ন",
        "Niue": "নিউ",
        "Zimbabwe": "জিম্বাবুয়ে",
        "Thailand": "থাইল্যান্ড",
        "Algeria": "আলজেরিয়া",
        "Finland": "ফিনল্যান্ড",
        "Macedonia": "উত্তর মেসিডোনিয়া",
        "Antigua and Barbuda": "অ্যান্টিগুয়া ও বার্বুডা",
        "Nigeria": "নাইজেরিয়া",
        "Switzerland": "সুইজারল্যান্ড",
        "Bulgaria": "বুলগেরিয়া",
        "Montenegro": "মন্টিনিগ্রো",
        "Tajikistan": "তাজিকিস্তান",
        "Austria": "অস্ট্রিয়া",
        "Bolivia": "বলিভিয়া",
        "Sudan": "সুদান",
        "Suriname": "সুরিনাম",
        "Iraq": "ইরাক",
        "Bahrain": "বাহরাইন",
        "Colombia": "কলোমবিয়া",
        "Papua New Guinea": "পাপুয়া নিউ গিনি",
        "Yemen": "ইয়েমেন",
        "Venezuela": "ভেনেজুয়েলা",
        "Djibouti": "জিবুতি",
        "British Indian Ocean Territory": "ব্রিটিশ ভারত মহাসাগর অঞ্চল",
        "Chad": "চাদ",
        "Germany": "জার্মানি",
        "Fiji": "ফিজি",
        "British Virgin Islands": "ব্রিটিশ ভার্জিন দ্বীপপুঞ্জ",
        "San Marino": "সান মারিনো",
        "Vietnam": "ভিয়েতনাম",
        "Macau": "ম্যাকাও",
        "South Africa": "দক্ষিণ আফ্রিকা",
        "Eritrea": "ইরিত্রিয়া",
        "Greece": "গ্রিস",
        "Ethiopia": "ইথিওপিয়া",
        "Madagascar": "মাদাগাস্কার",
        "Marshall Islands": "মার্শাল দ্বীপপুঞ্জ",
        "United States": "মার্কিন যুক্তরাষ্ট্র",
        "Benin": "বেনিন",
        "El Salvador": "এল সালভাদর",
        "Lebanon": "লেবানন",
        "Palestine": "প্যালেস্টাইন",
        "Tuvalu": "তুভালু",
        "Solomon Islands": "সলোমন দ্বীপপুঞ্জ",
        "China": "চীন",
        "Tonga": "টোঙ্গা"
    },
};
